// import React from "react";
// import ContainerHeader from "components/ContainerHeader/index";
// import CardBox from "components/CardBox/index";
// import CardBoxNew from "components/CardBoxNew/index";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import "../../../../src/assets/vendors/react-notification/react-notifications.css"
// import { httpClient } from "appUtility/Api";
// import IntlMessages from "util/IntlMessages";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
// import Switch from "@material-ui/core/Switch";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import featureServer from "../../../appUtility/featureServer";
// import { FormControl, Grid, MenuItem, Radio, Select, Tooltip } from "@material-ui/core";
// import configureStore from "../../../store";

// const loginOBJ = localStorage.getItem("login");
// const logindetail = JSON.parse(loginOBJ);

// let ItemOBJ = localStorage.getItem("itemLabels");
// let itemDetails = JSON.parse(ItemOBJ);
// var modifiedData = logindetail && logindetail.syncLastModified;
// const qs = require("qs");

// var param, settingdetail;

// //const Settings = ({match}) => {
// class Settings extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       error: null,
//       isLoaded: false,
//       id: "",
//       incometemplate: "",
//       incomedescription: "",
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       mcode: logindetail && logindetail.mCode,
//       settingdetail: "",
//       checked: [],
//       customerName: false,
//       bookingTotal: false,
//       customerAddress: false,
//       petName: false,
//       petBreed: false,
//       serviceName: false,
//       syncModified: "",
//       loading: false,
//       display_booking_end_time: logindetail && logindetail.display_booking_end_time,
//       timeFormat: logindetail && logindetail.timeFormat,
//       addressInInvoice: logindetail && logindetail.addressInInvoice,
//       phoneInInvoice: logindetail && logindetail.phoneInInvoice,
//       enableCancellationPolicy: logindetail && logindetail.enableCancellationPolicy,
//       selectedSetting: "",
//       confirmationHour: 24,
//       loadingConfirmation: false,
//     };

//     this.handleChange = this.handleChange.bind(this);
//   }

//   handleEndDate = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       display_booking_end_time: checked ? "1" : "0"
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       display_booking_end_time: checked ? "1" : "0"
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_display_end_time",
//           source: dateVals,
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           // loginData.display_booking_end_time = data.display_booking_end_time;
//           loginData.display_booking_end_time = this.state.display_booking_end_time;

//           this.setState({
//             ...this.setState,
//             display_booking_end_time: loginData.display_booking_end_time
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);

//         }

//       })
//   }

//   handleFormatChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       timeFormat: checked ? 24 : 12
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       timeFormat: checked ? 24 : 12
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "timeFormat",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',

//           timeFormat: dateVals.timeFormat
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.timeFormat = this.state.timeFormat;
//           this.setState({
//             ...this.setState,
//             timeFormat: loginData.timeFormat
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);


//         }
//       })
//   }

//   handleAddressInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       addressInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       addressInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "addressInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',

//           addressInInvoice: dateVals.addressInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.addressInInvoice = this.state.addressInInvoice;
//           this.setState({
//             ...this.setState,
//             addressInInvoice: loginData.addressInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);


//         }
//       })
//   }

//   handlePersonalPhoneInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       phoneInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       phoneInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "phoneInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',

//           phoneInInvoice: dateVals.phoneInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.phoneInInvoice = this.state.phoneInInvoice;
//           this.setState({
//             ...this.setState,
//             phoneInInvoice: loginData.phoneInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);


//         }
//       })
//   }


//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       enableCancellationPolicy: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       enableCancellationPolicy: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',

//           enableCancellationPolicy: dateVals.enableCancellationPolicy
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.enableCancellationPolicy = this.state.enableCancellationPolicy;
//           this.setState({
//             ...this.setState,
//             enableCancellationPolicy: loginData.enableCancellationPolicy
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);


//         }
//       })
//   }

//   handleToggle = (event, value) => {
//     var settingParam;
//     var aid, cid, uid;
//     var btntype;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail.uid;
//     btntype = value;

//     const { checked } = this.state;
//     const currentIndex = checked.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex == -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     //this.hideValues(value);

//     this.setState({
//       checked: newChecked,
//     });

//     settingParam = aid + "_" + cid + "_" + uid + "_" + value;
//     // console.log(settingParam);
//     // console.log(btntype);

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: btntype,
//           source: settingParam,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data.success != "true") {
//             NotificationManager.info(data.failedMSG);
//           } else if (data.success == "true") {
//             var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
//             var objname = data.actionOn;

//             if (objname == "displayCustNotes")
//               loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

//             if (objname == "hideOldRecurring")
//               loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

//             if (objname == "displayBookingClash")
//               loginTempOBJ.displayBookingClash =
//                 1 - loginTempOBJ.displayBookingClash;

//             if (objname == "hidePastBookingsCalendarSearch")
//               loginTempOBJ.hidePastBookingsCalendarSearch =
//                 1 - loginTempOBJ.hidePastBookingsCalendarSearch;

//             if (objname == "filterBookingServices") {
//               loginTempOBJ.filterBookingServices =
//                 1 - loginTempOBJ.filterBookingServices;
//             }

//             //loginTempOBJ.'[objname]' = 1-loginTempOBJ.[objname];
//             localStorage.setItem("login", JSON.stringify(loginTempOBJ));
//             NotificationManager.info(data.msg);
//           }
//         },
//         // error handler
//         (error) => {
//           this.setState({
//             //isLoaded: true,
//             error,
//           });
//         }
//       );
//   };

//   handleCalendarChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//   };

//   handleBookingConfirmationChange = (event) => {
//     this.setState({ selectedSetting: event.target.value });
//   };

//   handleChangeConfirmationHour = (e) => {
//     this.setState({
//       confirmationHour: e.target.value,
//     });
//   };


//   handleSaveSettings() {
//     //alert(this.state.incometemplate);
//     if (this.state.incometemplate == "" && this.state.incomedescription == "") {
//       NotificationManager.info("Nothing changed to save");
//     } else {
//       //console.log(this.state);

//       httpClient
//         .post(
//           "saveMemberSettings.php",
//           qs.stringify({
//             action: "save_settings",
//             source: this.state,
//           })
//         )
//         .then(
//           ({ data }) => {
//             if (data.success != "true") {
//               NotificationManager.info(data.failedMSG);
//             } else {
//               NotificationManager.info(data.successMSG);
//               this.setState({
//                 incometemplate: "",
//                 incomedescription: "",
//               });
//             }
//           },
//           // error handler
//           (error) => {
//             NotificationManager.info(
//               "Error Occured: Refresh the page and try again"
//             );
//           }
//         );
//     }
//   }

//   handleChange(evt) {
//     this.setState({ [evt.target.name]: evt.target.value });
//   }

//   componentDidMount() {
//     var aid, cid, uid;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail && logindetail.uid;

//     param = aid + "_" + cid + "_" + uid;

//     httpClient
//       .post(
//         "getMemberSettings.php",
//         qs.stringify({
//           action: "member_settings",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             localStorage.setItem("settings", JSON.stringify(data));
//             this.setState(
//               {
//                 isLoaded: false,
//                 id: data.id,
//                 settingdetail: data,
//                 checked: data.flags,
//                 petName: data.pet_name == "1" ? true : false,
//                 petBreed: data.pet_breed == "1" ? true : false,
//                 serviceName: data.services_name == "1" ? true : false,
//                 customerName: data.customer_name == "1" ? true : false,
//                 bookingTotal: data.bookingCost == "1" ? true : false,
//                 customerAddress: data.customer_address == "1" ? true : false,
//                 confirmationHour: parseInt(data.confirmationHour),
//                 selectedSetting: data.confirmationBy,
//               },
//               function () {
//                 this.setState({
//                   isLoaded: true,
//                 });
//               }
//             );
//             // console.log(this.state.checked);
//           } else {
//           }
//         },
//         // error handler
//         (error) => {
//           this.setState({
//             isLoaded: true,
//             error,
//           });
//         }
//       );

//     const loginValue = JSON.parse(localStorage.getItem("login"));
//     this.setState({
//       ...this.state,
//       // display_booking_end_time: loginValue.display_booking_end_time == "1" ? true : false
//       display_booking_end_time: loginValue.display_booking_end_time,
//       timeFormat: loginValue.timeFormat,
//       addressInInvoice: loginValue.addressInInvoice,
//       phoneInInvoice: loginValue.phoneInInvoice,
//       enableCancellationPolicy: loginValue.enableCancellationPolicy
//     })
//     console.log('disp', this.state);
//   }

//   handleSubmitCalendar = (e) => {
//     // console.log("sumit");
//     e.preventDefault();


//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//       // document.getElementById("user_name_1") !== null && (document.getElementById("user_name_1").style.cssText = "display: none");
//       // document.getElementById("user_name_100") !== null && (document.getElementById("user_name_100").style.cssText = "display: block");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");


//     this.setState({
//       ...this.state,
//       loading: true,
//     });
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       customer_name: this.state.customerName,
//       bookingCost: this.state.bookingTotal,
//       customer_address: this.state.customerAddress,
//       pet_name: this.state.petName,
//       pet_breed: this.state.petBreed,
//       services_name: this.state.serviceName,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_calendar_settings",
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           NotificationManager.success(data.successMSG);
//           let calendarData = [];
//           let calendarStorage = JSON.parse(localStorage.getItem("settings"));
//           // calendarData = calendarStorage;

//           calendarData = {
//             ...calendarStorage,
//             customer_name: data.customer_name,
//             bookingCost: data.bookingCost,
//             pet_name: data.pet_name,
//             services_name: data.services_name,
//             customer_address: data.customer_address,
//           };

//           const cal = { ...calendarData };

//           localStorage.setItem("settings", JSON.stringify(cal));

//           setTimeout(() => {
//             NotificationManager.info("Retrieving Calendar Entries");
//           }, 1000);

//           this.getCalendarEntry();
//         } else {
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   handleSubmitConfirmation = (e) => {
//     // console.log("sumit");
//     e.preventDefault();

//     this.setState({
//       ...this.state,
//       loadingConfirmation: true,
//     });
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "bookingConfirmation",
//           source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
//           confirmationBy: this.state.selectedSetting,
//           confirmationHour: this.state.confirmationHour,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: data.data.confirmationBy,
//             confirmationHour: parseInt(data.data.confirmationHour),
//           });
//           NotificationManager.success(data.msg);

//         } else {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: "",
//             confirmationHour: "",
//           });
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   getCalendarEntry = () => {
//     httpClient
//       .post(
//         "getCalendarEntries.php",
//         qs.stringify({
//           action: "calendar_entries",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             var calendarLastMod = {
//               calendarLastModified: data.calendarLastModified,
//             };
//             var dataIndex =
//               modifiedData &&
//               modifiedData.findIndex((arr, i) => arr.calendarLastModified);
//             modifiedData && (modifiedData[dataIndex] = calendarLastMod);

//             localStorage.setItem("calendar_entries", JSON.stringify(data.data));
//             this.setState({
//               syncModified: modifiedData,
//             });

//             this.setState({
//               ...this.state,
//               loading: false,
//             });
//             if (this.state.syncModified.length > 0) {
//               var loginData = JSON.parse(localStorage.getItem("login"));
//               loginData.syncLastModified = this.state.syncModified;
//               loginData.syncLastModified !== [] &&
//                 localStorage.setItem("login", JSON.stringify(loginData));
//             }

//             NotificationManager.success(
//               "Calendar Settings Successfully Updated"
//             );

//             //Blur removed
//             let loginBlur = JSON.parse(localStorage.getItem("login"));

//             if (loginBlur && loginBlur.ismobiledevice != 1) {
//               document.getElementById("nav__menu__display") !== null &&
//                 (document.getElementById("nav__menu__display").style.cssText =
//                   "filter: blur(0px); pointer-events: block");
//               // document.getElementById("user_name_1") !== null &&  (document.getElementById("user_name_1").style.cssText = "display: block");
//               // document.getElementById("user_name_100") !== null && (document.getElementById("user_name_100").style.cssText = "display: none");
//             }
//             document.getElementById("appbar_mainapp__") !== null &&
//               (document.getElementById("appbar_mainapp__").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           } else {
//           }
//         }
//         // error handler
//       );
//   };


//   render() {

//     const {
//       error,
//       isLoaded,
//       incomedescription,
//       settingdetail,
//       incometemplate,
//       customerName,
//       bookingTotal,
//       customerAddress,
//       petName,
//       petBreed,
//       serviceName,

//     } = this.state;
//     console.log("state", this.state);
//     if (error) {
//       return <div className="jr-customers">Error: {error.message}</div>;
//     } else if (!isLoaded) {
//       return (
//         <div className="jr-customers">
//           <LinearProgress color="secondary" />
//         </div>
//       );
//     } else {
//       return (
//         <>
//           <div className="app-wrapper animated slideInUpTiny animation-duration-3">
//             <ContainerHeader
//               title={<IntlMessages id="sidebar.dashboard.settings" />}
//               match={this.props.match}
//             />


//             <div className="row">
//               <CardBox
//                 heading={<IntlMessages id="dashboard.settings.preferences" />}
//               >
//                 <div className="col-md-12 col-12">
//                   <List className="LawaList">
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Customer Notes on Booking" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayCustNotes")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayCustNotes") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "hideOldBookings")
//                           }
//                           checked={
//                             this.state.checked.indexOf("hideOldBookings") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Booking Clash Notifications" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayBookingClash")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayBookingClash") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Past Bookings from Calendar Search" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(
//                               event,
//                               "hidePastBookingsCalendarSearch"
//                             )
//                           }
//                           checked={
//                             this.state.checked.indexOf(
//                               "hidePastBookingsCalendarSearch"
//                             ) != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary={`Filter Services based on ${itemDetails.lowercase.singular} size`} />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "filterBookingServices")
//                           }
//                           checked={
//                             this.state.checked.indexOf("filterBookingServices") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Booking End Time" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           // onClick={this.handleEndDate}
//                           checked={this.state.display_booking_end_time === "1"}
//                           onChange={this.handleEndDate}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     {/* {featureServer && */}
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Address In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           // onClick={this.handleEndDate}
//                           checked={this.state.addressInInvoice === 1}
//                           onChange={this.handleAddressInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     {/* } */}

//                     {/* {featureServer && */}
//                       <ListItem>
//                         <ListItemIcon>
//                           <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
//                         </ListItemIcon>
//                         <ListItemText primary="Show Personal Phone In Invoice" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             // onClick={this.handleEndDate}
//                             checked={this.state.phoneInInvoice === 1}
//                             onChange={this.handlePersonalPhoneInInvoiceChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                      {/* } */}
//                     {/* {featureServer && */}
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Toggle 24hr Time Format" />
//                       <ListItemSecondaryAction>
//                         <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
//                         <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
//                           <Switch
//                             color="primary"
//                             // onClick={this.handleEndDate}
//                             checked={this.state.timeFormat === 24}
//                             onChange={this.handleFormatChange}
//                           />
//                         </Tooltip>
//                         <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
//                       </ListItemSecondaryAction>

//                     </ListItem>
//                     {/* } */}
//                   </List>
//                 </div>
//               </CardBox>

//               {/* <CardBox heading={<IntlMessages id="dashboard.settings.sms" />}>
//               <div className="col-md-12 col-12">
//                 <TextField
//                   id="smsNumber"
//                   label="SMS Sender"
//                   value="0495149675"
//                   margin="normal"
//                   helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                   fullWidth
//                 />
//               </div>
//             </CardBox> */}
//               <div className="col-md-6">
//                 <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
//                       <div className="col-md-12 col-12">
//                         <TextField
//                           id="smsNumber"
//                           label="SMS Sender"
//                           value="0495149675"
//                           margin="normal"
//                           helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                           fullWidth
//                         />
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
//                   {/* {featureServer && */}
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={"Cancellation Policy"}>
//                       <div className="col-md-12 col-12">
//                         <span>PLEASE NOTE: 24 hours notice is required to cancel your appointment.

//                           We reserve the right to charge a cancellation fee if you are not home when we call for our confirmed appointment time.</span>
//                         <List>
//                           <ListItem>
//                             <ListItemIcon>
//                               <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
//                             </ListItemIcon>
//                             <ListItemText primary="Attach Cancellation Policy" />
//                             <ListItemSecondaryAction>

//                               <Switch
//                                 color="primary"
//                                 // onClick={this.handleEndDate}
//                                 checked={this.state.enableCancellationPolicy === 1}
//                                 onChange={this.handleCancellationPolicyChange}
//                               />

//                             </ListItemSecondaryAction>

//                           </ListItem>
//                         </List>
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
//                   {/* } */}
//                 </Grid>
//               </div>






//               <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
//                 <form className="row" noValidate autoComplete="off">
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incometemplate"
//                       name="incometemplate"
//                       label="Income Title Template"
//                       margin="normal"
//                       defaultValue={this.state.settingdetail.title}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       onChange={this.handleChange}
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incomedescription"
//                       name="incomedescription"
//                       label="Income Description"
//                       defaultValue={this.state.settingdetail.desc}
//                       margin="normal"
//                       onChange={this.handleChange}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="jr-btn btn-margin-topbottom"
//                       position="static"
//                       onClick={() => {
//                         this.handleSaveSettings();
//                       }}
//                     >
//                       Save
//                     </Button>
//                   </div>
//                 </form>
//               </CardBox>
//               {
//                 // featureServer && (
//                   <CardBox heading="Send Booking Reminder">
//                     {this.state.loadingConfirmation && (
//                       <div style={{ position: "relative", top: "15px" }}>
//                         <LinearProgress color="secondary" />
//                       </div>
//                     )}
//                     <div className="row">
//                       <div className="col-md-12 col-12">
//                         <List className="LawaList">
//                           <ListItem>
//                             <ListItemText primary="Do not send booking reminder" />
//                             <ListItemSecondaryAction>
//                               <Radio
//                                 color="primary"
//                                 name="calendarSetting"
//                                 value=""
//                                 checked={this.state.selectedSetting === ""}
//                                 onChange={this.handleBookingConfirmationChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                           <ListItem>
//                             <ListItemText primary="Send email and SMS for all customers" />
//                             <ListItemSecondaryAction>
//                               <Radio
//                                 color="primary"
//                                 name="calendarSetting"
//                                 value="all"
//                                 checked={this.state.selectedSetting === "all"}
//                                 onChange={this.handleBookingConfirmationChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                           <ListItem>
//                             <ListItemText primary="Send email only, do not send SMS" />
//                             <ListItemSecondaryAction>
//                               <Radio
//                                 color="primary"
//                                 name="calendarSetting"
//                                 value="emailOnly"
//                                 checked={this.state.selectedSetting === 'emailOnly'}
//                                 onChange={this.handleBookingConfirmationChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                           <ListItem>
//                             <ListItemText primary="Send SMS only, do not send email" />
//                             <ListItemSecondaryAction>
//                               <Radio
//                                 color="primary"
//                                 name="calendarSetting"
//                                 value="smsOnly"
//                                 checked={this.state.selectedSetting === 'smsOnly'}
//                                 onChange={this.handleBookingConfirmationChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                           <ListItem>
//                             <ListItemText primary="Send by email but if not found, send SMS" />
//                             <ListItemSecondaryAction>
//                               <Radio
//                                 color="primary"
//                                 name="calendarSetting"
//                                 value="preferedEmail"
//                                 checked={this.state.selectedSetting === 'preferedEmail'}
//                                 onChange={this.handleBookingConfirmationChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                           <ListItem>
//                             <ListItemText primary="Send by SMS but if no mobile number, send email" />
//                             <ListItemSecondaryAction>
//                               <Radio
//                                 color="primary"
//                                 name="calendarSetting"
//                                 value="preferedSMS"
//                                 checked={this.state.selectedSetting === 'preferedSMS'}
//                                 onChange={this.handleBookingConfirmationChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                           <ListItem>
//                             <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
//                             <ListItemSecondaryAction>
//                               <FormControl variant="outlined" style={{ width: "100px" }}>
//                                 <Select
//                                   // name="inventoryService"
//                                   placeholder="Select Confirmation Before"
//                                   name="confirmationHour"
//                                   value={this.state.confirmationHour}
//                                   style={{
//                                     textAlign: 'center',
//                                     paddingLeft: '0',
//                                   }}
//                                   inputProps={{
//                                     style: {
//                                       textAlign: 'center',
//                                     },
//                                   }}
//                                   onChange={(e) => this.handleChangeConfirmationHour(e)}
//                                 >

//                                   <MenuItem value="">
//                                     <em>Select Confirmation Before</em>
//                                   </MenuItem>
//                                   <MenuItem value={24}>{"24 hrs"}</MenuItem>
//                                   <MenuItem value={48}>{"48 hrs"}</MenuItem>
//                                   <MenuItem value={72}>{"72 hrs"}</MenuItem>
//                                 </Select>
//                               </FormControl>
//                             </ListItemSecondaryAction>
//                           </ListItem>

//                           {this.state.loadingConfirmation ? (
//                             <Button
//                               variant="contained"
//                               color="primary"
//                               style={{ float: "right", marginTop: "20px" }}
//                               onClick={this.handleSubmitConfirmation}
//                               disabled={true}
//                             >
//                               Update Booking Reminder
//                             </Button>
//                           ) : (
//                             <Button
//                               variant="contained"
//                               color="primary"
//                               style={{ float: "right", marginTop: "20px" }}
//                               onClick={this.handleSubmitConfirmation}
//                             //disabled={!this.state.selectedSetting}
//                             >
//                               Update Booking Reminder
//                             </Button>
//                           )}
//                         </List>
//                       </div>
//                     </div>
//                   </CardBox>
//                 // )
//               }


//               {
//                 // featureServer && (
//                 <CardBox heading="Calendar Settings">
//                   {this.state.loading && (
//                     <div style={{ position: "relative", top: "15px" }}>
//                       <LinearProgress
//                         color="secondary"
//                       // variant="determinate"
//                       />
//                     </div>
//                   )}
//                   <div className="row">
//                     <div className="col-md-12 col-12">
//                       <List className="LawaList">
//                         <ListItem>
//                           <ListItemText primary="Show Booking Total" />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               name="bookingTotal"
//                               checked={bookingTotal}
//                               onChange={this.handleCalendarChange}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                         <ListItem>
//                           <ListItemText primary="Show Customer Name" />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               name="customerName"
//                               checked={customerName}
//                               onChange={this.handleCalendarChange}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                         <ListItem>
//                           <ListItemText primary="Show Customer Address" />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               name="customerAddress"
//                               checked={customerAddress}
//                               onChange={this.handleCalendarChange}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>

//                         <ListItem>
//                           <ListItemText primary={`Show ${itemDetails.singular} Name` }/>
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               name="petName"
//                               checked={petName}
//                               onChange={this.handleCalendarChange}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>

//                         <ListItem>
//                           <ListItemText primary={`Show ${itemDetails.singular} ${itemDetails.type}` }/>
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               name="petBreed"
//                               checked={petBreed}
//                               onChange={this.handleCalendarChange}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>

//                         <ListItem>
//                           <ListItemText primary="Show Services Name" />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               name="serviceName"
//                               checked={serviceName}
//                               onChange={this.handleCalendarChange}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>

//                         <div>
//                           <h5>Preview</h5>
//                         </div>
//                         {(bookingTotal ||
//                           customerName ||
//                           customerAddress ||
//                           petName || petBreed ||
//                           serviceName) && (
//                             <Card
//                               style={{
//                                 padding: "20px",
//                                 backgroundColor: "#3f51b5",
//                                 color: "#fff",
//                                 width: "400px",
//                               }}
//                             > {bookingTotal && <div>$Total Cost</div>}
//                               {customerName && <div>Firstname Lastname</div>}
//                               {customerAddress && <div>Street Address, Suburb, Postcode</div>}
//                               {petName && <div>{`${itemDetails.singular} Name`}</div>}
//                               {petBreed && <div>{`${itemDetails.singular} ${itemDetails.type}`}</div>}
//                               {serviceName && <div>Services</div>}
//                             </Card>
//                           )}
//                       </List>
//                       {this.state.loading ? (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "10px" }}
//                           onClick={this.handleSubmitCalendar}
//                           disabled={true}
//                         >
//                           Update Calendar Settings
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "10px" }}
//                           onClick={this.handleSubmitCalendar}
//                           disabled={
//                             bookingTotal ||
//                               customerName ||
//                               customerAddress ||
//                               petName || petBreed ||
//                               serviceName
//                               ? false
//                               : true
//                           }
//                         >
//                           Update Calendar Settings
//                         </Button>
//                       )}
//                     </div>
//                   </div>
//                 </CardBox>
//                 // )
//               }
//             </div>

//           </div>
//           <NotificationContainer />
//         </>
//       );
//     }
//   }
// }

// export default Settings;


// ****************************************************************************************************************************************

// import React from "react";
// import ContainerHeader from "components/ContainerHeader/index";
// import CardBox from "components/CardBox/index";
// import CardBoxNew from "components/CardBoxNew/index";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import "../../../../src/assets/vendors/react-notification/react-notifications.css"
// import { httpClient } from "appUtility/Api";
// import IntlMessages from "util/IntlMessages";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
// import Switch from "@material-ui/core/Switch";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import featureServer from "../../../appUtility/featureServer";
// import { FormControl, Grid, MenuItem, Radio, Select, Tooltip } from "@material-ui/core";
// import configureStore from "../../../store";

// const loginOBJ = localStorage.getItem("login");
// const logindetail = JSON.parse(loginOBJ);
// var modifiedData = logindetail && logindetail.syncLastModified;
// const qs = require("qs");

// var param, settingdetail;

// class Settings extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       error: null,
//       isLoaded: false,
//       id: "",
//       incometemplate: "",
//       incomedescription: "",
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       mcode: logindetail && logindetail.mCode,
//       settingdetail: "",
//       checked: [],
//       customerName: false,
//       bookingTotal: false,
//       customerAddress: false,
//       petName: false,
//       petBreed: false,
//       serviceName: false,
//       syncModified: "",
//       loading: false,
//       display_booking_end_time: logindetail && logindetail.display_booking_end_time,
//       timeFormat: logindetail && logindetail.timeFormat,
//       addressInInvoice: logindetail && logindetail.addressInInvoice,
//       phoneInInvoice: logindetail && logindetail.phoneInInvoice,
//       enableCancellationPolicy: logindetail && logindetail.enableCancellationPolicy,
//       selectedSetting: "",
//       confirmationHour: 24,
//       loadingConfirmation: false,
      
//       // App Calendar Settings
//       appCalendarItems: [
//         { id: 'appBookingTotal', label: 'Show Booking Total', icon: 'zmdi-money', enabled: false },
//         { id: 'appCustomerName', label: 'Show Customer Name', icon: 'zmdi-account', enabled: false },
//         { id: 'appCustomerAddress', label: 'Show Customer Address', icon: 'zmdi-pin', enabled: false },
//         { id: 'appPetName', label: 'Show Pet Name', icon: 'zmdi-face', enabled: false },
//         { id: 'appPetBreed', label: 'Show Pet Breed', icon: 'zmdi-label', enabled: false },
//         { id: 'appServiceName', label: 'Show Services Name', icon: 'zmdi-cut', enabled: false },
//       ],
//       appCalendarLoading: false,
//       draggedItem: null,
      
//       // Mobile touch states
//       isTouchDevice: false,
//       touchStartY: 0,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartTime: 0,
//     };

//     this.handleChange = this.handleChange.bind(this);
//     this.handleAppCalendarToggle = this.handleAppCalendarToggle.bind(this);
//     this.handleAppCalendarSubmit = this.handleAppCalendarSubmit.bind(this);
    
//     // Desktop drag handlers
//     this.handleDragStart = this.handleDragStart.bind(this);
//     this.handleDragOver = this.handleDragOver.bind(this);
//     this.handleDrop = this.handleDrop.bind(this);
//     this.handleDragEnd = this.handleDragEnd.bind(this);
    
//     // Mobile touch handlers
//     this.handleTouchStart = this.handleTouchStart.bind(this);
//     this.handleTouchMove = this.handleTouchMove.bind(this);
//     this.handleTouchEnd = this.handleTouchEnd.bind(this);
//     this.handleTouchCancel = this.handleTouchCancel.bind(this);
//   }

//   componentDidMount() {
//     // Detect touch device
//     this.setState({
//       isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
//     });

//     // Prevent default touch behaviors on draggable items
//     document.addEventListener('touchmove', this.preventTouchScroll, { passive: false });
    
//     var aid, cid, uid;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail && logindetail.uid;

//     param = aid + "_" + cid + "_" + uid;

//     httpClient
//       .post(
//         "getMemberSettings.php",
//         qs.stringify({
//           action: "member_settings",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             localStorage.setItem("settings", JSON.stringify(data));
//             this.setState(
//               {
//                 isLoaded: false,
//                 id: data.id,
//                 settingdetail: data,
//                 checked: data.flags,
//                 petName: data.pet_name == "1" ? true : false,
//                 petBreed: data.pet_breed == "1" ? true : false,
//                 serviceName: data.services_name == "1" ? true : false,
//                 customerName: data.customer_name == "1" ? true : false,
//                 bookingTotal: data.bookingCost == "1" ? true : false,
//                 customerAddress: data.customer_address == "1" ? true : false,
//                 confirmationHour: parseInt(data.confirmationHour),
//                 selectedSetting: data.confirmationBy,
//               },
//               function () {
//                 this.setState({
//                   isLoaded: true,
//                 });
//               }
//             );
//           } else {
//           }
//         },
//         (error) => {
//           this.setState({
//             isLoaded: true,
//             error,
//           });
//         }
//       );

//     const loginValue = JSON.parse(localStorage.getItem("login"));
//     this.setState({
//       ...this.state,
//       display_booking_end_time: loginValue.display_booking_end_time,
//       timeFormat: loginValue.timeFormat,
//       addressInInvoice: loginValue.addressInInvoice,
//       phoneInInvoice: loginValue.phoneInInvoice,
//       enableCancellationPolicy: loginValue.enableCancellationPolicy
//     });

//     // Add CSS for mobile
//     this.addMobileStyles();
//   }

//   componentWillUnmount() {
//     document.removeEventListener('touchmove', this.preventTouchScroll);
//   }

//   addMobileStyles = () => {
//     const style = document.createElement('style');
//     style.innerHTML = `
//       .app-calendar-item {
//         -webkit-touch-callout: none;
//         -webkit-user-select: none;
//         user-select: none;
//         touch-action: pan-y;
//         transition: all 0.2s ease;
//       }
//       .app-calendar-item.dragging {
//         opacity: 0.7 !important;
//         transform: scale(1.02) !important;
//         box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
//         z-index: 9999 !important;
//         background-color: #f5f5f5 !important;
//       }
//       .app-calendar-item.drag-over {
//         border: 2px dashed #3f51b5 !important;
//         background-color: #e8eaf6 !important;
//         opacity: 0.8;
//         transform: scale(1.01);
//       }
//       .app-calendar-item:active {
//         background-color: #f0f0f0;
//       }
//       @media (max-width: 768px) {
//         .app-calendar-item {
//           cursor: default !important;
//         }
//         .app-calendar-item .drag-handle {
//           padding: 10px 5px;
//         }
//       }
//     `;
//     document.head.appendChild(style);
//   };

//   preventTouchScroll = (e) => {
//     if (this.state.touchDraggedItem !== null) {
//       e.preventDefault();
//     }
//   };

//   // Desktop Drag Handlers
//   handleDragStart = (event, index) => {
//     if (this.state.isTouchDevice) return; // Skip on touch devices
    
//     event.dataTransfer.setData('text/plain', index.toString());
//     event.dataTransfer.effectAllowed = 'move';
//     this.setState({ draggedItem: index });
//     event.currentTarget.style.opacity = '0.5';
//     event.currentTarget.style.backgroundColor = '#f0f0f0';
//   };

//   handleDragOver = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
//     event.dataTransfer.dropEffect = 'move';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (event.currentTarget) {
//       event.currentTarget.classList.add('drag-over');
//     }
//   };

//   handleDrop = (event, targetIndex) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     const sourceIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
//     if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;
    
//     const newItems = [...this.state.appCalendarItems];
//     const [movedItem] = newItems.splice(sourceIndex, 1);
//     newItems.splice(targetIndex, 0, movedItem);
    
//     this.setState({ 
//       appCalendarItems: newItems,
//       draggedItem: null 
//     });
//   };

//   handleDragEnd = (event) => {
//     if (this.state.isTouchDevice) return;
    
//     event.currentTarget.style.opacity = '1';
//     event.currentTarget.style.backgroundColor = '';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     this.setState({ draggedItem: null });
//   };

//   // Mobile Touch Handlers
//   handleTouchStart = (e, index) => {
//     e.preventDefault();
    
//     const touch = e.touches[0];
//     const target = e.currentTarget;
    
//     // Long press detection (300ms)
//     this.touchStartTimeout = setTimeout(() => {
//       this.setState({
//         touchStartY: touch.clientY,
//         touchStartX: touch.clientX,
//         touchDraggedItem: index,
//         touchDraggedIndex: index,
//         draggedItem: index
//       });

//       // Add dragging class
//       target.classList.add('dragging');
      
//       // Vibrate if supported (haptic feedback)
//       if (window.navigator.vibrate) {
//         window.navigator.vibrate(50);
//       }
//     }, 300);
    
//     this.setState({ touchStartTime: Date.now() });
//   };

//   handleTouchMove = (e) => {
//     e.preventDefault();
    
//     const { touchDraggedItem, touchStartY } = this.state;
//     if (touchDraggedItem === null) {
//       clearTimeout(this.touchStartTimeout);
//       return;
//     }

//     const touch = e.touches[0];
//     const currentY = touch.clientY;
//     const deltaY = currentY - touchStartY;

//     // Find which item we're hovering over
//     const items = document.querySelectorAll('.app-calendar-item');
//     let targetIndex = touchDraggedItem;
    
//     items.forEach((item, idx) => {
//       const rect = item.getBoundingClientRect();
//       if (currentY >= rect.top && currentY <= rect.bottom) {
//         targetIndex = idx;
//       }
//     });

//     // Show drop target indicator
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (items[targetIndex] && targetIndex !== touchDraggedItem) {
//       items[targetIndex].classList.add('drag-over');
      
//       // Auto-scroll if near edges
//       const container = document.querySelector('.LawaList');
//       if (container) {
//         const containerRect = container.getBoundingClientRect();
//         const scrollSpeed = 10;
        
//         if (currentY < containerRect.top + 50) {
//           container.scrollTop -= scrollSpeed;
//         } else if (currentY > containerRect.bottom - 50) {
//           container.scrollTop += scrollSpeed;
//         }
//       }
//     }

//     // Move the dragged item visually
//     const draggedItem = items[touchDraggedItem];
//     if (draggedItem && Math.abs(deltaY) > 10) {
//       draggedItem.style.transform = `translateY(${deltaY}px) scale(1.02)`;
//     }

//     this.setState({ touchDraggedIndex: targetIndex });
//   };

//   handleTouchEnd = (e) => {
//     e.preventDefault();
//     clearTimeout(this.touchStartTimeout);
    
//     const { touchDraggedItem, touchDraggedIndex } = this.state;
    
//     if (touchDraggedItem !== null && touchDraggedIndex !== -1) {
//       // Reorder if dropped on different item
//       if (touchDraggedIndex !== touchDraggedItem) {
//         const newItems = [...this.state.appCalendarItems];
//         const [movedItem] = newItems.splice(touchDraggedItem, 1);
//         newItems.splice(touchDraggedIndex, 0, movedItem);
        
//         this.setState({ appCalendarItems: newItems });
//       }
//     }

//     // Reset all visual states
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.transform = '';
//       item.style.backgroundColor = '';
//       item.classList.remove('dragging', 'drag-over');
//     });

//     this.setState({ 
//       draggedItem: null,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartY: 0
//     });
//   };

//   handleTouchCancel = (e) => {
//     this.handleTouchEnd(e);
//   };

//   // Toggle handler for App Calendar items
//   handleAppCalendarToggle = (itemId) => {
//     const updatedItems = this.state.appCalendarItems.map(item => {
//       if (item.id === itemId) {
//         return { ...item, enabled: !item.enabled };
//       }
//       return item;
//     });

//     this.setState({ appCalendarItems: updatedItems });
//   };

//   // Submit handler for App Calendar settings
//   handleAppCalendarSubmit = (e) => {
//     e.preventDefault();

//     const enabledItems = this.state.appCalendarItems
//       .filter(item => item.enabled)
//       .map(item => item.id);

//     const orderItems = this.state.appCalendarItems.map(item => item.id);

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       appCalendarSettings: enabledItems,
//       appCalendarOrder: orderItems
//     };

//     console.log("App Calendar Settings to save:", parameters);

//     // Simulate API call
//     setTimeout(() => {
//       NotificationManager.success("App Calendar Settings Updated Successfully");
      
//       if (loginBlur && loginBlur.ismobiledevice != 1) {
//         document.getElementById("nav__menu__display") !== null &&
//           (document.getElementById("nav__menu__display").style.cssText =
//             "filter: blur(0px); pointer-events: block");
//       }
//       document.getElementById("appbar_mainapp__") !== null &&
//         (document.getElementById("appbar_mainapp__").style.cssText =
//           "filter: blur(0px); pointer-events: block");

//       this.setState({ appCalendarLoading: false });
//     }, 1000);
//   };

//   handleEndDate = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       display_booking_end_time: checked ? "1" : "0"
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       display_booking_end_time: checked ? "1" : "0"
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_display_end_time",
//           source: dateVals,
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.display_booking_end_time = this.state.display_booking_end_time;

//           this.setState({
//             ...this.setState,
//             display_booking_end_time: loginData.display_booking_end_time
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleFormatChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       timeFormat: checked ? 24 : 12
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       timeFormat: checked ? 24 : 12
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "timeFormat",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',
//           timeFormat: dateVals.timeFormat
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.timeFormat = this.state.timeFormat;
//           this.setState({
//             ...this.setState,
//             timeFormat: loginData.timeFormat
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleAddressInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       addressInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       addressInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "addressInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',
//           addressInInvoice: dateVals.addressInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.addressInInvoice = this.state.addressInInvoice;
//           this.setState({
//             ...this.setState,
//             addressInInvoice: loginData.addressInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handlePersonalPhoneInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       phoneInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       phoneInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "phoneInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',
//           phoneInInvoice: dateVals.phoneInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.phoneInInvoice = this.state.phoneInInvoice;
//           this.setState({
//             ...this.setState,
//             phoneInInvoice: loginData.phoneInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       enableCancellationPolicy: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       enableCancellationPolicy: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//           enableCancellationPolicy: dateVals.enableCancellationPolicy
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.enableCancellationPolicy = this.state.enableCancellationPolicy;
//           this.setState({
//             ...this.setState,
//             enableCancellationPolicy: loginData.enableCancellationPolicy
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleToggle = (event, value) => {
//     var settingParam;
//     var aid, cid, uid;
//     var btntype;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail.uid;
//     btntype = value;

//     const { checked } = this.state;
//     const currentIndex = checked.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex == -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     this.setState({
//       checked: newChecked,
//     });

//     settingParam = aid + "_" + cid + "_" + uid + "_" + value;

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: btntype,
//           source: settingParam,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data.success != "true") {
//             NotificationManager.info(data.failedMSG);
//           } else if (data.success == "true") {
//             var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
//             var objname = data.actionOn;

//             if (objname == "displayCustNotes")
//               loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

//             if (objname == "hideOldRecurring")
//               loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

//             if (objname == "displayBookingClash")
//               loginTempOBJ.displayBookingClash =
//                 1 - loginTempOBJ.displayBookingClash;

//             if (objname == "hidePastBookingsCalendarSearch")
//               loginTempOBJ.hidePastBookingsCalendarSearch =
//                 1 - loginTempOBJ.hidePastBookingsCalendarSearch;

//             if (objname == "filterBookingServices") {
//               loginTempOBJ.filterBookingServices =
//                 1 - loginTempOBJ.filterBookingServices;
//             }

//             localStorage.setItem("login", JSON.stringify(loginTempOBJ));
//             NotificationManager.info(data.msg);
//           }
//         },
//         (error) => {
//           this.setState({
//             error,
//           });
//         }
//       );
//   };

//   handleCalendarChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//   };

//   handleBookingConfirmationChange = (event) => {
//     this.setState({ selectedSetting: event.target.value });
//   };

//   handleChangeConfirmationHour = (e) => {
//     this.setState({
//       confirmationHour: e.target.value,
//     });
//   };

//   handleSaveSettings() {
//     if (this.state.incometemplate == "" && this.state.incomedescription == "") {
//       NotificationManager.info("Nothing changed to save");
//     } else {
//       httpClient
//         .post(
//           "saveMemberSettings.php",
//           qs.stringify({
//             action: "save_settings",
//             source: this.state,
//           })
//         )
//         .then(
//           ({ data }) => {
//             if (data.success != "true") {
//               NotificationManager.info(data.failedMSG);
//             } else {
//               NotificationManager.info(data.successMSG);
//               this.setState({
//                 incometemplate: "",
//                 incomedescription: "",
//               });
//             }
//           },
//           (error) => {
//             NotificationManager.info(
//               "Error Occured: Refresh the page and try again"
//             );
//           }
//         );
//     }
//   }

//   handleChange(evt) {
//     this.setState({ [evt.target.name]: evt.target.value });
//   }

//   handleSubmitCalendar = (e) => {
//     e.preventDefault();

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({
//       ...this.state,
//       loading: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       customer_name: this.state.customerName,
//       bookingCost: this.state.bookingTotal,
//       customer_address: this.state.customerAddress,
//       pet_name: this.state.petName,
//       pet_breed: this.state.petBreed,
//       services_name: this.state.serviceName,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_calendar_settings",
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           NotificationManager.success(data.successMSG);
//           let calendarData = [];
//           let calendarStorage = JSON.parse(localStorage.getItem("settings"));

//           calendarData = {
//             ...calendarStorage,
//             customer_name: data.customer_name,
//             bookingCost: data.bookingCost,
//             pet_name: data.pet_name,
//             services_name: data.services_name,
//             customer_address: data.customer_address,
//           };

//           const cal = { ...calendarData };

//           localStorage.setItem("settings", JSON.stringify(cal));

//           setTimeout(() => {
//             NotificationManager.info("Retrieving Calendar Entries");
//           }, 1000);

//           this.getCalendarEntry();
//         } else {
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   handleSubmitConfirmation = (e) => {
//     e.preventDefault();

//     this.setState({
//       ...this.state,
//       loadingConfirmation: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "bookingConfirmation",
//           source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
//           confirmationBy: this.state.selectedSetting,
//           confirmationHour: this.state.confirmationHour,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: data.data.confirmationBy,
//             confirmationHour: parseInt(data.data.confirmationHour),
//           });
//           NotificationManager.success(data.msg);
//         } else {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: "",
//             confirmationHour: "",
//           });
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   getCalendarEntry = () => {
//     httpClient
//       .post(
//         "getCalendarEntries.php",
//         qs.stringify({
//           action: "calendar_entries",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             var calendarLastMod = {
//               calendarLastModified: data.calendarLastModified,
//             };
//             var dataIndex =
//               modifiedData &&
//               modifiedData.findIndex((arr, i) => arr.calendarLastModified);
//             modifiedData && (modifiedData[dataIndex] = calendarLastMod);

//             localStorage.setItem("calendar_entries", JSON.stringify(data.data));
//             this.setState({
//               syncModified: modifiedData,
//             });

//             this.setState({
//               ...this.state,
//               loading: false,
//             });
            
//             if (this.state.syncModified.length > 0) {
//               var loginData = JSON.parse(localStorage.getItem("login"));
//               loginData.syncLastModified = this.state.syncModified;
//               loginData.syncLastModified !== [] &&
//                 localStorage.setItem("login", JSON.stringify(loginData));
//             }

//             NotificationManager.success(
//               "Calendar Settings Successfully Updated"
//             );

//             let loginBlur = JSON.parse(localStorage.getItem("login"));

//             if (loginBlur && loginBlur.ismobiledevice != 1) {
//               document.getElementById("nav__menu__display") !== null &&
//                 (document.getElementById("nav__menu__display").style.cssText =
//                   "filter: blur(0px); pointer-events: block");
//             }
//             document.getElementById("appbar_mainapp__") !== null &&
//               (document.getElementById("appbar_mainapp__").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           } else {
//           }
//         }
//       );
//   };

//   render() {
//     const {
//       error,
//       isLoaded,
//       incomedescription,
//       settingdetail,
//       incometemplate,
//       customerName,
//       bookingTotal,
//       customerAddress,
//       petName,
//       petBreed,
//       serviceName,
//       appCalendarItems,
//       appCalendarLoading,
//     } = this.state;

//     if (error) {
//       return <div className="jr-customers">Error: {error.message}</div>;
//     } else if (!isLoaded) {
//       return (
//         <div className="jr-customers">
//           <LinearProgress color="secondary" />
//         </div>
//       );
//     } else {
//       return (
//         <>
//           <div className="app-wrapper animated slideInUpTiny animation-duration-3">
//             <ContainerHeader
//               title={<IntlMessages id="sidebar.dashboard.settings" />}
//               match={this.props.match}
//             />

//             <div className="row">
//               <CardBox
//                 heading={<IntlMessages id="dashboard.settings.preferences" />}
//               >
//                 <div className="col-md-12 col-12">
//                   <List className="LawaList">
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Customer Notes on Booking" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayCustNotes")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayCustNotes") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "hideOldBookings")
//                           }
//                           checked={
//                             this.state.checked.indexOf("hideOldBookings") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Booking Clash Notifications" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayBookingClash")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayBookingClash") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Past Bookings from Calendar Search" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(
//                               event,
//                               "hidePastBookingsCalendarSearch"
//                             )
//                           }
//                           checked={
//                             this.state.checked.indexOf(
//                               "hidePastBookingsCalendarSearch"
//                             ) != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Filter Services based on pet size" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "filterBookingServices")
//                           }
//                           checked={
//                             this.state.checked.indexOf("filterBookingServices") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Booking End Time" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.display_booking_end_time === "1"}
//                           onChange={this.handleEndDate}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Address In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.addressInInvoice === 1}
//                           onChange={this.handleAddressInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Personal Phone In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.phoneInInvoice === 1}
//                           onChange={this.handlePersonalPhoneInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Toggle 24hr Time Format" />
//                       <ListItemSecondaryAction>
//                         <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
//                         <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
//                           <Switch
//                             color="primary"
//                             checked={this.state.timeFormat === 24}
//                             onChange={this.handleFormatChange}
//                           />
//                         </Tooltip>
//                         <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                   </List>
//                 </div>
//               </CardBox>

//               <div className="col-md-6">
//                 <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
//                       <div className="col-md-12 col-12">
//                         <TextField
//                           id="smsNumber"
//                           label="SMS Sender"
//                           value="0495149675"
//                           margin="normal"
//                           helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                           fullWidth
//                         />
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
                  
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={"Cancellation Policy"}>
//                       <div className="col-md-12 col-12">
//                         <span>PLEASE NOTE: 24 hours notice is required to cancel your appointment.
//                           We reserve the right to charge a cancellation fee if you are not home when we call for our confirmed appointment time.</span>
//                         <List>
//                           <ListItem>
//                             <ListItemIcon>
//                               <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
//                             </ListItemIcon>
//                             <ListItemText primary="Attach Cancellation Policy" />
//                             <ListItemSecondaryAction>
//                               <Switch
//                                 color="primary"
//                                 checked={this.state.enableCancellationPolicy === 1}
//                                 onChange={this.handleCancellationPolicyChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                         </List>
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
//                 </Grid>
//               </div>

//               <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
//                 <form className="row" noValidate autoComplete="off">
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incometemplate"
//                       name="incometemplate"
//                       label="Income Title Template"
//                       margin="normal"
//                       defaultValue={this.state.settingdetail.title}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       onChange={this.handleChange}
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incomedescription"
//                       name="incomedescription"
//                       label="Income Description"
//                       defaultValue={this.state.settingdetail.desc}
//                       margin="normal"
//                       onChange={this.handleChange}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="jr-btn btn-margin-topbottom"
//                       position="static"
//                       onClick={() => {
//                         this.handleSaveSettings();
//                       }}
//                     >
//                       Save
//                     </Button>
//                   </div>
//                 </form>
//               </CardBox>
              
//               <CardBox heading="Send Booking Reminder">
//                 {this.state.loadingConfirmation && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Do not send booking reminder" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value=""
//                             checked={this.state.selectedSetting === ""}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email and SMS for all customers" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="all"
//                             checked={this.state.selectedSetting === "all"}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email only, do not send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="emailOnly"
//                             checked={this.state.selectedSetting === 'emailOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send SMS only, do not send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="smsOnly"
//                             checked={this.state.selectedSetting === 'smsOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by email but if not found, send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedEmail"
//                             checked={this.state.selectedSetting === 'preferedEmail'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by SMS but if no mobile number, send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedSMS"
//                             checked={this.state.selectedSetting === 'preferedSMS'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
//                         <ListItemSecondaryAction>
//                           <FormControl variant="outlined" style={{ width: "100px" }}>
//                             <Select
//                               placeholder="Select Confirmation Before"
//                               name="confirmationHour"
//                               value={this.state.confirmationHour}
//                               style={{
//                                 textAlign: 'center',
//                                 paddingLeft: '0',
//                               }}
//                               inputProps={{
//                                 style: {
//                                   textAlign: 'center',
//                                 },
//                               }}
//                               onChange={(e) => this.handleChangeConfirmationHour(e)}
//                             >
//                               <MenuItem value="">
//                                 <em>Select Confirmation Before</em>
//                               </MenuItem>
//                               <MenuItem value={24}>{"24 hrs"}</MenuItem>
//                               <MenuItem value={48}>{"48 hrs"}</MenuItem>
//                               <MenuItem value={72}>{"72 hrs"}</MenuItem>
//                             </Select>
//                           </FormControl>
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       {this.state.loadingConfirmation ? (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                           disabled={true}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       )}
//                     </List>
//                   </div>
//                 </div>
//               </CardBox>

//               <CardBox heading="Calendar Settings">
//                 {this.state.loading && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Show Booking Total" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="bookingTotal"
//                             checked={bookingTotal}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerName"
//                             checked={customerName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Address" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerAddress"
//                             checked={customerAddress}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petName"
//                             checked={petName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Breed" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petBreed"
//                             checked={petBreed}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Services Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="serviceName"
//                             checked={serviceName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <div>
//                         <h5>Preview</h5>
//                       </div>
//                       {(bookingTotal ||
//                         customerName ||
//                         customerAddress ||
//                         petName || petBreed ||
//                         serviceName) && (
//                           <Card
//                             style={{
//                               padding: "20px",
//                               backgroundColor: "#3f51b5",
//                               color: "#fff",
//                               width: "400px",
//                             }}
//                           > 
//                             {bookingTotal && <div>$Total Cost</div>}
//                             {customerName && <div>Firstname Lastname</div>}
//                             {customerAddress && <div>Street Address, Suburb, Postcode</div>}
//                             {petName && <div>Pet Name</div>}
//                             {petBreed && <div>Pet Breed</div>}
//                             {serviceName && <div>Services</div>}
//                           </Card>
//                         )}
//                     </List>
//                     {this.state.loading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={true}
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={
//                           !(bookingTotal ||
//                             customerName ||
//                             customerAddress ||
//                             petName || petBreed ||
//                             serviceName)
//                         }
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>

//               {/* App Calendar Settings Section with Mobile Support */}
//               <CardBox heading="App Calendar Settings">
//                 {appCalendarLoading && (
//                   <div style={{ position: "relative", top: "15px", marginBottom: "20px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <p style={{ 
//                       marginBottom: '15px', 
//                       color: '#666', 
//                       fontSize: '0.9rem',
//                       padding: '10px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}>
//                       <i className="zmdi zmdi-menu" style={{ marginRight: '10px', fontSize: '20px' }}></i>
//                       {this.state.isTouchDevice ? (
//                         <span>Long press and drag the ⋮⋮ icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       ) : (
//                         <span>Drag the ⋮⋮ icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       )}
//                     </p>

//                     <List className="LawaList">
//                       {appCalendarItems.map((item, index) => (
//                         <ListItem
//                           key={item.id}
//                           className="app-calendar-item"
//                           draggable={!this.state.isTouchDevice}
//                           onDragStart={(e) => this.handleDragStart(e, index)}
//                           onDragOver={(e) => this.handleDragOver(e, index)}
//                           onDrop={(e) => this.handleDrop(e, index)}
//                           onDragEnd={this.handleDragEnd}
//                           onTouchStart={(e) => this.handleTouchStart(e, index)}
//                           onTouchMove={this.handleTouchMove}
//                           onTouchEnd={this.handleTouchEnd}
//                           onTouchCancel={this.handleTouchCancel}
//                           style={{
//                             cursor: this.state.isTouchDevice ? 'default' : 'grab',
//                             border: '1px solid transparent',
//                             transition: 'all 0.2s',
//                             backgroundColor: this.state.draggedItem === index ? '#f5f5f5' : 'transparent',
//                             WebkitTapHighlightColor: 'transparent',
//                           }}
//                         >
//                           <ListItemIcon 
//                             className="drag-handle"
//                             style={{ 
//                               cursor: this.state.isTouchDevice ? 'pointer' : 'grab', 
//                               minWidth: '40px',
//                               padding: this.state.isTouchDevice ? '10px 5px' : '0',
//                             }}
//                           >
//                             <i className="zmdi zmdi-menu" style={{ fontSize: '20px', color: '#999' }}></i>
//                           </ListItemIcon>
//                           <ListItemIcon>
//                             <i className={`zmdi ${item.icon} zmdi-hc-fw zmdi-hc-2x`} />
//                           </ListItemIcon>
//                           <ListItemText primary={item.label} />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               checked={item.enabled}
//                               onChange={() => this.handleAppCalendarToggle(item.id)}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                       ))}
//                     </List>

//                     {/* Preview Section */}
//                     <div style={{ marginTop: '20px' }}>
//                       <h5>Preview (shows enabled items in current order)</h5>
//                       {appCalendarItems.some(item => item.enabled) ? (
//                         <Card
//                           style={{
//                             padding: "20px",
//                             backgroundColor: "#3f51b5",
//                             color: "#fff",
//                             width: "100%",
//                             maxWidth: "400px",
//                           }}
//                         >
//                           {appCalendarItems
//                             .filter(item => item.enabled)
//                             .map(item => {
//                               switch(item.id) {
//                                 case 'appBookingTotal':
//                                   return <div key={item.id}>$Total Cost</div>;
//                                 case 'appCustomerName':
//                                   return <div key={item.id}>Customer Name </div>;
//                                 case 'appCustomerAddress':
//                                   return <div key={item.id}>Street Address, Suburb, Postcode</div>;
//                                 case 'appPetName':
//                                   return <div key={item.id}>Pet Name</div>;
//                                 case 'appPetBreed':
//                                   return <div key={item.id}>Pet Breed</div>;
//                                 case 'appServiceName':
//                                   return <div key={item.id}>Services</div>;
//                                 default:
//                                   return null;
//                               }
//                             })}
//                         </Card>
//                       ) : (
//                         <p style={{ color: '#999', fontStyle: 'italic' }}>Toggle on items to see preview</p>
//                       )}
//                     </div>

//                     {appCalendarLoading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         disabled={true}
//                       >
//                         Updating...
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         onClick={this.handleAppCalendarSubmit}
//                       >
//                         Update App Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>
//             </div>
//           </div>
//           <NotificationContainer />
//         </>
//       );
//     }
//   }
// }

// export default Settings;

// **********************************************************************************************************

// import React from "react";
// import ContainerHeader from "components/ContainerHeader/index";
// import CardBox from "components/CardBox/index";
// import CardBoxNew from "components/CardBoxNew/index";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import "../../../../src/assets/vendors/react-notification/react-notifications.css"
// import { httpClient } from "appUtility/Api";
// import IntlMessages from "util/IntlMessages";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
// import Switch from "@material-ui/core/Switch";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import featureServer from "../../../appUtility/featureServer";
// import { FormControl, Grid, MenuItem, Radio, Select, Tooltip } from "@material-ui/core";
// import configureStore from "../../../store";

// const loginOBJ = localStorage.getItem("login");
// const logindetail = JSON.parse(loginOBJ);
// var modifiedData = logindetail && logindetail.syncLastModified;
// const qs = require("qs");

// var param, settingdetail;

// class Settings extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       error: null,
//       isLoaded: false,
//       id: "",
//       incometemplate: "",
//       incomedescription: "",
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       mcode: logindetail && logindetail.mCode,
//       settingdetail: "",
//       checked: [],
//       customerName: false,
//       bookingTotal: false,
//       customerAddress: false,
//       petName: false,
//       petBreed: false,
//       serviceName: false,
//       syncModified: "",
//       loading: false,
//       display_booking_end_time: logindetail && logindetail.display_booking_end_time,
//       timeFormat: logindetail && logindetail.timeFormat,
//       addressInInvoice: logindetail && logindetail.addressInInvoice,
//       phoneInInvoice: logindetail && logindetail.phoneInInvoice,
//       enableCancellationPolicy: logindetail && logindetail.enableCancellationPolicy,
//       selectedSetting: "",
//       confirmationHour: 24,
//       loadingConfirmation: false,
      
//       // App Calendar Settings with all possible items (time instead of date)
//       appCalendarItems: [
//         { id: 'appTime', label: 'Show Time', icon: 'zmdi-time', enabled: false, apiKey: 'time' },
//         { id: 'appBookingTotal', label: 'Show Booking Total', icon: 'zmdi-money', enabled: false, apiKey: 'cost' },
//         { id: 'appCustomerName', label: 'Show Customer Name', icon: 'zmdi-account', enabled: false, apiKey: 'name' },
//         { id: 'appCustomerAddress', label: 'Show Customer Address', icon: 'zmdi-pin', enabled: false, apiKey: 'address' },
//         { id: 'appPetName', label: 'Show Pet Name', icon: 'zmdi-face', enabled: false, apiKey: 'petName' },
//         { id: 'appPetBreed', label: 'Show Pet Breed', icon: 'zmdi-label', enabled: false, apiKey: 'petBreed' },
//         { id: 'appServiceName', label: 'Show Services Name', icon: 'zmdi-cut', enabled: false, apiKey: 'serviceName' },
//       ],
//       appCalendarLoading: false,
//       draggedItem: null,
//       appCalendarInitialized: false,
      
//       // Mobile touch states
//       isTouchDevice: false,
//       touchStartY: 0,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartTime: 0,
//     };

//     this.handleChange = this.handleChange.bind(this);
//     this.handleAppCalendarToggle = this.handleAppCalendarToggle.bind(this);
//     this.handleAppCalendarSubmit = this.handleAppCalendarSubmit.bind(this);
    
//     // Desktop drag handlers
//     this.handleDragStart = this.handleDragStart.bind(this);
//     this.handleDragOver = this.handleDragOver.bind(this);
//     this.handleDrop = this.handleDrop.bind(this);
//     this.handleDragEnd = this.handleDragEnd.bind(this);
    
//     // Mobile touch handlers
//     this.handleTouchStart = this.handleTouchStart.bind(this);
//     this.handleTouchMove = this.handleTouchMove.bind(this);
//     this.handleTouchEnd = this.handleTouchEnd.bind(this);
//     this.handleTouchCancel = this.handleTouchCancel.bind(this);
//   }

//   componentDidMount() {
//     // Detect touch device
//     this.setState({
//       isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
//     });

//     // Prevent default touch behaviors on draggable items
//     document.addEventListener('touchmove', this.preventTouchScroll, { passive: false });
    
//     var aid, cid, uid;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail && logindetail.uid;

//     param = aid + "_" + cid + "_" + uid;

//     // Fetch member settings
//     httpClient
//       .post(
//         "getMemberSettings.php",
//         qs.stringify({
//           action: "member_settings",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             localStorage.setItem("settings", JSON.stringify(data));
//             this.setState(
//               {
//                 isLoaded: false,
//                 id: data.id,
//                 settingdetail: data,
//                 checked: data.flags,
//                 petName: data.pet_name == "1" ? true : false,
//                 petBreed: data.pet_breed == "1" ? true : false,
//                 serviceName: data.services_name == "1" ? true : false,
//                 customerName: data.customer_name == "1" ? true : false,
//                 bookingTotal: data.bookingCost == "1" ? true : false,
//                 customerAddress: data.customer_address == "1" ? true : false,
//                 confirmationHour: parseInt(data.confirmationHour),
//                 selectedSetting: data.confirmationBy,
//               },
//               function () {
//                 this.setState({
//                   isLoaded: true,
//                 });
//               }
//             );
//           } else {
//           }
//         },
//         (error) => {
//           this.setState({
//             isLoaded: true,
//             error,
//           });
//         }
//       );

//     const loginValue = JSON.parse(localStorage.getItem("login"));
//     this.setState({
//       ...this.state,
//       display_booking_end_time: loginValue.display_booking_end_time,
//       timeFormat: loginValue.timeFormat,
//       addressInInvoice: loginValue.addressInInvoice,
//       phoneInInvoice: loginValue.phoneInInvoice,
//       enableCancellationPolicy: loginValue.enableCancellationPolicy
//     });

//     // Fetch App Calendar Settings (no notification on page load)
//     this.fetchAppCalendarSettings(false);

//     // Add CSS for mobile
//     this.addMobileStyles();
//   }

//   componentWillUnmount() {
//     document.removeEventListener('touchmove', this.preventTouchScroll);
//   }

//   fetchAppCalendarSettings = (showNotification = false) => {
//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//      const loginData = JSON.parse(localStorage.getItem("login"));
//   const apiToken = loginData && loginData.memtoken ? loginData.memtoken : "";

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "getSettings",
//           api_token: apiToken,
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           // data.data contains array of enabled settings in order e.g., ["time", "cost", "name", ...]
//           const enabledSettings = data.data || [];
          
//           // Create a map of apiKey to enabled status and order
//           const settingsMap = {};
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const key = enabledSettings[i];
//             settingsMap[key] = { enabled: true, order: i };
//           }

//           // Create a new array with items in the exact order from API response
//           const orderedItems = [];
          
//           // First, add enabled items in the order they appear in API response
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const apiKey = enabledSettings[i];
//             // Find the matching item in appCalendarItems
//             for (let j = 0; j < this.state.appCalendarItems.length; j++) {
//               const item = this.state.appCalendarItems[j];
//               if (item.apiKey === apiKey) {
//                 orderedItems.push({
//                   ...item,
//                   enabled: true
//                 });
//                 break;
//               }
//             }
//           }
          
//           // Then, add disabled items that are not in the API response
//           for (let i = 0; i < this.state.appCalendarItems.length; i++) {
//             const item = this.state.appCalendarItems[i];
//             if (!settingsMap.hasOwnProperty(item.apiKey)) {
//               orderedItems.push({
//                 ...item,
//                 enabled: false
//               });
//             }
//           }

//           this.setState({ 
//             appCalendarItems: orderedItems,
//             appCalendarLoading: false,
//             appCalendarInitialized: true
//           });

//           // Only show notification if explicitly requested (not on page load)
//           if (showNotification) {
//             NotificationManager.success(data.message || "Calendar settings loaded");
//           }
//         } else {
//           if (showNotification) {
//             NotificationManager.info(data.message || "Failed to load calendar settings");
//           }
//           this.setState({ appCalendarLoading: false });
//         }
//       })
//       .catch(error => {
//         console.error("Error fetching app calendar settings:", error);
//         if (showNotification) {
//           NotificationManager.info("Error loading calendar settings");
//         }
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   addMobileStyles = () => {
//     const style = document.createElement('style');
//     style.innerHTML = `
//       .app-calendar-item {
//         -webkit-touch-callout: none;
//         -webkit-user-select: none;
//         user-select: none;
//         touch-action: pan-y;
//         transition: all 0.2s ease;
//       }
//       .app-calendar-item.dragging {
//         opacity: 0.7 !important;
//         transform: scale(1.02) !important;
//         box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
//         z-index: 9999 !important;
//         background-color: #f5f5f5 !important;
//       }
//       .app-calendar-item.drag-over {
//         border: 2px dashed #3f51b5 !important;
//         background-color: #e8eaf6 !important;
//         opacity: 0.8;
//         transform: scale(1.01);
//       }
//       .app-calendar-item:active {
//         background-color: #f0f0f0;
//       }
//       @media (max-width: 768px) {
//         .app-calendar-item {
//           cursor: default !important;
//         }
//         .app-calendar-item .drag-handle {
//           padding: 10px 5px;
//         }
//       }
//     `;
//     document.head.appendChild(style);
//   };

//   preventTouchScroll = (e) => {
//     if (this.state.touchDraggedItem !== null) {
//       e.preventDefault();
//     }
//   };

//   // Desktop Drag Handlers
//   handleDragStart = (event, index) => {
//     if (this.state.isTouchDevice) return; // Skip on touch devices
    
//     event.dataTransfer.setData('text/plain', index.toString());
//     event.dataTransfer.effectAllowed = 'move';
//     this.setState({ draggedItem: index });
//     event.currentTarget.style.opacity = '0.5';
//     event.currentTarget.style.backgroundColor = '#f0f0f0';
//   };

//   handleDragOver = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
//     event.dataTransfer.dropEffect = 'move';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (event.currentTarget) {
//       event.currentTarget.classList.add('drag-over');
//     }
//   };

//   handleDrop = (event, targetIndex) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     const sourceIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
//     if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;
    
//     const newItems = [...this.state.appCalendarItems];
//     const [movedItem] = newItems.splice(sourceIndex, 1);
//     newItems.splice(targetIndex, 0, movedItem);
    
//     this.setState({ 
//       appCalendarItems: newItems,
//       draggedItem: null 
//     });
//   };

//   handleDragEnd = (event) => {
//     if (this.state.isTouchDevice) return;
    
//     event.currentTarget.style.opacity = '1';
//     event.currentTarget.style.backgroundColor = '';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     this.setState({ draggedItem: null });
//   };

//   // Mobile Touch Handlers
//   handleTouchStart = (e, index) => {
//     e.preventDefault();
    
//     const touch = e.touches[0];
//     const target = e.currentTarget;
    
//     // Long press detection (300ms)
//     this.touchStartTimeout = setTimeout(() => {
//       this.setState({
//         touchStartY: touch.clientY,
//         touchStartX: touch.clientX,
//         touchDraggedItem: index,
//         touchDraggedIndex: index,
//         draggedItem: index
//       });

//       // Add dragging class
//       target.classList.add('dragging');
      
//       // Vibrate if supported (haptic feedback)
//       if (window.navigator.vibrate) {
//         window.navigator.vibrate(50);
//       }
//     }, 300);
    
//     this.setState({ touchStartTime: Date.now() });
//   };

//   handleTouchMove = (e) => {
//     e.preventDefault();
    
//     const { touchDraggedItem, touchStartY } = this.state;
//     if (touchDraggedItem === null) {
//       clearTimeout(this.touchStartTimeout);
//       return;
//     }

//     const touch = e.touches[0];
//     const currentY = touch.clientY;
//     const deltaY = currentY - touchStartY;

//     // Find which item we're hovering over
//     const items = document.querySelectorAll('.app-calendar-item');
//     let targetIndex = touchDraggedItem;
    
//     items.forEach((item, idx) => {
//       const rect = item.getBoundingClientRect();
//       if (currentY >= rect.top && currentY <= rect.bottom) {
//         targetIndex = idx;
//       }
//     });

//     // Show drop target indicator
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (items[targetIndex] && targetIndex !== touchDraggedItem) {
//       items[targetIndex].classList.add('drag-over');
      
//       // Auto-scroll if near edges
//       const container = document.querySelector('.LawaList');
//       if (container) {
//         const containerRect = container.getBoundingClientRect();
//         const scrollSpeed = 10;
        
//         if (currentY < containerRect.top + 50) {
//           container.scrollTop -= scrollSpeed;
//         } else if (currentY > containerRect.bottom - 50) {
//           container.scrollTop += scrollSpeed;
//         }
//       }
//     }

//     // Move the dragged item visually
//     const draggedItem = items[touchDraggedItem];
//     if (draggedItem && Math.abs(deltaY) > 10) {
//       draggedItem.style.transform = `translateY(${deltaY}px) scale(1.02)`;
//     }

//     this.setState({ touchDraggedIndex: targetIndex });
//   };

//   handleTouchEnd = (e) => {
//     e.preventDefault();
//     clearTimeout(this.touchStartTimeout);
    
//     const { touchDraggedItem, touchDraggedIndex } = this.state;
    
//     if (touchDraggedItem !== null && touchDraggedIndex !== -1) {
//       // Reorder if dropped on different item
//       if (touchDraggedIndex !== touchDraggedItem) {
//         const newItems = [...this.state.appCalendarItems];
//         const [movedItem] = newItems.splice(touchDraggedItem, 1);
//         newItems.splice(touchDraggedIndex, 0, movedItem);
        
//         this.setState({ appCalendarItems: newItems });
//       }
//     }

//     // Reset all visual states
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.transform = '';
//       item.style.backgroundColor = '';
//       item.classList.remove('dragging', 'drag-over');
//     });

//     this.setState({ 
//       draggedItem: null,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartY: 0
//     });
//   };

//   handleTouchCancel = (e) => {
//     this.handleTouchEnd(e);
//   };

//   // Toggle handler for App Calendar items
//   handleAppCalendarToggle = (itemId) => {
//     const updatedItems = this.state.appCalendarItems.map(item => {
//       if (item.id === itemId) {
//         return { ...item, enabled: !item.enabled };
//       }
//       return item;
//     });

//     this.setState({ appCalendarItems: updatedItems });
//   };

//   // Submit handler for App Calendar settings - SAVE API
//   handleAppCalendarSubmit = (e) => {
//     e.preventDefault();

//     // Get enabled items in current order
//     const enabledItems = this.state.appCalendarItems
//       .filter(item => item.enabled)
//       .map(item => item.apiKey); // Send apiKey to backend

//     // Apply blur effect
//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const apiToken = "bBB9nUASjh2LPJBSkbL3vq8CfGfjJZ_20220907022941_3_1_T5M2AWH4pauGifUkkIYq";

//     // Create source object with the correct structure: source[appID], source[memberID], source[companyID], source[settings][0], etc.
//     const sourceData = {
//       appID: parameters.appID,
//       memberID: parameters.memberID,
//       companyID: parameters.companyID,
//     };

//     // Add settings as source[settings][0], source[settings][1], etc.
//     // This creates the structure: { appID:1, memberID:3, companyID:4, settings:{0:"time",1:"cost",2:"name"} }
//     const settingsObj = {};
//     for (let i = 0; i < enabledItems.length; i++) {
//       settingsObj[i] = enabledItems[i];
//     }
//     sourceData.settings = settingsObj;

//     console.log("App Calendar Settings to save:", {
//       action: "saveSettings",
//       api_token: apiToken,
//       source: sourceData
//     });

//     // API Call to save settings
//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "saveSettings",
//           api_token: apiToken,
//           source: sourceData,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           // Show only one success notification
//           NotificationManager.success(data.message || "App Calendar Settings Updated Successfully");
          
//           // Refresh the settings to get the latest from server (with notification false)
//           this.fetchAppCalendarSettings(false);
//         } else {
//           NotificationManager.info(data.message || "Failed to update settings");
//           this.setState({ appCalendarLoading: false });
          
//           // Remove blur effect on error
//           if (loginBlur && loginBlur.ismobiledevice != 1) {
//             document.getElementById("nav__menu__display") !== null &&
//               (document.getElementById("nav__menu__display").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           }
//           document.getElementById("appbar_mainapp__") !== null &&
//             (document.getElementById("appbar_mainapp__").style.cssText =
//               "filter: blur(0px); pointer-events: block");
//         }
//       })
//       .catch(error => {
//         console.error("Error saving app calendar settings:", error);
//         NotificationManager.info("Error updating app calendar settings");
        
//         // Remove blur effect
//         if (loginBlur && loginBlur.ismobiledevice != 1) {
//           document.getElementById("nav__menu__display") !== null &&
//             (document.getElementById("nav__menu__display").style.cssText =
//               "filter: blur(0px); pointer-events: block");
//         }
//         document.getElementById("appbar_mainapp__") !== null &&
//           (document.getElementById("appbar_mainapp__").style.cssText =
//             "filter: blur(0px); pointer-events: block");
        
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   handleEndDate = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       display_booking_end_time: checked ? "1" : "0"
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       display_booking_end_time: checked ? "1" : "0"
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_display_end_time",
//           source: dateVals,
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.display_booking_end_time = this.state.display_booking_end_time;

//           this.setState({
//             ...this.setState,
//             display_booking_end_time: loginData.display_booking_end_time
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleFormatChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       timeFormat: checked ? 24 : 12
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       timeFormat: checked ? 24 : 12
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "timeFormat",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',
//           timeFormat: dateVals.timeFormat
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.timeFormat = this.state.timeFormat;
//           this.setState({
//             ...this.state,
//             timeFormat: loginData.timeFormat
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleAddressInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       addressInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       addressInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "addressInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',
//           addressInInvoice: dateVals.addressInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.addressInInvoice = this.state.addressInInvoice;
//           this.setState({
//             ...this.state,
//             addressInInvoice: loginData.addressInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handlePersonalPhoneInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       phoneInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       phoneInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "phoneInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',
//           phoneInInvoice: dateVals.phoneInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.phoneInInvoice = this.state.phoneInInvoice;
//           this.setState({
//             ...this.state,
//             phoneInInvoice: loginData.phoneInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       enableCancellationPolicy: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       enableCancellationPolicy: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//           enableCancellationPolicy: dateVals.enableCancellationPolicy
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.enableCancellationPolicy = this.state.enableCancellationPolicy;
//           this.setState({
//             ...this.state,
//             enableCancellationPolicy: loginData.enableCancellationPolicy
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleToggle = (event, value) => {
//     var settingParam;
//     var aid, cid, uid;
//     var btntype;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail.uid;
//     btntype = value;

//     const { checked } = this.state;
//     const currentIndex = checked.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex == -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     this.setState({
//       checked: newChecked,
//     });

//     settingParam = aid + "_" + cid + "_" + uid + "_" + value;

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: btntype,
//           source: settingParam,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data.success != "true") {
//             NotificationManager.info(data.failedMSG);
//           } else if (data.success == "true") {
//             var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
//             var objname = data.actionOn;

//             if (objname == "displayCustNotes")
//               loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

//             if (objname == "hideOldRecurring")
//               loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

//             if (objname == "displayBookingClash")
//               loginTempOBJ.displayBookingClash =
//                 1 - loginTempOBJ.displayBookingClash;

//             if (objname == "hidePastBookingsCalendarSearch")
//               loginTempOBJ.hidePastBookingsCalendarSearch =
//                 1 - loginTempOBJ.hidePastBookingsCalendarSearch;

//             if (objname == "filterBookingServices") {
//               loginTempOBJ.filterBookingServices =
//                 1 - loginTempOBJ.filterBookingServices;
//             }

//             localStorage.setItem("login", JSON.stringify(loginTempOBJ));
//             NotificationManager.info(data.msg);
//           }
//         },
//         (error) => {
//           this.setState({
//             error,
//           });
//         }
//       );
//   };

//   handleCalendarChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//   };

//   handleBookingConfirmationChange = (event) => {
//     this.setState({ selectedSetting: event.target.value });
//   };

//   handleChangeConfirmationHour = (e) => {
//     this.setState({
//       confirmationHour: e.target.value,
//     });
//   };

//   handleSaveSettings() {
//     if (this.state.incometemplate == "" && this.state.incomedescription == "") {
//       NotificationManager.info("Nothing changed to save");
//     } else {
//       httpClient
//         .post(
//           "saveMemberSettings.php",
//           qs.stringify({
//             action: "save_settings",
//             source: this.state,
//           })
//         )
//         .then(
//           ({ data }) => {
//             if (data.success != "true") {
//               NotificationManager.info(data.failedMSG);
//             } else {
//               NotificationManager.info(data.successMSG);
//               this.setState({
//                 incometemplate: "",
//                 incomedescription: "",
//               });
//             }
//           },
//           (error) => {
//             NotificationManager.info(
//               "Error Occured: Refresh the page and try again"
//             );
//           }
//         );
//     }
//   }

//   handleChange(evt) {
//     this.setState({ [evt.target.name]: evt.target.value });
//   }

//   handleSubmitCalendar = (e) => {
//     e.preventDefault();

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({
//       ...this.state,
//       loading: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       customer_name: this.state.customerName,
//       bookingCost: this.state.bookingTotal,
//       customer_address: this.state.customerAddress,
//       pet_name: this.state.petName,
//       pet_breed: this.state.petBreed,
//       services_name: this.state.serviceName,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_calendar_settings",
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           NotificationManager.success(data.successMSG);
//           let calendarData = [];
//           let calendarStorage = JSON.parse(localStorage.getItem("settings"));

//           calendarData = {
//             ...calendarStorage,
//             customer_name: data.customer_name,
//             bookingCost: data.bookingCost,
//             pet_name: data.pet_name,
//             services_name: data.services_name,
//             customer_address: data.customer_address,
//           };

//           const cal = { ...calendarData };

//           localStorage.setItem("settings", JSON.stringify(cal));

//           setTimeout(() => {
//             NotificationManager.info("Retrieving Calendar Entries");
//           }, 1000);

//           this.getCalendarEntry();
//         } else {
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   handleSubmitConfirmation = (e) => {
//     e.preventDefault();

//     this.setState({
//       ...this.state,
//       loadingConfirmation: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "bookingConfirmation",
//           source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
//           confirmationBy: this.state.selectedSetting,
//           confirmationHour: this.state.confirmationHour,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: data.data.confirmationBy,
//             confirmationHour: parseInt(data.data.confirmationHour),
//           });
//           NotificationManager.success(data.msg);
//         } else {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: "",
//             confirmationHour: "",
//           });
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   getCalendarEntry = () => {
//     httpClient
//       .post(
//         "getCalendarEntries.php",
//         qs.stringify({
//           action: "calendar_entries",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             var calendarLastMod = {
//               calendarLastModified: data.calendarLastModified,
//             };
//             var dataIndex =
//               modifiedData &&
//               modifiedData.findIndex((arr, i) => arr.calendarLastModified);
//             modifiedData && (modifiedData[dataIndex] = calendarLastMod);

//             localStorage.setItem("calendar_entries", JSON.stringify(data.data));
//             this.setState({
//               syncModified: modifiedData,
//             });

//             this.setState({
//               ...this.state,
//               loading: false,
//             });
            
//             if (this.state.syncModified.length > 0) {
//               var loginData = JSON.parse(localStorage.getItem("login"));
//               loginData.syncLastModified = this.state.syncModified;
//               loginData.syncLastModified !== [] &&
//                 localStorage.setItem("login", JSON.stringify(loginData));
//             }

//             NotificationManager.success(
//               "Calendar Settings Successfully Updated"
//             );

//             let loginBlur = JSON.parse(localStorage.getItem("login"));

//             if (loginBlur && loginBlur.ismobiledevice != 1) {
//               document.getElementById("nav__menu__display") !== null &&
//                 (document.getElementById("nav__menu__display").style.cssText =
//                   "filter: blur(0px); pointer-events: block");
//             }
//             document.getElementById("appbar_mainapp__") !== null &&
//               (document.getElementById("appbar_mainapp__").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           } else {
//           }
//         }
//       );
//   };

//   render() {
//     const {
//       error,
//       isLoaded,
//       incomedescription,
//       settingdetail,
//       incometemplate,
//       customerName,
//       bookingTotal,
//       customerAddress,
//       petName,
//       petBreed,
//       serviceName,
//       appCalendarItems,
//       appCalendarLoading,
//       appCalendarInitialized,
//     } = this.state;

//     if (error) {
//       return <div className="jr-customers">Error: {error.message}</div>;
//     } else if (!isLoaded || (appCalendarLoading && !appCalendarInitialized)) {
//       return (
//         <div className="jr-customers">
//           <LinearProgress color="secondary" />
//         </div>
//       );
//     } else {
//       return (
//         <>
//           <div className="app-wrapper animated slideInUpTiny animation-duration-3">
//             <ContainerHeader
//               title={<IntlMessages id="sidebar.dashboard.settings" />}
//               match={this.props.match}
//             />

//             <div className="row">
//               <CardBox
//                 heading={<IntlMessages id="dashboard.settings.preferences" />}
//               >
//                 <div className="col-md-12 col-12">
//                   <List className="LawaList">
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Customer Notes on Booking" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayCustNotes")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayCustNotes") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "hideOldBookings")
//                           }
//                           checked={
//                             this.state.checked.indexOf("hideOldBookings") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Booking Clash Notifications" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayBookingClash")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayBookingClash") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Past Bookings from Calendar Search" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(
//                               event,
//                               "hidePastBookingsCalendarSearch"
//                             )
//                           }
//                           checked={
//                             this.state.checked.indexOf(
//                               "hidePastBookingsCalendarSearch"
//                             ) != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Filter Services based on pet size" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "filterBookingServices")
//                           }
//                           checked={
//                             this.state.checked.indexOf("filterBookingServices") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Booking End Time" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.display_booking_end_time === "1"}
//                           onChange={this.handleEndDate}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Address In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.addressInInvoice === 1}
//                           onChange={this.handleAddressInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Personal Phone In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.phoneInInvoice === 1}
//                           onChange={this.handlePersonalPhoneInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Toggle 24hr Time Format" />
//                       <ListItemSecondaryAction>
//                         <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
//                         <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
//                           <Switch
//                             color="primary"
//                             checked={this.state.timeFormat === 24}
//                             onChange={this.handleFormatChange}
//                           />
//                         </Tooltip>
//                         <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                   </List>
//                 </div>
//               </CardBox>

//               <div className="col-md-6">
//                 <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
//                       <div className="col-md-12 col-12">
//                         <TextField
//                           id="smsNumber"
//                           label="SMS Sender"
//                           value="0495149675"
//                           margin="normal"
//                           helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                           fullWidth
//                         />
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
                  
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={"Cancellation Policy"}>
//                       <div className="col-md-12 col-12">
//                         <span>PLEASE NOTE: 24 hours notice is required to cancel your appointment.
//                           We reserve the right to charge a cancellation fee if you are not home when we call for our confirmed appointment time.</span>
//                         <List>
//                           <ListItem>
//                             <ListItemIcon>
//                               <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
//                             </ListItemIcon>
//                             <ListItemText primary="Attach Cancellation Policy" />
//                             <ListItemSecondaryAction>
//                               <Switch
//                                 color="primary"
//                                 checked={this.state.enableCancellationPolicy === 1}
//                                 onChange={this.handleCancellationPolicyChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                         </List>
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
//                 </Grid>
//               </div>

//               <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
//                 <form className="row" noValidate autoComplete="off">
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incometemplate"
//                       name="incometemplate"
//                       label="Income Title Template"
//                       margin="normal"
//                       defaultValue={this.state.settingdetail.title}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       onChange={this.handleChange}
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incomedescription"
//                       name="incomedescription"
//                       label="Income Description"
//                       defaultValue={this.state.settingdetail.desc}
//                       margin="normal"
//                       onChange={this.handleChange}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="jr-btn btn-margin-topbottom"
//                       position="static"
//                       onClick={() => {
//                         this.handleSaveSettings();
//                       }}
//                     >
//                       Save
//                     </Button>
//                   </div>
//                 </form>
//               </CardBox>
              
//               <CardBox heading="Send Booking Reminder">
//                 {this.state.loadingConfirmation && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Do not send booking reminder" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value=""
//                             checked={this.state.selectedSetting === ""}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email and SMS for all customers" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="all"
//                             checked={this.state.selectedSetting === "all"}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email only, do not send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="emailOnly"
//                             checked={this.state.selectedSetting === 'emailOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send SMS only, do not send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="smsOnly"
//                             checked={this.state.selectedSetting === 'smsOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by email but if not found, send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedEmail"
//                             checked={this.state.selectedSetting === 'preferedEmail'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by SMS but if no mobile number, send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedSMS"
//                             checked={this.state.selectedSetting === 'preferedSMS'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
//                         <ListItemSecondaryAction>
//                           <FormControl variant="outlined" style={{ width: "100px" }}>
//                             <Select
//                               placeholder="Select Confirmation Before"
//                               name="confirmationHour"
//                               value={this.state.confirmationHour}
//                               style={{
//                                 textAlign: 'center',
//                                 paddingLeft: '0',
//                               }}
//                               inputProps={{
//                                 style: {
//                                   textAlign: 'center',
//                                 },
//                               }}
//                               onChange={(e) => this.handleChangeConfirmationHour(e)}
//                             >
//                               <MenuItem value="">
//                                 <em>Select Confirmation Before</em>
//                               </MenuItem>
//                               <MenuItem value={24}>{"24 hrs"}</MenuItem>
//                               <MenuItem value={48}>{"48 hrs"}</MenuItem>
//                               <MenuItem value={72}>{"72 hrs"}</MenuItem>
//                             </Select>
//                           </FormControl>
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       {this.state.loadingConfirmation ? (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                           disabled={true}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       )}
//                     </List>
//                   </div>
//                 </div>
//               </CardBox>

//               <CardBox heading="Calendar Settings">
//                 {this.state.loading && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Show Booking Total" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="bookingTotal"
//                             checked={bookingTotal}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerName"
//                             checked={customerName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Address" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerAddress"
//                             checked={customerAddress}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petName"
//                             checked={petName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Breed" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petBreed"
//                             checked={petBreed}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Services Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="serviceName"
//                             checked={serviceName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <div>
//                         <h5>Preview</h5>
//                       </div>
//                       {(bookingTotal ||
//                         customerName ||
//                         customerAddress ||
//                         petName || petBreed ||
//                         serviceName) && (
//                           <Card
//                             style={{
//                               padding: "20px",
//                               backgroundColor: "#3f51b5",
//                               color: "#fff",
//                               width: "400px",
//                             }}
//                           > 
//                             {bookingTotal && <div>$Total Cost</div>}
//                             {customerName && <div>Firstname Lastname</div>}
//                             {customerAddress && <div>Street Address, Suburb, Postcode</div>}
//                             {petName && <div>Pet Name</div>}
//                             {petBreed && <div>Pet Breed</div>}
//                             {serviceName && <div>Services</div>}
//                           </Card>
//                         )}
//                     </List>
//                     {this.state.loading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={true}
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={
//                           !(bookingTotal ||
//                             customerName ||
//                             customerAddress ||
//                             petName || petBreed ||
//                             serviceName)
//                         }
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>

//               {/* App Calendar Settings Section with Mobile Support */}
//               <CardBox heading="App Calendar Settings">
//                 {appCalendarLoading && (
//                   <div style={{ position: "relative", top: "15px", marginBottom: "20px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <p style={{ 
//                       marginBottom: '15px', 
//                       color: '#666', 
//                       fontSize: '0.9rem',
//                       padding: '10px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}>
//                       <i className="zmdi zmdi-menu" style={{ marginRight: '10px', fontSize: '20px' }}></i>
//                       {this.state.isTouchDevice ? (
//                         <span>Long press and drag the ⋮⋮ icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       ) : (
//                         <span>Drag the ⋮⋮ icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       )}
//                     </p>

//                     <List className="LawaList">
//                       {appCalendarItems.map((item, index) => (
//                         <ListItem
//                           key={item.id}
//                           className="app-calendar-item"
//                           draggable={!this.state.isTouchDevice}
//                           onDragStart={(e) => this.handleDragStart(e, index)}
//                           onDragOver={(e) => this.handleDragOver(e, index)}
//                           onDrop={(e) => this.handleDrop(e, index)}
//                           onDragEnd={this.handleDragEnd}
//                           onTouchStart={(e) => this.handleTouchStart(e, index)}
//                           onTouchMove={this.handleTouchMove}
//                           onTouchEnd={this.handleTouchEnd}
//                           onTouchCancel={this.handleTouchCancel}
//                           style={{
//                             cursor: this.state.isTouchDevice ? 'default' : 'grab',
//                             border: '1px solid transparent',
//                             transition: 'all 0.2s',
//                             backgroundColor: this.state.draggedItem === index ? '#f5f5f5' : 'transparent',
//                             WebkitTapHighlightColor: 'transparent',
//                           }}
//                         >
//                           <ListItemIcon 
//                             className="drag-handle"
//                             style={{ 
//                               cursor: this.state.isTouchDevice ? 'pointer' : 'grab', 
//                               minWidth: '40px',
//                               padding: this.state.isTouchDevice ? '10px 5px' : '0',
//                             }}
//                           >
//                             <i className="zmdi zmdi-menu" style={{ fontSize: '20px', color: '#999' }}></i>
//                           </ListItemIcon>
//                           <ListItemIcon>
//                             <i className={`zmdi ${item.icon} zmdi-hc-fw zmdi-hc-2x`} />
//                           </ListItemIcon>
//                           <ListItemText primary={item.label} />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               checked={item.enabled}
//                               onChange={() => this.handleAppCalendarToggle(item.id)}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                       ))}
//                     </List>

//                     {/* Preview Section */}
//                     <div style={{ marginTop: '20px' }}>
//                       <h5>Preview </h5>
//                       {appCalendarItems.some(item => item.enabled) ? (
//                         <Card
//                           style={{
//                             padding: "20px",
//                             backgroundColor: "#3f51b5",
//                             color: "#fff",
//                             width: "100%",
//                             maxWidth: "400px",
//                           }}
//                         >
//                           {appCalendarItems
//                             .filter(item => item.enabled)
//                             .map(item => {
//                               switch(item.apiKey) {
//                                 case 'time':
//                                   return <div key={item.id}>10:30 AM</div>;
//                                 case 'cost':
//                                   return <div key={item.id}>Service Cost</div>;
//                                 case 'name':
//                                   return <div key={item.id}>Customer Name</div>;
//                                 case 'address':
//                                   return <div key={item.id}>123 Main St, Sydney 2000</div>;
//                                 case 'petName':
//                                   return <div key={item.id}>Pet Name</div>;
//                                 case 'petBreed':
//                                   return <div key={item.id}>Pet Breed</div>;
//                                 case 'serviceName':
//                                   return <div key={item.id}>Full Grooming</div>;
//                                 default:
//                                   return null;
//                               }
//                             })}
//                         </Card>
//                       ) : (
//                         <p style={{ color: '#999', fontStyle: 'italic' }}>Toggle on items to see preview</p>
//                       )}
//                     </div>

//                     {appCalendarLoading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         disabled={true}
//                       >
//                         Updating...
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         onClick={this.handleAppCalendarSubmit}
//                       >
//                         Update App Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>
//             </div>
//           </div>
//           <NotificationContainer />
//         </>
//       );
//     }
//   }
// }

// export default Settings;

// **********************************************************************************************************
// import React from "react";
// import ContainerHeader from "components/ContainerHeader/index";
// import CardBox from "components/CardBox/index";
// import CardBoxNew from "components/CardBoxNew/index";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import "../../../../src/assets/vendors/react-notification/react-notifications.css"
// import { httpClient } from "appUtility/Api";
// import IntlMessages from "util/IntlMessages";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
// import Switch from "@material-ui/core/Switch";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import featureServer from "../../../appUtility/featureServer";
// import { FormControl, Grid, MenuItem, Radio, Select, Tooltip, RadioGroup, FormControlLabel, Divider, FormLabel } from "@material-ui/core";
// import configureStore from "../../../store";

// const loginOBJ = localStorage.getItem("login");
// const logindetail = JSON.parse(loginOBJ);
// var modifiedData = logindetail && logindetail.syncLastModified;
// const qs = require("qs");

// var param, settingdetail;

// class Settings extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       error: null,
//       isLoaded: false,
//       id: "",
//       incometemplate: "",
//       incomedescription: "",
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       mcode: logindetail && logindetail.mCode,
//       settingdetail: "",
//       checked: [],
//       customerName: false,
//       bookingTotal: false,
//       customerAddress: false,
//       petName: false,
//       petBreed: false,
//       serviceName: false,
//       syncModified: "",
//       loading: false,
//       display_booking_end_time: logindetail && logindetail.display_booking_end_time,
//       timeFormat: logindetail && logindetail.timeFormat,
//       addressInInvoice: logindetail && logindetail.addressInInvoice,
//       phoneInInvoice: logindetail && logindetail.phoneInInvoice,
//       enableCancellationPolicy: logindetail && logindetail.enableCancellationPolicy,
//       selectedSetting: "",
//       confirmationHour: 24,
//       loadingConfirmation: false,
      
//       // New state for policies
//       policies: [],
//       policiesLoading: false,
//       selectedPolicyId: logindetail && logindetail.enableCancellationPolicy ? logindetail.enableCancellationPolicy : "",
//       savingPolicy: false,
      
//       // App Calendar Settings with all possible items (time instead of date)
//       appCalendarItems: [
//         { id: 'appTime', label: 'Show Time', icon: 'zmdi-time', enabled: false, apiKey: 'time' },
//         { id: 'appBookingTotal', label: 'Show Booking Total', icon: 'zmdi-money', enabled: false, apiKey: 'cost' },
//         { id: 'appCustomerName', label: 'Show Customer Name', icon: 'zmdi-account', enabled: false, apiKey: 'name' },
//         { id: 'appCustomerAddress', label: 'Show Customer Address', icon: 'zmdi-pin', enabled: false, apiKey: 'address' },
//         { id: 'appPetName', label: 'Show Pet Name', icon: 'zmdi-face', enabled: false, apiKey: 'petName' },
//         { id: 'appPetBreed', label: 'Show Pet Breed', icon: 'zmdi-label', enabled: false, apiKey: 'petBreed' },
//         { id: 'appServiceName', label: 'Show Services Name', icon: 'zmdi-cut', enabled: false, apiKey: 'serviceName' },
//       ],
//       appCalendarLoading: false,
//       draggedItem: null,
//       appCalendarInitialized: false,
      
//       // Mobile touch states
//       isTouchDevice: false,
//       touchStartY: 0,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartTime: 0,
//     };

//     this.handleChange = this.handleChange.bind(this);
//     this.handleAppCalendarToggle = this.handleAppCalendarToggle.bind(this);
//     this.handleAppCalendarSubmit = this.handleAppCalendarSubmit.bind(this);
    
//     // Desktop drag handlers
//     this.handleDragStart = this.handleDragStart.bind(this);
//     this.handleDragOver = this.handleDragOver.bind(this);
//     this.handleDrop = this.handleDrop.bind(this);
//     this.handleDragEnd = this.handleDragEnd.bind(this);
    
//     // Mobile touch handlers
//     this.handleTouchStart = this.handleTouchStart.bind(this);
//     this.handleTouchMove = this.handleTouchMove.bind(this);
//     this.handleTouchEnd = this.handleTouchEnd.bind(this);
//     this.handleTouchCancel = this.handleTouchCancel.bind(this);
    
//     // Policy handlers
//     this.fetchPolicies = this.fetchPolicies.bind(this);
//     this.handlePolicyChange = this.handlePolicyChange.bind(this);
//     this.handleSavePolicy = this.handleSavePolicy.bind(this);
//   }

//   componentDidMount() {
//     // Detect touch device
//     this.setState({
//       isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
//     });

//     // Prevent default touch behaviors on draggable items
//     document.addEventListener('touchmove', this.preventTouchScroll, { passive: false });
    
//     var aid, cid, uid;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail && logindetail.uid;

//     param = aid + "_" + cid + "_" + uid;

//     // Fetch member settings
//     httpClient
//       .post(
//         "getMemberSettings.php",
//         qs.stringify({
//           action: "member_settings",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             localStorage.setItem("settings", JSON.stringify(data));
//             this.setState(
//               {
//                 isLoaded: false,
//                 id: data.id,
//                 settingdetail: data,
//                 checked: data.flags,
//                 petName: data.pet_name == "1" ? true : false,
//                 petBreed: data.pet_breed == "1" ? true : false,
//                 serviceName: data.services_name == "1" ? true : false,
//                 customerName: data.customer_name == "1" ? true : false,
//                 bookingTotal: data.bookingCost == "1" ? true : false,
//                 customerAddress: data.customer_address == "1" ? true : false,
//                 confirmationHour: parseInt(data.confirmationHour),
//                 selectedSetting: data.confirmationBy,
//               },
//               function () {
//                 this.setState({
//                   isLoaded: true,
//                 });
//               }
//             );
//           } else {
//           }
//         },
//         (error) => {
//           this.setState({
//             isLoaded: true,
//             error,
//           });
//         }
//       );

//     const loginValue = JSON.parse(localStorage.getItem("login"));
//     this.setState({
//       ...this.state,
//       display_booking_end_time: loginValue.display_booking_end_time,
//       timeFormat: loginValue.timeFormat,
//       addressInInvoice: loginValue.addressInInvoice,
//       phoneInInvoice: loginValue.phoneInInvoice,
//       enableCancellationPolicy: loginValue.enableCancellationPolicy,
//       selectedPolicyId: loginValue.enableCancellationPolicy ? loginValue.enableCancellationPolicy : "",
//     });

//     // Fetch policies
//     this.fetchPolicies();

//     // Fetch App Calendar Settings (no notification on page load)
//     this.fetchAppCalendarSettings(false);

//     // Add CSS for mobile
//     this.addMobileStyles();
//   }

//   componentWillUnmount() {
//     document.removeEventListener('touchmove', this.preventTouchScroll);
//   }

//   // Fetch policies from API
//   fetchPolicies = () => {
//     this.setState({ policiesLoading: true });

//     const apiToken = logindetail && logindetail.memtoken ? logindetail.memtoken : "";

//     const formData = new FormData();
//     formData.append('action', 'getPolicies');
//     formData.append('api_token', apiToken);
//     formData.append('source[appID]', this.state.appID);
//     formData.append('source[memberID]', this.state.memberID);
//     formData.append('source[companyID]', this.state.companyID);

//     httpClient
//       .post("/v2/getPolicies.php", formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       })
//       .then((response) => {
//         if (response.data.success && response.data.data) {
//           this.setState({ 
//             policies: response.data.data,
//             policiesLoading: false,
//           });
//         } else {
//           this.setState({ policiesLoading: false });
//           NotificationManager.info("Failed to load policies");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching policies:", error);
//         this.setState({ policiesLoading: false });
//         NotificationManager.info("Error loading policies");
//       });
//   };

//   // Handle policy radio change
//   handlePolicyChange = (event) => {
//     this.setState({ selectedPolicyId: event.target.value });
//   };

//   // Save selected policy
//   handleSavePolicy = () => {
//     if (!this.state.selectedPolicyId) {
//       NotificationManager.info("Please select a policy");
//       return;
//     }

//     this.setState({ savingPolicy: true });

//     const source = `${this.state.appID}_${this.state.companyID}_${this.state.memberID}_enableCancellationPolicy`;

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: source,
//           enableCancellationPolicy: this.state.selectedPolicyId, // Send policy ID as the value
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));
          
//           // Update login data with the selected policy ID
//           loginData.enableCancellationPolicy = this.state.selectedPolicyId;
          
//           this.setState({
//             enableCancellationPolicy: this.state.selectedPolicyId,
//             savingPolicy: false
//           });
          
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.success("Policy saved successfully");
//         } else {
//           this.setState({ savingPolicy: false });
//           NotificationManager.info(data.msg || "Failed to save policy");
//         }
//       })
//       .catch((error) => {
//         console.error("Error saving policy:", error);
//         this.setState({ savingPolicy: false });
//         NotificationManager.info("Error saving policy");
//       });
//   };

//   fetchAppCalendarSettings = (showNotification = false) => {
//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//      const loginData = JSON.parse(localStorage.getItem("login"));
//   const apiToken = loginData && loginData.memtoken ? loginData.memtoken : "";

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "getSettings",
//           api_token: apiToken,
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           // data.data contains array of enabled settings in order e.g., ["time", "cost", "name", ...]
//           const enabledSettings = data.data || [];
          
//           // Create a map of apiKey to enabled status and order
//           const settingsMap = {};
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const key = enabledSettings[i];
//             settingsMap[key] = { enabled: true, order: i };
//           }

//           // Create a new array with items in the exact order from API response
//           const orderedItems = [];
          
//           // First, add enabled items in the order they appear in API response
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const apiKey = enabledSettings[i];
//             // Find the matching item in appCalendarItems
//             for (let j = 0; j < this.state.appCalendarItems.length; j++) {
//               const item = this.state.appCalendarItems[j];
//               if (item.apiKey === apiKey) {
//                 orderedItems.push({
//                   ...item,
//                   enabled: true
//                 });
//                 break;
//               }
//             }
//           }
          
//           // Then, add disabled items that are not in the API response
//           for (let i = 0; i < this.state.appCalendarItems.length; i++) {
//             const item = this.state.appCalendarItems[i];
//             if (!settingsMap.hasOwnProperty(item.apiKey)) {
//               orderedItems.push({
//                 ...item,
//                 enabled: false
//               });
//             }
//           }

//           this.setState({ 
//             appCalendarItems: orderedItems,
//             appCalendarLoading: false,
//             appCalendarInitialized: true
//           });

//           // Only show notification if explicitly requested (not on page load)
//           if (showNotification) {
//             NotificationManager.success(data.message || "Calendar settings loaded");
//           }
//         } else {
//           if (showNotification) {
//             NotificationManager.info(data.message || "Failed to load calendar settings");
//           }
//           this.setState({ appCalendarLoading: false });
//         }
//       })
//       .catch(error => {
//         console.error("Error fetching app calendar settings:", error);
//         if (showNotification) {
//           NotificationManager.info("Error loading calendar settings");
//         }
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   addMobileStyles = () => {
//     const style = document.createElement('style');
//     style.innerHTML = `
//       .app-calendar-item {
//         -webkit-touch-callout: none;
//         -webkit-user-select: none;
//         user-select: none;
//         touch-action: pan-y;
//         transition: all 0.2s ease;
//       }
//       .app-calendar-item.dragging {
//         opacity: 0.7 !important;
//         transform: scale(1.02) !important;
//         box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
//         z-index: 9999 !important;
//         background-color: #f5f5f5 !important;
//       }
//       .app-calendar-item.drag-over {
//         border: 2px dashed #3f51b5 !important;
//         background-color: #e8eaf6 !important;
//         opacity: 0.8;
//         transform: scale(1.01);
//       }
//       .app-calendar-item:active {
//         background-color: #f0f0f0;
//       }
//       @media (max-width: 768px) {
//         .app-calendar-item {
//           cursor: default !important;
//         }
//         .app-calendar-item .drag-handle {
//           padding: 10px 5px;
//         }
//       }
//     `;
//     document.head.appendChild(style);
//   };

//   preventTouchScroll = (e) => {
//     if (this.state.touchDraggedItem !== null) {
//       e.preventDefault();
//     }
//   };

//   // Desktop Drag Handlers
//   handleDragStart = (event, index) => {
//     if (this.state.isTouchDevice) return; // Skip on touch devices
    
//     event.dataTransfer.setData('text/plain', index.toString());
//     event.dataTransfer.effectAllowed = 'move';
//     this.setState({ draggedItem: index });
//     event.currentTarget.style.opacity = '0.5';
//     event.currentTarget.style.backgroundColor = '#f0f0f0';
//   };

//   handleDragOver = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
//     event.dataTransfer.dropEffect = 'move';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (event.currentTarget) {
//       event.currentTarget.classList.add('drag-over');
//     }
//   };

//   handleDrop = (event, targetIndex) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     const sourceIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
//     if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;
    
//     const newItems = [...this.state.appCalendarItems];
//     const [movedItem] = newItems.splice(sourceIndex, 1);
//     newItems.splice(targetIndex, 0, movedItem);
    
//     this.setState({ 
//       appCalendarItems: newItems,
//       draggedItem: null 
//     });
//   };

//   handleDragEnd = (event) => {
//     if (this.state.isTouchDevice) return;
    
//     event.currentTarget.style.opacity = '1';
//     event.currentTarget.style.backgroundColor = '';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     this.setState({ draggedItem: null });
//   };

//   // Mobile Touch Handlers
//   handleTouchStart = (e, index) => {
//     e.preventDefault();
    
//     const touch = e.touches[0];
//     const target = e.currentTarget;
    
//     // Long press detection (300ms)
//     this.touchStartTimeout = setTimeout(() => {
//       this.setState({
//         touchStartY: touch.clientY,
//         touchStartX: touch.clientX,
//         touchDraggedItem: index,
//         touchDraggedIndex: index,
//         draggedItem: index
//       });

//       // Add dragging class
//       target.classList.add('dragging');
      
//       // Vibrate if supported (haptic feedback)
//       if (window.navigator.vibrate) {
//         window.navigator.vibrate(50);
//       }
//     }, 300);
    
//     this.setState({ touchStartTime: Date.now() });
//   };

//   handleTouchMove = (e) => {
//     e.preventDefault();
    
//     const { touchDraggedItem, touchStartY } = this.state;
//     if (touchDraggedItem === null) {
//       clearTimeout(this.touchStartTimeout);
//       return;
//     }

//     const touch = e.touches[0];
//     const currentY = touch.clientY;
//     const deltaY = currentY - touchStartY;

//     // Find which item we're hovering over
//     const items = document.querySelectorAll('.app-calendar-item');
//     let targetIndex = touchDraggedItem;
    
//     items.forEach((item, idx) => {
//       const rect = item.getBoundingClientRect();
//       if (currentY >= rect.top && currentY <= rect.bottom) {
//         targetIndex = idx;
//       }
//     });

//     // Show drop target indicator
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (items[targetIndex] && targetIndex !== touchDraggedItem) {
//       items[targetIndex].classList.add('drag-over');
      
//       // Auto-scroll if near edges
//       const container = document.querySelector('.LawaList');
//       if (container) {
//         const containerRect = container.getBoundingClientRect();
//         const scrollSpeed = 10;
        
//         if (currentY < containerRect.top + 50) {
//           container.scrollTop -= scrollSpeed;
//         } else if (currentY > containerRect.bottom - 50) {
//           container.scrollTop += scrollSpeed;
//         }
//       }
//     }

//     // Move the dragged item visually
//     const draggedItem = items[touchDraggedItem];
//     if (draggedItem && Math.abs(deltaY) > 10) {
//       draggedItem.style.transform = `translateY(${deltaY}px) scale(1.02)`;
//     }

//     this.setState({ touchDraggedIndex: targetIndex });
//   };

//   handleTouchEnd = (e) => {
//     e.preventDefault();
//     clearTimeout(this.touchStartTimeout);
    
//     const { touchDraggedItem, touchDraggedIndex } = this.state;
    
//     if (touchDraggedItem !== null && touchDraggedIndex !== -1) {
//       // Reorder if dropped on different item
//       if (touchDraggedIndex !== touchDraggedItem) {
//         const newItems = [...this.state.appCalendarItems];
//         const [movedItem] = newItems.splice(touchDraggedItem, 1);
//         newItems.splice(touchDraggedIndex, 0, movedItem);
        
//         this.setState({ appCalendarItems: newItems });
//       }
//     }

//     // Reset all visual states
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.transform = '';
//       item.style.backgroundColor = '';
//       item.classList.remove('dragging', 'drag-over');
//     });

//     this.setState({ 
//       draggedItem: null,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartY: 0
//     });
//   };

//   handleTouchCancel = (e) => {
//     this.handleTouchEnd(e);
//   };

//   // Toggle handler for App Calendar items
//   handleAppCalendarToggle = (itemId) => {
//     const updatedItems = this.state.appCalendarItems.map(item => {
//       if (item.id === itemId) {
//         return { ...item, enabled: !item.enabled };
//       }
//       return item;
//     });

//     this.setState({ appCalendarItems: updatedItems });
//   };

//   // Submit handler for App Calendar settings - SAVE API
//   handleAppCalendarSubmit = (e) => {
//     e.preventDefault();

//     // Get enabled items in current order
//     const enabledItems = this.state.appCalendarItems
//       .filter(item => item.enabled)
//       .map(item => item.apiKey); // Send apiKey to backend

//     // Apply blur effect
//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const apiToken = "bBB9nUASjh2LPJBSkbL3vq8CfGfjJZ_20220907022941_3_1_T5M2AWH4pauGifUkkIYq";

//     // Create source object with the correct structure: source[appID], source[memberID], source[companyID], source[settings][0], etc.
//     const sourceData = {
//       appID: parameters.appID,
//       memberID: parameters.memberID,
//       companyID: parameters.companyID,
//     };

//     // Add settings as source[settings][0], source[settings][1], etc.
//     // This creates the structure: { appID:1, memberID:3, companyID:4, settings:{0:"time",1:"cost",2:"name"} }
//     const settingsObj = {};
//     for (let i = 0; i < enabledItems.length; i++) {
//       settingsObj[i] = enabledItems[i];
//     }
//     sourceData.settings = settingsObj;

//     console.log("App Calendar Settings to save:", {
//       action: "saveSettings",
//       api_token: apiToken,
//       source: sourceData
//     });

//     // API Call to save settings
//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "saveSettings",
//           api_token: apiToken,
//           source: sourceData,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           // Show only one success notification
//           NotificationManager.success(data.message || "App Calendar Settings Updated Successfully");
          
//           // Refresh the settings to get the latest from server (with notification false)
//           this.fetchAppCalendarSettings(false);
//         } else {
//           NotificationManager.info(data.message || "Failed to update settings");
//           this.setState({ appCalendarLoading: false });
          
//           // Remove blur effect on error
//           if (loginBlur && loginBlur.ismobiledevice != 1) {
//             document.getElementById("nav__menu__display") !== null &&
//               (document.getElementById("nav__menu__display").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           }
//           document.getElementById("appbar_mainapp__") !== null &&
//             (document.getElementById("appbar_mainapp__").style.cssText =
//               "filter: blur(0px); pointer-events: block");
//         }
//       })
//       .catch(error => {
//         console.error("Error saving app calendar settings:", error);
//         NotificationManager.info("Error updating app calendar settings");
        
//         // Remove blur effect
//         if (loginBlur && loginBlur.ismobiledevice != 1) {
//           document.getElementById("nav__menu__display") !== null &&
//             (document.getElementById("nav__menu__display").style.cssText =
//               "filter: blur(0px); pointer-events: block");
//         }
//         document.getElementById("appbar_mainapp__") !== null &&
//           (document.getElementById("appbar_mainapp__").style.cssText =
//             "filter: blur(0px); pointer-events: block");
        
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   handleEndDate = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       display_booking_end_time: checked ? "1" : "0"
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       display_booking_end_time: checked ? "1" : "0"
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_display_end_time",
//           source: dateVals,
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.display_booking_end_time = this.state.display_booking_end_time;

//           this.setState({
//             ...this.setState,
//             display_booking_end_time: loginData.display_booking_end_time
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleFormatChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       timeFormat: checked ? 24 : 12
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       timeFormat: checked ? 24 : 12
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "timeFormat",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',
//           timeFormat: dateVals.timeFormat
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.timeFormat = this.state.timeFormat;
//           this.setState({
//             ...this.state,
//             timeFormat: loginData.timeFormat
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleAddressInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       addressInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       addressInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "addressInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',
//           addressInInvoice: dateVals.addressInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.addressInInvoice = this.state.addressInInvoice;
//           this.setState({
//             ...this.state,
//             addressInInvoice: loginData.addressInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handlePersonalPhoneInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       phoneInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       phoneInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "phoneInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',
//           phoneInInvoice: dateVals.phoneInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.phoneInInvoice = this.state.phoneInInvoice;
//           this.setState({
//             ...this.state,
//             phoneInInvoice: loginData.phoneInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   // Original cancellation policy toggle - completely unchanged
//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       enableCancellationPolicy: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       enableCancellationPolicy: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//           enableCancellationPolicy: dateVals.enableCancellationPolicy
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.enableCancellationPolicy = this.state.enableCancellationPolicy;
//           this.setState({
//             ...this.state,
//             enableCancellationPolicy: loginData.enableCancellationPolicy
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleToggle = (event, value) => {
//     var settingParam;
//     var aid, cid, uid;
//     var btntype;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail.uid;
//     btntype = value;

//     const { checked } = this.state;
//     const currentIndex = checked.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex == -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     this.setState({
//       checked: newChecked,
//     });

//     settingParam = aid + "_" + cid + "_" + uid + "_" + value;

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: btntype,
//           source: settingParam,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data.success != "true") {
//             NotificationManager.info(data.failedMSG);
//           } else if (data.success == "true") {
//             var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
//             var objname = data.actionOn;

//             if (objname == "displayCustNotes")
//               loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

//             if (objname == "hideOldRecurring")
//               loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

//             if (objname == "displayBookingClash")
//               loginTempOBJ.displayBookingClash =
//                 1 - loginTempOBJ.displayBookingClash;

//             if (objname == "hidePastBookingsCalendarSearch")
//               loginTempOBJ.hidePastBookingsCalendarSearch =
//                 1 - loginTempOBJ.hidePastBookingsCalendarSearch;

//             if (objname == "filterBookingServices") {
//               loginTempOBJ.filterBookingServices =
//                 1 - loginTempOBJ.filterBookingServices;
//             }

//             localStorage.setItem("login", JSON.stringify(loginTempOBJ));
//             NotificationManager.info(data.msg);
//           }
//         },
//         (error) => {
//           this.setState({
//             error,
//           });
//         }
//       );
//   };

//   handleCalendarChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//   };

//   handleBookingConfirmationChange = (event) => {
//     this.setState({ selectedSetting: event.target.value });
//   };

//   handleChangeConfirmationHour = (e) => {
//     this.setState({
//       confirmationHour: e.target.value,
//     });
//   };

//   handleSaveSettings() {
//     if (this.state.incometemplate == "" && this.state.incomedescription == "") {
//       NotificationManager.info("Nothing changed to save");
//     } else {
//       httpClient
//         .post(
//           "saveMemberSettings.php",
//           qs.stringify({
//             action: "save_settings",
//             source: this.state,
//           })
//         )
//         .then(
//           ({ data }) => {
//             if (data.success != "true") {
//               NotificationManager.info(data.failedMSG);
//             } else {
//               NotificationManager.info(data.successMSG);
//               this.setState({
//                 incometemplate: "",
//                 incomedescription: "",
//               });
//             }
//           },
//           (error) => {
//             NotificationManager.info(
//               "Error Occured: Refresh the page and try again"
//             );
//           }
//         );
//     }
//   }

//   handleChange(evt) {
//     this.setState({ [evt.target.name]: evt.target.value });
//   }

//   handleSubmitCalendar = (e) => {
//     e.preventDefault();

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({
//       ...this.state,
//       loading: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       customer_name: this.state.customerName,
//       bookingCost: this.state.bookingTotal,
//       customer_address: this.state.customerAddress,
//       pet_name: this.state.petName,
//       pet_breed: this.state.petBreed,
//       services_name: this.state.serviceName,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_calendar_settings",
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           NotificationManager.success(data.successMSG);
//           let calendarData = [];
//           let calendarStorage = JSON.parse(localStorage.getItem("settings"));

//           calendarData = {
//             ...calendarStorage,
//             customer_name: data.customer_name,
//             bookingCost: data.bookingCost,
//             pet_name: data.pet_name,
//             services_name: data.services_name,
//             customer_address: data.customer_address,
//           };

//           const cal = { ...calendarData };

//           localStorage.setItem("settings", JSON.stringify(cal));

//           setTimeout(() => {
//             NotificationManager.info("Retrieving Calendar Entries");
//           }, 1000);

//           this.getCalendarEntry();
//         } else {
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   handleSubmitConfirmation = (e) => {
//     e.preventDefault();

//     this.setState({
//       ...this.state,
//       loadingConfirmation: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "bookingConfirmation",
//           source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
//           confirmationBy: this.state.selectedSetting,
//           confirmationHour: this.state.confirmationHour,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: data.data.confirmationBy,
//             confirmationHour: parseInt(data.data.confirmationHour),
//           });
//           NotificationManager.success(data.msg);
//         } else {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: "",
//             confirmationHour: "",
//           });
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   getCalendarEntry = () => {
//     httpClient
//       .post(
//         "getCalendarEntries.php",
//         qs.stringify({
//           action: "calendar_entries",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             var calendarLastMod = {
//               calendarLastModified: data.calendarLastModified,
//             };
//             var dataIndex =
//               modifiedData &&
//               modifiedData.findIndex((arr, i) => arr.calendarLastModified);
//             modifiedData && (modifiedData[dataIndex] = calendarLastMod);

//             localStorage.setItem("calendar_entries", JSON.stringify(data.data));
//             this.setState({
//               syncModified: modifiedData,
//             });

//             this.setState({
//               ...this.state,
//               loading: false,
//             });
            
//             if (this.state.syncModified.length > 0) {
//               var loginData = JSON.parse(localStorage.getItem("login"));
//               loginData.syncLastModified = this.state.syncModified;
//               loginData.syncLastModified !== [] &&
//                 localStorage.setItem("login", JSON.stringify(loginData));
//             }

//             NotificationManager.success(
//               "Calendar Settings Successfully Updated"
//             );

//             let loginBlur = JSON.parse(localStorage.getItem("login"));

//             if (loginBlur && loginBlur.ismobiledevice != 1) {
//               document.getElementById("nav__menu__display") !== null &&
//                 (document.getElementById("nav__menu__display").style.cssText =
//                   "filter: blur(0px); pointer-events: block");
//             }
//             document.getElementById("appbar_mainapp__") !== null &&
//               (document.getElementById("appbar_mainapp__").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           } else {
//           }
//         }
//       );
//   };

//   render() {
//     const {
//       error,
//       isLoaded,
//       incomedescription,
//       settingdetail,
//       incometemplate,
//       customerName,
//       bookingTotal,
//       customerAddress,
//       petName,
//       petBreed,
//       serviceName,
//       appCalendarItems,
//       appCalendarLoading,
//       appCalendarInitialized,
//       policies,
//       policiesLoading,
//       selectedPolicyId,
//       savingPolicy,
//       enableCancellationPolicy,
//     } = this.state;

//     if (error) {
//       return <div className="jr-customers">Error: {error.message}</div>;
//     } else if (!isLoaded || (appCalendarLoading && !appCalendarInitialized)) {
//       return (
//         <div className="jr-customers">
//           <LinearProgress color="secondary" />
//         </div>
//       );
//     } else {
//       return (
//         <>
//           <div className="app-wrapper animated slideInUpTiny animation-duration-3">
//             <ContainerHeader
//               title={<IntlMessages id="sidebar.dashboard.settings" />}
//               match={this.props.match}
//             />

//             <div className="row">
//               <CardBox
//                 heading={<IntlMessages id="dashboard.settings.preferences" />}
//               >
//                 <div className="col-md-12 col-12">
//                   <List className="LawaList">
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Customer Notes on Booking" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayCustNotes")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayCustNotes") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "hideOldBookings")
//                           }
//                           checked={
//                             this.state.checked.indexOf("hideOldBookings") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Booking Clash Notifications" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayBookingClash")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayBookingClash") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Past Bookings from Calendar Search" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(
//                               event,
//                               "hidePastBookingsCalendarSearch"
//                             )
//                           }
//                           checked={
//                             this.state.checked.indexOf(
//                               "hidePastBookingsCalendarSearch"
//                             ) != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Filter Services based on pet size" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "filterBookingServices")
//                           }
//                           checked={
//                             this.state.checked.indexOf("filterBookingServices") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Booking End Time" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.display_booking_end_time === "1"}
//                           onChange={this.handleEndDate}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Address In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.addressInInvoice === 1}
//                           onChange={this.handleAddressInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Personal Phone In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.phoneInInvoice === 1}
//                           onChange={this.handlePersonalPhoneInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Toggle 24hr Time Format" />
//                       <ListItemSecondaryAction>
//                         <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
//                         <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
//                           <Switch
//                             color="primary"
//                             checked={this.state.timeFormat === 24}
//                             onChange={this.handleFormatChange}
//                           />
//                         </Tooltip>
//                         <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                   </List>
//                 </div>
//               </CardBox>

//               <div className="col-md-6">
//                 <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
//                       <div className="col-md-12 col-12">
//                         <TextField
//                           id="smsNumber"
//                           label="SMS Sender"
//                           value="0495149675"
//                           margin="normal"
//                           helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                           fullWidth
//                         />
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
                  
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={"Cancellation Policy"}>
//                       <div className="col-md-12 col-12">
//                         {/* Original static policy text */}
//                         <span>PLEASE NOTE: 24 hours notice is required to cancel your appointment.
//                           We reserve the right to charge a cancellation fee if you are not home when we call for our confirmed appointment time.</span>
                        
//                         {/* Original toggle - completely unchanged */}
//                         <List>
//                           <ListItem>
//                             <ListItemIcon>
//                               <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
//                             </ListItemIcon>
//                             <ListItemText primary="Attach Cancellation Policy" />
//                             <ListItemSecondaryAction>
//                               <Switch
//                                 color="primary"
//                                 checked={this.state.enableCancellationPolicy === 1}
//                                 onChange={this.handleCancellationPolicyChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                         </List>

//                         {/* New policy selection section - only visible when toggle is ON */}
//                         {enableCancellationPolicy === 1 && (
//                           <>
//                             <Divider style={{ margin: '15px 0' }} />
//                             <FormLabel component="legend" style={{ marginBottom: '10px', marginLeft: '15px' }}>
//                               Select Policy
//                             </FormLabel>
//                             {policiesLoading ? (
//                               <LinearProgress color="secondary" />
//                             ) : (
//                               <>
//                                 <FormControl component="fieldset" fullWidth>
//                                   <RadioGroup
//                                     name="policies-radio-group"
//                                     value={selectedPolicyId}
//                                     onChange={this.handlePolicyChange}
//                                   >
//                                     {policies.map((policy) => (
//                                       <FormControlLabel
//                                         key={policy.policyID}
//                                         value={policy.policyID}
//                                         control={<Radio color="primary" />}
//                                         label={
//                                           <span 
//                                             dangerouslySetInnerHTML={{ __html: policy.policy }}
//                                             style={{ fontSize: '0.9rem' }}
//                                           />
//                                         }
//                                         style={{
//                                           marginBottom: '10px',
//                                           alignItems: 'flex-start',
//                                         }}
//                                       />
//                                     ))}
//                                   </RadioGroup>
//                                 </FormControl>
                                
//                                 <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
//                                   {savingPolicy ? (
//                                     <Button
//                                       variant="contained"
//                                       color="primary"
//                                       disabled={true}
//                                     >
//                                       Saving...
//                                     </Button>
//                                   ) : (
//                                     <Button
//                                       variant="contained"
//                                       color="primary"
//                                       onClick={this.handleSavePolicy}
//                                       disabled={!selectedPolicyId}
//                                     >
//                                       Save Policy Selection
//                                     </Button>
//                                   )}
//                                 </div>
//                               </>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
//                 </Grid>
//               </div>

//               <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
//                 <form className="row" noValidate autoComplete="off">
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incometemplate"
//                       name="incometemplate"
//                       label="Income Title Template"
//                       margin="normal"
//                       defaultValue={this.state.settingdetail.title}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       onChange={this.handleChange}
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incomedescription"
//                       name="incomedescription"
//                       label="Income Description"
//                       defaultValue={this.state.settingdetail.desc}
//                       margin="normal"
//                       onChange={this.handleChange}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="jr-btn btn-margin-topbottom"
//                       position="static"
//                       onClick={() => {
//                         this.handleSaveSettings();
//                       }}
//                     >
//                       Save
//                     </Button>
//                   </div>
//                 </form>
//               </CardBox>
              
//               <CardBox heading="Send Booking Reminder">
//                 {this.state.loadingConfirmation && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Do not send booking reminder" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value=""
//                             checked={this.state.selectedSetting === ""}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email and SMS for all customers" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="all"
//                             checked={this.state.selectedSetting === "all"}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email only, do not send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="emailOnly"
//                             checked={this.state.selectedSetting === 'emailOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send SMS only, do not send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="smsOnly"
//                             checked={this.state.selectedSetting === 'smsOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by email but if not found, send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedEmail"
//                             checked={this.state.selectedSetting === 'preferedEmail'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by SMS but if no mobile number, send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedSMS"
//                             checked={this.state.selectedSetting === 'preferedSMS'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
//                         <ListItemSecondaryAction>
//                           <FormControl variant="outlined" style={{ width: "100px" }}>
//                             <Select
//                               placeholder="Select Confirmation Before"
//                               name="confirmationHour"
//                               value={this.state.confirmationHour}
//                               style={{
//                                 textAlign: 'center',
//                                 paddingLeft: '0',
//                               }}
//                               inputProps={{
//                                 style: {
//                                   textAlign: 'center',
//                                 },
//                               }}
//                               onChange={(e) => this.handleChangeConfirmationHour(e)}
//                             >
//                               <MenuItem value="">
//                                 <em>Select Confirmation Before</em>
//                               </MenuItem>
//                               <MenuItem value={24}>{"24 hrs"}</MenuItem>
//                               <MenuItem value={48}>{"48 hrs"}</MenuItem>
//                               <MenuItem value={72}>{"72 hrs"}</MenuItem>
//                             </Select>
//                           </FormControl>
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       {this.state.loadingConfirmation ? (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                           disabled={true}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       )}
//                     </List>
//                   </div>
//                 </div>
//               </CardBox>

//               <CardBox heading="Calendar Settings">
//                 {this.state.loading && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Show Booking Total" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="bookingTotal"
//                             checked={bookingTotal}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerName"
//                             checked={customerName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Address" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerAddress"
//                             checked={customerAddress}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petName"
//                             checked={petName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Breed" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petBreed"
//                             checked={petBreed}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Services Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="serviceName"
//                             checked={serviceName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <div>
//                         <h5>Preview</h5>
//                       </div>
//                       {(bookingTotal ||
//                         customerName ||
//                         customerAddress ||
//                         petName || petBreed ||
//                         serviceName) && (
//                           <Card
//                             style={{
//                               padding: "20px",
//                               backgroundColor: "#3f51b5",
//                               color: "#fff",
//                               width: "400px",
//                             }}
//                           > 
//                             {bookingTotal && <div>$Total Cost</div>}
//                             {customerName && <div>Firstname Lastname</div>}
//                             {customerAddress && <div>Street Address, Suburb, Postcode</div>}
//                             {petName && <div>Pet Name</div>}
//                             {petBreed && <div>Pet Breed</div>}
//                             {serviceName && <div>Services</div>}
//                           </Card>
//                         )}
//                     </List>
//                     {this.state.loading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={true}
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={
//                           !(bookingTotal ||
//                             customerName ||
//                             customerAddress ||
//                             petName || petBreed ||
//                             serviceName)
//                         }
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>

//               {/* App Calendar Settings Section with Mobile Support */}
//               <CardBox heading="App Calendar Settings">
//                 {appCalendarLoading && (
//                   <div style={{ position: "relative", top: "15px", marginBottom: "20px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <p style={{ 
//                       marginBottom: '15px', 
//                       color: '#666', 
//                       fontSize: '0.9rem',
//                       padding: '10px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}>
//                       <i className="zmdi zmdi-menu" style={{ marginRight: '10px', fontSize: '20px' }}></i>
//                       {this.state.isTouchDevice ? (
//                         <span>Long press and drag the ⋮⋮ icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       ) : (
//                         <span>Drag the ⋮⋮ icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       )}
//                     </p>

//                     <List className="LawaList">
//                       {appCalendarItems.map((item, index) => (
//                         <ListItem
//                           key={item.id}
//                           className="app-calendar-item"
//                           draggable={!this.state.isTouchDevice}
//                           onDragStart={(e) => this.handleDragStart(e, index)}
//                           onDragOver={(e) => this.handleDragOver(e, index)}
//                           onDrop={(e) => this.handleDrop(e, index)}
//                           onDragEnd={this.handleDragEnd}
//                           onTouchStart={(e) => this.handleTouchStart(e, index)}
//                           onTouchMove={this.handleTouchMove}
//                           onTouchEnd={this.handleTouchEnd}
//                           onTouchCancel={this.handleTouchCancel}
//                           style={{
//                             cursor: this.state.isTouchDevice ? 'default' : 'grab',
//                             border: '1px solid transparent',
//                             transition: 'all 0.2s',
//                             backgroundColor: this.state.draggedItem === index ? '#f5f5f5' : 'transparent',
//                             WebkitTapHighlightColor: 'transparent',
//                           }}
//                         >
//                           <ListItemIcon 
//                             className="drag-handle"
//                             style={{ 
//                               cursor: this.state.isTouchDevice ? 'pointer' : 'grab', 
//                               minWidth: '40px',
//                               padding: this.state.isTouchDevice ? '10px 5px' : '0',
//                             }}
//                           >
//                             <i className="zmdi zmdi-menu" style={{ fontSize: '20px', color: '#999' }}></i>
//                           </ListItemIcon>
//                           <ListItemIcon>
//                             <i className={`zmdi ${item.icon} zmdi-hc-fw zmdi-hc-2x`} />
//                           </ListItemIcon>
//                           <ListItemText primary={item.label} />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               checked={item.enabled}
//                               onChange={() => this.handleAppCalendarToggle(item.id)}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                       ))}
//                     </List>

//                     {/* Preview Section */}
//                     <div style={{ marginTop: '20px' }}>
//                       <h5>Preview </h5>
//                       {appCalendarItems.some(item => item.enabled) ? (
//                         <Card
//                           style={{
//                             padding: "20px",
//                             backgroundColor: "#3f51b5",
//                             color: "#fff",
//                             width: "100%",
//                             maxWidth: "400px",
//                           }}
//                         >
//                           {appCalendarItems
//                             .filter(item => item.enabled)
//                             .map(item => {
//                               switch(item.apiKey) {
//                                 case 'time':
//                                   return <div key={item.id}>10:30 AM</div>;
//                                 case 'cost':
//                                   return <div key={item.id}>Service Cost</div>;
//                                 case 'name':
//                                   return <div key={item.id}>Customer Name</div>;
//                                 case 'address':
//                                   return <div key={item.id}>123 Main St, Sydney 2000</div>;
//                                 case 'petName':
//                                   return <div key={item.id}>Pet Name</div>;
//                                 case 'petBreed':
//                                   return <div key={item.id}>Pet Breed</div>;
//                                 case 'serviceName':
//                                   return <div key={item.id}>Full Grooming</div>;
//                                 default:
//                                   return null;
//                               }
//                             })}
//                         </Card>
//                       ) : (
//                         <p style={{ color: '#999', fontStyle: 'italic' }}>Toggle on items to see preview</p>
//                       )}
//                     </div>

//                     {appCalendarLoading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         disabled={true}
//                       >
//                         Updating...
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         onClick={this.handleAppCalendarSubmit}
//                       >
//                         Update App Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>
//             </div>
//           </div>
//           <NotificationContainer />
//         </>
//       );
//     }
//   }
// }

// export default Settings;

// *************************************************************************************************************************************************
// import React from "react";
// import ContainerHeader from "components/ContainerHeader/index";
// import CardBox from "components/CardBox/index";
// import CardBoxNew from "components/CardBoxNew/index";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import "../../../../src/assets/vendors/react-notification/react-notifications.css"
// import { httpClient } from "appUtility/Api";
// import IntlMessages from "util/IntlMessages";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
// import Switch from "@material-ui/core/Switch";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import featureServer from "../../../appUtility/featureServer";
// import { FormControl, Grid, MenuItem, Radio, Select, Tooltip, RadioGroup, FormControlLabel, Divider, FormLabel } from "@material-ui/core";
// import configureStore from "../../../store";

// const loginOBJ = localStorage.getItem("login");
// const logindetail = JSON.parse(loginOBJ);
// var modifiedData = logindetail && logindetail.syncLastModified;
// const qs = require("qs");

// var param, settingdetail;

// class Settings extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       error: null,
//       isLoaded: false,
//       id: "",
//       incometemplate: "",
//       incomedescription: "",
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       mcode: logindetail && logindetail.mCode,
//       settingdetail: "",
//       checked: [],
//       customerName: false,
//       bookingTotal: false,
//       customerAddress: false,
//       petName: false,
//       petBreed: false,
//       serviceName: false,
//       syncModified: "",
//       loading: false,
//       display_booking_end_time: logindetail && logindetail.display_booking_end_time,
//       timeFormat: logindetail && logindetail.timeFormat,
//       addressInInvoice: logindetail && logindetail.addressInInvoice,
//       phoneInInvoice: logindetail && logindetail.phoneInInvoice,
//       enableCancellationPolicy: logindetail && logindetail.enableCancellationPolicy ? 1 : 0,
//       selectedSetting: "",
//       confirmationHour: 24,
//       loadingConfirmation: false,
      
//       // New state for policies
//       policies: [],
//       policiesLoading: false,
//       selectedPolicyId: "",
//       savingPolicy: false,
      
//       // App Calendar Settings with all possible items (time instead of date)
//       appCalendarItems: [
//         { id: 'appTime', label: 'Show Time', icon: 'zmdi-time', enabled: false, apiKey: 'time' },
//         { id: 'appBookingTotal', label: 'Show Booking Total', icon: 'zmdi-money', enabled: false, apiKey: 'cost' },
//         { id: 'appCustomerName', label: 'Show Customer Name', icon: 'zmdi-account', enabled: false, apiKey: 'name' },
//         { id: 'appCustomerAddress', label: 'Show Customer Address', icon: 'zmdi-pin', enabled: false, apiKey: 'address' },
//         { id: 'appPetName', label: 'Show Pet Name', icon: 'zmdi-face', enabled: false, apiKey: 'petName' },
//         { id: 'appPetBreed', label: 'Show Pet Breed', icon: 'zmdi-label', enabled: false, apiKey: 'petBreed' },
//         { id: 'appServiceName', label: 'Show Services Name', icon: 'zmdi-cut', enabled: false, apiKey: 'serviceName' },
//       ],
//       appCalendarLoading: false,
//       draggedItem: null,
//       appCalendarInitialized: false,
      
//       // Mobile touch states
//       isTouchDevice: false,
//       touchStartY: 0,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartTime: 0,
//     };

//     this.handleChange = this.handleChange.bind(this);
//     this.handleAppCalendarToggle = this.handleAppCalendarToggle.bind(this);
//     this.handleAppCalendarSubmit = this.handleAppCalendarSubmit.bind(this);
    
//     // Desktop drag handlers
//     this.handleDragStart = this.handleDragStart.bind(this);
//     this.handleDragOver = this.handleDragOver.bind(this);
//     this.handleDrop = this.handleDrop.bind(this);
//     this.handleDragEnd = this.handleDragEnd.bind(this);
    
//     // Mobile touch handlers
//     this.handleTouchStart = this.handleTouchStart.bind(this);
//     this.handleTouchMove = this.handleTouchMove.bind(this);
//     this.handleTouchEnd = this.handleTouchEnd.bind(this);
//     this.handleTouchCancel = this.handleTouchCancel.bind(this);
    
//     // Policy handlers
//     this.fetchPolicies = this.fetchPolicies.bind(this);
//     this.handlePolicyChange = this.handlePolicyChange.bind(this);
//     this.handleSavePolicy = this.handleSavePolicy.bind(this);
//   }

//   componentDidMount() {
//     // Detect touch device
//     this.setState({
//       isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
//     });

//     // Prevent default touch behaviors on draggable items
//     document.addEventListener('touchmove', this.preventTouchScroll, { passive: false });
    
//     var aid, cid, uid;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail && logindetail.uid;

//     param = aid + "_" + cid + "_" + uid;

//     // Fetch member settings
//     httpClient
//       .post(
//         "getMemberSettings.php",
//         qs.stringify({
//           action: "member_settings",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             localStorage.setItem("settings", JSON.stringify(data));
//             this.setState(
//               {
//                 isLoaded: false,
//                 id: data.id,
//                 settingdetail: data,
//                 checked: data.flags,
//                 petName: data.pet_name == "1" ? true : false,
//                 petBreed: data.pet_breed == "1" ? true : false,
//                 serviceName: data.services_name == "1" ? true : false,
//                 customerName: data.customer_name == "1" ? true : false,
//                 bookingTotal: data.bookingCost == "1" ? true : false,
//                 customerAddress: data.customer_address == "1" ? true : false,
//                 confirmationHour: parseInt(data.confirmationHour),
//                 selectedSetting: data.confirmationBy,
//               },
//               function () {
//                 this.setState({
//                   isLoaded: true,
//                 });
//               }
//             );
//           } else {
//           }
//         },
//         (error) => {
//           this.setState({
//             isLoaded: true,
//             error,
//           });
//         }
//       );

//     const loginValue = JSON.parse(localStorage.getItem("login"));
//     this.setState({
//       ...this.state,
//       display_booking_end_time: loginValue.display_booking_end_time,
//       timeFormat: loginValue.timeFormat,
//       addressInInvoice: loginValue.addressInInvoice,
//       phoneInInvoice: loginValue.phoneInInvoice,
//       enableCancellationPolicy: loginValue.enableCancellationPolicy ? 1 : 0,
//     });

//     // Fetch policies
//     this.fetchPolicies();

//     // Fetch App Calendar Settings (no notification on page load)
//     this.fetchAppCalendarSettings(false);

//     // Add CSS for mobile
//     this.addMobileStyles();
//   }

//   componentWillUnmount() {
//     document.removeEventListener('touchmove', this.preventTouchScroll);
//   }

//   // Fetch policies from API
//   fetchPolicies = () => {
//     this.setState({ policiesLoading: true });

//     const apiToken =  logindetail.memtoken || "";
//     const formData = new FormData();
//     formData.append('action', 'getPolicies');
//     formData.append('api_token', apiToken);
//     formData.append('source[appID]', this.state.appID);
//     formData.append('source[memberID]', this.state.memberID);
//     formData.append('source[companyID]', this.state.companyID);

//     httpClient
//       .post("/v2/getPolicies.php", formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       })
//       .then((response) => {
//         if (response.data.success && response.data.data) {
//           const policies = response.data.data;
//           const selectedPolicy = policies.find(policy => policy.is_selected === 1);
          
//           this.setState({ 
//             policies: policies,
//             policiesLoading: false,
//             selectedPolicyId: selectedPolicy ? selectedPolicy.policyID : "",
//           });

//           // Update localStorage with the selected policy
//           if (selectedPolicy) {
//             var loginData = JSON.parse(localStorage.getItem("login"));
//             loginData.enableCancellationPolicy = selectedPolicy.policyID;
//             localStorage.setItem("login", JSON.stringify(loginData));
//           }
//         } else {
//           this.setState({ policiesLoading: false });
//           NotificationManager.info("Failed to load policies");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching policies:", error);
//         this.setState({ policiesLoading: false });
//         NotificationManager.info("Error loading policies");
//       });
//   };

//   // Handle policy radio change
//   handlePolicyChange = (event) => {
//     this.setState({ selectedPolicyId: event.target.value });
//   };

//   // Save selected policy - UPDATED to use updateUserSettings.php
//   handleSavePolicy = () => {
//     if (!this.state.selectedPolicyId) {
//       NotificationManager.info("Please select a policy");
//       return;
//     }

//     this.setState({ savingPolicy: true });

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       enableCancellationPolicy: this.state.selectedPolicyId // Send the policy ID instead of 1/0
//     };

//     // Use the existing updateUserSettings.php endpoint
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//           enableCancellationPolicy: dateVals.enableCancellationPolicy // This will be the policy ID
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           // Store the policy ID in enableCancellationPolicy
//           loginData.enableCancellationPolicy = this.state.selectedPolicyId;
          
//           this.setState({
//             enableCancellationPolicy: 1, // Keep toggle ON visually
//             savingPolicy: false
//           });
          
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.success("Policy saved successfully");
          
//           // Refresh policies to get updated is_selected flags
//           this.fetchPolicies();
//         } else {
//           this.setState({ savingPolicy: false });
//           NotificationManager.info(data.msg || "Failed to save policy");
//         }
//       })
//       .catch((error) => {
//         console.error("Error saving policy:", error);
//         this.setState({ savingPolicy: false });
//         NotificationManager.info("Error saving policy");
//       });
//   };

//   fetchAppCalendarSettings = (showNotification = false) => {
//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const loginData = JSON.parse(localStorage.getItem("login"));
//     const apiToken =  loginData.memtoken ;

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "getSettings",
//           api_token: apiToken,
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           // data.data contains array of enabled settings in order e.g., ["time", "cost", "name", ...]
//           const enabledSettings = data.data || [];
          
//           // Create a map of apiKey to enabled status and order
//           const settingsMap = {};
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const key = enabledSettings[i];
//             settingsMap[key] = { enabled: true, order: i };
//           }

//           // Create a new array with items in the exact order from API response
//           const orderedItems = [];
          
//           // First, add enabled items in the order they appear in API response
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const apiKey = enabledSettings[i];
//             // Find the matching item in appCalendarItems
//             for (let j = 0; j < this.state.appCalendarItems.length; j++) {
//               const item = this.state.appCalendarItems[j];
//               if (item.apiKey === apiKey) {
//                 orderedItems.push({
//                   ...item,
//                   enabled: true
//                 });
//                 break;
//               }
//             }
//           }
          
//           // Then, add disabled items that are not in the API response
//           for (let i = 0; i < this.state.appCalendarItems.length; i++) {
//             const item = this.state.appCalendarItems[i];
//             if (!settingsMap.hasOwnProperty(item.apiKey)) {
//               orderedItems.push({
//                 ...item,
//                 enabled: false
//               });
//             }
//           }

//           this.setState({ 
//             appCalendarItems: orderedItems,
//             appCalendarLoading: false,
//             appCalendarInitialized: true
//           });

//           // Only show notification if explicitly requested (not on page load)
//           if (showNotification) {
//             NotificationManager.success(data.message || "Calendar settings loaded");
//           }
//         } else {
//           if (showNotification) {
//             NotificationManager.info(data.message || "Failed to load calendar settings");
//           }
//           this.setState({ appCalendarLoading: false });
//         }
//       })
//       .catch(error => {
//         console.error("Error fetching app calendar settings:", error);
//         if (showNotification) {
//           NotificationManager.info("Error loading calendar settings");
//         }
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   addMobileStyles = () => {
//     const style = document.createElement('style');
//     style.innerHTML = `
//       .app-calendar-item {
//         -webkit-touch-callout: none;
//         -webkit-user-select: none;
//         user-select: none;
//         touch-action: pan-y;
//         transition: all 0.2s ease;
//       }
//       .app-calendar-item.dragging {
//         opacity: 0.7 !important;
//         transform: scale(1.02) !important;
//         box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
//         z-index: 9999 !important;
//         background-color: #f5f5f5 !important;
//       }
//       .app-calendar-item.drag-over {
//         border: 2px dashed #3f51b5 !important;
//         background-color: #e8eaf6 !important;
//         opacity: 0.8;
//         transform: scale(1.01);
//       }
//       .app-calendar-item:active {
//         background-color: #f0f0f0;
//       }
//       @media (max-width: 768px) {
//         .app-calendar-item {
//           cursor: default !important;
//         }
//         .app-calendar-item .drag-handle {
//           padding: 10px 5px;
//         }
//       }
//     `;
//     document.head.appendChild(style);
//   };

//   preventTouchScroll = (e) => {
//     if (this.state.touchDraggedItem !== null) {
//       e.preventDefault();
//     }
//   };

//   // Desktop Drag Handlers
//   handleDragStart = (event, index) => {
//     if (this.state.isTouchDevice) return; // Skip on touch devices
    
//     event.dataTransfer.setData('text/plain', index.toString());
//     event.dataTransfer.effectAllowed = 'move';
//     this.setState({ draggedItem: index });
//     event.currentTarget.style.opacity = '0.5';
//     event.currentTarget.style.backgroundColor = '#f0f0f0';
//   };

//   handleDragOver = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
//     event.dataTransfer.dropEffect = 'move';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (event.currentTarget) {
//       event.currentTarget.classList.add('drag-over');
//     }
//   };

//   handleDrop = (event, targetIndex) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     const sourceIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
//     if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;
    
//     const newItems = [...this.state.appCalendarItems];
//     const [movedItem] = newItems.splice(sourceIndex, 1);
//     newItems.splice(targetIndex, 0, movedItem);
    
//     this.setState({ 
//       appCalendarItems: newItems,
//       draggedItem: null 
//     });
//   };

//   handleDragEnd = (event) => {
//     if (this.state.isTouchDevice) return;
    
//     event.currentTarget.style.opacity = '1';
//     event.currentTarget.style.backgroundColor = '';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     this.setState({ draggedItem: null });
//   };

//   // Mobile Touch Handlers
//   handleTouchStart = (e, index) => {
//     e.preventDefault();
    
//     const touch = e.touches[0];
//     const target = e.currentTarget;
    
//     // Long press detection (300ms)
//     this.touchStartTimeout = setTimeout(() => {
//       this.setState({
//         touchStartY: touch.clientY,
//         touchStartX: touch.clientX,
//         touchDraggedItem: index,
//         touchDraggedIndex: index,
//         draggedItem: index
//       });

//       // Add dragging class
//       target.classList.add('dragging');
      
//       // Vibrate if supported (haptic feedback)
//       if (window.navigator.vibrate) {
//         window.navigator.vibrate(50);
//       }
//     }, 300);
    
//     this.setState({ touchStartTime: Date.now() });
//   };

//   handleTouchMove = (e) => {
//     e.preventDefault();
    
//     const { touchDraggedItem, touchStartY } = this.state;
//     if (touchDraggedItem === null) {
//       clearTimeout(this.touchStartTimeout);
//       return;
//     }

//     const touch = e.touches[0];
//     const currentY = touch.clientY;
//     const deltaY = currentY - touchStartY;

//     // Find which item we're hovering over
//     const items = document.querySelectorAll('.app-calendar-item');
//     let targetIndex = touchDraggedItem;
    
//     items.forEach((item, idx) => {
//       const rect = item.getBoundingClientRect();
//       if (currentY >= rect.top && currentY <= rect.bottom) {
//         targetIndex = idx;
//       }
//     });

//     // Show drop target indicator
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (items[targetIndex] && targetIndex !== touchDraggedItem) {
//       items[targetIndex].classList.add('drag-over');
      
//       // Auto-scroll if near edges
//       const container = document.querySelector('.LawaList');
//       if (container) {
//         const containerRect = container.getBoundingClientRect();
//         const scrollSpeed = 10;
        
//         if (currentY < containerRect.top + 50) {
//           container.scrollTop -= scrollSpeed;
//         } else if (currentY > containerRect.bottom - 50) {
//           container.scrollTop += scrollSpeed;
//         }
//       }
//     }

//     // Move the dragged item visually
//     const draggedItem = items[touchDraggedItem];
//     if (draggedItem && Math.abs(deltaY) > 10) {
//       draggedItem.style.transform = `translateY(${deltaY}px) scale(1.02)`;
//     }

//     this.setState({ touchDraggedIndex: targetIndex });
//   };

//   handleTouchEnd = (e) => {
//     e.preventDefault();
//     clearTimeout(this.touchStartTimeout);
    
//     const { touchDraggedItem, touchDraggedIndex } = this.state;
    
//     if (touchDraggedItem !== null && touchDraggedIndex !== -1) {
//       // Reorder if dropped on different item
//       if (touchDraggedIndex !== touchDraggedItem) {
//         const newItems = [...this.state.appCalendarItems];
//         const [movedItem] = newItems.splice(touchDraggedItem, 1);
//         newItems.splice(touchDraggedIndex, 0, movedItem);
        
//         this.setState({ appCalendarItems: newItems });
//       }
//     }

//     // Reset all visual states
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.transform = '';
//       item.style.backgroundColor = '';
//       item.classList.remove('dragging', 'drag-over');
//     });

//     this.setState({ 
//       draggedItem: null,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartY: 0
//     });
//   };

//   handleTouchCancel = (e) => {
//     this.handleTouchEnd(e);
//   };

//   // Toggle handler for App Calendar items
//   handleAppCalendarToggle = (itemId) => {
//     const updatedItems = this.state.appCalendarItems.map(item => {
//       if (item.id === itemId) {
//         return { ...item, enabled: !item.enabled };
//       }
//       return item;
//     });

//     this.setState({ appCalendarItems: updatedItems });
//   };

//   // Submit handler for App Calendar settings - SAVE API
//   handleAppCalendarSubmit = (e) => {
//     e.preventDefault();

//     // Get enabled items in current order
//     const enabledItems = this.state.appCalendarItems
//       .filter(item => item.enabled)
//       .map(item => item.apiKey); // Send apiKey to backend

//     // Apply blur effect
//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const apiToken =  logindetail.memtoken ;

//     // Create source object with the correct structure: source[appID], source[memberID], source[companyID], source[settings][0], etc.
//     const sourceData = {
//       appID: parameters.appID,
//       memberID: parameters.memberID,
//       companyID: parameters.companyID,
//     };

//     // Add settings as source[settings][0], source[settings][1], etc.
//     const settingsObj = {};
//     for (let i = 0; i < enabledItems.length; i++) {
//       settingsObj[i] = enabledItems[i];
//     }
//     sourceData.settings = settingsObj;

//     // API Call to save settings
//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "saveSettings",
//           api_token: apiToken,
//           source: sourceData,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           NotificationManager.success(data.message || "App Calendar Settings Updated Successfully");
          
//           // Refresh the settings to get the latest from server (with notification false)
//           this.fetchAppCalendarSettings(false);
//         } else {
//           NotificationManager.info(data.message || "Failed to update settings");
//           this.setState({ appCalendarLoading: false });
          
//           // Remove blur effect on error
//           if (loginBlur && loginBlur.ismobiledevice != 1) {
//             document.getElementById("nav__menu__display") !== null &&
//               (document.getElementById("nav__menu__display").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           }
//           document.getElementById("appbar_mainapp__") !== null &&
//             (document.getElementById("appbar_mainapp__").style.cssText =
//               "filter: blur(0px); pointer-events: block");
//         }
//       })
//       .catch(error => {
//         console.error("Error saving app calendar settings:", error);
//         NotificationManager.info("Error updating app calendar settings");
        
//         // Remove blur effect
//         if (loginBlur && loginBlur.ismobiledevice != 1) {
//           document.getElementById("nav__menu__display") !== null &&
//             (document.getElementById("nav__menu__display").style.cssText =
//               "filter: blur(0px); pointer-events: block");
//         }
//         document.getElementById("appbar_mainapp__") !== null &&
//           (document.getElementById("appbar_mainapp__").style.cssText =
//             "filter: blur(0px); pointer-events: block");
        
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   handleEndDate = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       display_booking_end_time: checked ? "1" : "0"
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       display_booking_end_time: checked ? "1" : "0"
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_display_end_time",
//           source: dateVals,
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.display_booking_end_time = this.state.display_booking_end_time;

//           this.setState({
//             ...this.setState,
//             display_booking_end_time: loginData.display_booking_end_time
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleFormatChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       timeFormat: checked ? 24 : 12
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       timeFormat: checked ? 24 : 12
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "timeFormat",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',
//           timeFormat: dateVals.timeFormat
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.timeFormat = this.state.timeFormat;
//           this.setState({
//             ...this.state,
//             timeFormat: loginData.timeFormat
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleAddressInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       addressInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       addressInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "addressInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',
//           addressInInvoice: dateVals.addressInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.addressInInvoice = this.state.addressInInvoice;
//           this.setState({
//             ...this.state,
//             addressInInvoice: loginData.addressInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handlePersonalPhoneInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       phoneInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       phoneInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "phoneInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',
//           phoneInInvoice: dateVals.phoneInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.phoneInInvoice = this.state.phoneInInvoice;
//           this.setState({
//             ...this.state,
//             phoneInInvoice: loginData.phoneInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   // Original cancellation policy toggle - updated to handle policy ID
//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
    
//     // If turning ON, we need to fetch policies first or use default
//     if (checked) {
//       // If we have policies and a selected policy ID, use that
//       if (this.state.policies.length > 0 && this.state.selectedPolicyId) {
//         this.setState({
//           enableCancellationPolicy: 1
//         });

//         var dateVals = {
//           appID: logindetail && logindetail.aid,
//           companyID: logindetail && logindetail.cid,
//           memberID: logindetail && logindetail.uid,
//           enableCancellationPolicy: this.state.selectedPolicyId // Send the selected policy ID
//         };
        
//         httpClient
//           .post(
//             "updateUserSettings.php",
//             qs.stringify({
//               action: "enableCancellationPolicy",
//               source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//               enableCancellationPolicy: dateVals.enableCancellationPolicy
//             })
//           ).then(({ data }) => {
//             if (data.success == "true") {
//               var loginData = JSON.parse(localStorage.getItem("login"));

//               loginData.enableCancellationPolicy = this.state.selectedPolicyId;
//               this.setState({
//                 enableCancellationPolicy: 1
//               });
//               localStorage.setItem("login", JSON.stringify(loginData));
//               NotificationManager.info("Cancellation policy enabled");
//             }
//           });
//       } else {
//         // If no policies loaded or selected, fetch them first
//         this.fetchPolicies();
//         this.setState({
//           enableCancellationPolicy: 1
//         });
//       }
//     } else {
//       // Turning OFF - send 0
//       this.setState({
//         enableCancellationPolicy: 0
//       });

//       var dateVals = {
//         appID: logindetail && logindetail.aid,
//         companyID: logindetail && logindetail.cid,
//         memberID: logindetail && logindetail.uid,
//         enableCancellationPolicy: 0 // Send 0 to disable
//       };
      
//       httpClient
//         .post(
//           "updateUserSettings.php",
//           qs.stringify({
//             action: "enableCancellationPolicy",
//             source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//             enableCancellationPolicy: dateVals.enableCancellationPolicy
//           })
//         ).then(({ data }) => {
//           if (data.success == "true") {
//             var loginData = JSON.parse(localStorage.getItem("login"));

//             loginData.enableCancellationPolicy = 0;
//             this.setState({
//               enableCancellationPolicy: 0
//             });
//             localStorage.setItem("login", JSON.stringify(loginData));
//             NotificationManager.info("Cancellation policy disabled");
//           }
//         });
//     }
//   }

//   handleToggle = (event, value) => {
//     var settingParam;
//     var aid, cid, uid;
//     var btntype;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail.uid;
//     btntype = value;

//     const { checked } = this.state;
//     const currentIndex = checked.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex == -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     this.setState({
//       checked: newChecked,
//     });

//     settingParam = aid + "_" + cid + "_" + uid + "_" + value;

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: btntype,
//           source: settingParam,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data.success != "true") {
//             NotificationManager.info(data.failedMSG);
//           } else if (data.success == "true") {
//             var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
//             var objname = data.actionOn;

//             if (objname == "displayCustNotes")
//               loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

//             if (objname == "hideOldRecurring")
//               loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

//             if (objname == "displayBookingClash")
//               loginTempOBJ.displayBookingClash =
//                 1 - loginTempOBJ.displayBookingClash;

//             if (objname == "hidePastBookingsCalendarSearch")
//               loginTempOBJ.hidePastBookingsCalendarSearch =
//                 1 - loginTempOBJ.hidePastBookingsCalendarSearch;

//             if (objname == "filterBookingServices") {
//               loginTempOBJ.filterBookingServices =
//                 1 - loginTempOBJ.filterBookingServices;
//             }

//             localStorage.setItem("login", JSON.stringify(loginTempOBJ));
//             NotificationManager.info(data.msg);
//           }
//         },
//         (error) => {
//           this.setState({
//             error,
//           });
//         }
//       );
//   };

//   handleCalendarChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//   };

//   handleBookingConfirmationChange = (event) => {
//     this.setState({ selectedSetting: event.target.value });
//   };

//   handleChangeConfirmationHour = (e) => {
//     this.setState({
//       confirmationHour: e.target.value,
//     });
//   };

//   handleSaveSettings() {
//     if (this.state.incometemplate == "" && this.state.incomedescription == "") {
//       NotificationManager.info("Nothing changed to save");
//     } else {
//       httpClient
//         .post(
//           "saveMemberSettings.php",
//           qs.stringify({
//             action: "save_settings",
//             source: this.state,
//           })
//         )
//         .then(
//           ({ data }) => {
//             if (data.success != "true") {
//               NotificationManager.info(data.failedMSG);
//             } else {
//               NotificationManager.info(data.successMSG);
//               this.setState({
//                 incometemplate: "",
//                 incomedescription: "",
//               });
//             }
//           },
//           (error) => {
//             NotificationManager.info(
//               "Error Occured: Refresh the page and try again"
//             );
//           }
//         );
//     }
//   }

//   handleChange(evt) {
//     this.setState({ [evt.target.name]: evt.target.value });
//   }

//   handleSubmitCalendar = (e) => {
//     e.preventDefault();

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({
//       ...this.state,
//       loading: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       customer_name: this.state.customerName,
//       bookingCost: this.state.bookingTotal,
//       customer_address: this.state.customerAddress,
//       pet_name: this.state.petName,
//       pet_breed: this.state.petBreed,
//       services_name: this.state.serviceName,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_calendar_settings",
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           NotificationManager.success(data.successMSG);
//           let calendarData = [];
//           let calendarStorage = JSON.parse(localStorage.getItem("settings"));

//           calendarData = {
//             ...calendarStorage,
//             customer_name: data.customer_name,
//             bookingCost: data.bookingCost,
//             pet_name: data.pet_name,
//             services_name: data.services_name,
//             customer_address: data.customer_address,
//           };

//           const cal = { ...calendarData };

//           localStorage.setItem("settings", JSON.stringify(cal));

//           setTimeout(() => {
//             NotificationManager.info("Retrieving Calendar Entries");
//           }, 1000);

//           this.getCalendarEntry();
//         } else {
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   handleSubmitConfirmation = (e) => {
//     e.preventDefault();

//     this.setState({
//       ...this.state,
//       loadingConfirmation: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "bookingConfirmation",
//           source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
//           confirmationBy: this.state.selectedSetting,
//           confirmationHour: this.state.confirmationHour,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: data.data.confirmationBy,
//             confirmationHour: parseInt(data.data.confirmationHour),
//           });
//           NotificationManager.success(data.msg);
//         } else {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: "",
//             confirmationHour: "",
//           });
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   getCalendarEntry = () => {
//     httpClient
//       .post(
//         "getCalendarEntries.php",
//         qs.stringify({
//           action: "calendar_entries",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             var calendarLastMod = {
//               calendarLastModified: data.calendarLastModified,
//             };
//             var dataIndex =
//               modifiedData &&
//               modifiedData.findIndex((arr, i) => arr.calendarLastModified);
//             modifiedData && (modifiedData[dataIndex] = calendarLastMod);

//             localStorage.setItem("calendar_entries", JSON.stringify(data.data));
//             this.setState({
//               syncModified: modifiedData,
//             });

//             this.setState({
//               ...this.state,
//               loading: false,
//             });
            
//             if (this.state.syncModified.length > 0) {
//               var loginData = JSON.parse(localStorage.getItem("login"));
//               loginData.syncLastModified = this.state.syncModified;
//               loginData.syncLastModified !== [] &&
//                 localStorage.setItem("login", JSON.stringify(loginData));
//             }

//             NotificationManager.success(
//               "Calendar Settings Successfully Updated"
//             );

//             let loginBlur = JSON.parse(localStorage.getItem("login"));

//             if (loginBlur && loginBlur.ismobiledevice != 1) {
//               document.getElementById("nav__menu__display") !== null &&
//                 (document.getElementById("nav__menu__display").style.cssText =
//                   "filter: blur(0px); pointer-events: block");
//             }
//             document.getElementById("appbar_mainapp__") !== null &&
//               (document.getElementById("appbar_mainapp__").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           } else {
//           }
//         }
//       );
//   };

//   render() {
//     const {
//       error,
//       isLoaded,
//       incomedescription,
//       settingdetail,
//       incometemplate,
//       customerName,
//       bookingTotal,
//       customerAddress,
//       petName,
//       petBreed,
//       serviceName,
//       appCalendarItems,
//       appCalendarLoading,
//       appCalendarInitialized,
//       policies,
//       policiesLoading,
//       selectedPolicyId,
//       savingPolicy,
//       enableCancellationPolicy,
//     } = this.state;

//     if (error) {
//       return <div className="jr-customers">Error: {error.message}</div>;
//     } else if (!isLoaded || (appCalendarLoading && !appCalendarInitialized)) {
//       return (
//         <div className="jr-customers">
//           <LinearProgress color="secondary" />
//         </div>
//       );
//     } else {
//       return (
//         <>
//           <div className="app-wrapper animated slideInUpTiny animation-duration-3">
//             <ContainerHeader
//               title={<IntlMessages id="sidebar.dashboard.settings" />}
//               match={this.props.match}
//             />

//             <div className="row">
//               <CardBox
//                 heading={<IntlMessages id="dashboard.settings.preferences" />}
//               >
//                 <div className="col-md-12 col-12">
//                   <List className="LawaList">
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Customer Notes on Booking" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayCustNotes")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayCustNotes") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "hideOldBookings")
//                           }
//                           checked={
//                             this.state.checked.indexOf("hideOldBookings") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Booking Clash Notifications" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayBookingClash")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayBookingClash") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Past Bookings from Calendar Search" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(
//                               event,
//                               "hidePastBookingsCalendarSearch"
//                             )
//                           }
//                           checked={
//                             this.state.checked.indexOf(
//                               "hidePastBookingsCalendarSearch"
//                             ) != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Filter Services based on pet size" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "filterBookingServices")
//                           }
//                           checked={
//                             this.state.checked.indexOf("filterBookingServices") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Booking End Time" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.display_booking_end_time === "1"}
//                           onChange={this.handleEndDate}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Address In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.addressInInvoice === 1}
//                           onChange={this.handleAddressInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Personal Phone In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.phoneInInvoice === 1}
//                           onChange={this.handlePersonalPhoneInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Toggle 24hr Time Format" />
//                       <ListItemSecondaryAction>
//                         <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
//                         <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
//                           <Switch
//                             color="primary"
//                             checked={this.state.timeFormat === 24}
//                             onChange={this.handleFormatChange}
//                           />
//                         </Tooltip>
//                         <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                   </List>
//                 </div>
//               </CardBox>

//               <div className="col-md-6">
//                 <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
//                       <div className="col-md-12 col-12">
//                         <TextField
//                           id="smsNumber"
//                           label="SMS Sender"
//                           value="0495149675"
//                           margin="normal"
//                           helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                           fullWidth
//                         />
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
                  
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={"Cancellation Policy"}>
//                       <div className="col-md-12 col-12">
//                         {/* Original static policy text */}
//                         {/* <span>PLEASE NOTE: 24 hours notice is required to cancel your appointment.
//                           We reserve the right to charge a cancellation fee if you are not home when we call for our confirmed appointment time.</span>
//                          */}
//                         {/* Original toggle - now handles policy ID when turning ON */}
//                         <List>
//                           <ListItem>
//                             <ListItemIcon>
//                               <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
//                             </ListItemIcon>
//                             <ListItemText primary="Attach Cancellation Policy" />
//                             <ListItemSecondaryAction>
//                               <Switch
//                                 color="primary"
//                                 checked={enableCancellationPolicy === 1}
//                                 onChange={this.handleCancellationPolicyChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                         </List>

//                         {/* New policy selection section - only visible when toggle is ON */}
//                         {enableCancellationPolicy === 1 && (
//                           <>
//                             <Divider style={{ margin: '15px 0' }} />
//                             <FormLabel component="legend" style={{ marginBottom: '10px', marginLeft: '15px' }}>
//                               Select Policy
//                             </FormLabel>
//                             {policiesLoading ? (
//                               <LinearProgress color="secondary" />
//                             ) : (
//                               <>
//                                 <FormControl component="fieldset" fullWidth>
//                                   <RadioGroup
//                                     name="policies-radio-group"
//                                     value={selectedPolicyId}
//                                     onChange={this.handlePolicyChange}
//                                   >
//                                     {policies.map((policy) => (
//                                       <FormControlLabel
//                                         key={policy.policyID}
//                                         value={policy.policyID}
//                                         control={<Radio color="primary" />}
//                                         label={
//                                           <span 
//                                             dangerouslySetInnerHTML={{ __html: policy.policy }}
//                                             style={{ fontSize: '0.9rem' }}
//                                           />
//                                         }
//                                         style={{
//                                           marginBottom: '10px',
//                                           alignItems: 'flex-start',
//                                         }}
//                                       />
//                                     ))}
//                                   </RadioGroup>
//                                 </FormControl>
                                
//                                 <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
//                                   {savingPolicy ? (
//                                     <Button
//                                       variant="contained"
//                                       color="primary"
//                                       disabled={true}
//                                     >
//                                       Saving...
//                                     </Button>
//                                   ) : (
//                                     <Button
//                                       variant="contained"
//                                       color="primary"
//                                       onClick={this.handleSavePolicy}
//                                       disabled={!selectedPolicyId}
//                                     >
//                                       Save Policy Selection
//                                     </Button>
//                                   )}
//                                 </div>
//                               </>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
//                 </Grid>
//               </div>

//               <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
//                 <form className="row" noValidate autoComplete="off">
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incometemplate"
//                       name="incometemplate"
//                       label="Income Title Template"
//                       margin="normal"
//                       defaultValue={this.state.settingdetail.title}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       onChange={this.handleChange}
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incomedescription"
//                       name="incomedescription"
//                       label="Income Description"
//                       defaultValue={this.state.settingdetail.desc}
//                       margin="normal"
//                       onChange={this.handleChange}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="jr-btn btn-margin-topbottom"
//                       position="static"
//                       onClick={() => {
//                         this.handleSaveSettings();
//                       }}
//                     >
//                       Save
//                     </Button>
//                   </div>
//                 </form>
//               </CardBox>
              
//               <CardBox heading="Send Booking Reminder">
//                 {this.state.loadingConfirmation && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Do not send booking reminder" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value=""
//                             checked={this.state.selectedSetting === ""}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email and SMS for all customers" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="all"
//                             checked={this.state.selectedSetting === "all"}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email only, do not send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="emailOnly"
//                             checked={this.state.selectedSetting === 'emailOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send SMS only, do not send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="smsOnly"
//                             checked={this.state.selectedSetting === 'smsOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by email but if not found, send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedEmail"
//                             checked={this.state.selectedSetting === 'preferedEmail'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by SMS but if no mobile number, send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedSMS"
//                             checked={this.state.selectedSetting === 'preferedSMS'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
//                         <ListItemSecondaryAction>
//                           <FormControl variant="outlined" style={{ width: "100px" }}>
//                             <Select
//                               placeholder="Select Confirmation Before"
//                               name="confirmationHour"
//                               value={this.state.confirmationHour}
//                               style={{
//                                 textAlign: 'center',
//                                 paddingLeft: '0',
//                               }}
//                               inputProps={{
//                                 style: {
//                                   textAlign: 'center',
//                                 },
//                               }}
//                               onChange={(e) => this.handleChangeConfirmationHour(e)}
//                             >
//                               <MenuItem value="">
//                                 <em>Select Confirmation Before</em>
//                               </MenuItem>
//                               <MenuItem value={24}>{"24 hrs"}</MenuItem>
//                               <MenuItem value={48}>{"48 hrs"}</MenuItem>
//                               <MenuItem value={72}>{"72 hrs"}</MenuItem>
//                             </Select>
//                           </FormControl>
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       {this.state.loadingConfirmation ? (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                           disabled={true}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       )}
//                     </List>
//                   </div>
//                 </div>
//               </CardBox>

//               <CardBox heading="Calendar Settings">
//                 {this.state.loading && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Show Booking Total" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="bookingTotal"
//                             checked={bookingTotal}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerName"
//                             checked={customerName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Address" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerAddress"
//                             checked={customerAddress}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petName"
//                             checked={petName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Breed" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petBreed"
//                             checked={petBreed}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Services Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="serviceName"
//                             checked={serviceName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <div>
//                         <h5>Preview</h5>
//                       </div>
//                       {(bookingTotal ||
//                         customerName ||
//                         customerAddress ||
//                         petName || petBreed ||
//                         serviceName) && (
//                           <Card
//                             style={{
//                               padding: "20px",
//                               backgroundColor: "#3f51b5",
//                               color: "#fff",
//                               width: "400px",
//                             }}
//                           > 
//                             {bookingTotal && <div>$Total Cost</div>}
//                             {customerName && <div>Firstname Lastname</div>}
//                             {customerAddress && <div>Street Address, Suburb, Postcode</div>}
//                             {petName && <div>Pet Name</div>}
//                             {petBreed && <div>Pet Breed</div>}
//                             {serviceName && <div>Services</div>}
//                           </Card>
//                         )}
//                     </List>
//                     {this.state.loading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={true}
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={
//                           !(bookingTotal ||
//                             customerName ||
//                             customerAddress ||
//                             petName || petBreed ||
//                             serviceName)
//                         }
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>

//               {/* App Calendar Settings Section with Mobile Support */}
//               <CardBox heading="App Calendar Settings">
//                 {appCalendarLoading && (
//                   <div style={{ position: "relative", top: "15px", marginBottom: "20px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <p style={{ 
//                       marginBottom: '15px', 
//                       color: '#666', 
//                       fontSize: '0.9rem',
//                       padding: '10px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}>
//                       <i className="zmdi zmdi-menu" style={{ marginRight: '10px', fontSize: '20px' }}></i>
//                       {this.state.isTouchDevice ? (
//                         <span>Long press and drag the ⋮⋮ icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       ) : (
//                         <span>Drag the ⋮⋮ icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       )}
//                     </p>

//                     <List className="LawaList">
//                       {appCalendarItems.map((item, index) => (
//                         <ListItem
//                           key={item.id}
//                           className="app-calendar-item"
//                           draggable={!this.state.isTouchDevice}
//                           onDragStart={(e) => this.handleDragStart(e, index)}
//                           onDragOver={(e) => this.handleDragOver(e, index)}
//                           onDrop={(e) => this.handleDrop(e, index)}
//                           onDragEnd={this.handleDragEnd}
//                           onTouchStart={(e) => this.handleTouchStart(e, index)}
//                           onTouchMove={this.handleTouchMove}
//                           onTouchEnd={this.handleTouchEnd}
//                           onTouchCancel={this.handleTouchCancel}
//                           style={{
//                             cursor: this.state.isTouchDevice ? 'default' : 'grab',
//                             border: '1px solid transparent',
//                             transition: 'all 0.2s',
//                             backgroundColor: this.state.draggedItem === index ? '#f5f5f5' : 'transparent',
//                             WebkitTapHighlightColor: 'transparent',
//                           }}
//                         >
//                           <ListItemIcon 
//                             className="drag-handle"
//                             style={{ 
//                               cursor: this.state.isTouchDevice ? 'pointer' : 'grab', 
//                               minWidth: '40px',
//                               padding: this.state.isTouchDevice ? '10px 5px' : '0',
//                             }}
//                           >
//                             <i className="zmdi zmdi-menu" style={{ fontSize: '20px', color: '#999' }}></i>
//                           </ListItemIcon>
//                           <ListItemIcon>
//                             <i className={`zmdi ${item.icon} zmdi-hc-fw zmdi-hc-2x`} />
//                           </ListItemIcon>
//                           <ListItemText primary={item.label} />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               checked={item.enabled}
//                               onChange={() => this.handleAppCalendarToggle(item.id)}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                       ))}
//                     </List>

//                     {/* Preview Section */}
//                     <div style={{ marginTop: '20px' }}>
//                       <h5>Preview </h5>
//                       {appCalendarItems.some(item => item.enabled) ? (
//                         <Card
//                           style={{
//                             padding: "20px",
//                             backgroundColor: "#3f51b5",
//                             color: "#fff",
//                             width: "100%",
//                             maxWidth: "400px",
//                           }}
//                         >
//                           {appCalendarItems
//                             .filter(item => item.enabled)
//                             .map(item => {
//                               switch(item.apiKey) {
//                                 case 'time':
//                                   return <div key={item.id}>10:30 AM</div>;
//                                 case 'cost':
//                                   return <div key={item.id}>Service Cost</div>;
//                                 case 'name':
//                                   return <div key={item.id}>Customer Name</div>;
//                                 case 'address':
//                                   return <div key={item.id}>123 Main St, Sydney 2000</div>;
//                                 case 'petName':
//                                   return <div key={item.id}>Pet Name</div>;
//                                 case 'petBreed':
//                                   return <div key={item.id}>Pet Breed</div>;
//                                 case 'serviceName':
//                                   return <div key={item.id}>Full Grooming</div>;
//                                 default:
//                                   return null;
//                               }
//                             })}
//                         </Card>
//                       ) : (
//                         <p style={{ color: '#999', fontStyle: 'italic' }}>Toggle on items to see preview</p>
//                       )}
//                     </div>

//                     {appCalendarLoading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         disabled={true}
//                       >
//                         Updating...
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         onClick={this.handleAppCalendarSubmit}
//                       >
//                         Update App Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>
//             </div>
//           </div>
//           <NotificationContainer />
//         </>
//       );
//     }
//   }
// }

// export default Settings;

// *************************************************************************************************************************************

// import React from "react";
// import ContainerHeader from "components/ContainerHeader/index";
// import CardBox from "components/CardBox/index";
// import CardBoxNew from "components/CardBoxNew/index";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import "../../../../src/assets/vendors/react-notification/react-notifications.css"
// import { httpClient } from "appUtility/Api";
// import IntlMessages from "util/IntlMessages";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
// import Switch from "@material-ui/core/Switch";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import featureServer from "../../../appUtility/featureServer";
// import { FormControl, Grid, MenuItem, Radio, Select, Tooltip, RadioGroup, FormControlLabel, Divider, FormLabel } from "@material-ui/core";
// import configureStore from "../../../store";

// const loginOBJ = localStorage.getItem("login");
// const logindetail = JSON.parse(loginOBJ);
// var modifiedData = logindetail && logindetail.syncLastModified;
// const qs = require("qs");

// var param, settingdetail;

// class Settings extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       error: null,
//       isLoaded: false,
//       id: "",
//       incometemplate: "",
//       incomedescription: "",
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       mcode: logindetail && logindetail.mCode,
//       settingdetail: "",
//       checked: [],
//       customerName: false,
//       bookingTotal: false,
//       customerAddress: false,
//       petName: false,
//       petBreed: false,
//       serviceName: false,
//       syncModified: "",
//       loading: false,
//       display_booking_end_time: logindetail && logindetail.display_booking_end_time,
//       timeFormat: logindetail && logindetail.timeFormat,
//       addressInInvoice: logindetail && logindetail.addressInInvoice,
//       phoneInInvoice: logindetail && logindetail.phoneInInvoice,
//       enableCancellationPolicy: logindetail && logindetail.enableCancellationPolicy ? 1 : 0,
//       selectedSetting: "",
//       confirmationHour: 24,
//       loadingConfirmation: false,
      
//       // New state for policies
//       policies: [],
//       policiesLoading: false,
//       selectedPolicyId: "",
//       savingPolicy: false,
      
//       // App Calendar Settings with all possible items (time instead of date)
//       appCalendarItems: [
//         { id: 'appTime', label: 'Show Time', icon: 'zmdi-time', enabled: false, apiKey: 'time' },
//         { id: 'appBookingTotal', label: 'Show Booking Total', icon: 'zmdi-money', enabled: false, apiKey: 'cost' },
//         { id: 'appCustomerName', label: 'Show Customer Name', icon: 'zmdi-account', enabled: false, apiKey: 'name' },
//         { id: 'appCustomerAddress', label: 'Show Customer Address', icon: 'zmdi-pin', enabled: false, apiKey: 'address' },
//         { id: 'appPetName', label: 'Show Pet Name', icon: 'zmdi-face', enabled: false, apiKey: 'petName' },
//         { id: 'appPetBreed', label: 'Show Pet Breed', icon: 'zmdi-label', enabled: false, apiKey: 'petBreed' },
//         { id: 'appServiceName', label: 'Show Services Name', icon: 'zmdi-cut', enabled: false, apiKey: 'serviceName' },
//       ],
//       appCalendarLoading: false,
//       draggedItem: null,
//       appCalendarInitialized: false,
      
//       // Mobile touch states
//       isTouchDevice: false,
//       touchStartY: 0,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartTime: 0,
//     };

//     this.handleChange = this.handleChange.bind(this);
//     this.handleAppCalendarToggle = this.handleAppCalendarToggle.bind(this);
//     this.handleAppCalendarSubmit = this.handleAppCalendarSubmit.bind(this);
//     this.removeBlurEffect = this.removeBlurEffect.bind(this);
    
//     // Desktop drag handlers
//     this.handleDragStart = this.handleDragStart.bind(this);
//     this.handleDragOver = this.handleDragOver.bind(this);
//     this.handleDrop = this.handleDrop.bind(this);
//     this.handleDragEnd = this.handleDragEnd.bind(this);
    
//     // Mobile touch handlers
//     this.handleTouchStart = this.handleTouchStart.bind(this);
//     this.handleTouchMove = this.handleTouchMove.bind(this);
//     this.handleTouchEnd = this.handleTouchEnd.bind(this);
//     this.handleTouchCancel = this.handleTouchCancel.bind(this);
    
//     // Policy handlers
//     this.fetchPolicies = this.fetchPolicies.bind(this);
//     this.handlePolicyChange = this.handlePolicyChange.bind(this);
//     this.handleSavePolicy = this.handleSavePolicy.bind(this);
//   }

//   componentDidMount() {
//     // Detect touch device
//     this.setState({
//       isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
//     });

//     // Prevent default touch behaviors on draggable items
//     document.addEventListener('touchmove', this.preventTouchScroll, { passive: false });
    
//     var aid, cid, uid;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail && logindetail.uid;

//     param = aid + "_" + cid + "_" + uid;

//     // Fetch member settings
//     httpClient
//       .post(
//         "getMemberSettings.php",
//         qs.stringify({
//           action: "member_settings",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             localStorage.setItem("settings", JSON.stringify(data));
//             this.setState(
//               {
//                 isLoaded: false,
//                 id: data.id,
//                 settingdetail: data,
//                 checked: data.flags,
//                 petName: data.pet_name == "1" ? true : false,
//                 petBreed: data.pet_breed == "1" ? true : false,
//                 serviceName: data.services_name == "1" ? true : false,
//                 customerName: data.customer_name == "1" ? true : false,
//                 bookingTotal: data.bookingCost == "1" ? true : false,
//                 customerAddress: data.customer_address == "1" ? true : false,
//                 confirmationHour: parseInt(data.confirmationHour),
//                 selectedSetting: data.confirmationBy,
//               },
//               function () {
//                 this.setState({
//                   isLoaded: true,
//                 });
//               }
//             );
//           } else {
//           }
//         },
//         (error) => {
//           this.setState({
//             isLoaded: true,
//             error,
//           });
//         }
//       );

//     const loginValue = JSON.parse(localStorage.getItem("login"));
//     this.setState({
//       ...this.state,
//       display_booking_end_time: loginValue.display_booking_end_time,
//       timeFormat: loginValue.timeFormat,
//       addressInInvoice: loginValue.addressInInvoice,
//       phoneInInvoice: loginValue.phoneInInvoice,
//       enableCancellationPolicy: loginValue.enableCancellationPolicy ? 1 : 0,
//     });

//     // Fetch policies
//     this.fetchPolicies();

//     // Fetch App Calendar Settings (no notification on page load)
//     this.fetchAppCalendarSettings(false);

//     // Add CSS for mobile
//     this.addMobileStyles();
//   }

//   componentWillUnmount() {
//     document.removeEventListener('touchmove', this.preventTouchScroll);
//   }

//   // Helper function to remove blur effect
//   removeBlurEffect = () => {
//     let loginBlur = JSON.parse(localStorage.getItem("login"));
    
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(0px); pointer-events: block");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(0px); pointer-events: block");
//   }

//   // Fetch policies from API
//   fetchPolicies = () => {
//     this.setState({ policiesLoading: true });

//     const apiToken =  logindetail.memtoken || "";
//     const formData = new FormData();
//     formData.append('action', 'getPolicies');
//     formData.append('api_token', apiToken);
//     formData.append('source[appID]', this.state.appID);
//     formData.append('source[memberID]', this.state.memberID);
//     formData.append('source[companyID]', this.state.companyID);

//     httpClient
//       .post("/v2/getPolicies.php", formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       })
//       .then((response) => {
//         if (response.data.success && response.data.data) {
//           const policies = response.data.data;
//           const selectedPolicy = policies.find(policy => policy.is_selected === 1);
          
//           this.setState({ 
//             policies: policies,
//             policiesLoading: false,
//             selectedPolicyId: selectedPolicy ? selectedPolicy.policyID : "",
//           });

//           // Update localStorage with the selected policy
//           if (selectedPolicy) {
//             var loginData = JSON.parse(localStorage.getItem("login"));
//             loginData.enableCancellationPolicy = selectedPolicy.policyID;
//             localStorage.setItem("login", JSON.stringify(loginData));
//           }
//         } else {
//           this.setState({ policiesLoading: false });
//           NotificationManager.info("Failed to load policies");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching policies:", error);
//         this.setState({ policiesLoading: false });
//         NotificationManager.info("Error loading policies");
//       });
//   };

//   // Handle policy radio change
//   handlePolicyChange = (event) => {
//     this.setState({ selectedPolicyId: event.target.value });
//   };

//   // Save selected policy - UPDATED to use updateUserSettings.php
//   handleSavePolicy = () => {
//     if (!this.state.selectedPolicyId) {
//       NotificationManager.info("Please select a policy");
//       return;
//     }

//     this.setState({ savingPolicy: true });

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       enableCancellationPolicy: this.state.selectedPolicyId // Send the policy ID instead of 1/0
//     };

//     // Use the existing updateUserSettings.php endpoint
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//           enableCancellationPolicy: dateVals.enableCancellationPolicy // This will be the policy ID
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           // Store the policy ID in enableCancellationPolicy
//           loginData.enableCancellationPolicy = this.state.selectedPolicyId;
          
//           this.setState({
//             enableCancellationPolicy: 1, // Keep toggle ON visually
//             savingPolicy: false
//           });
          
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.success("Policy saved successfully");
          
//           // Refresh policies to get updated is_selected flags
//           this.fetchPolicies();
//         } else {
//           this.setState({ savingPolicy: false });
//           NotificationManager.info(data.msg || "Failed to save policy");
//         }
//       })
//       .catch((error) => {
//         console.error("Error saving policy:", error);
//         this.setState({ savingPolicy: false });
//         NotificationManager.info("Error saving policy");
//       });
//   };

//   fetchAppCalendarSettings = (showNotification = false) => {
//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const loginData = JSON.parse(localStorage.getItem("login"));
//     const apiToken =  loginData.memtoken ;

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "getSettings",
//           api_token: apiToken,
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           // data.data contains array of enabled settings in order e.g., ["time", "cost", "name", ...]
//           const enabledSettings = data.data || [];
          
//           // Create a map of apiKey to enabled status and order
//           const settingsMap = {};
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const key = enabledSettings[i];
//             settingsMap[key] = { enabled: true, order: i };
//           }

//           // Create a new array with items in the exact order from API response
//           const orderedItems = [];
          
//           // First, add enabled items in the order they appear in API response
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const apiKey = enabledSettings[i];
//             // Find the matching item in appCalendarItems
//             for (let j = 0; j < this.state.appCalendarItems.length; j++) {
//               const item = this.state.appCalendarItems[j];
//               if (item.apiKey === apiKey) {
//                 orderedItems.push({
//                   ...item,
//                   enabled: true
//                 });
//                 break;
//               }
//             }
//           }
          
//           // Then, add disabled items that are not in the API response
//           for (let i = 0; i < this.state.appCalendarItems.length; i++) {
//             const item = this.state.appCalendarItems[i];
//             if (!settingsMap.hasOwnProperty(item.apiKey)) {
//               orderedItems.push({
//                 ...item,
//                 enabled: false
//               });
//             }
//           }

//           this.setState({ 
//             appCalendarItems: orderedItems,
//             appCalendarLoading: false,
//             appCalendarInitialized: true
//           });

//           // Only show notification if explicitly requested (not on page load)
//           if (showNotification) {
//             NotificationManager.success(data.message || "Calendar settings loaded");
//           }
//         } else {
//           if (showNotification) {
//             NotificationManager.info(data.message || "Failed to load calendar settings");
//           }
//           this.setState({ appCalendarLoading: false });
//         }
//       })
//       .catch(error => {
//         console.error("Error fetching app calendar settings:", error);
//         if (showNotification) {
//           NotificationManager.info("Error loading calendar settings");
//         }
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   addMobileStyles = () => {
//     const style = document.createElement('style');
//     style.innerHTML = `
//       .app-calendar-item {
//         -webkit-touch-callout: none;
//         -webkit-user-select: none;
//         user-select: none;
//         touch-action: pan-y;
//         transition: all 0.2s ease;
//       }
//       .app-calendar-item.dragging {
//         opacity: 0.7 !important;
//         transform: scale(1.02) !important;
//         box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
//         z-index: 9999 !important;
//         background-color: #f5f5f5 !important;
//       }
//       .app-calendar-item.drag-over {
//         border: 2px dashed #3f51b5 !important;
//         background-color: #e8eaf6 !important;
//         opacity: 0.8;
//         transform: scale(1.01);
//       }
//       .app-calendar-item:active {
//         background-color: #f0f0f0;
//       }
//       @media (max-width: 768px) {
//         .app-calendar-item {
//           cursor: default !important;
//         }
//         .app-calendar-item .drag-handle {
//           padding: 10px 5px;
//         }
//       }
//     `;
//     document.head.appendChild(style);
//   };

//   preventTouchScroll = (e) => {
//     if (this.state.touchDraggedItem !== null) {
//       e.preventDefault();
//     }
//   };

//   // Desktop Drag Handlers
//   handleDragStart = (event, index) => {
//     if (this.state.isTouchDevice) return; // Skip on touch devices
    
//     event.dataTransfer.setData('text/plain', index.toString());
//     event.dataTransfer.effectAllowed = 'move';
//     this.setState({ draggedItem: index });
//     event.currentTarget.style.opacity = '0.5';
//     event.currentTarget.style.backgroundColor = '#f0f0f0';
//   };

//   handleDragOver = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
//     event.dataTransfer.dropEffect = 'move';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (event.currentTarget) {
//       event.currentTarget.classList.add('drag-over');
//     }
//   };

//   handleDrop = (event, targetIndex) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     const sourceIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
//     if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;
    
//     const newItems = [...this.state.appCalendarItems];
//     const [movedItem] = newItems.splice(sourceIndex, 1);
//     newItems.splice(targetIndex, 0, movedItem);
    
//     this.setState({ 
//       appCalendarItems: newItems,
//       draggedItem: null 
//     });
//   };

//   handleDragEnd = (event) => {
//     if (this.state.isTouchDevice) return;
    
//     event.currentTarget.style.opacity = '1';
//     event.currentTarget.style.backgroundColor = '';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     this.setState({ draggedItem: null });
//   };

//   // Mobile Touch Handlers
//   handleTouchStart = (e, index) => {
//     e.preventDefault();
    
//     const touch = e.touches[0];
//     const target = e.currentTarget;
    
//     // Long press detection (300ms)
//     this.touchStartTimeout = setTimeout(() => {
//       this.setState({
//         touchStartY: touch.clientY,
//         touchStartX: touch.clientX,
//         touchDraggedItem: index,
//         touchDraggedIndex: index,
//         draggedItem: index
//       });

//       // Add dragging class
//       target.classList.add('dragging');
      
//       // Vibrate if supported (haptic feedback)
//       if (window.navigator.vibrate) {
//         window.navigator.vibrate(50);
//       }
//     }, 300);
    
//     this.setState({ touchStartTime: Date.now() });
//   };

//   handleTouchMove = (e) => {
//     e.preventDefault();
    
//     const { touchDraggedItem, touchStartY } = this.state;
//     if (touchDraggedItem === null) {
//       clearTimeout(this.touchStartTimeout);
//       return;
//     }

//     const touch = e.touches[0];
//     const currentY = touch.clientY;
//     const deltaY = currentY - touchStartY;

//     // Find which item we're hovering over
//     const items = document.querySelectorAll('.app-calendar-item');
//     let targetIndex = touchDraggedItem;
    
//     items.forEach((item, idx) => {
//       const rect = item.getBoundingClientRect();
//       if (currentY >= rect.top && currentY <= rect.bottom) {
//         targetIndex = idx;
//       }
//     });

//     // Show drop target indicator
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (items[targetIndex] && targetIndex !== touchDraggedItem) {
//       items[targetIndex].classList.add('drag-over');
      
//       // Auto-scroll if near edges
//       const container = document.querySelector('.LawaList');
//       if (container) {
//         const containerRect = container.getBoundingClientRect();
//         const scrollSpeed = 10;
        
//         if (currentY < containerRect.top + 50) {
//           container.scrollTop -= scrollSpeed;
//         } else if (currentY > containerRect.bottom - 50) {
//           container.scrollTop += scrollSpeed;
//         }
//       }
//     }

//     // Move the dragged item visually
//     const draggedItem = items[touchDraggedItem];
//     if (draggedItem && Math.abs(deltaY) > 10) {
//       draggedItem.style.transform = `translateY(${deltaY}px) scale(1.02)`;
//     }

//     this.setState({ touchDraggedIndex: targetIndex });
//   };

//   handleTouchEnd = (e) => {
//     e.preventDefault();
//     clearTimeout(this.touchStartTimeout);
    
//     const { touchDraggedItem, touchDraggedIndex } = this.state;
    
//     if (touchDraggedItem !== null && touchDraggedIndex !== -1) {
//       // Reorder if dropped on different item
//       if (touchDraggedIndex !== touchDraggedItem) {
//         const newItems = [...this.state.appCalendarItems];
//         const [movedItem] = newItems.splice(touchDraggedItem, 1);
//         newItems.splice(touchDraggedIndex, 0, movedItem);
        
//         this.setState({ appCalendarItems: newItems });
//       }
//     }

//     // Reset all visual states
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.transform = '';
//       item.style.backgroundColor = '';
//       item.classList.remove('dragging', 'drag-over');
//     });

//     this.setState({ 
//       draggedItem: null,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartY: 0
//     });
//   };

//   handleTouchCancel = (e) => {
//     this.handleTouchEnd(e);
//   };

//   // Toggle handler for App Calendar items
//   handleAppCalendarToggle = (itemId) => {
//     const updatedItems = this.state.appCalendarItems.map(item => {
//       if (item.id === itemId) {
//         return { ...item, enabled: !item.enabled };
//       }
//       return item;
//     });

//     this.setState({ appCalendarItems: updatedItems });
//   };

//   // Submit handler for App Calendar settings - SAVE API
//   handleAppCalendarSubmit = (e) => {
//     e.preventDefault();

//     // Get enabled items in current order
//     const enabledItems = this.state.appCalendarItems
//       .filter(item => item.enabled)
//       .map(item => item.apiKey); // Send apiKey to backend

//     // Apply blur effect
//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const apiToken =  logindetail.memtoken ;

//     // Create source object with the correct structure: source[appID], source[memberID], source[companyID], source[settings][0], etc.
//     const sourceData = {
//       appID: parameters.appID,
//       memberID: parameters.memberID,
//       companyID: parameters.companyID,
//     };

//     // Add settings as source[settings][0], source[settings][1], etc.
//     const settingsObj = {};
//     for (let i = 0; i < enabledItems.length; i++) {
//       settingsObj[i] = enabledItems[i];
//     }
//     sourceData.settings = settingsObj;

//     // API Call to save settings
//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "saveSettings",
//           api_token: apiToken,
//           source: sourceData,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           NotificationManager.success(data.message || "App Calendar Settings Updated Successfully");
          
//           // Refresh the settings to get the latest from server (with notification false)
//           this.fetchAppCalendarSettings(false);
          
//           // Remove blur effect after successful update
//           this.removeBlurEffect();
//         } else {
//           NotificationManager.info(data.message || "Failed to update settings");
//           this.setState({ appCalendarLoading: false });
          
//           // Remove blur effect on error
//           this.removeBlurEffect();
//         }
//       })
//       .catch(error => {
//         console.error("Error saving app calendar settings:", error);
//         NotificationManager.info("Error updating app calendar settings");
        
//         // Remove blur effect on error
//         this.removeBlurEffect();
        
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   handleEndDate = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       display_booking_end_time: checked ? "1" : "0"
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       display_booking_end_time: checked ? "1" : "0"
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_display_end_time",
//           source: dateVals,
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.display_booking_end_time = this.state.display_booking_end_time;

//           this.setState({
//             ...this.setState,
//             display_booking_end_time: loginData.display_booking_end_time
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleFormatChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       timeFormat: checked ? 24 : 12
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       timeFormat: checked ? 24 : 12
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "timeFormat",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',
//           timeFormat: dateVals.timeFormat
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.timeFormat = this.state.timeFormat;
//           this.setState({
//             ...this.state,
//             timeFormat: loginData.timeFormat
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleAddressInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       addressInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       addressInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "addressInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',
//           addressInInvoice: dateVals.addressInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.addressInInvoice = this.state.addressInInvoice;
//           this.setState({
//             ...this.state,
//             addressInInvoice: loginData.addressInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handlePersonalPhoneInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       phoneInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       phoneInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "phoneInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',
//           phoneInInvoice: dateVals.phoneInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.phoneInInvoice = this.state.phoneInInvoice;
//           this.setState({
//             ...this.state,
//             phoneInInvoice: loginData.phoneInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   // Original cancellation policy toggle - updated to handle policy ID
//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
    
//     // If turning ON, we need to fetch policies first or use default
//     if (checked) {
//       // If we have policies and a selected policy ID, use that
//       if (this.state.policies.length > 0 && this.state.selectedPolicyId) {
//         this.setState({
//           enableCancellationPolicy: 1
//         });

//         var dateVals = {
//           appID: logindetail && logindetail.aid,
//           companyID: logindetail && logindetail.cid,
//           memberID: logindetail && logindetail.uid,
//           enableCancellationPolicy: this.state.selectedPolicyId // Send the selected policy ID
//         };
        
//         httpClient
//           .post(
//             "updateUserSettings.php",
//             qs.stringify({
//               action: "enableCancellationPolicy",
//               source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//               enableCancellationPolicy: dateVals.enableCancellationPolicy
//             })
//           ).then(({ data }) => {
//             if (data.success == "true") {
//               var loginData = JSON.parse(localStorage.getItem("login"));

//               loginData.enableCancellationPolicy = this.state.selectedPolicyId;
//               this.setState({
//                 enableCancellationPolicy: 1
//               });
//               localStorage.setItem("login", JSON.stringify(loginData));
//               NotificationManager.info("Cancellation policy enabled");
//             }
//           });
//       } else {
//         // If no policies loaded or selected, fetch them first
//         this.fetchPolicies();
//         this.setState({
//           enableCancellationPolicy: 1
//         });
//       }
//     } else {
//       // Turning OFF - send 0
//       this.setState({
//         enableCancellationPolicy: 0
//       });

//       var dateVals = {
//         appID: logindetail && logindetail.aid,
//         companyID: logindetail && logindetail.cid,
//         memberID: logindetail && logindetail.uid,
//         enableCancellationPolicy: 0 // Send 0 to disable
//       };
      
//       httpClient
//         .post(
//           "updateUserSettings.php",
//           qs.stringify({
//             action: "enableCancellationPolicy",
//             source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//             enableCancellationPolicy: dateVals.enableCancellationPolicy
//           })
//         ).then(({ data }) => {
//           if (data.success == "true") {
//             var loginData = JSON.parse(localStorage.getItem("login"));

//             loginData.enableCancellationPolicy = 0;
//             this.setState({
//               enableCancellationPolicy: 0
//             });
//             localStorage.setItem("login", JSON.stringify(loginData));
//             NotificationManager.info("Cancellation policy disabled");
//           }
//         });
//     }
//   }

//   handleToggle = (event, value) => {
//     var settingParam;
//     var aid, cid, uid;
//     var btntype;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail.uid;
//     btntype = value;

//     const { checked } = this.state;
//     const currentIndex = checked.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex == -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     this.setState({
//       checked: newChecked,
//     });

//     settingParam = aid + "_" + cid + "_" + uid + "_" + value;

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: btntype,
//           source: settingParam,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data.success != "true") {
//             NotificationManager.info(data.failedMSG);
//           } else if (data.success == "true") {
//             var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
//             var objname = data.actionOn;

//             if (objname == "displayCustNotes")
//               loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

//             if (objname == "hideOldRecurring")
//               loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

//             if (objname == "displayBookingClash")
//               loginTempOBJ.displayBookingClash =
//                 1 - loginTempOBJ.displayBookingClash;

//             if (objname == "hidePastBookingsCalendarSearch")
//               loginTempOBJ.hidePastBookingsCalendarSearch =
//                 1 - loginTempOBJ.hidePastBookingsCalendarSearch;

//             if (objname == "filterBookingServices") {
//               loginTempOBJ.filterBookingServices =
//                 1 - loginTempOBJ.filterBookingServices;
//             }

//             localStorage.setItem("login", JSON.stringify(loginTempOBJ));
//             NotificationManager.info(data.msg);
//           }
//         },
//         (error) => {
//           this.setState({
//             error,
//           });
//         }
//       );
//   };

//   handleCalendarChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//   };

//   handleBookingConfirmationChange = (event) => {
//     this.setState({ selectedSetting: event.target.value });
//   };

//   handleChangeConfirmationHour = (e) => {
//     this.setState({
//       confirmationHour: e.target.value,
//     });
//   };

//   handleSaveSettings() {
//     if (this.state.incometemplate == "" && this.state.incomedescription == "") {
//       NotificationManager.info("Nothing changed to save");
//     } else {
//       httpClient
//         .post(
//           "saveMemberSettings.php",
//           qs.stringify({
//             action: "save_settings",
//             source: this.state,
//           })
//         )
//         .then(
//           ({ data }) => {
//             if (data.success != "true") {
//               NotificationManager.info(data.failedMSG);
//             } else {
//               NotificationManager.info(data.successMSG);
//               this.setState({
//                 incometemplate: "",
//                 incomedescription: "",
//               });
//             }
//           },
//           (error) => {
//             NotificationManager.info(
//               "Error Occured: Refresh the page and try again"
//             );
//           }
//         );
//     }
//   }

//   handleChange(evt) {
//     this.setState({ [evt.target.name]: evt.target.value });
//   }

//   handleSubmitCalendar = (e) => {
//     e.preventDefault();

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({
//       ...this.state,
//       loading: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       customer_name: this.state.customerName,
//       bookingCost: this.state.bookingTotal,
//       customer_address: this.state.customerAddress,
//       pet_name: this.state.petName,
//       pet_breed: this.state.petBreed,
//       services_name: this.state.serviceName,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_calendar_settings",
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           NotificationManager.success(data.successMSG);
//           let calendarData = [];
//           let calendarStorage = JSON.parse(localStorage.getItem("settings"));

//           calendarData = {
//             ...calendarStorage,
//             customer_name: data.customer_name,
//             bookingCost: data.bookingCost,
//             pet_name: data.pet_name,
//             services_name: data.services_name,
//             customer_address: data.customer_address,
//           };

//           const cal = { ...calendarData };

//           localStorage.setItem("settings", JSON.stringify(cal));

//           setTimeout(() => {
//             NotificationManager.info("Retrieving Calendar Entries");
//           }, 1000);

//           this.getCalendarEntry();
//         } else {
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   handleSubmitConfirmation = (e) => {
//     e.preventDefault();

//     this.setState({
//       ...this.state,
//       loadingConfirmation: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "bookingConfirmation",
//           source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
//           confirmationBy: this.state.selectedSetting,
//           confirmationHour: this.state.confirmationHour,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: data.data.confirmationBy,
//             confirmationHour: parseInt(data.data.confirmationHour),
//           });
//           NotificationManager.success(data.msg);
//         } else {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: "",
//             confirmationHour: "",
//           });
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   getCalendarEntry = () => {
//     httpClient
//       .post(
//         "getCalendarEntries.php",
//         qs.stringify({
//           action: "calendar_entries",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             var calendarLastMod = {
//               calendarLastModified: data.calendarLastModified,
//             };
//             var dataIndex =
//               modifiedData &&
//               modifiedData.findIndex((arr, i) => arr.calendarLastModified);
//             modifiedData && (modifiedData[dataIndex] = calendarLastMod);

//             localStorage.setItem("calendar_entries", JSON.stringify(data.data));
//             this.setState({
//               syncModified: modifiedData,
//             });

//             this.setState({
//               ...this.state,
//               loading: false,
//             });
            
//             if (this.state.syncModified.length > 0) {
//               var loginData = JSON.parse(localStorage.getItem("login"));
//               loginData.syncLastModified = this.state.syncModified;
//               loginData.syncLastModified !== [] &&
//                 localStorage.setItem("login", JSON.stringify(loginData));
//             }

//             NotificationManager.success(
//               "Calendar Settings Successfully Updated"
//             );

//             let loginBlur = JSON.parse(localStorage.getItem("login"));

//             if (loginBlur && loginBlur.ismobiledevice != 1) {
//               document.getElementById("nav__menu__display") !== null &&
//                 (document.getElementById("nav__menu__display").style.cssText =
//                   "filter: blur(0px); pointer-events: block");
//             }
//             document.getElementById("appbar_mainapp__") !== null &&
//               (document.getElementById("appbar_mainapp__").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           } else {
//           }
//         }
//       );
//   };

//   render() {
//     const {
//       error,
//       isLoaded,
//       incomedescription,
//       settingdetail,
//       incometemplate,
//       customerName,
//       bookingTotal,
//       customerAddress,
//       petName,
//       petBreed,
//       serviceName,
//       appCalendarItems,
//       appCalendarLoading,
//       appCalendarInitialized,
//       policies,
//       policiesLoading,
//       selectedPolicyId,
//       savingPolicy,
//       enableCancellationPolicy,
//     } = this.state;

//     if (error) {
//       return <div className="jr-customers">Error: {error.message}</div>;
//     } else if (!isLoaded || (appCalendarLoading && !appCalendarInitialized)) {
//       return (
//         <div className="jr-customers">
//           <LinearProgress color="secondary" />
//         </div>
//       );
//     } else {
//       return (
//         <>
//           <div className="app-wrapper animated slideInUpTiny animation-duration-3">
//             <ContainerHeader
//               title={<IntlMessages id="sidebar.dashboard.settings" />}
//               match={this.props.match}
//             />

//             <div className="row">
//               <CardBox
//                 heading={<IntlMessages id="dashboard.settings.preferences" />}
//               >
//                 <div className="col-md-12 col-12">
//                   <List className="LawaList">
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Customer Notes on Booking" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayCustNotes")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayCustNotes") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "hideOldBookings")
//                           }
//                           checked={
//                             this.state.checked.indexOf("hideOldBookings") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Booking Clash Notifications" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayBookingClash")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayBookingClash") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Past Bookings from Calendar Search" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(
//                               event,
//                               "hidePastBookingsCalendarSearch"
//                             )
//                           }
//                           checked={
//                             this.state.checked.indexOf(
//                               "hidePastBookingsCalendarSearch"
//                             ) != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Filter Services based on pet size" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "filterBookingServices")
//                           }
//                           checked={
//                             this.state.checked.indexOf("filterBookingServices") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Booking End Time" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.display_booking_end_time === "1"}
//                           onChange={this.handleEndDate}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Address In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.addressInInvoice === 1}
//                           onChange={this.handleAddressInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Personal Phone In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.phoneInInvoice === 1}
//                           onChange={this.handlePersonalPhoneInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Toggle 24hr Time Format" />
//                       <ListItemSecondaryAction>
//                         <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
//                         <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
//                           <Switch
//                             color="primary"
//                             checked={this.state.timeFormat === 24}
//                             onChange={this.handleFormatChange}
//                           />
//                         </Tooltip>
//                         <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                   </List>
//                 </div>
//               </CardBox>

//               <div className="col-md-6">
//                 <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
//                       <div className="col-md-12 col-12">
//                         <TextField
//                           id="smsNumber"
//                           label="SMS Sender"
//                           value="0495149675"
//                           margin="normal"
//                           helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                           fullWidth
//                         />
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
                  
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={"Cancellation Policy"}>
//                       <div className="col-md-12 col-12">
//                         {/* Original static policy text */}
//                         {/* <span>PLEASE NOTE: 24 hours notice is required to cancel your appointment.
//                           We reserve the right to charge a cancellation fee if you are not home when we call for our confirmed appointment time.</span>
//                          */}
//                         {/* Original toggle - now handles policy ID when turning ON */}
//                         <List>
//                           <ListItem>
//                             <ListItemIcon>
//                               <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
//                             </ListItemIcon>
//                             <ListItemText primary="Attach Cancellation Policy" />
//                             <ListItemSecondaryAction>
//                               <Switch
//                                 color="primary"
//                                 checked={enableCancellationPolicy === 1}
//                                 onChange={this.handleCancellationPolicyChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                         </List>

//                         {/* New policy selection section - only visible when toggle is ON */}
//                         {enableCancellationPolicy === 1 && (
//                           <>
//                             <Divider style={{ margin: '15px 0' }} />
//                             <FormLabel component="legend" style={{ marginBottom: '10px', marginLeft: '15px' }}>
//                               Select Policy
//                             </FormLabel>
//                             {policiesLoading ? (
//                               <LinearProgress color="secondary" />
//                             ) : (
//                               <>
//                                 <FormControl component="fieldset" fullWidth>
//                                   <RadioGroup
//                                     name="policies-radio-group"
//                                     value={selectedPolicyId}
//                                     onChange={this.handlePolicyChange}
//                                   >
//                                     {policies.map((policy) => (
//                                       <FormControlLabel
//                                         key={policy.policyID}
//                                         value={policy.policyID}
//                                         control={<Radio color="primary" />}
//                                         label={
//                                           <span 
//                                             dangerouslySetInnerHTML={{ __html: policy.policy }}
//                                             style={{ fontSize: '0.9rem' }}
//                                           />
//                                         }
//                                         style={{
//                                           marginBottom: '10px',
//                                           alignItems: 'flex-start',
//                                         }}
//                                       />
//                                     ))}
//                                   </RadioGroup>
//                                 </FormControl>
                                
//                                 <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
//                                   {savingPolicy ? (
//                                     <Button
//                                       variant="contained"
//                                       color="primary"
//                                       disabled={true}
//                                     >
//                                       Saving...
//                                     </Button>
//                                   ) : (
//                                     <Button
//                                       variant="contained"
//                                       color="primary"
//                                       onClick={this.handleSavePolicy}
//                                       disabled={!selectedPolicyId}
//                                     >
//                                       Save Policy Selection
//                                     </Button>
//                                   )}
//                                 </div>
//                               </>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
//                 </Grid>
//               </div>

//               <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
//                 <form className="row" noValidate autoComplete="off">
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incometemplate"
//                       name="incometemplate"
//                       label="Income Title Template"
//                       margin="normal"
//                       defaultValue={this.state.settingdetail.title}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       onChange={this.handleChange}
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incomedescription"
//                       name="incomedescription"
//                       label="Income Description"
//                       defaultValue={this.state.settingdetail.desc}
//                       margin="normal"
//                       onChange={this.handleChange}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="jr-btn btn-margin-topbottom"
//                       position="static"
//                       onClick={() => {
//                         this.handleSaveSettings();
//                       }}
//                     >
//                       Save
//                     </Button>
//                   </div>
//                 </form>
//               </CardBox>
              
//               <CardBox heading="Send Booking Reminder">
//                 {this.state.loadingConfirmation && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Do not send booking reminder" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value=""
//                             checked={this.state.selectedSetting === ""}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email and SMS for all customers" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="all"
//                             checked={this.state.selectedSetting === "all"}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email only, do not send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="emailOnly"
//                             checked={this.state.selectedSetting === 'emailOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send SMS only, do not send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="smsOnly"
//                             checked={this.state.selectedSetting === 'smsOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by email but if not found, send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedEmail"
//                             checked={this.state.selectedSetting === 'preferedEmail'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by SMS but if no mobile number, send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedSMS"
//                             checked={this.state.selectedSetting === 'preferedSMS'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
//                         <ListItemSecondaryAction>
//                           <FormControl variant="outlined" style={{ width: "100px" }}>
//                             <Select
//                               placeholder="Select Confirmation Before"
//                               name="confirmationHour"
//                               value={this.state.confirmationHour}
//                               style={{
//                                 textAlign: 'center',
//                                 paddingLeft: '0',
//                               }}
//                               inputProps={{
//                                 style: {
//                                   textAlign: 'center',
//                                 },
//                               }}
//                               onChange={(e) => this.handleChangeConfirmationHour(e)}
//                             >
//                               <MenuItem value="">
//                                 <em>Select Confirmation Before</em>
//                               </MenuItem>
//                               <MenuItem value={24}>{"24 hrs"}</MenuItem>
//                               <MenuItem value={48}>{"48 hrs"}</MenuItem>
//                               <MenuItem value={72}>{"72 hrs"}</MenuItem>
//                             </Select>
//                           </FormControl>
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       {this.state.loadingConfirmation ? (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                           disabled={true}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       )}
//                     </List>
//                   </div>
//                 </div>
//               </CardBox>

//               <CardBox heading="Calendar Settings">
//                 {this.state.loading && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Show Booking Total" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="bookingTotal"
//                             checked={bookingTotal}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerName"
//                             checked={customerName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Address" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerAddress"
//                             checked={customerAddress}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petName"
//                             checked={petName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Breed" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petBreed"
//                             checked={petBreed}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Services Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="serviceName"
//                             checked={serviceName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <div>
//                         <h5>Preview</h5>
//                       </div>
//                       {(bookingTotal ||
//                         customerName ||
//                         customerAddress ||
//                         petName || petBreed ||
//                         serviceName) && (
//                           <Card
//                             style={{
//                               padding: "20px",
//                               backgroundColor: "#3f51b5",
//                               color: "#fff",
//                               width: "400px",
//                             }}
//                           > 
//                             {bookingTotal && <div>$Total Cost</div>}
//                             {customerName && <div>Firstname Lastname</div>}
//                             {customerAddress && <div>Street Address, Suburb, Postcode</div>}
//                             {petName && <div>Pet Name</div>}
//                             {petBreed && <div>Pet Breed</div>}
//                             {serviceName && <div>Services</div>}
//                           </Card>
//                         )}
//                     </List>
//                     {this.state.loading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={true}
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={
//                           !(bookingTotal ||
//                             customerName ||
//                             customerAddress ||
//                             petName || petBreed ||
//                             serviceName)
//                         }
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>

//               {/* App Calendar Settings Section with Mobile Support */}
//               <CardBox heading="App Calendar Settings">
//                 {appCalendarLoading && (
//                   <div style={{ position: "relative", top: "15px", marginBottom: "20px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <p style={{ 
//                       marginBottom: '15px', 
//                       color: '#666', 
//                       fontSize: '0.9rem',
//                       padding: '10px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}>
//                       {/* <i className="zmdi zmdi-menu" style={{ marginRight: '10px', fontSize: '20px' }}></i> */}
//                       {this.state.isTouchDevice ? (
//                         <span>Long press and drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       ) : (
//                         <span>Drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       )}
//                     </p>

//                     <List className="LawaList">
//                       {appCalendarItems.map((item, index) => (
//                         <ListItem
//                           key={item.id}
//                           className="app-calendar-item"
//                           draggable={!this.state.isTouchDevice}
//                           onDragStart={(e) => this.handleDragStart(e, index)}
//                           onDragOver={(e) => this.handleDragOver(e, index)}
//                           onDrop={(e) => this.handleDrop(e, index)}
//                           onDragEnd={this.handleDragEnd}
//                           onTouchStart={(e) => this.handleTouchStart(e, index)}
//                           onTouchMove={this.handleTouchMove}
//                           onTouchEnd={this.handleTouchEnd}
//                           onTouchCancel={this.handleTouchCancel}
//                           style={{
//                             cursor: this.state.isTouchDevice ? 'default' : 'grab',
//                             border: '1px solid transparent',
//                             transition: 'all 0.2s',
//                             backgroundColor: this.state.draggedItem === index ? '#f5f5f5' : 'transparent',
//                             WebkitTapHighlightColor: 'transparent',
//                           }}
//                         >
//                           <ListItemIcon 
//                             className="drag-handle"
//                             style={{ 
//                               cursor: this.state.isTouchDevice ? 'pointer' : 'grab', 
//                               minWidth: '40px',
//                               padding: this.state.isTouchDevice ? '10px 5px' : '0',
//                             }}
//                           >
//                             <i className="zmdi zmdi-menu" style={{ fontSize: '20px', color: '#999' }}></i>
//                           </ListItemIcon>
//                           {/* <ListItemIcon>
//                             <i className={`zmdi ${item.icon} zmdi-hc-fw zmdi-hc-2x`} />
//                           </ListItemIcon> */}
//                           <ListItemText primary={item.label} />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               checked={item.enabled}
//                               onChange={() => this.handleAppCalendarToggle(item.id)}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                       ))}
//                     </List>

//                     {/* Preview Section */}
//                     <div style={{ marginTop: '20px' }}>
//                       <h5>Preview </h5>
//                       {appCalendarItems.some(item => item.enabled) ? (
//                         <Card
//                           style={{
//                             padding: "20px",
//                             backgroundColor: "#3f51b5",
//                             color: "#fff",
//                             width: "100%",
//                             maxWidth: "400px",
//                           }}
//                         >
//                           {appCalendarItems
//                             .filter(item => item.enabled)
//                             .map(item => {
//                               switch(item.apiKey) {
//                                 case 'time':
//                                   return <div key={item.id}>10:30 AM</div>;
//                                 case 'cost':
//                                   return <div key={item.id}>Service Cost</div>;
//                                 case 'name':
//                                   return <div key={item.id}>Customer Name</div>;
//                                 case 'address':
//                                   return <div key={item.id}>123 Main St, Sydney 2000</div>;
//                                 case 'petName':
//                                   return <div key={item.id}>Pet Name</div>;
//                                 case 'petBreed':
//                                   return <div key={item.id}>Pet Breed</div>;
//                                 case 'serviceName':
//                                   return <div key={item.id}>Full Grooming</div>;
//                                 default:
//                                   return null;
//                               }
//                             })}
//                         </Card>
//                       ) : (
//                         <p style={{ color: '#999', fontStyle: 'italic' }}>Toggle on items to see preview</p>
//                       )}
//                     </div>

//                     {appCalendarLoading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         disabled={true}
//                       >
//                         Updating...
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         onClick={this.handleAppCalendarSubmit}
//                       >
//                         Update App Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>
//             </div>
//           </div>
//           <NotificationContainer />
//         </>
//       );
//     }
//   }
// }

// export default Settings;

// **********************************************************************************************************************

// import React from "react";
// import ContainerHeader from "components/ContainerHeader/index";
// import CardBox from "components/CardBox/index";
// import CardBoxNew from "components/CardBoxNew/index";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import "../../../../src/assets/vendors/react-notification/react-notifications.css"
// import { httpClient } from "appUtility/Api";
// import IntlMessages from "util/IntlMessages";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
// import Switch from "@material-ui/core/Switch";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import featureServer from "../../../appUtility/featureServer";
// import { FormControl, Grid, MenuItem, Radio, Select, Tooltip, RadioGroup, FormControlLabel, Divider, FormLabel, InputAdornment,InputLabel } from "@material-ui/core";
// import configureStore from "../../../store";

// const loginOBJ = localStorage.getItem("login");
// const logindetail = JSON.parse(loginOBJ);
// var modifiedData = logindetail && logindetail.syncLastModified;
// const qs = require("qs");

// var param, settingdetail;

// class Settings extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       error: null,
//       isLoaded: false,
//       id: "",
//       incometemplate: "",
//       incomedescription: "",
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       mcode: logindetail && logindetail.mCode,
//       settingdetail: "",
//       checked: [],
//       customerName: false,
//       bookingTotal: false,
//       customerAddress: false,
//       petName: false,
//       petBreed: false,
//       serviceName: false,
//       syncModified: "",
//       loading: false,
//       display_booking_end_time: logindetail && logindetail.display_booking_end_time,
//       timeFormat: logindetail && logindetail.timeFormat,
//       addressInInvoice: logindetail && logindetail.addressInInvoice,
//       phoneInInvoice: logindetail && logindetail.phoneInInvoice,
//       enableCancellationPolicy: logindetail && logindetail.enableCancellationPolicy,
//       selectedSetting: "",
//       confirmationHour: 24,
//       loadingConfirmation: false,
      
//       // New state for policies
//       policies: [],
//       policiesLoading: false,
//       selectedPolicyId: "",
//       savingPolicy: false,
      
//       // Dynamic policy fields
//       cancelBeforeValue: "",
//       cancelBeforeUnit: "hours",
//       cancelFeeValue: "",
//       cancelFeeUnit: "%",
//       cancelCutoffTime: "",
//       dynamicFieldsDisabled: true,
      
//       // App Calendar Settings with all possible items (time instead of date)
//       appCalendarItems: [
//         { id: 'appTime', label: 'Show Time', icon: 'zmdi-time', enabled: false, apiKey: 'time' },
//         { id: 'appBookingTotal', label: 'Show Booking Total', icon: 'zmdi-money', enabled: false, apiKey: 'cost' },
//         { id: 'appCustomerName', label: 'Show Customer Name', icon: 'zmdi-account', enabled: false, apiKey: 'name' },
//         { id: 'appCustomerAddress', label: 'Show Customer Address', icon: 'zmdi-pin', enabled: false, apiKey: 'address' },
//         { id: 'appPetName', label: 'Show Pet Name', icon: 'zmdi-face', enabled: false, apiKey: 'petName' },
//         { id: 'appPetBreed', label: 'Show Pet Breed', icon: 'zmdi-label', enabled: false, apiKey: 'petBreed' },
//         { id: 'appServiceName', label: 'Show Services Name', icon: 'zmdi-cut', enabled: false, apiKey: 'serviceName' },
//       ],
//       appCalendarLoading: false,
//       draggedItem: null,
//       appCalendarInitialized: false,
      
//       // Mobile touch states
//       isTouchDevice: false,
//       touchStartY: 0,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartTime: 0,
//     };

//     this.handleChange = this.handleChange.bind(this);
//     this.handleAppCalendarToggle = this.handleAppCalendarToggle.bind(this);
//     this.handleAppCalendarSubmit = this.handleAppCalendarSubmit.bind(this);
//     this.removeBlurEffect = this.removeBlurEffect.bind(this);
    
//     // Desktop drag handlers
//     this.handleDragStart = this.handleDragStart.bind(this);
//     this.handleDragOver = this.handleDragOver.bind(this);
//     this.handleDrop = this.handleDrop.bind(this);
//     this.handleDragEnd = this.handleDragEnd.bind(this);
    
//     // Mobile touch handlers
//     this.handleTouchStart = this.handleTouchStart.bind(this);
//     this.handleTouchMove = this.handleTouchMove.bind(this);
//     this.handleTouchEnd = this.handleTouchEnd.bind(this);
//     this.handleTouchCancel = this.handleTouchCancel.bind(this);
    
//     // Policy handlers
//     this.fetchPolicies = this.fetchPolicies.bind(this);
//     this.handlePolicyChange = this.handlePolicyChange.bind(this);
//     this.handleSavePolicy = this.handleSavePolicy.bind(this);
    
//     // Dynamic policy field handlers
//     this.handleCancelBeforeValueChange = this.handleCancelBeforeValueChange.bind(this);
//     this.handleCancelBeforeUnitChange = this.handleCancelBeforeUnitChange.bind(this);
//     this.handleCancelFeeValueChange = this.handleCancelFeeValueChange.bind(this);
//     this.handleCancelFeeUnitChange = this.handleCancelFeeUnitChange.bind(this);
//     this.handleCancelCutoffTimeChange = this.handleCancelCutoffTimeChange.bind(this);
//   }

//   componentDidMount() {
//     // Detect touch device
//     this.setState({
//       isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
//     });

//     // Prevent default touch behaviors on draggable items
//     document.addEventListener('touchmove', this.preventTouchScroll, { passive: false });
    
//     var aid, cid, uid;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail && logindetail.uid;

//     param = aid + "_" + cid + "_" + uid;

//     // Fetch member settings
//     httpClient
//       .post(
//         "getMemberSettings.php",
//         qs.stringify({
//           action: "member_settings",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             localStorage.setItem("settings", JSON.stringify(data));
//             this.setState(
//               {
//                 isLoaded: false,
//                 id: data.id,
//                 settingdetail: data,
//                 checked: data.flags,
//                 petName: data.pet_name == "1" ? true : false,
//                 petBreed: data.pet_breed == "1" ? true : false,
//                 serviceName: data.services_name == "1" ? true : false,
//                 customerName: data.customer_name == "1" ? true : false,
//                 bookingTotal: data.bookingCost == "1" ? true : false,
//                 customerAddress: data.customer_address == "1" ? true : false,
//                 confirmationHour: parseInt(data.confirmationHour),
//                 selectedSetting: data.confirmationBy,
//               },
//               function () {
//                 this.setState({
//                   isLoaded: true,
//                 });
//               }
//             );
//           } else {
//           }
//         },
//         (error) => {
//           this.setState({
//             isLoaded: true,
//             error,
//           });
//         }
//       );

//     const loginValue = JSON.parse(localStorage.getItem("login"));
//     this.setState({
//       ...this.state,
//       display_booking_end_time: loginValue.display_booking_end_time,
//       timeFormat: loginValue.timeFormat,
//       addressInInvoice: loginValue.addressInInvoice,
//       phoneInInvoice: loginValue.phoneInInvoice,
//       enableCancellationPolicy: loginValue.enableCancellationPolicy
//     });

//     // Fetch policies
//     this.fetchPolicies();

//     // Fetch App Calendar Settings (no notification on page load)
//     this.fetchAppCalendarSettings(false);

//     // Add CSS for mobile
//     this.addMobileStyles();
//   }

//   componentWillUnmount() {
//     document.removeEventListener('touchmove', this.preventTouchScroll);
//   }

//   // Helper function to remove blur effect
//   removeBlurEffect = () => {
//     let loginBlur = JSON.parse(localStorage.getItem("login"));
    
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(0px); pointer-events: block");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(0px); pointer-events: block");
//   }

//   // Fetch policies from API
//   fetchPolicies = () => {
//     this.setState({ policiesLoading: true });

//     const apiToken = logindetail.memtoken || "";
//     const formData = new FormData();
//     formData.append('action', 'getPolicies');
//     formData.append('api_token', apiToken);
//     formData.append('source[appID]', this.state.appID);
//     formData.append('source[memberID]', this.state.memberID);
//     formData.append('source[companyID]', this.state.companyID);

//     httpClient
//       .post("/v2/getPolicies.php", formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       })
//       .then((response) => {
//         if (response.data.success && response.data.data) {
//           const policies = response.data.data;
//           const selectedPolicy = policies.find(policy => policy.is_selected === 1);
//           const settings = response.data.settings || {};
          
//           this.setState({ 
//             policies: policies,
//             policiesLoading: false,
//             selectedPolicyId: selectedPolicy ? selectedPolicy.policyID : "",
//             // Populate dynamic fields from settings
//             cancelBeforeValue: settings.cancelBeforeValue || "",
//             cancelBeforeUnit: settings.cancelBeforeUnit || "hours",
//             cancelFeeValue: settings.cancelFeeValue || "",
//             cancelFeeUnit: settings.cancelFeeUnit || "%",
//             cancelCutoffTime: settings.cancelCutoffTime || "",
//             dynamicFieldsDisabled: !selectedPolicy, // Disable if no policy selected
//           });

//           // Update localStorage with the selected policy
//           if (selectedPolicy) {
//             var loginData = JSON.parse(localStorage.getItem("login"));
//             loginData.enableCancellationPolicy = selectedPolicy.policyID;
//             localStorage.setItem("login", JSON.stringify(loginData));
//           }
//         } else {
//           this.setState({ policiesLoading: false });
//           NotificationManager.info("Failed to load policies");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching policies:", error);
//         this.setState({ policiesLoading: false });
//         NotificationManager.info("Error loading policies");
//       });
//   };

//   // Handle policy radio change
//   handlePolicyChange = (event) => {
//     const selectedPolicyId = event.target.value;
//     this.setState({ 
//       selectedPolicyId: selectedPolicyId,
//       dynamicFieldsDisabled: false // Enable dynamic fields when policy is selected
//     });
//   };

//   // Dynamic policy field handlers
//   handleCancelBeforeValueChange = (e) => {
//     this.setState({ cancelBeforeValue: e.target.value });
//   };

//   handleCancelBeforeUnitChange = (e) => {
//     this.setState({ cancelBeforeUnit: e.target.value });
//   };

//   handleCancelFeeValueChange = (e) => {
//     this.setState({ cancelFeeValue: e.target.value });
//   };

//   handleCancelFeeUnitChange = (e) => {
//     this.setState({ cancelFeeUnit: e.target.value });
//   };

//   handleCancelCutoffTimeChange = (e) => {
//     this.setState({ cancelCutoffTime: e.target.value });
//   };

//   // Validate dynamic fields
//   validateDynamicFields = () => {
//     const { cancelBeforeValue, cancelFeeValue, cancelCutoffTime } = this.state;
//     const timePattern = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
    
//     if (!cancelBeforeValue || cancelBeforeValue <= 0) {
//       NotificationManager.info("Please enter valid Cancel Before Value");
//       return false;
//     }
    
//     if (!cancelFeeValue || cancelFeeValue <= 0) {
//       NotificationManager.info("Please enter valid Cancellation Fee Value");
//       return false;
//     }
    
//     if (!cancelCutoffTime || !timePattern.test(cancelCutoffTime)) {
//       NotificationManager.info("Please enter valid Cutoff Time in HH:MM:SS format (e.g., 22:00:00)");
//       return false;
//     }
    
//     return true;
//   };

//   // Save selected policy - UPDATED to include dynamic fields
//   handleSavePolicy = () => {
//     if (!this.state.selectedPolicyId) {
//       NotificationManager.info("Please select a policy");
//       return;
//     }
    
//     // Validate dynamic fields
//     if (!this.validateDynamicFields()) {
//       return;
//     }

//     this.setState({ savingPolicy: true });

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       enableCancellationPolicy: this.state.selectedPolicyId,
//       cancelBeforeValue: this.state.cancelBeforeValue,
//       cancelBeforeUnit: this.state.cancelBeforeUnit,
//       cancelFeeValue: this.state.cancelFeeValue,
//       cancelFeeUnit: this.state.cancelFeeUnit,
//       cancelCutoffTime: this.state.cancelCutoffTime
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//           enableCancellationPolicy: dateVals.enableCancellationPolicy,
//           cancelBeforeValue: dateVals.cancelBeforeValue,
//           cancelBeforeUnit: dateVals.cancelBeforeUnit,
//           cancelFeeValue: dateVals.cancelFeeValue,
//           cancelFeeUnit: dateVals.cancelFeeUnit,
//           cancelCutoffTime: dateVals.cancelCutoffTime
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.enableCancellationPolicy = this.state.selectedPolicyId;
          
//           this.setState({
//             enableCancellationPolicy: 1,
//             savingPolicy: false
//           });
          
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.success("Policy saved successfully");
          
//           // Refresh policies to get updated settings
//           this.fetchPolicies();
//         } else {
//           this.setState({ savingPolicy: false });
//           NotificationManager.info(data.msg || "Failed to save policy");
//         }
//       })
//       .catch((error) => {
//         console.error("Error saving policy:", error);
//         this.setState({ savingPolicy: false });
//         NotificationManager.info("Error saving policy");
//       });
//   };

//   fetchAppCalendarSettings = (showNotification = false) => {
//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const loginData = JSON.parse(localStorage.getItem("login"));
//     const apiToken = loginData.memtoken ;

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "getSettings",
//           api_token: apiToken,
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           const enabledSettings = data.data || [];
          
//           const settingsMap = {};
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const key = enabledSettings[i];
//             settingsMap[key] = { enabled: true, order: i };
//           }

//           const orderedItems = [];
          
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const apiKey = enabledSettings[i];
//             for (let j = 0; j < this.state.appCalendarItems.length; j++) {
//               const item = this.state.appCalendarItems[j];
//               if (item.apiKey === apiKey) {
//                 orderedItems.push({
//                   ...item,
//                   enabled: true
//                 });
//                 break;
//               }
//             }
//           }
          
//           for (let i = 0; i < this.state.appCalendarItems.length; i++) {
//             const item = this.state.appCalendarItems[i];
//             if (!settingsMap.hasOwnProperty(item.apiKey)) {
//               orderedItems.push({
//                 ...item,
//                 enabled: false
//               });
//             }
//           }

//           this.setState({ 
//             appCalendarItems: orderedItems,
//             appCalendarLoading: false,
//             appCalendarInitialized: true
//           });

//           if (showNotification) {
//             NotificationManager.success(data.message || "Calendar settings loaded");
//           }
//         } else {
//           if (showNotification) {
//             NotificationManager.info(data.message || "Failed to load calendar settings");
//           }
//           this.setState({ appCalendarLoading: false });
//         }
//       })
//       .catch(error => {
//         console.error("Error fetching app calendar settings:", error);
//         if (showNotification) {
//           NotificationManager.info("Error loading calendar settings");
//         }
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   addMobileStyles = () => {
//     const style = document.createElement('style');
//     style.innerHTML = `
//       .app-calendar-item {
//         -webkit-touch-callout: none;
//         -webkit-user-select: none;
//         user-select: none;
//         touch-action: pan-y;
//         transition: all 0.2s ease;
//       }
//       .app-calendar-item.dragging {
//         opacity: 0.7 !important;
//         transform: scale(1.02) !important;
//         box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
//         z-index: 9999 !important;
//         background-color: #f5f5f5 !important;
//       }
//       .app-calendar-item.drag-over {
//         border: 2px dashed #3f51b5 !important;
//         background-color: #e8eaf6 !important;
//         opacity: 0.8;
//         transform: scale(1.01);
//       }
//       .app-calendar-item:active {
//         background-color: #f0f0f0;
//       }
//       @media (max-width: 768px) {
//         .app-calendar-item {
//           cursor: default !important;
//         }
//         .app-calendar-item .drag-handle {
//           padding: 10px 5px;
//         }
//       }
//     `;
//     document.head.appendChild(style);
//   };

//   preventTouchScroll = (e) => {
//     if (this.state.touchDraggedItem !== null) {
//       e.preventDefault();
//     }
//   };

//   // Desktop Drag Handlers
//   handleDragStart = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.dataTransfer.setData('text/plain', index.toString());
//     event.dataTransfer.effectAllowed = 'move';
//     this.setState({ draggedItem: index });
//     event.currentTarget.style.opacity = '0.5';
//     event.currentTarget.style.backgroundColor = '#f0f0f0';
//   };

//   handleDragOver = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
//     event.dataTransfer.dropEffect = 'move';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (event.currentTarget) {
//       event.currentTarget.classList.add('drag-over');
//     }
//   };

//   handleDrop = (event, targetIndex) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     const sourceIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
//     if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;
    
//     const newItems = [...this.state.appCalendarItems];
//     const [movedItem] = newItems.splice(sourceIndex, 1);
//     newItems.splice(targetIndex, 0, movedItem);
    
//     this.setState({ 
//       appCalendarItems: newItems,
//       draggedItem: null 
//     });
//   };

//   handleDragEnd = (event) => {
//     if (this.state.isTouchDevice) return;
    
//     event.currentTarget.style.opacity = '1';
//     event.currentTarget.style.backgroundColor = '';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     this.setState({ draggedItem: null });
//   };

//   // Mobile Touch Handlers
//   handleTouchStart = (e, index) => {
//     e.preventDefault();
    
//     const touch = e.touches[0];
//     const target = e.currentTarget;
    
//     this.touchStartTimeout = setTimeout(() => {
//       this.setState({
//         touchStartY: touch.clientY,
//         touchStartX: touch.clientX,
//         touchDraggedItem: index,
//         touchDraggedIndex: index,
//         draggedItem: index
//       });

//       target.classList.add('dragging');
      
//       if (window.navigator.vibrate) {
//         window.navigator.vibrate(50);
//       }
//     }, 300);
    
//     this.setState({ touchStartTime: Date.now() });
//   };

//   handleTouchMove = (e) => {
//     e.preventDefault();
    
//     const { touchDraggedItem, touchStartY } = this.state;
//     if (touchDraggedItem === null) {
//       clearTimeout(this.touchStartTimeout);
//       return;
//     }

//     const touch = e.touches[0];
//     const currentY = touch.clientY;
//     const deltaY = currentY - touchStartY;

//     const items = document.querySelectorAll('.app-calendar-item');
//     let targetIndex = touchDraggedItem;
    
//     items.forEach((item, idx) => {
//       const rect = item.getBoundingClientRect();
//       if (currentY >= rect.top && currentY <= rect.bottom) {
//         targetIndex = idx;
//       }
//     });

//     items.forEach(item => item.classList.remove('drag-over'));
//     if (items[targetIndex] && targetIndex !== touchDraggedItem) {
//       items[targetIndex].classList.add('drag-over');
      
//       const container = document.querySelector('.LawaList');
//       if (container) {
//         const containerRect = container.getBoundingClientRect();
//         const scrollSpeed = 10;
        
//         if (currentY < containerRect.top + 50) {
//           container.scrollTop -= scrollSpeed;
//         } else if (currentY > containerRect.bottom - 50) {
//           container.scrollTop += scrollSpeed;
//         }
//       }
//     }

//     const draggedItem = items[touchDraggedItem];
//     if (draggedItem && Math.abs(deltaY) > 10) {
//       draggedItem.style.transform = `translateY(${deltaY}px) scale(1.02)`;
//     }

//     this.setState({ touchDraggedIndex: targetIndex });
//   };

//   handleTouchEnd = (e) => {
//     e.preventDefault();
//     clearTimeout(this.touchStartTimeout);
    
//     const { touchDraggedItem, touchDraggedIndex } = this.state;
    
//     if (touchDraggedItem !== null && touchDraggedIndex !== -1) {
//       if (touchDraggedIndex !== touchDraggedItem) {
//         const newItems = [...this.state.appCalendarItems];
//         const [movedItem] = newItems.splice(touchDraggedItem, 1);
//         newItems.splice(touchDraggedIndex, 0, movedItem);
        
//         this.setState({ appCalendarItems: newItems });
//       }
//     }

//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.transform = '';
//       item.style.backgroundColor = '';
//       item.classList.remove('dragging', 'drag-over');
//     });

//     this.setState({ 
//       draggedItem: null,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartY: 0
//     });
//   };

//   handleTouchCancel = (e) => {
//     this.handleTouchEnd(e);
//   };

//   // Toggle handler for App Calendar items
//   handleAppCalendarToggle = (itemId) => {
//     const updatedItems = this.state.appCalendarItems.map(item => {
//       if (item.id === itemId) {
//         return { ...item, enabled: !item.enabled };
//       }
//       return item;
//     });

//     this.setState({ appCalendarItems: updatedItems });
//   };

//   // Submit handler for App Calendar settings - SAVE API
//   handleAppCalendarSubmit = (e) => {
//     e.preventDefault();

//     const enabledItems = this.state.appCalendarItems
//       .filter(item => item.enabled)
//       .map(item => item.apiKey);

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const apiToken = logindetail.memtoken ;

//     const sourceData = {
//       appID: parameters.appID,
//       memberID: parameters.memberID,
//       companyID: parameters.companyID,
//     };

//     const settingsObj = {};
//     for (let i = 0; i < enabledItems.length; i++) {
//       settingsObj[i] = enabledItems[i];
//     }
//     sourceData.settings = settingsObj;

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "saveSettings",
//           api_token: apiToken,
//           source: sourceData,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           NotificationManager.success(data.message || "App Calendar Settings Updated Successfully");
          
//           this.fetchAppCalendarSettings(false);
          
//           this.removeBlurEffect();
//         } else {
//           NotificationManager.info(data.message || "Failed to update settings");
//           this.setState({ appCalendarLoading: false });
          
//           this.removeBlurEffect();
//         }
//       })
//       .catch(error => {
//         console.error("Error saving app calendar settings:", error);
//         NotificationManager.info("Error updating app calendar settings");
        
//         this.removeBlurEffect();
        
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   handleEndDate = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       display_booking_end_time: checked ? "1" : "0"
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       display_booking_end_time: checked ? "1" : "0"
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_display_end_time",
//           source: dateVals,
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.display_booking_end_time = this.state.display_booking_end_time;

//           this.setState({
//             ...this.setState,
//             display_booking_end_time: loginData.display_booking_end_time
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleFormatChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       timeFormat: checked ? 24 : 12
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       timeFormat: checked ? 24 : 12
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "timeFormat",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',
//           timeFormat: dateVals.timeFormat
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.timeFormat = this.state.timeFormat;
//           this.setState({
//             ...this.state,
//             timeFormat: loginData.timeFormat
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleAddressInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       addressInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       addressInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "addressInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',
//           addressInInvoice: dateVals.addressInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.addressInInvoice = this.state.addressInInvoice;
//           this.setState({
//             ...this.state,
//             addressInInvoice: loginData.addressInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handlePersonalPhoneInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       phoneInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       phoneInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "phoneInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',
//           phoneInInvoice: dateVals.phoneInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.phoneInInvoice = this.state.phoneInInvoice;
//           this.setState({
//             ...this.state,
//             phoneInInvoice: loginData.phoneInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   // Original cancellation policy toggle - updated to handle dynamic fields
//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
    
//     if (checked) {
//       if (this.state.policies.length > 0 && this.state.selectedPolicyId) {
//         this.setState({
//           enableCancellationPolicy: 1
//         });

//         var dateVals = {
//           appID: logindetail && logindetail.aid,
//           companyID: logindetail && logindetail.cid,
//           memberID: logindetail && logindetail.uid,
//           enableCancellationPolicy: this.state.selectedPolicyId,
//           cancelBeforeValue: this.state.cancelBeforeValue,
//           cancelBeforeUnit: this.state.cancelBeforeUnit,
//           cancelFeeValue: this.state.cancelFeeValue,
//           cancelFeeUnit: this.state.cancelFeeUnit,
//           cancelCutoffTime: this.state.cancelCutoffTime
//         };
        
//         httpClient
//           .post(
//             "updateUserSettings.php",
//             qs.stringify({
//               action: "enableCancellationPolicy",
//               source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//               enableCancellationPolicy: dateVals.enableCancellationPolicy,
//               cancelBeforeValue: dateVals.cancelBeforeValue,
//               cancelBeforeUnit: dateVals.cancelBeforeUnit,
//               cancelFeeValue: dateVals.cancelFeeValue,
//               cancelFeeUnit: dateVals.cancelFeeUnit,
//               cancelCutoffTime: dateVals.cancelCutoffTime
//             })
//           ).then(({ data }) => {
//             if (data.success == "true") {
//               var loginData = JSON.parse(localStorage.getItem("login"));

//               loginData.enableCancellationPolicy = this.state.selectedPolicyId;
//               this.setState({
//                 enableCancellationPolicy: 1
//               });
//               localStorage.setItem("login", JSON.stringify(loginData));
//               NotificationManager.info("Cancellation policy enabled");
//             }
//           });
//       } else {
//         this.fetchPolicies();
//         this.setState({
//           enableCancellationPolicy: 1
//         });
//       }
//     } else {
//       this.setState({
//         enableCancellationPolicy: 0
//       });

//       var dateVals = {
//         appID: logindetail && logindetail.aid,
//         companyID: logindetail && logindetail.cid,
//         memberID: logindetail && logindetail.uid,
//         enableCancellationPolicy: 0
//       };
      
//       httpClient
//         .post(
//           "updateUserSettings.php",
//           qs.stringify({
//             action: "enableCancellationPolicy",
//             source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//             enableCancellationPolicy: dateVals.enableCancellationPolicy
//           })
//         ).then(({ data }) => {
//           if (data.success == "true") {
//             var loginData = JSON.parse(localStorage.getItem("login"));

//             loginData.enableCancellationPolicy = 0;
//             this.setState({
//               enableCancellationPolicy: 0
//             });
//             localStorage.setItem("login", JSON.stringify(loginData));
//             NotificationManager.info("Cancellation policy disabled");
//           }
//         });
//     }
//   }

//   handleToggle = (event, value) => {
//     var settingParam;
//     var aid, cid, uid;
//     var btntype;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail.uid;
//     btntype = value;

//     const { checked } = this.state;
//     const currentIndex = checked.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex == -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     this.setState({
//       checked: newChecked,
//     });

//     settingParam = aid + "_" + cid + "_" + uid + "_" + value;

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: btntype,
//           source: settingParam,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data.success != "true") {
//             NotificationManager.info(data.failedMSG);
//           } else if (data.success == "true") {
//             var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
//             var objname = data.actionOn;

//             if (objname == "displayCustNotes")
//               loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

//             if (objname == "hideOldRecurring")
//               loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

//             if (objname == "displayBookingClash")
//               loginTempOBJ.displayBookingClash =
//                 1 - loginTempOBJ.displayBookingClash;

//             if (objname == "hidePastBookingsCalendarSearch")
//               loginTempOBJ.hidePastBookingsCalendarSearch =
//                 1 - loginTempOBJ.hidePastBookingsCalendarSearch;

//             if (objname == "filterBookingServices") {
//               loginTempOBJ.filterBookingServices =
//                 1 - loginTempOBJ.filterBookingServices;
//             }

//             localStorage.setItem("login", JSON.stringify(loginTempOBJ));
//             NotificationManager.info(data.msg);
//           }
//         },
//         (error) => {
//           this.setState({
//             error,
//           });
//         }
//       );
//   };

//   handleCalendarChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//   };

//   handleBookingConfirmationChange = (event) => {
//     this.setState({ selectedSetting: event.target.value });
//   };

//   handleChangeConfirmationHour = (e) => {
//     this.setState({
//       confirmationHour: e.target.value,
//     });
//   };

//   handleSaveSettings() {
//     if (this.state.incometemplate == "" && this.state.incomedescription == "") {
//       NotificationManager.info("Nothing changed to save");
//     } else {
//       httpClient
//         .post(
//           "saveMemberSettings.php",
//           qs.stringify({
//             action: "save_settings",
//             source: this.state,
//           })
//         )
//         .then(
//           ({ data }) => {
//             if (data.success != "true") {
//               NotificationManager.info(data.failedMSG);
//             } else {
//               NotificationManager.info(data.successMSG);
//               this.setState({
//                 incometemplate: "",
//                 incomedescription: "",
//               });
//             }
//           },
//           (error) => {
//             NotificationManager.info(
//               "Error Occured: Refresh the page and try again"
//             );
//           }
//         );
//     }
//   }

//   handleChange(evt) {
//     this.setState({ [evt.target.name]: evt.target.value });
//   }

//   handleSubmitCalendar = (e) => {
//     e.preventDefault();

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({
//       ...this.state,
//       loading: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       customer_name: this.state.customerName,
//       bookingCost: this.state.bookingTotal,
//       customer_address: this.state.customerAddress,
//       pet_name: this.state.petName,
//       pet_breed: this.state.petBreed,
//       services_name: this.state.serviceName,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_calendar_settings",
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           NotificationManager.success(data.successMSG);
//           let calendarData = [];
//           let calendarStorage = JSON.parse(localStorage.getItem("settings"));

//           calendarData = {
//             ...calendarStorage,
//             customer_name: data.customer_name,
//             bookingCost: data.bookingCost,
//             pet_name: data.pet_name,
//             services_name: data.services_name,
//             customer_address: data.customer_address,
//           };

//           const cal = { ...calendarData };

//           localStorage.setItem("settings", JSON.stringify(cal));

//           setTimeout(() => {
//             NotificationManager.info("Retrieving Calendar Entries");
//           }, 1000);

//           this.getCalendarEntry();
//         } else {
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   handleSubmitConfirmation = (e) => {
//     e.preventDefault();

//     this.setState({
//       ...this.state,
//       loadingConfirmation: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "bookingConfirmation",
//           source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
//           confirmationBy: this.state.selectedSetting,
//           confirmationHour: this.state.confirmationHour,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: data.data.confirmationBy,
//             confirmationHour: parseInt(data.data.confirmationHour),
//           });
//           NotificationManager.success(data.msg);
//         } else {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: "",
//             confirmationHour: "",
//           });
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   getCalendarEntry = () => {
//     httpClient
//       .post(
//         "getCalendarEntries.php",
//         qs.stringify({
//           action: "calendar_entries",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             var calendarLastMod = {
//               calendarLastModified: data.calendarLastModified,
//             };
//             var dataIndex =
//               modifiedData &&
//               modifiedData.findIndex((arr, i) => arr.calendarLastModified);
//             modifiedData && (modifiedData[dataIndex] = calendarLastMod);

//             localStorage.setItem("calendar_entries", JSON.stringify(data.data));
//             this.setState({
//               syncModified: modifiedData,
//             });

//             this.setState({
//               ...this.state,
//               loading: false,
//             });
            
//             if (this.state.syncModified.length > 0) {
//               var loginData = JSON.parse(localStorage.getItem("login"));
//               loginData.syncLastModified = this.state.syncModified;
//               loginData.syncLastModified !== [] &&
//                 localStorage.setItem("login", JSON.stringify(loginData));
//             }

//             NotificationManager.success(
//               "Calendar Settings Successfully Updated"
//             );

//             let loginBlur = JSON.parse(localStorage.getItem("login"));

//             if (loginBlur && loginBlur.ismobiledevice != 1) {
//               document.getElementById("nav__menu__display") !== null &&
//                 (document.getElementById("nav__menu__display").style.cssText =
//                   "filter: blur(0px); pointer-events: block");
//             }
//             document.getElementById("appbar_mainapp__") !== null &&
//               (document.getElementById("appbar_mainapp__").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           } else {
//           }
//         }
//       );
//   };

//   render() {
//     const {
//       error,
//       isLoaded,
//       incomedescription,
//       settingdetail,
//       incometemplate,
//       customerName,
//       bookingTotal,
//       customerAddress,
//       petName,
//       petBreed,
//       serviceName,
//       appCalendarItems,
//       appCalendarLoading,
//       appCalendarInitialized,
//       policies,
//       policiesLoading,
//       selectedPolicyId,
//       savingPolicy,
//       enableCancellationPolicy,
//       cancelBeforeValue,
//       cancelBeforeUnit,
//       cancelFeeValue,
//       cancelFeeUnit,
//       cancelCutoffTime,
//       dynamicFieldsDisabled,
//     } = this.state;

//     if (error) {
//       return <div className="jr-customers">Error: {error.message}</div>;
//     } else if (!isLoaded || (appCalendarLoading && !appCalendarInitialized)) {
//       return (
//         <div className="jr-customers">
//           <LinearProgress color="secondary" />
//         </div>
//       );
//     } else {
//       return (
//         <>
//           <div className="app-wrapper animated slideInUpTiny animation-duration-3">
//             <ContainerHeader
//               title={<IntlMessages id="sidebar.dashboard.settings" />}
//               match={this.props.match}
//             />

//             <div className="row">
//               <CardBox
//                 heading={<IntlMessages id="dashboard.settings.preferences" />}
//               >
//                 <div className="col-md-12 col-12">
//                   <List className="LawaList">
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Customer Notes on Booking" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayCustNotes")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayCustNotes") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "hideOldBookings")
//                           }
//                           checked={
//                             this.state.checked.indexOf("hideOldBookings") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Booking Clash Notifications" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayBookingClash")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayBookingClash") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Past Bookings from Calendar Search" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(
//                               event,
//                               "hidePastBookingsCalendarSearch"
//                             )
//                           }
//                           checked={
//                             this.state.checked.indexOf(
//                               "hidePastBookingsCalendarSearch"
//                             ) != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Filter Services based on pet size" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "filterBookingServices")
//                           }
//                           checked={
//                             this.state.checked.indexOf("filterBookingServices") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Booking End Time" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.display_booking_end_time === "1"}
//                           onChange={this.handleEndDate}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Address In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.addressInInvoice === 1}
//                           onChange={this.handleAddressInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Personal Phone In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.phoneInInvoice === 1}
//                           onChange={this.handlePersonalPhoneInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Toggle 24hr Time Format" />
//                       <ListItemSecondaryAction>
//                         <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
//                         <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
//                           <Switch
//                             color="primary"
//                             checked={this.state.timeFormat === 24}
//                             onChange={this.handleFormatChange}
//                           />
//                         </Tooltip>
//                         <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                   </List>
//                 </div>
//               </CardBox>

//               <div className="col-md-6">
//                 <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
//                       <div className="col-md-12 col-12">
//                         <TextField
//                           id="smsNumber"
//                           label="SMS Sender"
//                           value="0495149675"
//                           margin="normal"
//                           helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                           fullWidth
//                         />
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
                  
//                   <Grid item xs={12}>
//                   <CardBoxNew heading={"Cancellation Policy"}>
//   <div className="col-md-12 col-12">
//     <List>
//       <ListItem>
//         <ListItemIcon>
//           <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
//         </ListItemIcon>
//         <ListItemText primary="Attach Cancellation Policy" />
//         <ListItemSecondaryAction>
//           <Switch
//             color="primary"
//             checked={enableCancellationPolicy === 1}
//             onChange={this.handleCancellationPolicyChange}
//           />
//         </ListItemSecondaryAction>
//       </ListItem>
//     </List>

//     {enableCancellationPolicy === 1 && (
//       <>
//         <Divider style={{ margin: '15px 0' }} />
        
//         {/* Dynamic Input Fields Section */}
//         <div style={{ 
//           marginBottom: '20px', 
//           padding: '15px', 
//           backgroundColor: '#f9f9f9', 
//           borderRadius: '8px',
//           border: '1px solid #e0e0e0'
//         }}>
//           <FormLabel component="legend" style={{ marginBottom: '15px', fontWeight: 600 }}>
//             Cancellation Policy Settings
//           </FormLabel>
          
//           <Grid container spacing={2}>
//             {/* Cancel Before Section */}
//             <Grid item xs={12} sm={4}>
//               <TextField
//                 label="Cancel Before Value"
//                 type="number"
//                 value={cancelBeforeValue}
//                 onChange={this.handleCancelBeforeValueChange}
//                 disabled={dynamicFieldsDisabled}
//                 fullWidth
//                 size="small"
//                 variant="outlined"
//                 InputProps={{
//                   inputProps: { min: 1 }
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth size="small" variant="outlined" disabled={dynamicFieldsDisabled}>
//                 <InputLabel>Cancel Before Unit</InputLabel>
//                 <Select
//                   value={cancelBeforeUnit}
//                   onChange={this.handleCancelBeforeUnitChange}
//                   label="Cancel Before Unit"
//                 >
//                   <MenuItem value="hours">Hours</MenuItem>
//                   <MenuItem value="days">Days</MenuItem>
//                   <MenuItem value="weeks">Weeks</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             {/* Fee Section */}
//             <Grid item xs={12} sm={2}>
//               <TextField
//                 label="Fee Value"
//                 type="number"
//                 value={cancelFeeValue}
//                 onChange={this.handleCancelFeeValueChange}
//                 disabled={dynamicFieldsDisabled}
//                 fullWidth
//                 size="small"
//                 variant="outlined"
//                 InputProps={{
//                   inputProps: { min: 1 }
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={2}>
//               <FormControl fullWidth size="small" variant="outlined" disabled={dynamicFieldsDisabled}>
//                 <InputLabel>Fee Unit</InputLabel>
//                 <Select
//                   value={cancelFeeUnit}
//                   onChange={this.handleCancelFeeUnitChange}
//                   label="Fee Unit"
//                 >
//                   <MenuItem value="$">$ (Dollar)</MenuItem>
//                   <MenuItem value="%">% (Percent)</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             {/* Cutoff Time - Simple text field with pattern validation */}
//             <Grid item xs={12} sm={4}>
//               <TextField
//                 label="Cutoff Time (HH:MM:SS)"
//                 value={cancelCutoffTime}
//                 onChange={this.handleCancelCutoffTimeChange}
//                 disabled={dynamicFieldsDisabled}
//                 fullWidth
//                 size="small"
//                 variant="outlined"
//                 placeholder="22:00:00"
//                 error={cancelCutoffTime && !/^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/.test(cancelCutoffTime)}
//                 helperText={cancelCutoffTime && !/^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/.test(cancelCutoffTime) ? "Format: HH:MM:SS (e.g., 22:00:00)" : "Example: 22:00:00"}
//               />
//             </Grid>
//           </Grid>
//         </div>
        
//         <FormLabel component="legend" style={{ marginBottom: '10px', marginLeft: '15px' }}>
//           Select Policy
//         </FormLabel>
//         {policiesLoading ? (
//           <LinearProgress color="secondary" />
//         ) : (
//           <>
//             <FormControl component="fieldset" fullWidth>
//               <RadioGroup
//                 name="policies-radio-group"
//                 value={selectedPolicyId}
//                 onChange={this.handlePolicyChange}
//               >
//                 {policies.map((policy) => {
//                   // Replace placeholders with actual values from state
//                   let displayPolicy = policy.policy;
                  
//                   // Replace cancelBeforeValue placeholder
//                   displayPolicy = displayPolicy.replace(/{{cancelBeforeValue}}/g, cancelBeforeValue || '_____');
                  
//                   // Replace cancelBeforeUnit placeholder and handle singular/plural
//                   let unitText = cancelBeforeUnit || '_____';
//                   if (cancelBeforeUnit === 'hours') {
//                     unitText = parseInt(cancelBeforeValue) === 1 ? 'hour' : 'hours';
//                   } else if (cancelBeforeUnit === 'days') {
//                     unitText = parseInt(cancelBeforeValue) === 1 ? 'day' : 'days';
//                   } else if (cancelBeforeUnit === 'weeks') {
//                     unitText = parseInt(cancelBeforeValue) === 1 ? 'week' : 'weeks';
//                   }
//                   displayPolicy = displayPolicy.replace(/{{cancelBeforeUnit}}/g, unitText);
//                   displayPolicy = displayPolicy.replace(/{{cancelBeforeUnit:pluralize}}/g, unitText);
                  
//                   // Replace cancelFeeValue placeholder
//                   displayPolicy = displayPolicy.replace(/{{cancelFeeValue}}/g, cancelFeeValue || '_____');
                  
//                   // Replace cancelFeeUnit placeholder
//                   displayPolicy = displayPolicy.replace(/{{cancelFeeUnit}}/g, cancelFeeUnit || '_____');
                  
//                   // Replace cancelCutoffTime placeholder
//                   displayPolicy = displayPolicy.replace(/{{cancelCutoffTime}}/g, cancelCutoffTime || '_____');
                  
//                   return (
//                     <FormControlLabel
//                       key={policy.policyID}
//                       value={policy.policyID}
//                       control={<Radio color="primary" />}
//                       label={
//                         <span 
//                           dangerouslySetInnerHTML={{ __html: displayPolicy }}
//                           style={{ fontSize: '0.9rem' }}
//                         />
//                       }
//                       style={{
//                         marginBottom: '10px',
//                         alignItems: 'flex-start',
//                       }}
//                     />
//                   );
//                 })}
//               </RadioGroup>
//             </FormControl>
            
//             <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
//               {savingPolicy ? (
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   disabled={true}
//                 >
//                   Saving...
//                 </Button>
//               ) : (
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={this.handleSavePolicy}
//                   disabled={!selectedPolicyId || dynamicFieldsDisabled}
//                 >
//                   Save Policy Selection
//                 </Button>
//               )}
//             </div>
//           </>
//         )}
//       </>
//     )}
//   </div>
// </CardBoxNew>
//                   </Grid>
//                 </Grid>
//               </div>

//               <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
//                 <form className="row" noValidate autoComplete="off">
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incometemplate"
//                       name="incometemplate"
//                       label="Income Title Template"
//                       margin="normal"
//                       defaultValue={this.state.settingdetail.title}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       onChange={this.handleChange}
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incomedescription"
//                       name="incomedescription"
//                       label="Income Description"
//                       defaultValue={this.state.settingdetail.desc}
//                       margin="normal"
//                       onChange={this.handleChange}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="jr-btn btn-margin-topbottom"
//                       position="static"
//                       onClick={() => {
//                         this.handleSaveSettings();
//                       }}
//                     >
//                       Save
//                     </Button>
//                   </div>
//                 </form>
//               </CardBox>
              
//               <CardBox heading="Send Booking Reminder">
//                 {this.state.loadingConfirmation && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Do not send booking reminder" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value=""
//                             checked={this.state.selectedSetting === ""}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email and SMS for all customers" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="all"
//                             checked={this.state.selectedSetting === "all"}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email only, do not send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="emailOnly"
//                             checked={this.state.selectedSetting === 'emailOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send SMS only, do not send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="smsOnly"
//                             checked={this.state.selectedSetting === 'smsOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by email but if not found, send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedEmail"
//                             checked={this.state.selectedSetting === 'preferedEmail'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by SMS but if no mobile number, send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedSMS"
//                             checked={this.state.selectedSetting === 'preferedSMS'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
//                         <ListItemSecondaryAction>
//                           <FormControl variant="outlined" style={{ width: "100px" }}>
//                             <Select
//                               placeholder="Select Confirmation Before"
//                               name="confirmationHour"
//                               value={this.state.confirmationHour}
//                               style={{
//                                 textAlign: 'center',
//                                 paddingLeft: '0',
//                               }}
//                               inputProps={{
//                                 style: {
//                                   textAlign: 'center',
//                                 },
//                               }}
//                               onChange={(e) => this.handleChangeConfirmationHour(e)}
//                             >
//                               <MenuItem value="">
//                                 <em>Select Confirmation Before</em>
//                               </MenuItem>
//                               <MenuItem value={24}>{"24 hrs"}</MenuItem>
//                               <MenuItem value={48}>{"48 hrs"}</MenuItem>
//                               <MenuItem value={72}>{"72 hrs"}</MenuItem>
//                             </Select>
//                           </FormControl>
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       {this.state.loadingConfirmation ? (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                           disabled={true}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       )}
//                     </List>
//                   </div>
//                 </div>
//               </CardBox>

//               <CardBox heading="Calendar Settings">
//                 {this.state.loading && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Show Booking Total" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="bookingTotal"
//                             checked={bookingTotal}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerName"
//                             checked={customerName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Address" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerAddress"
//                             checked={customerAddress}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petName"
//                             checked={petName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Breed" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petBreed"
//                             checked={petBreed}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Services Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="serviceName"
//                             checked={serviceName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <div>
//                         <h5>Preview</h5>
//                       </div>
//                       {(bookingTotal ||
//                         customerName ||
//                         customerAddress ||
//                         petName || petBreed ||
//                         serviceName) && (
//                           <Card
//                             style={{
//                               padding: "20px",
//                               backgroundColor: "#3f51b5",
//                               color: "#fff",
//                               width: "400px",
//                             }}
//                           > 
//                             {bookingTotal && <div>$Total Cost</div>}
//                             {customerName && <div>Firstname Lastname</div>}
//                             {customerAddress && <div>Street Address, Suburb, Postcode</div>}
//                             {petName && <div>Pet Name</div>}
//                             {petBreed && <div>Pet Breed</div>}
//                             {serviceName && <div>Services</div>}
//                           </Card>
//                         )}
//                     </List>
//                     {this.state.loading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={true}
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={
//                           !(bookingTotal ||
//                             customerName ||
//                             customerAddress ||
//                             petName || petBreed ||
//                             serviceName)
//                         }
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>

//               {/* App Calendar Settings Section with Mobile Support */}
//               <CardBox heading="App Calendar Settings">
//                 {appCalendarLoading && (
//                   <div style={{ position: "relative", top: "15px", marginBottom: "20px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <p style={{ 
//                       marginBottom: '15px', 
//                       color: '#666', 
//                       fontSize: '0.9rem',
//                       padding: '10px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}>
//                       {this.state.isTouchDevice ? (
//                         <span>Long press and drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       ) : (
//                         <span>Drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       )}
//                     </p>

//                     <List className="LawaList">
//                       {appCalendarItems.map((item, index) => (
//                         <ListItem
//                           key={item.id}
//                           className="app-calendar-item"
//                           draggable={!this.state.isTouchDevice}
//                           onDragStart={(e) => this.handleDragStart(e, index)}
//                           onDragOver={(e) => this.handleDragOver(e, index)}
//                           onDrop={(e) => this.handleDrop(e, index)}
//                           onDragEnd={this.handleDragEnd}
//                           onTouchStart={(e) => this.handleTouchStart(e, index)}
//                           onTouchMove={this.handleTouchMove}
//                           onTouchEnd={this.handleTouchEnd}
//                           onTouchCancel={this.handleTouchCancel}
//                           style={{
//                             cursor: this.state.isTouchDevice ? 'default' : 'grab',
//                             border: '1px solid transparent',
//                             transition: 'all 0.2s',
//                             backgroundColor: this.state.draggedItem === index ? '#f5f5f5' : 'transparent',
//                             WebkitTapHighlightColor: 'transparent',
//                           }}
//                         >
//                           <ListItemIcon 
//                             className="drag-handle"
//                             style={{ 
//                               cursor: this.state.isTouchDevice ? 'pointer' : 'grab', 
//                               minWidth: '40px',
//                               padding: this.state.isTouchDevice ? '10px 5px' : '0',
//                             }}
//                           >
//                             <i className="zmdi zmdi-menu" style={{ fontSize: '20px', color: '#999' }}></i>
//                           </ListItemIcon>
//                           <ListItemText primary={item.label} />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               checked={item.enabled}
//                               onChange={() => this.handleAppCalendarToggle(item.id)}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                       ))}
//                     </List>

//                     {/* Preview Section */}
//                     <div style={{ marginTop: '20px' }}>
//                       <h5>Preview </h5>
//                       {appCalendarItems.some(item => item.enabled) ? (
//                         <Card
//                           style={{
//                             padding: "20px",
//                             backgroundColor: "#3f51b5",
//                             color: "#fff",
//                             width: "100%",
//                             maxWidth: "400px",
//                           }}
//                         >
//                           {appCalendarItems
//                             .filter(item => item.enabled)
//                             .map(item => {
//                               switch(item.apiKey) {
//                                 case 'time':
//                                   return <div key={item.id}>10:30 AM</div>;
//                                 case 'cost':
//                                   return <div key={item.id}>Service Cost</div>;
//                                 case 'name':
//                                   return <div key={item.id}>Customer Name</div>;
//                                 case 'address':
//                                   return <div key={item.id}>123 Main St, Sydney 2000</div>;
//                                 case 'petName':
//                                   return <div key={item.id}>Pet Name</div>;
//                                 case 'petBreed':
//                                   return <div key={item.id}>Pet Breed</div>;
//                                 case 'serviceName':
//                                   return <div key={item.id}>Full Grooming</div>;
//                                 default:
//                                   return null;
//                               }
//                             })}
//                         </Card>
//                       ) : (
//                         <p style={{ color: '#999', fontStyle: 'italic' }}>Toggle on items to see preview</p>
//                       )}
//                     </div>

//                     {appCalendarLoading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         disabled={true}
//                       >
//                         Updating...
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         onClick={this.handleAppCalendarSubmit}
//                       >
//                         Update App Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>
//             </div>
//           </div>
//           <NotificationContainer />
//         </>
//       );
//     }
//   }
// }

// export default Settings;


// // *********************************************************************************************************************************************

// import React from "react";
// import ContainerHeader from "components/ContainerHeader/index";
// import CardBox from "components/CardBox/index";
// import CardBoxNew from "components/CardBoxNew/index";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import "../../../../src/assets/vendors/react-notification/react-notifications.css"
// import { httpClient } from "appUtility/Api";
// import IntlMessages from "util/IntlMessages";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
// import Switch from "@material-ui/core/Switch";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import featureServer from "../../../appUtility/featureServer";
// import { FormControl, Grid, MenuItem, Radio, Select, Tooltip, RadioGroup, FormControlLabel, Divider, FormLabel, InputAdornment, InputLabel } from "@material-ui/core";
// import configureStore from "../../../store";

// const loginOBJ = localStorage.getItem("login");
// const logindetail = JSON.parse(loginOBJ);
// var modifiedData = logindetail && logindetail.syncLastModified;
// const qs = require("qs");

// var param, settingdetail;

// class Settings extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       error: null,
//       isLoaded: false,
//       id: "",
//       incometemplate: "",
//       incomedescription: "",
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       mcode: logindetail && logindetail.mCode,
//       settingdetail: "",
//       checked: [],
//       customerName: false,
//       bookingTotal: false,
//       customerAddress: false,
//       petName: false,
//       petBreed: false,
//       serviceName: false,
//       syncModified: "",
//       loading: false,
//       display_booking_end_time: logindetail && logindetail.display_booking_end_time,
//       timeFormat: logindetail && logindetail.timeFormat,
//       addressInInvoice: logindetail && logindetail.addressInInvoice,
//       phoneInInvoice: logindetail && logindetail.phoneInInvoice,
//       enableCancellationPolicy: logindetail && logindetail.enableCancellationPolicy,
//       selectedSetting: "",
//       confirmationHour: 24,
//       loadingConfirmation: false,
      
//       // New state for policies
//       policies: [],
//       policiesLoading: false,
//       selectedPolicyId: "",
//       savingPolicy: false,
      
//       // Dynamic policy fields
//       cancelBeforeValue: "",
//       cancelBeforeUnit: "hours",
//       cancelFeeValue: "",
//       cancelFeeUnit: "%",
//       cancelCutoffTime: "",
//       dynamicFieldsDisabled: true,
//       cutoffTimeError: false,
      
//       // App Calendar Settings with all possible items (time instead of date)
//       appCalendarItems: [
//         { id: 'appTime', label: 'Show Time', icon: 'zmdi-time', enabled: false, apiKey: 'time' },
//         { id: 'appBookingTotal', label: 'Show Booking Total', icon: 'zmdi-money', enabled: false, apiKey: 'cost' },
//         { id: 'appCustomerName', label: 'Show Customer Name', icon: 'zmdi-account', enabled: false, apiKey: 'name' },
//         { id: 'appCustomerAddress', label: 'Show Customer Address', icon: 'zmdi-pin', enabled: false, apiKey: 'address' },
//         { id: 'appPetName', label: 'Show Pet Name', icon: 'zmdi-face', enabled: false, apiKey: 'petName' },
//         { id: 'appPetBreed', label: 'Show Pet Breed', icon: 'zmdi-label', enabled: false, apiKey: 'petBreed' },
//         { id: 'appServiceName', label: 'Show Services Name', icon: 'zmdi-cut', enabled: false, apiKey: 'serviceName' },
//       ],
//       appCalendarLoading: false,
//       draggedItem: null,
//       appCalendarInitialized: false,
      
//       // Mobile touch states
//       isTouchDevice: false,
//       touchStartY: 0,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartTime: 0,
//     };

//     this.handleChange = this.handleChange.bind(this);
//     this.handleAppCalendarToggle = this.handleAppCalendarToggle.bind(this);
//     this.handleAppCalendarSubmit = this.handleAppCalendarSubmit.bind(this);
//     this.removeBlurEffect = this.removeBlurEffect.bind(this);
    
//     // Desktop drag handlers
//     this.handleDragStart = this.handleDragStart.bind(this);
//     this.handleDragOver = this.handleDragOver.bind(this);
//     this.handleDrop = this.handleDrop.bind(this);
//     this.handleDragEnd = this.handleDragEnd.bind(this);
    
//     // Mobile touch handlers
//     this.handleTouchStart = this.handleTouchStart.bind(this);
//     this.handleTouchMove = this.handleTouchMove.bind(this);
//     this.handleTouchEnd = this.handleTouchEnd.bind(this);
//     this.handleTouchCancel = this.handleTouchCancel.bind(this);
    
//     // Policy handlers
//     this.fetchPolicies = this.fetchPolicies.bind(this);
//     this.handlePolicyChange = this.handlePolicyChange.bind(this);
//     this.handleSavePolicy = this.handleSavePolicy.bind(this);
    
//     // Dynamic policy field handlers
//     this.handleCancelBeforeValueChange = this.handleCancelBeforeValueChange.bind(this);
//     this.handleCancelBeforeUnitChange = this.handleCancelBeforeUnitChange.bind(this);
//     this.handleCancelFeeValueChange = this.handleCancelFeeValueChange.bind(this);
//     this.handleCancelFeeUnitChange = this.handleCancelFeeUnitChange.bind(this);
//     this.handleCancelCutoffTimeChange = this.handleCancelCutoffTimeChange.bind(this);
//   }

//   componentDidMount() {
//     // Detect touch device
//     this.setState({
//       isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
//     });

//     // Prevent default touch behaviors on draggable items
//     document.addEventListener('touchmove', this.preventTouchScroll, { passive: false });
    
//     var aid, cid, uid;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail && logindetail.uid;

//     param = aid + "_" + cid + "_" + uid;

//     // Fetch member settings
//     httpClient
//       .post(
//         "getMemberSettings.php",
//         qs.stringify({
//           action: "member_settings",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             localStorage.setItem("settings", JSON.stringify(data));
//             this.setState(
//               {
//                 isLoaded: false,
//                 id: data.id,
//                 settingdetail: data,
//                 checked: data.flags,
//                 petName: data.pet_name == "1" ? true : false,
//                 petBreed: data.pet_breed == "1" ? true : false,
//                 serviceName: data.services_name == "1" ? true : false,
//                 customerName: data.customer_name == "1" ? true : false,
//                 bookingTotal: data.bookingCost == "1" ? true : false,
//                 customerAddress: data.customer_address == "1" ? true : false,
//                 confirmationHour: parseInt(data.confirmationHour),
//                 selectedSetting: data.confirmationBy,
//               },
//               function () {
//                 this.setState({
//                   isLoaded: true,
//                 });
//               }
//             );
//           } else {
//           }
//         },
//         (error) => {
//           this.setState({
//             isLoaded: true,
//             error,
//           });
//         }
//       );

//     const loginValue = JSON.parse(localStorage.getItem("login"));
//     this.setState({
//       ...this.state,
//       display_booking_end_time: loginValue.display_booking_end_time,
//       timeFormat: loginValue.timeFormat,
//       addressInInvoice: loginValue.addressInInvoice,
//       phoneInInvoice: loginValue.phoneInInvoice,
//       enableCancellationPolicy: loginValue.enableCancellationPolicy
//     });

//     // Fetch policies
//     this.fetchPolicies();

//     // Fetch App Calendar Settings (no notification on page load)
//     this.fetchAppCalendarSettings(false);

//     // Add inline styles for mobile
//     this.addInlineStyles();
//   }

//   componentWillUnmount() {
//     document.removeEventListener('touchmove', this.preventTouchScroll);
//   }

//   // Helper function to remove blur effect
//   removeBlurEffect = () => {
//     let loginBlur = JSON.parse(localStorage.getItem("login"));
    
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(0px); pointer-events: block");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(0px); pointer-events: block");
//   }

//   addInlineStyles = () => {
//     // Add styles to head if not already present
//     if (!document.getElementById('settings-inline-styles')) {
//       const style = document.createElement('style');
//       style.id = 'settings-inline-styles';
//       style.innerHTML = `
//         .app-calendar-item {
//           -webkit-touch-callout: none;
//           -webkit-user-select: none;
//           user-select: none;
//           touch-action: pan-y;
//           transition: all 0.2s ease;
//         }
//         .app-calendar-item.dragging {
//           opacity: 0.7 !important;
//           transform: scale(1.02) !important;
//           box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
//           z-index: 9999 !important;
//           background-color: #f5f5f5 !important;
//         }
//         .app-calendar-item.drag-over {
//           border: 2px dashed #3f51b5 !important;
//           background-color: #e8eaf6 !important;
//           opacity: 0.8;
//           transform: scale(1.01);
//         }
//         .app-calendar-item:active {
//           background-color: #f0f0f0;
//         }
//         @media (max-width: 768px) {
//           .app-calendar-item {
//             cursor: default !important;
//           }
//           .app-calendar-item .drag-handle {
//             padding: 10px 5px;
//           }
//         }
//       `;
//       document.head.appendChild(style);
//     }
//   };

//   preventTouchScroll = (e) => {
//     if (this.state.touchDraggedItem !== null) {
//       e.preventDefault();
//     }
//   };

//   // Desktop Drag Handlers
//   handleDragStart = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.dataTransfer.setData('text/plain', index.toString());
//     event.dataTransfer.effectAllowed = 'move';
//     this.setState({ draggedItem: index });
//     event.currentTarget.style.opacity = '0.5';
//     event.currentTarget.style.backgroundColor = '#f0f0f0';
//   };

//   handleDragOver = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
//     event.dataTransfer.dropEffect = 'move';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (event.currentTarget) {
//       event.currentTarget.classList.add('drag-over');
//     }
//   };

//   handleDrop = (event, targetIndex) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     const sourceIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
//     if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;
    
//     const newItems = [...this.state.appCalendarItems];
//     const [movedItem] = newItems.splice(sourceIndex, 1);
//     newItems.splice(targetIndex, 0, movedItem);
    
//     this.setState({ 
//       appCalendarItems: newItems,
//       draggedItem: null 
//     });
//   };

//   handleDragEnd = (event) => {
//     if (this.state.isTouchDevice) return;
    
//     event.currentTarget.style.opacity = '1';
//     event.currentTarget.style.backgroundColor = '';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     this.setState({ draggedItem: null });
//   };

//   // Mobile Touch Handlers
//   handleTouchStart = (e, index) => {
//     e.preventDefault();
    
//     const touch = e.touches[0];
//     const target = e.currentTarget;
    
//     this.touchStartTimeout = setTimeout(() => {
//       this.setState({
//         touchStartY: touch.clientY,
//         touchStartX: touch.clientX,
//         touchDraggedItem: index,
//         touchDraggedIndex: index,
//         draggedItem: index
//       });

//       target.classList.add('dragging');
      
//       if (window.navigator.vibrate) {
//         window.navigator.vibrate(50);
//       }
//     }, 300);
    
//     this.setState({ touchStartTime: Date.now() });
//   };

//   handleTouchMove = (e) => {
//     e.preventDefault();
    
//     const { touchDraggedItem, touchStartY } = this.state;
//     if (touchDraggedItem === null) {
//       clearTimeout(this.touchStartTimeout);
//       return;
//     }

//     const touch = e.touches[0];
//     const currentY = touch.clientY;
//     const deltaY = currentY - touchStartY;

//     const items = document.querySelectorAll('.app-calendar-item');
//     let targetIndex = touchDraggedItem;
    
//     items.forEach((item, idx) => {
//       const rect = item.getBoundingClientRect();
//       if (currentY >= rect.top && currentY <= rect.bottom) {
//         targetIndex = idx;
//       }
//     });

//     items.forEach(item => item.classList.remove('drag-over'));
//     if (items[targetIndex] && targetIndex !== touchDraggedItem) {
//       items[targetIndex].classList.add('drag-over');
      
//       const container = document.querySelector('.LawaList');
//       if (container) {
//         const containerRect = container.getBoundingClientRect();
//         const scrollSpeed = 10;
        
//         if (currentY < containerRect.top + 50) {
//           container.scrollTop -= scrollSpeed;
//         } else if (currentY > containerRect.bottom - 50) {
//           container.scrollTop += scrollSpeed;
//         }
//       }
//     }

//     const draggedItem = items[touchDraggedItem];
//     if (draggedItem && Math.abs(deltaY) > 10) {
//       draggedItem.style.transform = `translateY(${deltaY}px) scale(1.02)`;
//     }

//     this.setState({ touchDraggedIndex: targetIndex });
//   };

//   handleTouchEnd = (e) => {
//     e.preventDefault();
//     clearTimeout(this.touchStartTimeout);
    
//     const { touchDraggedItem, touchDraggedIndex } = this.state;
    
//     if (touchDraggedItem !== null && touchDraggedIndex !== -1) {
//       if (touchDraggedIndex !== touchDraggedItem) {
//         const newItems = [...this.state.appCalendarItems];
//         const [movedItem] = newItems.splice(touchDraggedItem, 1);
//         newItems.splice(touchDraggedIndex, 0, movedItem);
        
//         this.setState({ appCalendarItems: newItems });
//       }
//     }

//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.transform = '';
//       item.style.backgroundColor = '';
//       item.classList.remove('dragging', 'drag-over');
//     });

//     this.setState({ 
//       draggedItem: null,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartY: 0
//     });
//   };

//   handleTouchCancel = (e) => {
//     this.handleTouchEnd(e);
//   };

//   // Toggle handler for App Calendar items
//   handleAppCalendarToggle = (itemId) => {
//     const updatedItems = this.state.appCalendarItems.map(item => {
//       if (item.id === itemId) {
//         return { ...item, enabled: !item.enabled };
//       }
//       return item;
//     });

//     this.setState({ appCalendarItems: updatedItems });
//   };

//   // Submit handler for App Calendar settings - SAVE API
//   handleAppCalendarSubmit = (e) => {
//     e.preventDefault();

//     const enabledItems = this.state.appCalendarItems
//       .filter(item => item.enabled)
//       .map(item => item.apiKey);

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const apiToken = logindetail.memtoken ;

//     const sourceData = {
//       appID: parameters.appID,
//       memberID: parameters.memberID,
//       companyID: parameters.companyID,
//     };

//     const settingsObj = {};
//     for (let i = 0; i < enabledItems.length; i++) {
//       settingsObj[i] = enabledItems[i];
//     }
//     sourceData.settings = settingsObj;

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "saveSettings",
//           api_token: apiToken,
//           source: sourceData,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           NotificationManager.success(data.message || "App Calendar Settings Updated Successfully");
          
//           this.fetchAppCalendarSettings(false);
          
//           this.removeBlurEffect();
//         } else {
//           NotificationManager.info(data.message || "Failed to update settings");
//           this.setState({ appCalendarLoading: false });
          
//           this.removeBlurEffect();
//         }
//       })
//       .catch(error => {
//         console.error("Error saving app calendar settings:", error);
//         NotificationManager.info("Error updating app calendar settings");
        
//         this.removeBlurEffect();
        
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   handleEndDate = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       display_booking_end_time: checked ? "1" : "0"
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       display_booking_end_time: checked ? "1" : "0"
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_display_end_time",
//           source: dateVals,
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.display_booking_end_time = this.state.display_booking_end_time;

//           this.setState({
//             ...this.setState,
//             display_booking_end_time: loginData.display_booking_end_time
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleFormatChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       timeFormat: checked ? 24 : 12
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       timeFormat: checked ? 24 : 12
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "timeFormat",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',
//           timeFormat: dateVals.timeFormat
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.timeFormat = this.state.timeFormat;
//           this.setState({
//             ...this.state,
//             timeFormat: loginData.timeFormat
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleAddressInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       addressInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       addressInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "addressInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',
//           addressInInvoice: dateVals.addressInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.addressInInvoice = this.state.addressInInvoice;
//           this.setState({
//             ...this.state,
//             addressInInvoice: loginData.addressInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handlePersonalPhoneInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       phoneInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       phoneInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "phoneInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',
//           phoneInInvoice: dateVals.phoneInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.phoneInInvoice = this.state.phoneInInvoice;
//           this.setState({
//             ...this.state,
//             phoneInInvoice: loginData.phoneInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   // Fetch policies from API
//   fetchPolicies = () => {
//     this.setState({ policiesLoading: true });

//     const apiToken = logindetail.memtoken || "";
//     const formData = new FormData();
//     formData.append('action', 'getPolicies');
//     formData.append('api_token', apiToken);
//     formData.append('source[appID]', this.state.appID);
//     formData.append('source[memberID]', this.state.memberID);
//     formData.append('source[companyID]', this.state.companyID);

//     httpClient
//       .post("/v2/getPolicies.php", formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       })
//       .then((response) => {
//         if (response.data.success && response.data.data) {
//           const policies = response.data.data;
//           const selectedPolicy = policies.find(policy => policy.is_selected === 1);
//           const settings = response.data.settings || {};
          
//           this.setState({ 
//             policies: policies,
//             policiesLoading: false,
//             selectedPolicyId: selectedPolicy ? selectedPolicy.policyID : "",
//             cancelBeforeValue: settings.cancelBeforeValue || "",
//             cancelBeforeUnit: settings.cancelBeforeUnit || "hours",
//             cancelFeeValue: settings.cancelFeeValue || "",
//             cancelFeeUnit: settings.cancelFeeUnit || "%",
//             cancelCutoffTime: settings.cancelCutoffTime || "",
//             dynamicFieldsDisabled: !selectedPolicy,
//             cutoffTimeError: false,
//           });

//           if (selectedPolicy) {
//             var loginData = JSON.parse(localStorage.getItem("login"));
//             loginData.enableCancellationPolicy = selectedPolicy.policyID;
//             localStorage.setItem("login", JSON.stringify(loginData));
//           }
//         } else {
//           this.setState({ policiesLoading: false });
//           NotificationManager.info("Failed to load policies");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching policies:", error);
//         this.setState({ policiesLoading: false });
//         NotificationManager.info("Error loading policies");
//       });
//   };

//   // Handle policy radio change
//   handlePolicyChange = (event) => {
//     const selectedPolicyId = event.target.value;
//     this.setState({ 
//       selectedPolicyId: selectedPolicyId,
//       dynamicFieldsDisabled: false
//     });
//   };

//   // Dynamic policy field handlers
//   handleCancelBeforeValueChange = (e) => {
//     this.setState({ cancelBeforeValue: e.target.value });
//   };

//   handleCancelBeforeUnitChange = (e) => {
//     this.setState({ cancelBeforeUnit: e.target.value });
//   };

//   handleCancelFeeValueChange = (e) => {
//     this.setState({ cancelFeeValue: e.target.value });
//   };

//   handleCancelFeeUnitChange = (e) => {
//     this.setState({ cancelFeeUnit: e.target.value });
//   };

//   handleCancelCutoffTimeChange = (e) => {
//     const value = e.target.value;
//     const timePattern = /^([0-1][0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9]$/
//     const isValid = value === "" || timePattern.test(value);
    
//     this.setState({ 
//       cancelCutoffTime: value,
//       cutoffTimeError: value !== "" && !timePattern.test(value)
//     });
//   };

//   // Validate dynamic fields
//   validateDynamicFields = () => {
//     const { cancelBeforeValue, cancelFeeValue, cancelCutoffTime } = this.state;
//     const timePattern = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
    
//     if (!cancelBeforeValue || cancelBeforeValue <= 0) {
//       NotificationManager.info("Please enter valid Cancel Before Value");
//       return false;
//     }
    
//     if (!cancelFeeValue || cancelFeeValue <= 0) {
//       NotificationManager.info("Please enter valid Cancellation Fee Value");
//       return false;
//     }
    
//     if (!cancelCutoffTime || !timePattern.test(cancelCutoffTime)) {
//       NotificationManager.info("Please enter valid Cutoff Time in HH:MM:SS format (e.g., 22:00:00)");
//       return false;
//     }
    
//     return true;
//   };

//   // Save selected policy
//   handleSavePolicy = () => {
//     if (!this.state.selectedPolicyId) {
//       NotificationManager.info("Please select a policy");
//       return;
//     }
    
//     if (!this.validateDynamicFields()) {
//       return;
//     }

//     this.setState({ savingPolicy: true });

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       enableCancellationPolicy: this.state.selectedPolicyId,
//       cancelBeforeValue: this.state.cancelBeforeValue,
//       cancelBeforeUnit: this.state.cancelBeforeUnit,
//       cancelFeeValue: this.state.cancelFeeValue,
//       cancelFeeUnit: this.state.cancelFeeUnit,
//       cancelCutoffTime: this.state.cancelCutoffTime
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//           enableCancellationPolicy: dateVals.enableCancellationPolicy,
//           cancelBeforeValue: dateVals.cancelBeforeValue,
//           cancelBeforeUnit: dateVals.cancelBeforeUnit,
//           cancelFeeValue: dateVals.cancelFeeValue,
//           cancelFeeUnit: dateVals.cancelFeeUnit,
//           cancelCutoffTime: dateVals.cancelCutoffTime
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.enableCancellationPolicy = this.state.selectedPolicyId;
          
//           this.setState({
//             enableCancellationPolicy: 1,
//             savingPolicy: false
//           });
          
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.success("Policy saved successfully");
          
//           this.fetchPolicies();
//         } else {
//           this.setState({ savingPolicy: false });
//           NotificationManager.info(data.msg || "Failed to save policy");
//         }
//       })
//       .catch((error) => {
//         console.error("Error saving policy:", error);
//         this.setState({ savingPolicy: false });
//         NotificationManager.info("Error saving policy");
//       });
//   };

//   fetchAppCalendarSettings = (showNotification = false) => {
//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const loginData = JSON.parse(localStorage.getItem("login"));
//     const apiToken = loginData.memtoken ;

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "getSettings",
//           api_token: apiToken,
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           const enabledSettings = data.data || [];
          
//           const settingsMap = {};
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const key = enabledSettings[i];
//             settingsMap[key] = { enabled: true, order: i };
//           }

//           const orderedItems = [];
          
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const apiKey = enabledSettings[i];
//             for (let j = 0; j < this.state.appCalendarItems.length; j++) {
//               const item = this.state.appCalendarItems[j];
//               if (item.apiKey === apiKey) {
//                 orderedItems.push({
//                   ...item,
//                   enabled: true
//                 });
//                 break;
//               }
//             }
//           }
          
//           for (let i = 0; i < this.state.appCalendarItems.length; i++) {
//             const item = this.state.appCalendarItems[i];
//             if (!settingsMap.hasOwnProperty(item.apiKey)) {
//               orderedItems.push({
//                 ...item,
//                 enabled: false
//               });
//             }
//           }

//           this.setState({ 
//             appCalendarItems: orderedItems,
//             appCalendarLoading: false,
//             appCalendarInitialized: true
//           });

//           if (showNotification) {
//             NotificationManager.success(data.message || "Calendar settings loaded");
//           }
//         } else {
//           if (showNotification) {
//             NotificationManager.info(data.message || "Failed to load calendar settings");
//           }
//           this.setState({ appCalendarLoading: false });
//         }
//       })
//       .catch(error => {
//         console.error("Error fetching app calendar settings:", error);
//         if (showNotification) {
//           NotificationManager.info("Error loading calendar settings");
//         }
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
    
//     if (checked) {
//       if (this.state.policies.length > 0 && this.state.selectedPolicyId) {
//         this.setState({
//           enableCancellationPolicy: 1
//         });

//         var dateVals = {
//           appID: logindetail && logindetail.aid,
//           companyID: logindetail && logindetail.cid,
//           memberID: logindetail && logindetail.uid,
//           enableCancellationPolicy: this.state.selectedPolicyId,
//           cancelBeforeValue: this.state.cancelBeforeValue,
//           cancelBeforeUnit: this.state.cancelBeforeUnit,
//           cancelFeeValue: this.state.cancelFeeValue,
//           cancelFeeUnit: this.state.cancelFeeUnit,
//           cancelCutoffTime: this.state.cancelCutoffTime
//         };
        
//         httpClient
//           .post(
//             "updateUserSettings.php",
//             qs.stringify({
//               action: "enableCancellationPolicy",
//               source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//               enableCancellationPolicy: dateVals.enableCancellationPolicy,
//               cancelBeforeValue: dateVals.cancelBeforeValue,
//               cancelBeforeUnit: dateVals.cancelBeforeUnit,
//               cancelFeeValue: dateVals.cancelFeeValue,
//               cancelFeeUnit: dateVals.cancelFeeUnit,
//               cancelCutoffTime: dateVals.cancelCutoffTime
//             })
//           ).then(({ data }) => {
//             if (data.success == "true") {
//               var loginData = JSON.parse(localStorage.getItem("login"));

//               loginData.enableCancellationPolicy = this.state.selectedPolicyId;
//               this.setState({
//                 enableCancellationPolicy: 1
//               });
//               localStorage.setItem("login", JSON.stringify(loginData));
//               NotificationManager.info("Cancellation policy enabled");
//             }
//           });
//       } else {
//         this.fetchPolicies();
//         this.setState({
//           enableCancellationPolicy: 1
//         });
//       }
//     } else {
//       this.setState({
//         enableCancellationPolicy: 0
//       });

//       var dateVals = {
//         appID: logindetail && logindetail.aid,
//         companyID: logindetail && logindetail.cid,
//         memberID: logindetail && logindetail.uid,
//         enableCancellationPolicy: 0
//       };
      
//       httpClient
//         .post(
//           "updateUserSettings.php",
//           qs.stringify({
//             action: "enableCancellationPolicy",
//             source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//             enableCancellationPolicy: dateVals.enableCancellationPolicy
//           })
//         ).then(({ data }) => {
//           if (data.success == "true") {
//             var loginData = JSON.parse(localStorage.getItem("login"));

//             loginData.enableCancellationPolicy = 0;
//             this.setState({
//               enableCancellationPolicy: 0
//             });
//             localStorage.setItem("login", JSON.stringify(loginData));
//             NotificationManager.info("Cancellation policy disabled");
//           }
//         });
//     }
//   }

//   handleToggle = (event, value) => {
//     var settingParam;
//     var aid, cid, uid;
//     var btntype;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail.uid;
//     btntype = value;

//     const { checked } = this.state;
//     const currentIndex = checked.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex == -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     this.setState({
//       checked: newChecked,
//     });

//     settingParam = aid + "_" + cid + "_" + uid + "_" + value;

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: btntype,
//           source: settingParam,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data.success != "true") {
//             NotificationManager.info(data.failedMSG);
//           } else if (data.success == "true") {
//             var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
//             var objname = data.actionOn;

//             if (objname == "displayCustNotes")
//               loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

//             if (objname == "hideOldRecurring")
//               loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

//             if (objname == "displayBookingClash")
//               loginTempOBJ.displayBookingClash =
//                 1 - loginTempOBJ.displayBookingClash;

//             if (objname == "hidePastBookingsCalendarSearch")
//               loginTempOBJ.hidePastBookingsCalendarSearch =
//                 1 - loginTempOBJ.hidePastBookingsCalendarSearch;

//             if (objname == "filterBookingServices") {
//               loginTempOBJ.filterBookingServices =
//                 1 - loginTempOBJ.filterBookingServices;
//             }

//             localStorage.setItem("login", JSON.stringify(loginTempOBJ));
//             NotificationManager.info(data.msg);
//           }
//         },
//         (error) => {
//           this.setState({
//             error,
//           });
//         }
//       );
//   };

//   handleCalendarChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//   };

//   handleBookingConfirmationChange = (event) => {
//     this.setState({ selectedSetting: event.target.value });
//   };

//   handleChangeConfirmationHour = (e) => {
//     this.setState({
//       confirmationHour: e.target.value,
//     });
//   };

//   handleSaveSettings() {
//     if (this.state.incometemplate == "" && this.state.incomedescription == "") {
//       NotificationManager.info("Nothing changed to save");
//     } else {
//       httpClient
//         .post(
//           "saveMemberSettings.php",
//           qs.stringify({
//             action: "save_settings",
//             source: this.state,
//           })
//         )
//         .then(
//           ({ data }) => {
//             if (data.success != "true") {
//               NotificationManager.info(data.failedMSG);
//             } else {
//               NotificationManager.info(data.successMSG);
//               this.setState({
//                 incometemplate: "",
//                 incomedescription: "",
//               });
//             }
//           },
//           (error) => {
//             NotificationManager.info(
//               "Error Occured: Refresh the page and try again"
//             );
//           }
//         );
//     }
//   }

//   handleChange(evt) {
//     this.setState({ [evt.target.name]: evt.target.value });
//   }

//   handleSubmitCalendar = (e) => {
//     e.preventDefault();

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({
//       ...this.state,
//       loading: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       customer_name: this.state.customerName,
//       bookingCost: this.state.bookingTotal,
//       customer_address: this.state.customerAddress,
//       pet_name: this.state.petName,
//       pet_breed: this.state.petBreed,
//       services_name: this.state.serviceName,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_calendar_settings",
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           NotificationManager.success(data.successMSG);
//           let calendarData = [];
//           let calendarStorage = JSON.parse(localStorage.getItem("settings"));

//           calendarData = {
//             ...calendarStorage,
//             customer_name: data.customer_name,
//             bookingCost: data.bookingCost,
//             pet_name: data.pet_name,
//             services_name: data.services_name,
//             customer_address: data.customer_address,
//           };

//           const cal = { ...calendarData };

//           localStorage.setItem("settings", JSON.stringify(cal));

//           setTimeout(() => {
//             NotificationManager.info("Retrieving Calendar Entries");
//           }, 1000);

//           this.getCalendarEntry();
//         } else {
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   handleSubmitConfirmation = (e) => {
//     e.preventDefault();

//     this.setState({
//       ...this.state,
//       loadingConfirmation: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "bookingConfirmation",
//           source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
//           confirmationBy: this.state.selectedSetting,
//           confirmationHour: this.state.confirmationHour,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: data.data.confirmationBy,
//             confirmationHour: parseInt(data.data.confirmationHour),
//           });
//           NotificationManager.success(data.msg);
//         } else {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: "",
//             confirmationHour: "",
//           });
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   getCalendarEntry = () => {
//     httpClient
//       .post(
//         "getCalendarEntries.php",
//         qs.stringify({
//           action: "calendar_entries",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             var calendarLastMod = {
//               calendarLastModified: data.calendarLastModified,
//             };
//             var dataIndex =
//               modifiedData &&
//               modifiedData.findIndex((arr, i) => arr.calendarLastModified);
//             modifiedData && (modifiedData[dataIndex] = calendarLastMod);

//             localStorage.setItem("calendar_entries", JSON.stringify(data.data));
//             this.setState({
//               syncModified: modifiedData,
//             });

//             this.setState({
//               ...this.state,
//               loading: false,
//             });
            
//             if (this.state.syncModified.length > 0) {
//               var loginData = JSON.parse(localStorage.getItem("login"));
//               loginData.syncLastModified = this.state.syncModified;
//               loginData.syncLastModified !== [] &&
//                 localStorage.setItem("login", JSON.stringify(loginData));
//             }

//             NotificationManager.success(
//               "Calendar Settings Successfully Updated"
//             );

//             let loginBlur = JSON.parse(localStorage.getItem("login"));

//             if (loginBlur && loginBlur.ismobiledevice != 1) {
//               document.getElementById("nav__menu__display") !== null &&
//                 (document.getElementById("nav__menu__display").style.cssText =
//                   "filter: blur(0px); pointer-events: block");
//             }
//             document.getElementById("appbar_mainapp__") !== null &&
//               (document.getElementById("appbar_mainapp__").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           } else {
//           }
//         }
//       );
//   };

//   render() {
//     const {
//       error,
//       isLoaded,
//       incomedescription,
//       settingdetail,
//       incometemplate,
//       customerName,
//       bookingTotal,
//       customerAddress,
//       petName,
//       petBreed,
//       serviceName,
//       appCalendarItems,
//       appCalendarLoading,
//       appCalendarInitialized,
//       policies,
//       policiesLoading,
//       selectedPolicyId,
//       savingPolicy,
//       enableCancellationPolicy,
//       cancelBeforeValue,
//       cancelBeforeUnit,
//       cancelFeeValue,
//       cancelFeeUnit,
//       cancelCutoffTime,
//       dynamicFieldsDisabled,
//       cutoffTimeError,
//     } = this.state;

//     if (error) {
//       return <div className="jr-customers">Error: {error.message}</div>;
//     } else if (!isLoaded || (appCalendarLoading && !appCalendarInitialized)) {
//       return (
//         <div className="jr-customers">
//           <LinearProgress color="secondary" />
//         </div>
//       );
//     } else {
//       return (
//         <>
//           <div className="app-wrapper animated slideInUpTiny animation-duration-3">
//             <ContainerHeader
//               title={<IntlMessages id="sidebar.dashboard.settings" />}
//               match={this.props.match}
//             />

//             <div className="row">
//               <CardBox
//                 heading={<IntlMessages id="dashboard.settings.preferences" />}
//               >
//                 <div className="col-md-12 col-12">
//                   <List className="LawaList">
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Customer Notes on Booking" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayCustNotes")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayCustNotes") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "hideOldBookings")
//                           }
//                           checked={
//                             this.state.checked.indexOf("hideOldBookings") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Booking Clash Notifications" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayBookingClash")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayBookingClash") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Past Bookings from Calendar Search" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(
//                               event,
//                               "hidePastBookingsCalendarSearch"
//                             )
//                           }
//                           checked={
//                             this.state.checked.indexOf(
//                               "hidePastBookingsCalendarSearch"
//                             ) != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Filter Services based on pet size" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "filterBookingServices")
//                           }
//                           checked={
//                             this.state.checked.indexOf("filterBookingServices") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Booking End Time" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.display_booking_end_time === "1"}
//                           onChange={this.handleEndDate}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Address In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.addressInInvoice === 1}
//                           onChange={this.handleAddressInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Personal Phone In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.phoneInInvoice === 1}
//                           onChange={this.handlePersonalPhoneInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Toggle 24hr Time Format" />
//                       <ListItemSecondaryAction>
//                         <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
//                         <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
//                           <Switch
//                             color="primary"
//                             checked={this.state.timeFormat === 24}
//                             onChange={this.handleFormatChange}
//                           />
//                         </Tooltip>
//                         <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                   </List>
//                 </div>
//               </CardBox>

//               <div className="col-md-6">
//                 <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
//                       <div className="col-md-12 col-12">
//                         <TextField
//                           id="smsNumber"
//                           label="SMS Sender"
//                           value="0495149675"
//                           margin="normal"
//                           helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                           fullWidth
//                         />
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
                  
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={"Cancellation Policy"}>
//                       <div className="col-md-12 col-12">
//                         <List>
//                           <ListItem>
//                             <ListItemIcon>
//                               <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
//                             </ListItemIcon>
//                             <ListItemText primary="Attach Cancellation Policy" />
//                             <ListItemSecondaryAction>
//                               <Switch
//                                 color="primary"
//                                 checked={enableCancellationPolicy === 1}
//                                 onChange={this.handleCancellationPolicyChange}
//                               />
//                             </ListItemSecondaryAction>
//                           </ListItem>
//                         </List>

//                         {enableCancellationPolicy === 1 && (
//                           <>
//                             <Divider style={{ margin: '15px 0' }} />
                            
//                             {/* Dynamic Input Fields Section */}
//                             <div style={{ 
//                               marginBottom: '20px', 
//                               padding: '15px', 
//                               backgroundColor: '#f9f9f9', 
//                               borderRadius: '8px',
//                               border: '1px solid #e0e0e0'
//                             }}>
//                               <FormLabel component="legend" style={{ marginBottom: '15px', fontWeight: 600 }}>
//                                 Cancellation Policy Settings
//                               </FormLabel>
                              
//                               <Grid container spacing={2}>
//                                 {/* Cancel Before Value */}
//                                 <Grid item xs={12} sm={6} md={6}>
//                                   <TextField
//                                     label="Cancel Before Value"
//                                     type="number"
//                                     value={cancelBeforeValue}
//                                     onChange={this.handleCancelBeforeValueChange}
//                                     disabled={dynamicFieldsDisabled}
//                                     fullWidth
//                                     variant="outlined"
//                                     InputLabelProps={{
//                                       shrink: true,
//                                     }}
//                                     InputProps={{
//                                       inputProps: { min: 1 }
//                                     }}
//                                   />
//                                 </Grid>
                                
//                                 {/* Cancel Before Unit */}
//                                 <Grid item xs={12} sm={6} md={6}>
//                                   <FormControl fullWidth variant="outlined" disabled={dynamicFieldsDisabled}>
//                                     <InputLabel shrink>Cancel Before Unit</InputLabel>
//                                     <Select
//                                       value={cancelBeforeUnit}
//                                       onChange={this.handleCancelBeforeUnitChange}
//                                       label="Cancel Before Unit"
//                                       notched={true}
//                                     >
//                                       <MenuItem value="hours">Hours</MenuItem>
//                                       <MenuItem value="days">Days</MenuItem>
//                                       <MenuItem value="weeks">Weeks</MenuItem>
//                                     </Select>
//                                   </FormControl>
//                                 </Grid>
                                
//                                 {/* Cancellation Fee Value */}
//                                 <Grid item xs={12} sm={6} md={6}>
//                                   <TextField
//                                     label="Cancellation Fee Value"
//                                     type="number"
//                                     value={cancelFeeValue}
//                                     onChange={this.handleCancelFeeValueChange}
//                                     disabled={dynamicFieldsDisabled}
//                                     fullWidth
//                                     variant="outlined"
//                                     InputLabelProps={{
//                                       shrink: true,
//                                     }}
//                                     InputProps={{
//                                       inputProps: { min: 1 }
//                                     }}
//                                   />
//                                 </Grid>
                                
//                                 {/* Fee Unit */}
//                                 <Grid item xs={12} sm={6} md={6}>
//                                   <FormControl fullWidth variant="outlined" disabled={dynamicFieldsDisabled}>
//                                     <InputLabel shrink>Fee Unit</InputLabel>
//                                     <Select
//                                       value={cancelFeeUnit}
//                                       onChange={this.handleCancelFeeUnitChange}
//                                       label="Fee Unit"
//                                       notched={true}
//                                     >
//                                       <MenuItem value="$">$ (Dollar)</MenuItem>
//                                       <MenuItem value="%">% (Percent)</MenuItem>
//                                     </Select>
//                                   </FormControl>
//                                 </Grid>
                                
//                                 {/* Cutoff Time - Fixed validation */}
//                                 <Grid item xs={12}>
//                                   <TextField
//                                     label="Cutoff Time (24-hour format)"
//                                     value={cancelCutoffTime}
//                                     onChange={this.handleCancelCutoffTimeChange}
//                                     disabled={dynamicFieldsDisabled}
//                                     fullWidth
//                                     variant="outlined"
//                                     placeholder="22:00:00"
//                                     InputLabelProps={{
//                                       shrink: true,
//                                     }}
//                                     error={cutoffTimeError}
//                                     helperText={
//                                       <span style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
//                                         <i className="zmdi zmdi-time" style={{ fontSize: '14px' }}></i>
//                                         <span>Format: HH:MM:SS (e.g., 22:00:00 for 10:00 PM)</span>
//                                         {cancelCutoffTime && !cutoffTimeError && cancelCutoffTime !== "" && (
//                                           <span style={{ color: '#4caf50', marginLeft: '4px' }}>
//                                             ✓ Valid format
//                                           </span>
//                                         )}
//                                       </span>
//                                     }
//                                   />
//                                 </Grid>
//                               </Grid>
//                             </div>
                            
//                             <FormLabel component="legend" style={{ marginBottom: '10px', marginLeft: '15px' }}>
//                               Select Policy
//                             </FormLabel>
//                             {policiesLoading ? (
//                               <LinearProgress color="secondary" />
//                             ) : (
//                               <>
//                                 <FormControl component="fieldset" fullWidth>
//                                   <RadioGroup
//                                     name="policies-radio-group"
//                                     value={selectedPolicyId}
//                                     onChange={this.handlePolicyChange}
//                                   >
//                                     {policies.map((policy) => {
//                                       let displayPolicy = policy.policy;
                                      
//                                       displayPolicy = displayPolicy.replace(/{{cancelBeforeValue}}/g, cancelBeforeValue || '_____');
                                      
//                                       let unitText = cancelBeforeUnit || '_____';
//                                       if (cancelBeforeUnit === 'hours') {
//                                         unitText = parseInt(cancelBeforeValue) === 1 ? 'hour' : 'hours';
//                                       } else if (cancelBeforeUnit === 'days') {
//                                         unitText = parseInt(cancelBeforeValue) === 1 ? 'day' : 'days';
//                                       } else if (cancelBeforeUnit === 'weeks') {
//                                         unitText = parseInt(cancelBeforeValue) === 1 ? 'week' : 'weeks';
//                                       }
//                                       displayPolicy = displayPolicy.replace(/{{cancelBeforeUnit}}/g, unitText);
//                                       displayPolicy = displayPolicy.replace(/{{cancelBeforeUnit:pluralize}}/g, unitText);
                                      
//                                       displayPolicy = displayPolicy.replace(/{{cancelFeeValue}}/g, cancelFeeValue || '_____');
//                                       displayPolicy = displayPolicy.replace(/{{cancelFeeUnit}}/g, cancelFeeUnit || '_____');
//                                       displayPolicy = displayPolicy.replace(/{{cancelCutoffTime}}/g, cancelCutoffTime || '_____');
                                      
//                                       return (
//                                         <FormControlLabel
//                                           key={policy.policyID}
//                                           value={policy.policyID}
//                                           control={<Radio color="primary" />}
//                                           label={
//                                             <div 
//                                               dangerouslySetInnerHTML={{ __html: displayPolicy }}
//                                               style={{ 
//                                                 fontSize: '0.9rem',
//                                                 lineHeight: '1.4',
//                                                 wordBreak: 'break-word'
//                                               }}
//                                             />
//                                           }
//                                           style={{
//                                             marginBottom: '12px',
//                                             alignItems: 'flex-start',
//                                             width: '100%',
//                                           }}
//                                         />
//                                       );
//                                     })}
//                                   </RadioGroup>
//                                 </FormControl>
                                
//                                 <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
//                                   {savingPolicy ? (
//                                     <Button
//                                       variant="contained"
//                                       color="primary"
//                                       disabled={true}
//                                       size="large"
//                                     >
//                                       Saving...
//                                     </Button>
//                                   ) : (
//                                     <Button
//                                       variant="contained"
//                                       color="primary"
//                                       onClick={this.handleSavePolicy}
//                                       disabled={!selectedPolicyId || dynamicFieldsDisabled}
//                                       size="large"
//                                     >
//                                       Save Policy Selection
//                                     </Button>
//                                   )}
//                                 </div>
//                               </>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
//                 </Grid>
//               </div>

//               <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
//                 <form className="row" noValidate autoComplete="off">
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incometemplate"
//                       name="incometemplate"
//                       label="Income Title Template"
//                       margin="normal"
//                       defaultValue={this.state.settingdetail.title}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       onChange={this.handleChange}
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incomedescription"
//                       name="incomedescription"
//                       label="Income Description"
//                       defaultValue={this.state.settingdetail.desc}
//                       margin="normal"
//                       onChange={this.handleChange}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="jr-btn btn-margin-topbottom"
//                       position="static"
//                       onClick={() => {
//                         this.handleSaveSettings();
//                       }}
//                     >
//                       Save
//                     </Button>
//                   </div>
//                 </form>
//               </CardBox>
              
//               <CardBox heading="Send Booking Reminder">
//                 {this.state.loadingConfirmation && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Do not send booking reminder" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value=""
//                             checked={this.state.selectedSetting === ""}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email and SMS for all customers" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="all"
//                             checked={this.state.selectedSetting === "all"}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email only, do not send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="emailOnly"
//                             checked={this.state.selectedSetting === 'emailOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send SMS only, do not send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="smsOnly"
//                             checked={this.state.selectedSetting === 'smsOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by email but if not found, send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedEmail"
//                             checked={this.state.selectedSetting === 'preferedEmail'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by SMS but if no mobile number, send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedSMS"
//                             checked={this.state.selectedSetting === 'preferedSMS'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
//                         <ListItemSecondaryAction>
//                           <FormControl variant="outlined" style={{ width: "100px" }}>
//                             <Select
//                               placeholder="Select Confirmation Before"
//                               name="confirmationHour"
//                               value={this.state.confirmationHour}
//                               style={{
//                                 textAlign: 'center',
//                                 paddingLeft: '0',
//                               }}
//                               inputProps={{
//                                 style: {
//                                   textAlign: 'center',
//                                 },
//                               }}
//                               onChange={(e) => this.handleChangeConfirmationHour(e)}
//                             >
//                               <MenuItem value="">
//                                 <em>Select Confirmation Before</em>
//                               </MenuItem>
//                               <MenuItem value={24}>{"24 hrs"}</MenuItem>
//                               <MenuItem value={48}>{"48 hrs"}</MenuItem>
//                               <MenuItem value={72}>{"72 hrs"}</MenuItem>
//                             </Select>
//                           </FormControl>
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       {this.state.loadingConfirmation ? (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                           disabled={true}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       )}
//                     </List>
//                   </div>
//                 </div>
//               </CardBox>

//               <CardBox heading="Calendar Settings">
//                 {this.state.loading && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Show Booking Total" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="bookingTotal"
//                             checked={bookingTotal}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerName"
//                             checked={customerName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Address" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerAddress"
//                             checked={customerAddress}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petName"
//                             checked={petName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Breed" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petBreed"
//                             checked={petBreed}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Services Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="serviceName"
//                             checked={serviceName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <div>
//                         <h5>Preview</h5>
//                       </div>
//                       {(bookingTotal ||
//                         customerName ||
//                         customerAddress ||
//                         petName || petBreed ||
//                         serviceName) && (
//                           <Card
//                             style={{
//                               padding: "20px",
//                               backgroundColor: "#3f51b5",
//                               color: "#fff",
//                               width: "400px",
//                             }}
//                           > 
//                             {bookingTotal && <div>$Total Cost</div>}
//                             {customerName && <div>Firstname Lastname</div>}
//                             {customerAddress && <div>Street Address, Suburb, Postcode</div>}
//                             {petName && <div>Pet Name</div>}
//                             {petBreed && <div>Pet Breed</div>}
//                             {serviceName && <div>Services</div>}
//                           </Card>
//                         )}
//                     </List>
//                     {this.state.loading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={true}
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={
//                           !(bookingTotal ||
//                             customerName ||
//                             customerAddress ||
//                             petName || petBreed ||
//                             serviceName)
//                         }
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>

//               {/* App Calendar Settings Section with Mobile Support */}
//               <CardBox heading="App Calendar Settings">
//                 {appCalendarLoading && (
//                   <div style={{ position: "relative", top: "15px", marginBottom: "20px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <p style={{ 
//                       marginBottom: '15px', 
//                       color: '#666', 
//                       fontSize: '0.9rem',
//                       padding: '10px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}>
//                       {this.state.isTouchDevice ? (
//                         <span>Long press and drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       ) : (
//                         <span>Drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       )}
//                     </p>

//                     <List className="LawaList">
//                       {appCalendarItems.map((item, index) => (
//                         <ListItem
//                           key={item.id}
//                           className="app-calendar-item"
//                           draggable={!this.state.isTouchDevice}
//                           onDragStart={(e) => this.handleDragStart(e, index)}
//                           onDragOver={(e) => this.handleDragOver(e, index)}
//                           onDrop={(e) => this.handleDrop(e, index)}
//                           onDragEnd={this.handleDragEnd}
//                           onTouchStart={(e) => this.handleTouchStart(e, index)}
//                           onTouchMove={this.handleTouchMove}
//                           onTouchEnd={this.handleTouchEnd}
//                           onTouchCancel={this.handleTouchCancel}
//                           style={{
//                             cursor: this.state.isTouchDevice ? 'default' : 'grab',
//                             border: '1px solid transparent',
//                             transition: 'all 0.2s',
//                             backgroundColor: this.state.draggedItem === index ? '#f5f5f5' : 'transparent',
//                             WebkitTapHighlightColor: 'transparent',
//                           }}
//                         >
//                           <ListItemIcon 
//                             className="drag-handle"
//                             style={{ 
//                               cursor: this.state.isTouchDevice ? 'pointer' : 'grab', 
//                               minWidth: '40px',
//                               padding: this.state.isTouchDevice ? '10px 5px' : '0',
//                             }}
//                           >
//                             <i className="zmdi zmdi-menu" style={{ fontSize: '20px', color: '#999' }}></i>
//                           </ListItemIcon>
//                           <ListItemText primary={item.label} />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               checked={item.enabled}
//                               onChange={() => this.handleAppCalendarToggle(item.id)}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                       ))}
//                     </List>

//                     {/* Preview Section */}
//                     <div style={{ marginTop: '20px' }}>
//                       <h5>Preview</h5>
//                       {appCalendarItems.some(item => item.enabled) ? (
//                         <Card
//                           style={{
//                             padding: "20px",
//                             backgroundColor: "#3f51b5",
//                             color: "#fff",
//                             width: "100%",
//                             maxWidth: "400px",
//                           }}
//                         >
//                           {appCalendarItems
//                             .filter(item => item.enabled)
//                             .map(item => {
//                               switch(item.apiKey) {
//                                 case 'time':
//                                   return <div key={item.id}>10:30 AM</div>;
//                                 case 'cost':
//                                   return <div key={item.id}>Service Cost</div>;
//                                 case 'name':
//                                   return <div key={item.id}>Customer Name</div>;
//                                 case 'address':
//                                   return <div key={item.id}>123 Main St, Sydney 2000</div>;
//                                 case 'petName':
//                                   return <div key={item.id}>Pet Name</div>;
//                                 case 'petBreed':
//                                   return <div key={item.id}>Pet Breed</div>;
//                                 case 'serviceName':
//                                   return <div key={item.id}>Full Grooming</div>;
//                                 default:
//                                   return null;
//                               }
//                             })}
//                         </Card>
//                       ) : (
//                         <p style={{ color: '#999', fontStyle: 'italic' }}>Toggle on items to see preview</p>
//                       )}
//                     </div>

//                     {appCalendarLoading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         disabled={true}
//                       >
//                         Updating...
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         onClick={this.handleAppCalendarSubmit}
//                       >
//                         Update App Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>
//             </div>
//           </div>
//           <NotificationContainer />
//         </>
//       );
//     }
//   }
// }

// export default Settings;
// ****************************************************************************************************************************************************************
// import React from "react";
// import ContainerHeader from "components/ContainerHeader/index";
// import CardBox from "components/CardBox/index";
// import CardBoxNew from "components/CardBoxNew/index";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import "../../../../src/assets/vendors/react-notification/react-notifications.css"
// import { httpClient } from "appUtility/Api";
// import IntlMessages from "util/IntlMessages";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListSubheader from "@material-ui/core/ListSubheader";
// import Switch from "@material-ui/core/Switch";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import featureServer from "../../../appUtility/featureServer";
// import { FormControl, Grid, MenuItem, Radio, Select, Tooltip, RadioGroup, FormControlLabel, Divider, FormLabel, InputAdornment, InputLabel } from "@material-ui/core";
// import configureStore from "../../../store";

// const loginOBJ = localStorage.getItem("login");
// const logindetail = JSON.parse(loginOBJ);
// var modifiedData = logindetail && logindetail.syncLastModified;
// const qs = require("qs");

// var param, settingdetail;

// class Settings extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       error: null,
//       isLoaded: false,
//       id: "",
//       incometemplate: "",
//       incomedescription: "",
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       mcode: logindetail && logindetail.mCode,
//       settingdetail: "",
//       checked: [],
//       customerName: false,
//       bookingTotal: false,
//       customerAddress: false,
//       petName: false,
//       petBreed: false,
//       serviceName: false,
//       syncModified: "",
//       loading: false,
//       display_booking_end_time: logindetail && logindetail.display_booking_end_time,
//       timeFormat: logindetail && logindetail.timeFormat,
//       addressInInvoice: logindetail && logindetail.addressInInvoice,
//       phoneInInvoice: logindetail && logindetail.phoneInInvoice,
//       enableCancellationPolicy: logindetail && logindetail.enableCancellationPolicy,
//       selectedSetting: "",
//       confirmationHour: 24,
//       loadingConfirmation: false,
      
//       // New state for policies
//       policies: [],
//       policiesLoading: false,
//       selectedPolicyId: "",
//       savingPolicy: false,
      
//       // Dynamic policy fields
//       cancelBeforeValue: "",
//       cancelBeforeUnit: "hours", // 'hours' or 'cutoff'
//       cancelFeeValue: "",
//       cancelFeeUnit: "$", // '$' or '%'
//       cancelCutoffTime: "",
//       dynamicFieldsDisabled: true,
//       cutoffTimeError: false,
      
//       // App Calendar Settings with all possible items (time instead of date)
//       appCalendarItems: [
//         { id: 'appTime', label: 'Show Time', icon: 'zmdi-time', enabled: false, apiKey: 'time' },
//         { id: 'appBookingTotal', label: 'Show Booking Total', icon: 'zmdi-money', enabled: false, apiKey: 'cost' },
//         { id: 'appCustomerName', label: 'Show Customer Name', icon: 'zmdi-account', enabled: false, apiKey: 'name' },
//         { id: 'appCustomerAddress', label: 'Show Customer Address', icon: 'zmdi-pin', enabled: false, apiKey: 'address' },
//         { id: 'appPetName', label: 'Show Pet Name', icon: 'zmdi-face', enabled: false, apiKey: 'petName' },
//         { id: 'appPetBreed', label: 'Show Pet Breed', icon: 'zmdi-label', enabled: false, apiKey: 'petBreed' },
//         { id: 'appServiceName', label: 'Show Services Name', icon: 'zmdi-cut', enabled: false, apiKey: 'serviceName' },
//       ],
//       appCalendarLoading: false,
//       draggedItem: null,
//       appCalendarInitialized: false,
      
//       // Mobile touch states
//       isTouchDevice: false,
//       touchStartY: 0,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartTime: 0,
//     };

//     this.handleChange = this.handleChange.bind(this);
//     this.handleAppCalendarToggle = this.handleAppCalendarToggle.bind(this);
//     this.handleAppCalendarSubmit = this.handleAppCalendarSubmit.bind(this);
//     this.removeBlurEffect = this.removeBlurEffect.bind(this);
    
//     // Desktop drag handlers
//     this.handleDragStart = this.handleDragStart.bind(this);
//     this.handleDragOver = this.handleDragOver.bind(this);
//     this.handleDrop = this.handleDrop.bind(this);
//     this.handleDragEnd = this.handleDragEnd.bind(this);
    
//     // Mobile touch handlers
//     this.handleTouchStart = this.handleTouchStart.bind(this);
//     this.handleTouchMove = this.handleTouchMove.bind(this);
//     this.handleTouchEnd = this.handleTouchEnd.bind(this);
//     this.handleTouchCancel = this.handleTouchCancel.bind(this);
    
//     // Policy handlers
//     this.fetchPolicies = this.fetchPolicies.bind(this);
//     this.handlePolicyChange = this.handlePolicyChange.bind(this);
//     this.handleSavePolicy = this.handleSavePolicy.bind(this);
    
//     // Dynamic policy field handlers
//     this.handleCancelBeforeValueChange = this.handleCancelBeforeValueChange.bind(this);
//     this.handleCancelBeforeUnitChange = this.handleCancelBeforeUnitChange.bind(this);
//     this.handleCancelFeeValueChange = this.handleCancelFeeValueChange.bind(this);
//     this.handleCancelFeeUnitChange = this.handleCancelFeeUnitChange.bind(this);
//     this.handleCancelCutoffTimeChange = this.handleCancelCutoffTimeChange.bind(this);
//   }

//   componentDidMount() {
//     // Detect touch device
//     this.setState({
//       isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
//     });

//     // Prevent default touch behaviors on draggable items
//     document.addEventListener('touchmove', this.preventTouchScroll, { passive: false });
    
//     var aid, cid, uid;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail && logindetail.uid;

//     param = aid + "_" + cid + "_" + uid;

//     // Fetch member settings
//     httpClient
//       .post(
//         "getMemberSettings.php",
//         qs.stringify({
//           action: "member_settings",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             localStorage.setItem("settings", JSON.stringify(data));
//             this.setState(
//               {
//                 isLoaded: false,
//                 id: data.id,
//                 settingdetail: data,
//                 checked: data.flags,
//                 petName: data.pet_name == "1" ? true : false,
//                 petBreed: data.pet_breed == "1" ? true : false,
//                 serviceName: data.services_name == "1" ? true : false,
//                 customerName: data.customer_name == "1" ? true : false,
//                 bookingTotal: data.bookingCost == "1" ? true : false,
//                 customerAddress: data.customer_address == "1" ? true : false,
//                 confirmationHour: parseInt(data.confirmationHour),
//                 selectedSetting: data.confirmationBy,
//               },
//               function () {
//                 this.setState({
//                   isLoaded: true,
//                 });
//               }
//             );
//           } else {
//           }
//         },
//         (error) => {
//           this.setState({
//             isLoaded: true,
//             error,
//           });
//         }
//       );

//     const loginValue = JSON.parse(localStorage.getItem("login"));
//     this.setState({
//       ...this.state,
//       display_booking_end_time: loginValue.display_booking_end_time,
//       timeFormat: loginValue.timeFormat,
//       addressInInvoice: loginValue.addressInInvoice,
//       phoneInInvoice: loginValue.phoneInInvoice,
//       enableCancellationPolicy: loginValue.enableCancellationPolicy
//     });

//     // Fetch policies
//     this.fetchPolicies();

//     // Fetch App Calendar Settings (no notification on page load)
//     this.fetchAppCalendarSettings(false);

//     // Add inline styles for mobile
//     this.addInlineStyles();
//   }

//   componentWillUnmount() {
//     document.removeEventListener('touchmove', this.preventTouchScroll);
//   }

//   // Helper function to remove blur effect
//   removeBlurEffect = () => {
//     let loginBlur = JSON.parse(localStorage.getItem("login"));
    
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(0px); pointer-events: block");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(0px); pointer-events: block");
//   }

//   addInlineStyles = () => {
//     // Add styles to head if not already present
//     if (!document.getElementById('settings-inline-styles')) {
//       const style = document.createElement('style');
//       style.id = 'settings-inline-styles';
//       style.innerHTML = `
//         .app-calendar-item {
//           -webkit-touch-callout: none;
//           -webkit-user-select: none;
//           user-select: none;
//           touch-action: pan-y;
//           transition: all 0.2s ease;
//         }
//         .app-calendar-item.dragging {
//           opacity: 0.7 !important;
//           transform: scale(1.02) !important;
//           box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
//           z-index: 9999 !important;
//           background-color: #f5f5f5 !important;
//         }
//         .app-calendar-item.drag-over {
//           border: 2px dashed #3f51b5 !important;
//           background-color: #e8eaf6 !important;
//           opacity: 0.8;
//           transform: scale(1.01);
//         }
//         .app-calendar-item:active {
//           background-color: #f0f0f0;
//         }
//         @media (max-width: 768px) {
//           .app-calendar-item {
//             cursor: default !important;
//           }
//           .app-calendar-item .drag-handle {
//             padding: 10px 5px;
//           }
//         }
//       `;
//       document.head.appendChild(style);
//     }
//   };

//   preventTouchScroll = (e) => {
//     if (this.state.touchDraggedItem !== null) {
//       e.preventDefault();
//     }
//   };

//   // Desktop Drag Handlers
//   handleDragStart = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.dataTransfer.setData('text/plain', index.toString());
//     event.dataTransfer.effectAllowed = 'move';
//     this.setState({ draggedItem: index });
//     event.currentTarget.style.opacity = '0.5';
//     event.currentTarget.style.backgroundColor = '#f0f0f0';
//   };

//   handleDragOver = (event, index) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
//     event.dataTransfer.dropEffect = 'move';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => item.classList.remove('drag-over'));
//     if (event.currentTarget) {
//       event.currentTarget.classList.add('drag-over');
//     }
//   };

//   handleDrop = (event, targetIndex) => {
//     if (this.state.isTouchDevice) return;
    
//     event.preventDefault();
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     const sourceIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
//     if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;
    
//     const newItems = [...this.state.appCalendarItems];
//     const [movedItem] = newItems.splice(sourceIndex, 1);
//     newItems.splice(targetIndex, 0, movedItem);
    
//     this.setState({ 
//       appCalendarItems: newItems,
//       draggedItem: null 
//     });
//   };

//   handleDragEnd = (event) => {
//     if (this.state.isTouchDevice) return;
    
//     event.currentTarget.style.opacity = '1';
//     event.currentTarget.style.backgroundColor = '';
    
//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.backgroundColor = '';
//       item.classList.remove('drag-over');
//     });
    
//     this.setState({ draggedItem: null });
//   };

//   // Mobile Touch Handlers
//   handleTouchStart = (e, index) => {
//     e.preventDefault();
    
//     const touch = e.touches[0];
//     const target = e.currentTarget;
    
//     this.touchStartTimeout = setTimeout(() => {
//       this.setState({
//         touchStartY: touch.clientY,
//         touchStartX: touch.clientX,
//         touchDraggedItem: index,
//         touchDraggedIndex: index,
//         draggedItem: index
//       });

//       target.classList.add('dragging');
      
//       if (window.navigator.vibrate) {
//         window.navigator.vibrate(50);
//       }
//     }, 300);
    
//     this.setState({ touchStartTime: Date.now() });
//   };

//   handleTouchMove = (e) => {
//     e.preventDefault();
    
//     const { touchDraggedItem, touchStartY } = this.state;
//     if (touchDraggedItem === null) {
//       clearTimeout(this.touchStartTimeout);
//       return;
//     }

//     const touch = e.touches[0];
//     const currentY = touch.clientY;
//     const deltaY = currentY - touchStartY;

//     const items = document.querySelectorAll('.app-calendar-item');
//     let targetIndex = touchDraggedItem;
    
//     items.forEach((item, idx) => {
//       const rect = item.getBoundingClientRect();
//       if (currentY >= rect.top && currentY <= rect.bottom) {
//         targetIndex = idx;
//       }
//     });

//     items.forEach(item => item.classList.remove('drag-over'));
//     if (items[targetIndex] && targetIndex !== touchDraggedItem) {
//       items[targetIndex].classList.add('drag-over');
      
//       const container = document.querySelector('.LawaList');
//       if (container) {
//         const containerRect = container.getBoundingClientRect();
//         const scrollSpeed = 10;
        
//         if (currentY < containerRect.top + 50) {
//           container.scrollTop -= scrollSpeed;
//         } else if (currentY > containerRect.bottom - 50) {
//           container.scrollTop += scrollSpeed;
//         }
//       }
//     }

//     const draggedItem = items[touchDraggedItem];
//     if (draggedItem && Math.abs(deltaY) > 10) {
//       draggedItem.style.transform = `translateY(${deltaY}px) scale(1.02)`;
//     }

//     this.setState({ touchDraggedIndex: targetIndex });
//   };

//   handleTouchEnd = (e) => {
//     e.preventDefault();
//     clearTimeout(this.touchStartTimeout);
    
//     const { touchDraggedItem, touchDraggedIndex } = this.state;
    
//     if (touchDraggedItem !== null && touchDraggedIndex !== -1) {
//       if (touchDraggedIndex !== touchDraggedItem) {
//         const newItems = [...this.state.appCalendarItems];
//         const [movedItem] = newItems.splice(touchDraggedItem, 1);
//         newItems.splice(touchDraggedIndex, 0, movedItem);
        
//         this.setState({ appCalendarItems: newItems });
//       }
//     }

//     const items = document.querySelectorAll('.app-calendar-item');
//     items.forEach(item => {
//       item.style.opacity = '1';
//       item.style.transform = '';
//       item.style.backgroundColor = '';
//       item.classList.remove('dragging', 'drag-over');
//     });

//     this.setState({ 
//       draggedItem: null,
//       touchDraggedItem: null,
//       touchDraggedIndex: -1,
//       touchStartY: 0
//     });
//   };

//   handleTouchCancel = (e) => {
//     this.handleTouchEnd(e);
//   };

//   // Toggle handler for App Calendar items
//   handleAppCalendarToggle = (itemId) => {
//     const updatedItems = this.state.appCalendarItems.map(item => {
//       if (item.id === itemId) {
//         return { ...item, enabled: !item.enabled };
//       }
//       return item;
//     });

//     this.setState({ appCalendarItems: updatedItems });
//   };

//   // Submit handler for App Calendar settings - SAVE API
//   handleAppCalendarSubmit = (e) => {
//     e.preventDefault();

//     const enabledItems = this.state.appCalendarItems
//       .filter(item => item.enabled)
//       .map(item => item.apiKey);

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const apiToken = logindetail.memtoken ;

//     const sourceData = {
//       appID: parameters.appID,
//       memberID: parameters.memberID,
//       companyID: parameters.companyID,
//     };

//     const settingsObj = {};
//     for (let i = 0; i < enabledItems.length; i++) {
//       settingsObj[i] = enabledItems[i];
//     }
//     sourceData.settings = settingsObj;

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "saveSettings",
//           api_token: apiToken,
//           source: sourceData,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           NotificationManager.success(data.message || "App Calendar Settings Updated Successfully");
          
//           this.fetchAppCalendarSettings(false);
          
//           this.removeBlurEffect();
//         } else {
//           NotificationManager.info(data.message || "Failed to update settings");
//           this.setState({ appCalendarLoading: false });
          
//           this.removeBlurEffect();
//         }
//       })
//       .catch(error => {
//         console.error("Error saving app calendar settings:", error);
//         NotificationManager.info("Error updating app calendar settings");
        
//         this.removeBlurEffect();
        
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   handleEndDate = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       display_booking_end_time: checked ? "1" : "0"
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       display_booking_end_time: checked ? "1" : "0"
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_display_end_time",
//           source: dateVals,
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.display_booking_end_time = this.state.display_booking_end_time;

//           this.setState({
//             ...this.setState,
//             display_booking_end_time: loginData.display_booking_end_time
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleFormatChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.setState,
//       timeFormat: checked ? 24 : 12
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       timeFormat: checked ? 24 : 12
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "timeFormat",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',
//           timeFormat: dateVals.timeFormat
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.timeFormat = this.state.timeFormat;
//           this.setState({
//             ...this.state,
//             timeFormat: loginData.timeFormat
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handleAddressInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       addressInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       addressInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "addressInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',
//           addressInInvoice: dateVals.addressInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.addressInInvoice = this.state.addressInInvoice;
//           this.setState({
//             ...this.state,
//             addressInInvoice: loginData.addressInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   handlePersonalPhoneInInvoiceChange = (e) => {
//     const { checked } = e.target;
//     this.setState({
//       ...this.state,
//       phoneInInvoice: checked ? 1 : 0
//     })

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       phoneInInvoice: checked ? 1 : 0
//     }
//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "phoneInInvoice",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',
//           phoneInInvoice: dateVals.phoneInInvoice
//         })
//       ).then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.phoneInInvoice = this.state.phoneInInvoice;
//           this.setState({
//             ...this.state,
//             phoneInInvoice: loginData.phoneInInvoice
//           })
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.info(data.msg);
//         }
//       })
//   }

//   // Fetch policies from API
// //   fetchPolicies = () => {
// //     this.setState({ policiesLoading: true });

// //     const apiToken = logindetail.memtoken || "";
// //     const formData = new FormData();
// //     formData.append('action', 'getPolicies');
// //     formData.append('api_token', apiToken);
// //     formData.append('source[appID]', this.state.appID);
// //     formData.append('source[memberID]', this.state.memberID);
// //     formData.append('source[companyID]', this.state.companyID);

// //     httpClient
// //       .post("/v2/getPolicies.php", formData, {
// //         headers: {
// //           'Content-Type': 'multipart/form-data',
// //         },
// //       })
// //       .then((response) => {
// //         if (response.data.success && response.data.data) {
// //           const policies = response.data.data;
// //           const selectedPolicy = policies.find(policy => policy.is_selected === 1);
// //           const settings = response.data.settings || {};
          
// //           this.setState({ 
// //             policies: policies,
// //             policiesLoading: false,
// //             selectedPolicyId: selectedPolicy ? selectedPolicy.policyID : "",
// //             cancelBeforeValue: settings.cancelBeforeValue || "",
// //             cancelBeforeUnit: settings.cancelBeforeUnit || "hours",
// //             cancelFeeValue: settings.cancelFeeValue || "",
// //             cancelFeeUnit: settings.cancelFeeUnit || "$",
// //             cancelCutoffTime: settings.cancelCutoffTime || "",
// //             dynamicFieldsDisabled: !selectedPolicy,
// //             cutoffTimeError: false,
// //           });

// //           if (selectedPolicy) {
// //             var loginData = JSON.parse(localStorage.getItem("login"));
// //             loginData.enableCancellationPolicy = selectedPolicy.policyID;
// //             localStorage.setItem("login", JSON.stringify(loginData));
// //           }
// //         } else {
// //           this.setState({ policiesLoading: false });
// //           NotificationManager.info("Failed to load policies");
// //         }
// //       })
// //       .catch((error) => {
// //         console.error("Error fetching policies:", error);
// //         this.setState({ policiesLoading: false });
// //         NotificationManager.info("Error loading policies");
// //       });
// //   };
// // Fetch policies from API
// fetchPolicies = () => {
//   this.setState({ policiesLoading: true });

//   const apiToken = logindetail.memtoken || "";
//   const formData = new FormData();
//   formData.append('action', 'getPolicies');
//   formData.append('api_token', apiToken);
//   formData.append('source[appID]', this.state.appID);
//   formData.append('source[memberID]', this.state.memberID);
//   formData.append('source[companyID]', this.state.companyID);

//   httpClient
//     .post("/v2/getPolicies.php", formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     })
//     .then((response) => {
//       if (response.data.success && response.data.data) {
//         const policies = response.data.data;
//         const selectedPolicy = policies.find(policy => policy.is_selected === 1);
//         const settings = response.data.settings || {};
        
//         this.setState({ 
//           policies: policies,
//           policiesLoading: false,
//           selectedPolicyId: selectedPolicy ? selectedPolicy.policyID : "",
//           cancelBeforeValue: settings.cancelBeforeValue || "",
//           cancelBeforeUnit: settings.cancelBeforeUnit || "hours",
//           cancelFeeValue: settings.cancelFeeValue || "",
//           cancelFeeUnit: settings.cancelFeeUnit || "$",
//           cancelCutoffTime: settings.cancelCutoffTime || "",
//           dynamicFieldsDisabled: !selectedPolicy,
//           cutoffTimeError: false,
//         });

//         if (selectedPolicy) {
//           var loginData = JSON.parse(localStorage.getItem("login"));
//           loginData.enableCancellationPolicy = selectedPolicy.policyID;
//           localStorage.setItem("login", JSON.stringify(loginData));
//         }
//       } else {
//         this.setState({ policiesLoading: false });
//         NotificationManager.info("Failed to load policies");
//       }
//     })
//     .catch((error) => {
//       console.error("Error fetching policies:", error);
//       this.setState({ policiesLoading: false });
//       NotificationManager.info("Error loading policies");
//     });
// };
//   // Handle policy radio change
//   handlePolicyChange = (event) => {
//     const selectedPolicyId = event.target.value;
//     this.setState({ 
//       selectedPolicyId: selectedPolicyId,
//       dynamicFieldsDisabled: false
//     });
//   };

//   // Dynamic policy field handlers
//   handleCancelBeforeValueChange = (e) => {
//     this.setState({ cancelBeforeValue: e.target.value });
//   };

// //   handleCancelBeforeUnitChange = (e) => {
// //     const newValue = e.target.value;
// //     this.setState({ 
// //       cancelBeforeUnit: newValue,
// //       // Reset values when switching
// //       cancelBeforeValue: newValue === "hours" ? this.state.cancelBeforeValue : "",
// //       cancelCutoffTime: newValue === "cutoff" ? this.state.cancelCutoffTime : ""
// //     });
// //   };


// handleCancelBeforeUnitChange = (e) => {
//   const newValue = e.target.value;
//   // Just update the unit, don't clear the values
//   this.setState({ cancelBeforeUnit: newValue });
// };

//   handleCancelFeeValueChange = (e) => {
//     this.setState({ cancelFeeValue: e.target.value });
//   };

//   handleCancelFeeUnitChange = (e) => {
//     this.setState({ cancelFeeUnit: e.target.value });
//   };

//   handleCancelCutoffTimeChange = (e) => {
//     const value = e.target.value;
//     const timePattern = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/
//     const isValid = value === "" || timePattern.test(value);
    
//     this.setState({ 
//       cancelCutoffTime: value,
//       cutoffTimeError: value !== "" && !timePattern.test(value)
//     });
//   };

//   // Validate dynamic fields
//   validateDynamicFields = () => {
//     const { cancelBeforeUnit, cancelBeforeValue, cancelFeeValue, cancelCutoffTime } = this.state;
//     const timePattern = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
    
//     if (cancelBeforeUnit === 'hours') {
//       if (!cancelBeforeValue || cancelBeforeValue <= 0) {
//         NotificationManager.info("Please enter valid Hours value");
//         return false;
//       }
//     } else if (cancelBeforeUnit === 'cutoff') {
//       if (!cancelCutoffTime || !timePattern.test(cancelCutoffTime)) {
//         NotificationManager.info("Please enter valid Cutoff Time in HH:MM:SS format (e.g., 22:00:00)");
//         return false;
//       }
//     }
    
//     if (!cancelFeeValue || cancelFeeValue <= 0) {
//       NotificationManager.info("Please enter valid Cancellation Fee Value");
//       return false;
//     }
    
//     if (isNaN(cancelFeeValue) || parseFloat(cancelFeeValue) <= 0) {
//       NotificationManager.info("Please enter a valid numeric fee value");
//       return false;
//     }
    
//     return true;
//   };

//   // Save selected policy
//   handleSavePolicy = () => {
//     if (!this.state.selectedPolicyId) {
//       NotificationManager.info("Please select a policy");
//       return;
//     }
    
//     if (!this.validateDynamicFields()) {
//       return;
//     }

//     this.setState({ savingPolicy: true });

//     var dateVals = {
//       appID: logindetail && logindetail.aid,
//       companyID: logindetail && logindetail.cid,
//       memberID: logindetail && logindetail.uid,
//       enableCancellationPolicy: this.state.selectedPolicyId,
//       cancelBeforeValue: this.state.cancelBeforeValue,
//       cancelBeforeUnit: this.state.cancelBeforeUnit,
//       cancelFeeValue: this.state.cancelFeeValue,
//       cancelFeeUnit: this.state.cancelFeeUnit,
//       cancelCutoffTime: this.state.cancelCutoffTime
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "enableCancellationPolicy",
//           source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//           enableCancellationPolicy: dateVals.enableCancellationPolicy,
//           cancelBeforeValue: dateVals.cancelBeforeValue,
//           cancelBeforeUnit: dateVals.cancelBeforeUnit,
//           cancelFeeValue: dateVals.cancelFeeValue,
//           cancelFeeUnit: dateVals.cancelFeeUnit,
//           cancelCutoffTime: dateVals.cancelCutoffTime
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           var loginData = JSON.parse(localStorage.getItem("login"));

//           loginData.enableCancellationPolicy = this.state.selectedPolicyId;
          
//           this.setState({
//             enableCancellationPolicy: 1,
//             savingPolicy: false
//           });
          
//           localStorage.setItem("login", JSON.stringify(loginData));
//           NotificationManager.success("Policy saved successfully");
          
//           this.fetchPolicies();
//         } else {
//           this.setState({ savingPolicy: false });
//           NotificationManager.info(data.msg || "Failed to save policy");
//         }
//       })
//       .catch((error) => {
//         console.error("Error saving policy:", error);
//         this.setState({ savingPolicy: false });
//         NotificationManager.info("Error saving policy");
//       });
//   };

//   fetchAppCalendarSettings = (showNotification = false) => {
//     this.setState({ appCalendarLoading: true });

//     let parameters = {
//       appID: this.state.appID,
//       memberID: this.state.memberID,
//       companyID: this.state.companyID,
//     };

//     const loginData = JSON.parse(localStorage.getItem("login"));
//     const apiToken = loginData.memtoken ;

//     httpClient
//       .post(
//         "/v2/mobileCalendarSettings.php",
//         qs.stringify({
//           action: "getSettings",
//           api_token: apiToken,
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success) {
//           const enabledSettings = data.data || [];
          
//           const settingsMap = {};
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const key = enabledSettings[i];
//             settingsMap[key] = { enabled: true, order: i };
//           }

//           const orderedItems = [];
          
//           for (let i = 0; i < enabledSettings.length; i++) {
//             const apiKey = enabledSettings[i];
//             for (let j = 0; j < this.state.appCalendarItems.length; j++) {
//               const item = this.state.appCalendarItems[j];
//               if (item.apiKey === apiKey) {
//                 orderedItems.push({
//                   ...item,
//                   enabled: true
//                 });
//                 break;
//               }
//             }
//           }
          
//           for (let i = 0; i < this.state.appCalendarItems.length; i++) {
//             const item = this.state.appCalendarItems[i];
//             if (!settingsMap.hasOwnProperty(item.apiKey)) {
//               orderedItems.push({
//                 ...item,
//                 enabled: false
//               });
//             }
//           }

//           this.setState({ 
//             appCalendarItems: orderedItems,
//             appCalendarLoading: false,
//             appCalendarInitialized: true
//           });

//           if (showNotification) {
//             NotificationManager.success(data.message || "Calendar settings loaded");
//           }
//         } else {
//           if (showNotification) {
//             NotificationManager.info(data.message || "Failed to load calendar settings");
//           }
//           this.setState({ appCalendarLoading: false });
//         }
//       })
//       .catch(error => {
//         console.error("Error fetching app calendar settings:", error);
//         if (showNotification) {
//           NotificationManager.info("Error loading calendar settings");
//         }
//         this.setState({ appCalendarLoading: false });
//       });
//   };

//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
    
//     if (checked) {
//       if (this.state.policies.length > 0 && this.state.selectedPolicyId) {
//         this.setState({
//           enableCancellationPolicy: 1
//         });

//         var dateVals = {
//           appID: logindetail && logindetail.aid,
//           companyID: logindetail && logindetail.cid,
//           memberID: logindetail && logindetail.uid,
//           enableCancellationPolicy: this.state.selectedPolicyId,
//           cancelBeforeValue: this.state.cancelBeforeValue,
//           cancelBeforeUnit: this.state.cancelBeforeUnit,
//           cancelFeeValue: this.state.cancelFeeValue,
//           cancelFeeUnit: this.state.cancelFeeUnit,
//           cancelCutoffTime: this.state.cancelCutoffTime
//         };
        
//         httpClient
//           .post(
//             "updateUserSettings.php",
//             qs.stringify({
//               action: "enableCancellationPolicy",
//               source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//               enableCancellationPolicy: dateVals.enableCancellationPolicy,
//               cancelBeforeValue: dateVals.cancelBeforeValue,
//               cancelBeforeUnit: dateVals.cancelBeforeUnit,
//               cancelFeeValue: dateVals.cancelFeeValue,
//               cancelFeeUnit: dateVals.cancelFeeUnit,
//               cancelCutoffTime: dateVals.cancelCutoffTime
//             })
//           ).then(({ data }) => {
//             if (data.success == "true") {
//               var loginData = JSON.parse(localStorage.getItem("login"));

//               loginData.enableCancellationPolicy = this.state.selectedPolicyId;
//               this.setState({
//                 enableCancellationPolicy: 1
//               });
//               localStorage.setItem("login", JSON.stringify(loginData));
//               NotificationManager.info("Cancellation policy enabled");
//             }
//           });
//       } else {
//         this.fetchPolicies();
//         this.setState({
//           enableCancellationPolicy: 1
//         });
//       }
//     } else {
//       this.setState({
//         enableCancellationPolicy: 0
//       });

//       var dateVals = {
//         appID: logindetail && logindetail.aid,
//         companyID: logindetail && logindetail.cid,
//         memberID: logindetail && logindetail.uid,
//         enableCancellationPolicy: 0
//       };
      
//       httpClient
//         .post(
//           "updateUserSettings.php",
//           qs.stringify({
//             action: "enableCancellationPolicy",
//             source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//             enableCancellationPolicy: dateVals.enableCancellationPolicy
//           })
//         ).then(({ data }) => {
//           if (data.success == "true") {
//             var loginData = JSON.parse(localStorage.getItem("login"));

//             loginData.enableCancellationPolicy = 0;
//             this.setState({
//               enableCancellationPolicy: 0
//             });
//             localStorage.setItem("login", JSON.stringify(loginData));
//             NotificationManager.info("Cancellation policy disabled");
//           }
//         });
//     }
//   }

//   handleToggle = (event, value) => {
//     var settingParam;
//     var aid, cid, uid;
//     var btntype;
//     aid = logindetail && logindetail.aid;
//     cid = logindetail && logindetail.cid;
//     uid = logindetail && logindetail.uid;
//     btntype = value;

//     const { checked } = this.state;
//     const currentIndex = checked.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex == -1) {
//       newChecked.push(value);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     this.setState({
//       checked: newChecked,
//     });

//     settingParam = aid + "_" + cid + "_" + uid + "_" + value;

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: btntype,
//           source: settingParam,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data.success != "true") {
//             NotificationManager.info(data.failedMSG);
//           } else if (data.success == "true") {
//             var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
//             var objname = data.actionOn;

//             if (objname == "displayCustNotes")
//               loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

//             if (objname == "hideOldRecurring")
//               loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

//             if (objname == "displayBookingClash")
//               loginTempOBJ.displayBookingClash =
//                 1 - loginTempOBJ.displayBookingClash;

//             if (objname == "hidePastBookingsCalendarSearch")
//               loginTempOBJ.hidePastBookingsCalendarSearch =
//                 1 - loginTempOBJ.hidePastBookingsCalendarSearch;

//             if (objname == "filterBookingServices") {
//               loginTempOBJ.filterBookingServices =
//                 1 - loginTempOBJ.filterBookingServices;
//             }

//             localStorage.setItem("login", JSON.stringify(loginTempOBJ));
//             NotificationManager.info(data.msg);
//           }
//         },
//         (error) => {
//           this.setState({
//             error,
//           });
//         }
//       );
//   };

//   handleCalendarChange = (e) => {
//     const { name, checked } = e.target;
//     this.setState({ [name]: checked });
//   };

//   handleBookingConfirmationChange = (event) => {
//     this.setState({ selectedSetting: event.target.value });
//   };

//   handleChangeConfirmationHour = (e) => {
//     this.setState({
//       confirmationHour: e.target.value,
//     });
//   };

//   handleSaveSettings() {
//     if (this.state.incometemplate == "" && this.state.incomedescription == "") {
//       NotificationManager.info("Nothing changed to save");
//     } else {
//       httpClient
//         .post(
//           "saveMemberSettings.php",
//           qs.stringify({
//             action: "save_settings",
//             source: this.state,
//           })
//         )
//         .then(
//           ({ data }) => {
//             if (data.success != "true") {
//               NotificationManager.info(data.failedMSG);
//             } else {
//               NotificationManager.info(data.successMSG);
//               this.setState({
//                 incometemplate: "",
//                 incomedescription: "",
//               });
//             }
//           },
//           (error) => {
//             NotificationManager.info(
//               "Error Occured: Refresh the page and try again"
//             );
//           }
//         );
//     }
//   }

//   handleChange(evt) {
//     this.setState({ [evt.target.name]: evt.target.value });
//   }

//   handleSubmitCalendar = (e) => {
//     e.preventDefault();

//     let loginBlur = JSON.parse(localStorage.getItem("login"));
//     if (loginBlur && loginBlur.ismobiledevice != 1) {
//       document.getElementById("nav__menu__display") !== null &&
//         (document.getElementById("nav__menu__display").style.cssText =
//           "filter: blur(2px); pointer-events: none");
//     }
//     document.getElementById("appbar_mainapp__") !== null &&
//       (document.getElementById("appbar_mainapp__").style.cssText =
//         "filter: blur(2px); pointer-events: none");

//     this.setState({
//       ...this.state,
//       loading: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//       customer_name: this.state.customerName,
//       bookingCost: this.state.bookingTotal,
//       customer_address: this.state.customerAddress,
//       pet_name: this.state.petName,
//       pet_breed: this.state.petBreed,
//       services_name: this.state.serviceName,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "update_calendar_settings",
//           source: parameters,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           NotificationManager.success(data.successMSG);
//           let calendarData = [];
//           let calendarStorage = JSON.parse(localStorage.getItem("settings"));

//           calendarData = {
//             ...calendarStorage,
//             customer_name: data.customer_name,
//             bookingCost: data.bookingCost,
//             pet_name: data.pet_name,
//             services_name: data.services_name,
//             customer_address: data.customer_address,
//           };

//           const cal = { ...calendarData };

//           localStorage.setItem("settings", JSON.stringify(cal));

//           setTimeout(() => {
//             NotificationManager.info("Retrieving Calendar Entries");
//           }, 1000);

//           this.getCalendarEntry();
//         } else {
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   handleSubmitConfirmation = (e) => {
//     e.preventDefault();

//     this.setState({
//       ...this.state,
//       loadingConfirmation: true,
//     });
    
//     let parameters = {
//       appID: logindetail && logindetail.aid,
//       memberID: logindetail && logindetail.uid,
//       companyID: logindetail && logindetail.cid,
//     };

//     httpClient
//       .post(
//         "updateUserSettings.php",
//         qs.stringify({
//           action: "bookingConfirmation",
//           source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
//           confirmationBy: this.state.selectedSetting,
//           confirmationHour: this.state.confirmationHour,
//         })
//       )
//       .then(({ data }) => {
//         if (data.success == "true") {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: data.data.confirmationBy,
//             confirmationHour: parseInt(data.data.confirmationHour),
//           });
//           NotificationManager.success(data.msg);
//         } else {
//           this.setState({
//             ...this.state,
//             loadingConfirmation: false,
//             selectedSetting: "",
//             confirmationHour: "",
//           });
//           NotificationManager.info(data.failedMSG);
//         }
//       });
//   };

//   getCalendarEntry = () => {
//     httpClient
//       .post(
//         "getCalendarEntries.php",
//         qs.stringify({
//           action: "calendar_entries",
//           source: param,
//         })
//       )
//       .then(
//         ({ data }) => {
//           if (data) {
//             var calendarLastMod = {
//               calendarLastModified: data.calendarLastModified,
//             };
//             var dataIndex =
//               modifiedData &&
//               modifiedData.findIndex((arr, i) => arr.calendarLastModified);
//             modifiedData && (modifiedData[dataIndex] = calendarLastMod);

//             localStorage.setItem("calendar_entries", JSON.stringify(data.data));
//             this.setState({
//               syncModified: modifiedData,
//             });

//             this.setState({
//               ...this.state,
//               loading: false,
//             });
            
//             if (this.state.syncModified.length > 0) {
//               var loginData = JSON.parse(localStorage.getItem("login"));
//               loginData.syncLastModified = this.state.syncModified;
//               loginData.syncLastModified !== [] &&
//                 localStorage.setItem("login", JSON.stringify(loginData));
//             }

//             NotificationManager.success(
//               "Calendar Settings Successfully Updated"
//             );

//             let loginBlur = JSON.parse(localStorage.getItem("login"));

//             if (loginBlur && loginBlur.ismobiledevice != 1) {
//               document.getElementById("nav__menu__display") !== null &&
//                 (document.getElementById("nav__menu__display").style.cssText =
//                   "filter: blur(0px); pointer-events: block");
//             }
//             document.getElementById("appbar_mainapp__") !== null &&
//               (document.getElementById("appbar_mainapp__").style.cssText =
//                 "filter: blur(0px); pointer-events: block");
//           } else {
//           }
//         }
//       );
//   };

//   render() {
//     const {
//       error,
//       isLoaded,
//       incomedescription,
//       settingdetail,
//       incometemplate,
//       customerName,
//       bookingTotal,
//       customerAddress,
//       petName,
//       petBreed,
//       serviceName,
//       appCalendarItems,
//       appCalendarLoading,
//       appCalendarInitialized,
//       policies,
//       policiesLoading,
//       selectedPolicyId,
//       savingPolicy,
//       enableCancellationPolicy,
//       cancelBeforeValue,
//       cancelBeforeUnit,
//       cancelFeeValue,
//       cancelFeeUnit,
//       cancelCutoffTime,
//       dynamicFieldsDisabled,
//       cutoffTimeError,
//     } = this.state;

//     if (error) {
//       return <div className="jr-customers">Error: {error.message}</div>;
//     } else if (!isLoaded || (appCalendarLoading && !appCalendarInitialized)) {
//       return (
//         <div className="jr-customers">
//           <LinearProgress color="secondary" />
//         </div>
//       );
//     } else {
//       return (
//         <>
//           <div className="app-wrapper animated slideInUpTiny animation-duration-3">
//             <ContainerHeader
//               title={<IntlMessages id="sidebar.dashboard.settings" />}
//               match={this.props.match}
//             />

//             <div className="row">
//               <CardBox
//                 heading={<IntlMessages id="dashboard.settings.preferences" />}
//               >
//                 <div className="col-md-12 col-12">
//                   <List className="LawaList">
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Customer Notes on Booking" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayCustNotes")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayCustNotes") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "hideOldBookings")
//                           }
//                           checked={
//                             this.state.checked.indexOf("hideOldBookings") != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Booking Clash Notifications" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "displayBookingClash")
//                           }
//                           checked={
//                             this.state.checked.indexOf("displayBookingClash") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Hide Past Bookings from Calendar Search" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(
//                               event,
//                               "hidePastBookingsCalendarSearch"
//                             )
//                           }
//                           checked={
//                             this.state.checked.indexOf(
//                               "hidePastBookingsCalendarSearch"
//                             ) != -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Filter Services based on pet size" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           onClick={(event) =>
//                             this.handleToggle(event, "filterBookingServices")
//                           }
//                           checked={
//                             this.state.checked.indexOf("filterBookingServices") !=
//                             -1
//                           }
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Display Booking End Time" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.display_booking_end_time === "1"}
//                           onChange={this.handleEndDate}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Address In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.addressInInvoice === 1}
//                           onChange={this.handleAddressInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Show Personal Phone In Invoice" />
//                       <ListItemSecondaryAction>
//                         <Switch
//                           color="primary"
//                           checked={this.state.phoneInInvoice === 1}
//                           onChange={this.handlePersonalPhoneInInvoiceChange}
//                         />
//                       </ListItemSecondaryAction>
//                     </ListItem>

//                     <ListItem>
//                       <ListItemIcon>
//                         <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
//                       </ListItemIcon>
//                       <ListItemText primary="Toggle 24hr Time Format" />
//                       <ListItemSecondaryAction>
//                         <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
//                         <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
//                           <Switch
//                             color="primary"
//                             checked={this.state.timeFormat === 24}
//                             onChange={this.handleFormatChange}
//                           />
//                         </Tooltip>
//                         <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
//                       </ListItemSecondaryAction>
//                     </ListItem>
//                   </List>
//                 </div>
//               </CardBox>

//               <div className="col-md-6">
//                 <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
//                   <Grid item xs={12}>
//                     <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
//                       <div className="col-md-12 col-12">
//                         <TextField
//                           id="smsNumber"
//                           label="SMS Sender"
//                           value="0495149675"
//                           margin="normal"
//                           helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
//                           fullWidth
//                         />
//                       </div>
//                     </CardBoxNew>
//                   </Grid>
                  
//                   <Grid item xs={12}>
//                  <CardBoxNew heading={"Cancellation Policy"}>
//   <div className="col-md-12 col-12">
//     <List>
//       <ListItem>
//         <ListItemIcon>
//           <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
//         </ListItemIcon>
//         <ListItemText primary="Attach Cancellation Policy" />
//         <ListItemSecondaryAction>
//           <Switch
//             color="primary"
//             checked={enableCancellationPolicy === 1}
//             onChange={this.handleCancellationPolicyChange}
//           />
//         </ListItemSecondaryAction>
//       </ListItem>
//     </List>

//     {enableCancellationPolicy === 1 && (
//       <>
//         <Divider style={{ margin: '15px 0' }} />
        
//         {/* Dynamic Input Fields Section */}
//         <div style={{ 
//           marginBottom: '20px', 
//           padding: '15px', 
//           backgroundColor: '#f9f9f9', 
//           borderRadius: '8px',
//           border: '1px solid #e0e0e0'
//         }}>
//           <FormLabel component="legend" style={{ marginBottom: '15px', fontWeight: 600 }}>
//             Cancellation Policy Settings
//           </FormLabel>
          
//           <Grid container spacing={2}>
//             {/* Cancel Before - Dropdown */}
//             <Grid item xs={12} sm={6} md={6}>
//               <FormControl fullWidth variant="outlined" disabled={dynamicFieldsDisabled}>
//                 <InputLabel shrink>Cancel Before</InputLabel>
//                 <Select
//                   value={cancelBeforeUnit}
//                   onChange={this.handleCancelBeforeUnitChange}
//                   label="Cancel Before"
//                   notched={true}
//                 >
//                   <MenuItem value="hours">Hours</MenuItem>
//                   <MenuItem value="cutoff">Cutoff Time</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             {/* Conditional Input - Shows Hours or Cutoff Time */}
//             <Grid item xs={12} sm={6} md={6}>
//               {cancelBeforeUnit === "hours" ? (
//                 <TextField
//                   label="Hours"
//                   type="number"
//                   value={cancelBeforeValue}
//                   onChange={this.handleCancelBeforeValueChange}
//                   disabled={dynamicFieldsDisabled}
//                   fullWidth
//                   variant="outlined"
//                   InputLabelProps={{
//                     shrink: true,
//                   }}
//                   InputProps={{
//                     inputProps: { min: 1 }
//                   }}
//                 />
//               ) : (
//                 <TextField
//                   label="Cutoff Time (24-hour format)"
//                   value={cancelCutoffTime}
//                   onChange={this.handleCancelCutoffTimeChange}
//                   disabled={dynamicFieldsDisabled}
//                   fullWidth
//                   variant="outlined"
//                   placeholder="22:00:00"
//                   InputLabelProps={{
//                     shrink: true,
//                   }}
//                   error={cutoffTimeError}
//                   helperText="Format: HH:MM:SS (e.g., 22:00:00 for 10:00 PM)"
//                 />
//               )}
//             </Grid>
            
//             {/* Cancellation Fee Value */}
//             <Grid item xs={12} sm={6} md={6}>
//               <TextField
//                 label="Cancellation Fee Value"
//                 type="number"
//                 value={cancelFeeValue}
//                 onChange={this.handleCancelFeeValueChange}
//                 disabled={dynamicFieldsDisabled}
//                 fullWidth
//                 variant="outlined"
//                 InputLabelProps={{
//                   shrink: true,
//                 }}
//                 InputProps={{
//                   inputProps: { min: 1 }
//                 }}
//               />
//             </Grid>
            
//             {/* Fee Unit */}
//             <Grid item xs={12} sm={6} md={6}>
//               <FormControl fullWidth variant="outlined" disabled={dynamicFieldsDisabled}>
//                 <InputLabel shrink>Fee Unit</InputLabel>
//                 <Select
//                   value={cancelFeeUnit}
//                   onChange={this.handleCancelFeeUnitChange}
//                   label="Fee Unit"
//                   notched={true}
//                 >
//                   <MenuItem value="$">$ (Dollar)</MenuItem>
//                   <MenuItem value="%">% (Percent)</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//         </div>
        
//         <FormLabel component="legend" style={{ marginBottom: '10px', marginLeft: '15px' }}>
//           Select Policy
//         </FormLabel>
//         {policiesLoading ? (
//           <LinearProgress color="secondary" />
//         ) : (
//           <>
//             <FormControl component="fieldset" fullWidth>
//               <RadioGroup
//                 name="policies-radio-group"
//                 value={selectedPolicyId}
//                 onChange={this.handlePolicyChange}
//               >
//                 {policies.map((policy) => {
//                   let displayPolicy = policy.policy;
                  
//                   // Generate timeTemplate based on selection
//                   let timeTemplate = '';
//                   if (cancelBeforeUnit === 'hours') {
//                     const hourText = parseInt(cancelBeforeValue) === 1 ? 'hour' : 'hours';
//                     timeTemplate = `we kindly require ${cancelBeforeValue || '_____'} ${hourText} notice for any cancellations or reschedules.`;
//                   } else {
//                     // Format cutoff time for display (convert HH:MM:SS to 12-hour format)
//                     let formattedCutoffTime = cancelCutoffTime || '_____';
//                     if (cancelCutoffTime && cancelCutoffTime !== '_____') {
//                       const [hours, minutes] = cancelCutoffTime.split(':');
//                       let hour = parseInt(hours);
//                       const ampm = hour >= 12 ? 'PM' : 'AM';
//                       hour = hour % 12 || 12;
//                       formattedCutoffTime = `${hour}:${minutes} ${ampm}`;
//                     }
//                     timeTemplate = `notice of cancellation or reschedules must be received by ${formattedCutoffTime} the business day prior.`;
//                   }
//                   displayPolicy = displayPolicy.replace(/{{timeTemplate}}/g, timeTemplate);
                  
//                   // Generate feeTemplate based on selection
//                   let feeTemplate = '';
//                   if (cancelFeeUnit === '%') {
//                     feeTemplate = `${cancelFeeValue || '_____'}% of the service cost`;
//                   } else {
//                     feeTemplate = `$${cancelFeeValue || '_____'}`;
//                   }
//                   displayPolicy = displayPolicy.replace(/{{feeTemplate}}/g, feeTemplate);
                  
//                   return (
//                     <FormControlLabel
//                       key={policy.policyID}
//                       value={policy.policyID}
//                       control={<Radio color="primary" />}
//                       label={
//                         <div 
//                           dangerouslySetInnerHTML={{ __html: displayPolicy }}
//                           style={{ 
//                             fontSize: '0.9rem',
//                             lineHeight: '1.4',
//                             wordBreak: 'break-word'
//                           }}
//                         />
//                       }
//                       style={{
//                         marginBottom: '12px',
//                         alignItems: 'flex-start',
//                         width: '100%',
//                       }}
//                     />
//                   );
//                 })}
//               </RadioGroup>
//             </FormControl>
            
//             <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
//               {savingPolicy ? (
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   disabled={true}
//                   size="large"
//                 >
//                   Saving...
//                 </Button>
//               ) : (
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={this.handleSavePolicy}
//                   disabled={!selectedPolicyId || dynamicFieldsDisabled}
//                   size="large"
//                 >
//                   Save Policy Selection
//                 </Button>
//               )}
//             </div>
//           </>
//         )}
//       </>
//     )}
//   </div>
// </CardBoxNew>
//                   </Grid>
//                 </Grid>
//               </div>

//               <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
//                 <form className="row" noValidate autoComplete="off">
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incometemplate"
//                       name="incometemplate"
//                       label="Income Title Template"
//                       margin="normal"
//                       defaultValue={this.state.settingdetail.title}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       onChange={this.handleChange}
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <TextField
//                       id="incomedescription"
//                       name="incomedescription"
//                       label="Income Description"
//                       defaultValue={this.state.settingdetail.desc}
//                       margin="normal"
//                       onChange={this.handleChange}
//                       helperText="##date## and ##customername## will be replaced by actual date and customer name"
//                       fullWidth
//                     />
//                   </div>
//                   <div className="col-md-12 col-12">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       className="jr-btn btn-margin-topbottom"
//                       position="static"
//                       onClick={() => {
//                         this.handleSaveSettings();
//                       }}
//                     >
//                       Save
//                     </Button>
//                   </div>
//                 </form>
//               </CardBox>
              
//               <CardBox heading="Send Booking Reminder">
//                 {this.state.loadingConfirmation && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Do not send booking reminder" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value=""
//                             checked={this.state.selectedSetting === ""}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email and SMS for all customers" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="all"
//                             checked={this.state.selectedSetting === "all"}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send email only, do not send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="emailOnly"
//                             checked={this.state.selectedSetting === 'emailOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send SMS only, do not send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="smsOnly"
//                             checked={this.state.selectedSetting === 'smsOnly'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by email but if not found, send SMS" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedEmail"
//                             checked={this.state.selectedSetting === 'preferedEmail'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Send by SMS but if no mobile number, send email" />
//                         <ListItemSecondaryAction>
//                           <Radio
//                             color="primary"
//                             name="calendarSetting"
//                             value="preferedSMS"
//                             checked={this.state.selectedSetting === 'preferedSMS'}
//                             onChange={this.handleBookingConfirmationChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
//                         <ListItemSecondaryAction>
//                           <FormControl variant="outlined" style={{ width: "100px" }}>
//                             <Select
//                               placeholder="Select Confirmation Before"
//                               name="confirmationHour"
//                               value={this.state.confirmationHour}
//                               style={{
//                                 textAlign: 'center',
//                                 paddingLeft: '0',
//                               }}
//                               inputProps={{
//                                 style: {
//                                   textAlign: 'center',
//                                 },
//                               }}
//                               onChange={(e) => this.handleChangeConfirmationHour(e)}
//                             >
//                               <MenuItem value="">
//                                 <em>Select Confirmation Before</em>
//                               </MenuItem>
//                               <MenuItem value={24}>{"24 hrs"}</MenuItem>
//                               <MenuItem value={48}>{"48 hrs"}</MenuItem>
//                               <MenuItem value={72}>{"72 hrs"}</MenuItem>
//                             </Select>
//                           </FormControl>
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       {this.state.loadingConfirmation ? (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                           disabled={true}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       ) : (
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           style={{ float: "right", marginTop: "20px" }}
//                           onClick={this.handleSubmitConfirmation}
//                         >
//                           Update Booking Reminder
//                         </Button>
//                       )}
//                     </List>
//                   </div>
//                 </div>
//               </CardBox>

//               <CardBox heading="Calendar Settings">
//                 {this.state.loading && (
//                   <div style={{ position: "relative", top: "15px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <List className="LawaList">
//                       <ListItem>
//                         <ListItemText primary="Show Booking Total" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="bookingTotal"
//                             checked={bookingTotal}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerName"
//                             checked={customerName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Show Customer Address" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="customerAddress"
//                             checked={customerAddress}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petName"
//                             checked={petName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Pet Breed" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="petBreed"
//                             checked={petBreed}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <ListItem>
//                         <ListItemText primary="Show Services Name" />
//                         <ListItemSecondaryAction>
//                           <Switch
//                             color="primary"
//                             name="serviceName"
//                             checked={serviceName}
//                             onChange={this.handleCalendarChange}
//                           />
//                         </ListItemSecondaryAction>
//                       </ListItem>

//                       <div>
//                         <h5>Preview</h5>
//                       </div>
//                       {(bookingTotal ||
//                         customerName ||
//                         customerAddress ||
//                         petName || petBreed ||
//                         serviceName) && (
//                           <Card
//                             style={{
//                               padding: "20px",
//                               backgroundColor: "#3f51b5",
//                               color: "#fff",
//                               width: "400px",
//                             }}
//                           > 
//                             {bookingTotal && <div>$Total Cost</div>}
//                             {customerName && <div>Firstname Lastname</div>}
//                             {customerAddress && <div>Street Address, Suburb, Postcode</div>}
//                             {petName && <div>Pet Name</div>}
//                             {petBreed && <div>Pet Breed</div>}
//                             {serviceName && <div>Services</div>}
//                           </Card>
//                         )}
//                     </List>
//                     {this.state.loading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={true}
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "10px" }}
//                         onClick={this.handleSubmitCalendar}
//                         disabled={
//                           !(bookingTotal ||
//                             customerName ||
//                             customerAddress ||
//                             petName || petBreed ||
//                             serviceName)
//                         }
//                       >
//                         Update Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>

//               {/* App Calendar Settings Section with Mobile Support */}
//               <CardBox heading="App Calendar Settings">
//                 {appCalendarLoading && (
//                   <div style={{ position: "relative", top: "15px", marginBottom: "20px" }}>
//                     <LinearProgress color="secondary" />
//                   </div>
//                 )}
//                 <div className="row">
//                   <div className="col-md-12 col-12">
//                     <p style={{ 
//                       marginBottom: '15px', 
//                       color: '#666', 
//                       fontSize: '0.9rem',
//                       padding: '10px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}>
//                       {this.state.isTouchDevice ? (
//                         <span>Long press and drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       ) : (
//                         <span>Drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
//                       )}
//                     </p>

//                     <List className="LawaList">
//                       {appCalendarItems.map((item, index) => (
//                         <ListItem
//                           key={item.id}
//                           className="app-calendar-item"
//                           draggable={!this.state.isTouchDevice}
//                           onDragStart={(e) => this.handleDragStart(e, index)}
//                           onDragOver={(e) => this.handleDragOver(e, index)}
//                           onDrop={(e) => this.handleDrop(e, index)}
//                           onDragEnd={this.handleDragEnd}
//                           onTouchStart={(e) => this.handleTouchStart(e, index)}
//                           onTouchMove={this.handleTouchMove}
//                           onTouchEnd={this.handleTouchEnd}
//                           onTouchCancel={this.handleTouchCancel}
//                           style={{
//                             cursor: this.state.isTouchDevice ? 'default' : 'grab',
//                             border: '1px solid transparent',
//                             transition: 'all 0.2s',
//                             backgroundColor: this.state.draggedItem === index ? '#f5f5f5' : 'transparent',
//                             WebkitTapHighlightColor: 'transparent',
//                           }}
//                         >
//                           <ListItemIcon 
//                             className="drag-handle"
//                             style={{ 
//                               cursor: this.state.isTouchDevice ? 'pointer' : 'grab', 
//                               minWidth: '40px',
//                               padding: this.state.isTouchDevice ? '10px 5px' : '0',
//                             }}
//                           >
//                             <i className="zmdi zmdi-menu" style={{ fontSize: '20px', color: '#999' }}></i>
//                           </ListItemIcon>
//                           <ListItemText primary={item.label} />
//                           <ListItemSecondaryAction>
//                             <Switch
//                               color="primary"
//                               checked={item.enabled}
//                               onChange={() => this.handleAppCalendarToggle(item.id)}
//                             />
//                           </ListItemSecondaryAction>
//                         </ListItem>
//                       ))}
//                     </List>

//                     {/* Preview Section */}
//                     <div style={{ marginTop: '20px' }}>
//                       <h5>Preview</h5>
//                       {appCalendarItems.some(item => item.enabled) ? (
//                         <Card
//                           style={{
//                             padding: "20px",
//                             backgroundColor: "#3f51b5",
//                             color: "#fff",
//                             width: "100%",
//                             maxWidth: "400px",
//                           }}
//                         >
//                           {appCalendarItems
//                             .filter(item => item.enabled)
//                             .map(item => {
//                               switch(item.apiKey) {
//                                 case 'time':
//                                   return <div key={item.id}>10:30 AM</div>;
//                                 case 'cost':
//                                   return <div key={item.id}>Service Cost</div>;
//                                 case 'name':
//                                   return <div key={item.id}>Customer Name</div>;
//                                 case 'address':
//                                   return <div key={item.id}>123 Main St, Sydney 2000</div>;
//                                 case 'petName':
//                                   return <div key={item.id}>Pet Name</div>;
//                                 case 'petBreed':
//                                   return <div key={item.id}>Pet Breed</div>;
//                                 case 'serviceName':
//                                   return <div key={item.id}>Full Grooming</div>;
//                                 default:
//                                   return null;
//                               }
//                             })}
//                         </Card>
//                       ) : (
//                         <p style={{ color: '#999', fontStyle: 'italic' }}>Toggle on items to see preview</p>
//                       )}
//                     </div>

//                     {appCalendarLoading ? (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         disabled={true}
//                       >
//                         Updating...
//                       </Button>
//                     ) : (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         style={{ float: "right", marginTop: "20px" }}
//                         onClick={this.handleAppCalendarSubmit}
//                       >
//                         Update App Calendar Settings
//                       </Button>
//                     )}
//                   </div>
//                 </div>
//               </CardBox>
//             </div>
//           </div>
//           <NotificationContainer />
//         </>
//       );
//     }
//   }
// }

// export default Settings;



import React from "react";
import ContainerHeader from "components/ContainerHeader/index";
import CardBox from "components/CardBox/index";
import CardBoxNew from "components/CardBoxNew/index";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "../../../../src/assets/vendors/react-notification/react-notifications.css"
import { httpClient } from "appUtility/Api";
import IntlMessages from "util/IntlMessages";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Switch from "@material-ui/core/Switch";
import LinearProgress from "@material-ui/core/LinearProgress";
import featureServer from "../../../appUtility/featureServer";
import { FormControl, Grid, MenuItem, Radio, Select, Tooltip, RadioGroup, FormControlLabel, Divider, FormLabel, InputAdornment, InputLabel } from "@material-ui/core";
import configureStore from "../../../store";

const loginOBJ = localStorage.getItem("login");
const logindetail = JSON.parse(loginOBJ);
var modifiedData = logindetail && logindetail.syncLastModified;
const qs = require("qs");

var param, settingdetail;

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.isProcessingToggle = false;
    this.state = {
        
      error: null,
      isLoaded: false,
      id: "",
      incometemplate: "",
      incomedescription: "",
      appID: logindetail && logindetail.aid,
      memberID: logindetail && logindetail.uid,
      companyID: logindetail && logindetail.cid,
      mcode: logindetail && logindetail.mCode,
      settingdetail: "",
      checked: [],
      customerName: false,
      bookingTotal: false,
      customerAddress: false,
      petName: false,
      petBreed: false,
      serviceName: false,
      syncModified: "",
      loading: false,
      display_booking_end_time: logindetail && logindetail.display_booking_end_time,
      timeFormat: logindetail && logindetail.timeFormat,
      addressInInvoice: logindetail && logindetail.addressInInvoice,
      phoneInInvoice: logindetail && logindetail.phoneInInvoice,
      enableCancellationPolicy: (logindetail && logindetail.enableCancellationPolicy && logindetail.enableCancellationPolicy !== 0) ? 1 : 0,
      selectedSetting: "",
      confirmationHour: 24,
      loadingConfirmation: false,
      
      // New state for policies
      policies: [],
      policiesLoading: false,
      selectedPolicyId: "",
      savingPolicy: false,
      
      // Dynamic policy fields
      cancelBeforeValue: "",
      cancelBeforeUnit: "hours", // 'hours' or 'cutoff'
      cancelFeeValue: "",
      cancelFeeUnit: "$", // '$' or '%'
      cancelCutoffTime: "",
      dynamicFieldsDisabled: true,
      cutoffTimeError: false,
      
      // App Calendar Settings with all possible items (time instead of date)
      appCalendarItems: [
        { id: 'appTime', label: 'Show Time', icon: 'zmdi-time', enabled: false, apiKey: 'time' },
        { id: 'appBookingTotal', label: 'Show Booking Total', icon: 'zmdi-money', enabled: false, apiKey: 'cost' },
        { id: 'appCustomerName', label: 'Show Customer Name', icon: 'zmdi-account', enabled: false, apiKey: 'name' },
        { id: 'appCustomerAddress', label: 'Show Customer Address', icon: 'zmdi-pin', enabled: false, apiKey: 'address' },
        { id: 'appPetName', label: 'Show Pet Name', icon: 'zmdi-face', enabled: false, apiKey: 'petName' },
        { id: 'appPetBreed', label: 'Show Pet Breed', icon: 'zmdi-label', enabled: false, apiKey: 'petBreed' },
        { id: 'appServiceName', label: 'Show Services Name', icon: 'zmdi-cut', enabled: false, apiKey: 'serviceName' },
      ],
      appCalendarLoading: false,
      draggedItem: null,
      appCalendarInitialized: false,
      
      // Mobile touch states
      isTouchDevice: false,
      touchStartY: 0,
      touchDraggedItem: null,
      touchDraggedIndex: -1,
      touchStartTime: 0,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleAppCalendarToggle = this.handleAppCalendarToggle.bind(this);
    this.handleAppCalendarSubmit = this.handleAppCalendarSubmit.bind(this);
    this.removeBlurEffect = this.removeBlurEffect.bind(this);
    
    // Desktop drag handlers
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    
    // Mobile touch handlers
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.handleTouchCancel = this.handleTouchCancel.bind(this);
    
    // Policy handlers
    this.fetchPolicies = this.fetchPolicies.bind(this);
    this.handlePolicyChange = this.handlePolicyChange.bind(this);
    this.handleSavePolicy = this.handleSavePolicy.bind(this);
    
    // Dynamic policy field handlers
    this.handleCancelBeforeValueChange = this.handleCancelBeforeValueChange.bind(this);
    this.handleCancelBeforeUnitChange = this.handleCancelBeforeUnitChange.bind(this);
    this.handleCancelFeeValueChange = this.handleCancelFeeValueChange.bind(this);
    this.handleCancelFeeUnitChange = this.handleCancelFeeUnitChange.bind(this);
    this.handleCancelCutoffTimeChange = this.handleCancelCutoffTimeChange.bind(this);
  }

  componentDidMount() {
    // Detect touch device
    this.setState({
      isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0
    });

    // Prevent default touch behaviors on draggable items
    document.addEventListener('touchmove', this.preventTouchScroll, { passive: false });
    
    var aid, cid, uid;
    aid = logindetail && logindetail.aid;
    cid = logindetail && logindetail.cid;
    uid = logindetail && logindetail && logindetail.uid;

    param = aid + "_" + cid + "_" + uid;

    // Fetch member settings
    httpClient
      .post(
        "getMemberSettings.php",
        qs.stringify({
          action: "member_settings",
          source: param,
        })
      )
      .then(
        ({ data }) => {
          if (data) {
            localStorage.setItem("settings", JSON.stringify(data));
            this.setState(
              {
                isLoaded: false,
                id: data.id,
                settingdetail: data,
                checked: data.flags,
                petName: data.pet_name == "1" ? true : false,
                petBreed: data.pet_breed == "1" ? true : false,
                serviceName: data.services_name == "1" ? true : false,
                customerName: data.customer_name == "1" ? true : false,
                bookingTotal: data.bookingCost == "1" ? true : false,
                customerAddress: data.customer_address == "1" ? true : false,
                confirmationHour: parseInt(data.confirmationHour),
                selectedSetting: data.confirmationBy,
              },
              function () {
                this.setState({
                  isLoaded: true,
                });
              }
            );
          } else {
          }
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );

    const loginValue = JSON.parse(localStorage.getItem("login"));
    this.setState({
      ...this.state,
      display_booking_end_time: loginValue.display_booking_end_time,
      timeFormat: loginValue.timeFormat,
      addressInInvoice: loginValue.addressInInvoice,
      phoneInInvoice: loginValue.phoneInInvoice,
      enableCancellationPolicy: (loginValue.enableCancellationPolicy && loginValue.enableCancellationPolicy !== 0) ? 1 : 0
    });

    // Fetch policies
    this.fetchPolicies();

    // Fetch App Calendar Settings (no notification on page load)
    this.fetchAppCalendarSettings(false);

    // Add inline styles for mobile
    this.addInlineStyles();
  }

  componentWillUnmount() {
    document.removeEventListener('touchmove', this.preventTouchScroll);
  }

  // Helper function to remove blur effect
  removeBlurEffect = () => {
    let loginBlur = JSON.parse(localStorage.getItem("login"));
    
    if (loginBlur && loginBlur.ismobiledevice != 1) {
      document.getElementById("nav__menu__display") !== null &&
        (document.getElementById("nav__menu__display").style.cssText =
          "filter: blur(0px); pointer-events: block");
    }
    document.getElementById("appbar_mainapp__") !== null &&
      (document.getElementById("appbar_mainapp__").style.cssText =
        "filter: blur(0px); pointer-events: block");
  }

  addInlineStyles = () => {
    // Add styles to head if not already present
    if (!document.getElementById('settings-inline-styles')) {
      const style = document.createElement('style');
      style.id = 'settings-inline-styles';
      style.innerHTML = `
        .app-calendar-item {
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          user-select: none;
					touch-action: pan-x pan-y pinch-zoom;
          transition: all 0.2s ease;
        }
        .app-calendar-item.dragging {
          opacity: 0.7 !important;
          transform: scale(1.02) !important;
          box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
          z-index: 9999 !important;
          background-color: #f5f5f5 !important;
        }
        .app-calendar-item.drag-over {
          border: 2px dashed #3f51b5 !important;
          background-color: #e8eaf6 !important;
          opacity: 0.8;
          transform: scale(1.01);
        }
        .app-calendar-item:active {
          background-color: #f0f0f0;
        }
        @media (max-width: 768px) {
          .app-calendar-item {
            cursor: default !important;
          }
          .app-calendar-item .drag-handle {
            padding: 10px 5px;
          }
        }
      `;
      document.head.appendChild(style);
    }
  };

  preventTouchScroll = (e) => {
    if (this.state.touchDraggedItem !== null) {
      e.preventDefault();
    }
  };

  // Desktop Drag Handlers
  handleDragStart = (event, index) => {
    if (this.state.isTouchDevice) return;
    
    event.dataTransfer.setData('text/plain', index.toString());
    event.dataTransfer.effectAllowed = 'move';
    this.setState({ draggedItem: index });
    event.currentTarget.style.opacity = '0.5';
    event.currentTarget.style.backgroundColor = '#f0f0f0';
  };

  handleDragOver = (event, index) => {
    if (this.state.isTouchDevice) return;
    
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    
    const items = document.querySelectorAll('.app-calendar-item');
    items.forEach(item => item.classList.remove('drag-over'));
    if (event.currentTarget) {
      event.currentTarget.classList.add('drag-over');
    }
  };

  handleDrop = (event, targetIndex) => {
    if (this.state.isTouchDevice) return;
    
    event.preventDefault();
    
    const items = document.querySelectorAll('.app-calendar-item');
    items.forEach(item => {
      item.style.opacity = '1';
      item.style.backgroundColor = '';
      item.classList.remove('drag-over');
    });
    
    const sourceIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
    if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;
    
    const newItems = [...this.state.appCalendarItems];
    const [movedItem] = newItems.splice(sourceIndex, 1);
    newItems.splice(targetIndex, 0, movedItem);
    
    this.setState({ 
      appCalendarItems: newItems,
      draggedItem: null 
    });
  };

  handleDragEnd = (event) => {
    if (this.state.isTouchDevice) return;
    
    event.currentTarget.style.opacity = '1';
    event.currentTarget.style.backgroundColor = '';
    
    const items = document.querySelectorAll('.app-calendar-item');
    items.forEach(item => {
      item.style.opacity = '1';
      item.style.backgroundColor = '';
      item.classList.remove('drag-over');
    });
    
    this.setState({ draggedItem: null });
  };

  // Mobile Touch Handlers
  handleTouchStart = (e, index) => {
    e.preventDefault();
    
    const touch = e.touches[0];
    const target = e.currentTarget;
    
    this.touchStartTimeout = setTimeout(() => {
      this.setState({
        touchStartY: touch.clientY,
        touchStartX: touch.clientX,
        touchDraggedItem: index,
        touchDraggedIndex: index,
        draggedItem: index
      });

      target.classList.add('dragging');
      
      if (window.navigator.vibrate) {
        window.navigator.vibrate(50);
      }
    }, 300);
    
    this.setState({ touchStartTime: Date.now() });
  };

  handleTouchMove = (e) => {
    e.preventDefault();
    
    const { touchDraggedItem, touchStartY } = this.state;
    if (touchDraggedItem === null) {
      clearTimeout(this.touchStartTimeout);
      return;
    }

    const touch = e.touches[0];
    const currentY = touch.clientY;
    const deltaY = currentY - touchStartY;

    const items = document.querySelectorAll('.app-calendar-item');
    let targetIndex = touchDraggedItem;
    
    items.forEach((item, idx) => {
      const rect = item.getBoundingClientRect();
      if (currentY >= rect.top && currentY <= rect.bottom) {
        targetIndex = idx;
      }
    });

    items.forEach(item => item.classList.remove('drag-over'));
    if (items[targetIndex] && targetIndex !== touchDraggedItem) {
      items[targetIndex].classList.add('drag-over');
      
      const container = document.querySelector('.LawaList');
      if (container) {
        const containerRect = container.getBoundingClientRect();
        const scrollSpeed = 10;
        
        if (currentY < containerRect.top + 50) {
          container.scrollTop -= scrollSpeed;
        } else if (currentY > containerRect.bottom - 50) {
          container.scrollTop += scrollSpeed;
        }
      }
    }

    const draggedItem = items[touchDraggedItem];
    if (draggedItem && Math.abs(deltaY) > 10) {
      draggedItem.style.transform = `translateY(${deltaY}px) scale(1.02)`;
    }

    this.setState({ touchDraggedIndex: targetIndex });
  };

  handleTouchEnd = (e) => {
    e.preventDefault();
    clearTimeout(this.touchStartTimeout);
    
    const { touchDraggedItem, touchDraggedIndex } = this.state;
    
    if (touchDraggedItem !== null && touchDraggedIndex !== -1) {
      if (touchDraggedIndex !== touchDraggedItem) {
        const newItems = [...this.state.appCalendarItems];
        const [movedItem] = newItems.splice(touchDraggedItem, 1);
        newItems.splice(touchDraggedIndex, 0, movedItem);
        
        this.setState({ appCalendarItems: newItems });
      }
    }

    const items = document.querySelectorAll('.app-calendar-item');
    items.forEach(item => {
      item.style.opacity = '1';
      item.style.transform = '';
      item.style.backgroundColor = '';
      item.classList.remove('dragging', 'drag-over');
    });

    this.setState({ 
      draggedItem: null,
      touchDraggedItem: null,
      touchDraggedIndex: -1,
      touchStartY: 0
    });
  };

  handleTouchCancel = (e) => {
    this.handleTouchEnd(e);
  };

  // Toggle handler for App Calendar items
  handleAppCalendarToggle = (itemId) => {
    const updatedItems = this.state.appCalendarItems.map(item => {
      if (item.id === itemId) {
        return { ...item, enabled: !item.enabled };
      }
      return item;
    });

    this.setState({ appCalendarItems: updatedItems });
  };

  // Submit handler for App Calendar settings - SAVE API
  handleAppCalendarSubmit = (e) => {
    e.preventDefault();

    const enabledItems = this.state.appCalendarItems
      .filter(item => item.enabled)
      .map(item => item.apiKey);

    let loginBlur = JSON.parse(localStorage.getItem("login"));
    if (loginBlur && loginBlur.ismobiledevice != 1) {
      document.getElementById("nav__menu__display") !== null &&
        (document.getElementById("nav__menu__display").style.cssText =
          "filter: blur(2px); pointer-events: none");
    }
    document.getElementById("appbar_mainapp__") !== null &&
      (document.getElementById("appbar_mainapp__").style.cssText =
        "filter: blur(2px); pointer-events: none");

    this.setState({ appCalendarLoading: true });

    let parameters = {
      appID: this.state.appID,
      memberID: this.state.memberID,
      companyID: this.state.companyID,
    };

    const apiToken = logindetail.memtoken ;

    const sourceData = {
      appID: parameters.appID,
      memberID: parameters.memberID,
      companyID: parameters.companyID,
    };

    const settingsObj = {};
    for (let i = 0; i < enabledItems.length; i++) {
      settingsObj[i] = enabledItems[i];
    }
    sourceData.settings = settingsObj;

    httpClient
      .post(
        "/v2/mobileCalendarSettings.php",
        qs.stringify({
          action: "saveSettings",
          api_token: apiToken,
          source: sourceData,
        })
      )
      .then(({ data }) => {
        if (data.success) {
          NotificationManager.success(data.message || "App Calendar Settings Updated Successfully");
          
          this.fetchAppCalendarSettings(false);
          
          this.removeBlurEffect();
        } else {
          NotificationManager.info(data.message || "Failed to update settings");
          this.setState({ appCalendarLoading: false });
          
          this.removeBlurEffect();
        }
      })
      .catch(error => {
        console.error("Error saving app calendar settings:", error);
        NotificationManager.info("Error updating app calendar settings");
        
        this.removeBlurEffect();
        
        this.setState({ appCalendarLoading: false });
      });
  };

  handleEndDate = (e) => {
    const { checked } = e.target;
    this.setState({
      ...this.setState,
      display_booking_end_time: checked ? "1" : "0"
    })

    var dateVals = {
      appID: logindetail && logindetail.aid,
      companyID: logindetail && logindetail.cid,
      memberID: logindetail && logindetail.uid,
      display_booking_end_time: checked ? "1" : "0"
    }
    httpClient
      .post(
        "updateUserSettings.php",
        qs.stringify({
          action: "update_display_end_time",
          source: dateVals,
        })
      ).then(({ data }) => {
        if (data.success == "true") {
          var loginData = JSON.parse(localStorage.getItem("login"));

          loginData.display_booking_end_time = this.state.display_booking_end_time;

          this.setState({
            ...this.setState,
            display_booking_end_time: loginData.display_booking_end_time
          })
          localStorage.setItem("login", JSON.stringify(loginData));
          NotificationManager.info(data.msg);
        }
      })
  }

  handleFormatChange = (e) => {
    const { checked } = e.target;
    this.setState({
      ...this.setState,
      timeFormat: checked ? 24 : 12
    })

    var dateVals = {
      appID: logindetail && logindetail.aid,
      companyID: logindetail && logindetail.cid,
      memberID: logindetail && logindetail.uid,
      timeFormat: checked ? 24 : 12
    }
    httpClient
      .post(
        "updateUserSettings.php",
        qs.stringify({
          action: "timeFormat",
          source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'timeFormat',
          timeFormat: dateVals.timeFormat
        })
      ).then(({ data }) => {
        if (data.success == "true") {
          var loginData = JSON.parse(localStorage.getItem("login"));

          loginData.timeFormat = this.state.timeFormat;
          this.setState({
            ...this.state,
            timeFormat: loginData.timeFormat
          })
          localStorage.setItem("login", JSON.stringify(loginData));
          NotificationManager.info(data.msg);
        }
      })
  }

  handleAddressInInvoiceChange = (e) => {
    const { checked } = e.target;
    this.setState({
      ...this.state,
      addressInInvoice: checked ? 1 : 0
    })

    var dateVals = {
      appID: logindetail && logindetail.aid,
      companyID: logindetail && logindetail.cid,
      memberID: logindetail && logindetail.uid,
      addressInInvoice: checked ? 1 : 0
    }
    httpClient
      .post(
        "updateUserSettings.php",
        qs.stringify({
          action: "addressInInvoice",
          source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'addressInInvoice',
          addressInInvoice: dateVals.addressInInvoice
        })
      ).then(({ data }) => {
        if (data.success == "true") {
          var loginData = JSON.parse(localStorage.getItem("login"));

          loginData.addressInInvoice = this.state.addressInInvoice;
          this.setState({
            ...this.state,
            addressInInvoice: loginData.addressInInvoice
          })
          localStorage.setItem("login", JSON.stringify(loginData));
          NotificationManager.info(data.msg);
        }
      })
  }

  handlePersonalPhoneInInvoiceChange = (e) => {
    const { checked } = e.target;
    this.setState({
      ...this.state,
      phoneInInvoice: checked ? 1 : 0
    })

    var dateVals = {
      appID: logindetail && logindetail.aid,
      companyID: logindetail && logindetail.cid,
      memberID: logindetail && logindetail.uid,
      phoneInInvoice: checked ? 1 : 0
    }
    httpClient
      .post(
        "updateUserSettings.php",
        qs.stringify({
          action: "phoneInInvoice",
          source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'phoneInInvoice',
          phoneInInvoice: dateVals.phoneInInvoice
        })
      ).then(({ data }) => {
        if (data.success == "true") {
          var loginData = JSON.parse(localStorage.getItem("login"));

          loginData.phoneInInvoice = this.state.phoneInInvoice;
          this.setState({
            ...this.state,
            phoneInInvoice: loginData.phoneInInvoice
          })
          localStorage.setItem("login", JSON.stringify(loginData));
          NotificationManager.info(data.msg);
        }
      })
  }

  // Fetch policies from API
//   fetchPolicies = () => {
//     this.setState({ policiesLoading: true });

//     const apiToken = logindetail.memtoken || "";
//     const formData = new FormData();
//     formData.append('action', 'getPolicies');
//     formData.append('api_token', apiToken);
//     formData.append('source[appID]', this.state.appID);
//     formData.append('source[memberID]', this.state.memberID);
//     formData.append('source[companyID]', this.state.companyID);

//     httpClient
//       .post("/v2/getPolicies.php", formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       })
//       .then((response) => {
//         if (response.data.success && response.data.data) {
//           const policies = response.data.data;
//           const selectedPolicy = policies.find(policy => policy.is_selected === 1);
//           const settings = response.data.settings || {};
          
//           this.setState({ 
//             policies: policies,
//             policiesLoading: false,
//             selectedPolicyId: selectedPolicy ? selectedPolicy.policyID : "",
//             cancelBeforeValue: settings.cancelBeforeValue || "",
//             cancelBeforeUnit: settings.cancelBeforeUnit || "hours",
//             cancelFeeValue: settings.cancelFeeValue || "",
//             cancelFeeUnit: settings.cancelFeeUnit || "$",
//             cancelCutoffTime: settings.cancelCutoffTime || "",
//             dynamicFieldsDisabled: !selectedPolicy,
//             cutoffTimeError: false,
//           });

//           if (selectedPolicy) {
//             var loginData = JSON.parse(localStorage.getItem("login"));
//             loginData.enableCancellationPolicy = selectedPolicy.policyID;
//             localStorage.setItem("login", JSON.stringify(loginData));
//           }
//         } else {
//           this.setState({ policiesLoading: false });
//           NotificationManager.info("Failed to load policies");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching policies:", error);
//         this.setState({ policiesLoading: false });
//         NotificationManager.info("Error loading policies");
//       });
//   };
  // Fetch policies from API
fetchPolicies = () => {
  this.setState({ policiesLoading: true });

  const apiToken = logindetail.memtoken || "";
  const formData = new FormData();
  formData.append('action', 'getPolicies');
  formData.append('api_token', apiToken);
  formData.append('source[appID]', this.state.appID);
  formData.append('source[memberID]', this.state.memberID);
  formData.append('source[companyID]', this.state.companyID);

  httpClient
    .post("/v2/getPolicies.php", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.data.success && response.data.data) {
        const policies = response.data.data;
        const selectedPolicy = policies.find(policy => policy.is_selected === 1);
        const settings = response.data.settings || {};
        
        // Auto-select policy if there's only one policy and no policy is currently selected
        let autoSelectedPolicyId = selectedPolicy ? selectedPolicy.policyID : "";
        
        if (!selectedPolicy && policies.length === 1) {
          autoSelectedPolicyId = policies[0].policyID;
          // Set dynamic fields to not disabled since we auto-selected
          this.setState({ dynamicFieldsDisabled: false });
        } else if (selectedPolicy) {
          this.setState({ dynamicFieldsDisabled: false });
        }
        
        this.setState({ 
          policies: policies,
          policiesLoading: false,
          selectedPolicyId: autoSelectedPolicyId,
          cancelBeforeValue: settings.cancelBeforeValue || "",
          cancelBeforeUnit: settings.cancelBeforeUnit || "hours",
          cancelFeeValue: settings.cancelFeeValue || "",
          cancelFeeUnit: settings.cancelFeeUnit || "$",
          cancelCutoffTime: settings.cancelCutoffTime || "",
          dynamicFieldsDisabled: !selectedPolicy && policies.length !== 1,
          cutoffTimeError: false,
        });

        // Update localStorage with selected policy
        if (autoSelectedPolicyId) {
          var loginData = JSON.parse(localStorage.getItem("login"));
          loginData.enableCancellationPolicy = autoSelectedPolicyId;
          localStorage.setItem("login", JSON.stringify(loginData));
        }
      } else {
        this.setState({ policiesLoading: false });
        NotificationManager.info("Failed to load policies");
      }
    })
    .catch((error) => {
      console.error("Error fetching policies:", error);
      this.setState({ policiesLoading: false });
      NotificationManager.info("Error loading policies");
    });
};
  // Handle policy radio change
  handlePolicyChange = (event) => {
    const selectedPolicyId = event.target.value;
    this.setState({ 
      selectedPolicyId: selectedPolicyId,
      dynamicFieldsDisabled: false
    });
  };

  // Dynamic policy field handlers with validation
  handleCancelBeforeValueChange = (e) => {
    let value = e.target.value;
    // Allow only numbers, no special characters, plus, minus, multiply, divide
    value = value.replace(/[^0-9]/g, '');
    this.setState({ cancelBeforeValue: value });
  };

  handleCancelBeforeUnitChange = (e) => {
    const newValue = e.target.value;
    this.setState({ cancelBeforeUnit: newValue });
  };

  handleCancelFeeValueChange = (e) => {
    let value = e.target.value;
    // Allow only numbers and decimal point, no special characters
    value = value.replace(/[^0-9.]/g, '');
    // Prevent multiple decimal points
    const decimalCount = (value.match(/\./g) || []).length;
    if (decimalCount > 1) {
      value = value.substring(0, value.lastIndexOf('.'));
    }
    this.setState({ cancelFeeValue: value });
  };

  handleCancelFeeUnitChange = (e) => {
    this.setState({ cancelFeeUnit: e.target.value });
  };

  handleCancelCutoffTimeChange = (e) => {
    let value = e.target.value;
    // Allow only numbers and colon
    value = value.replace(/[^0-9:]/g, '');
    
    // Auto-format as user types
    if (value.length === 2 && !value.includes(':')) {
      value = value + ':';
    } else if (value.length === 5 && value.indexOf(':') === 2 && !value.includes(':', 3)) {
      value = value + ':';
    }
    
    this.setState({ cancelCutoffTime: value });
    
    const timePattern = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
    this.setState({ cutoffTimeError: value !== "" && !timePattern.test(value) && value.length >= 8 });
  };

  // Validate dynamic fields
  validateDynamicFields = () => {
    const { cancelBeforeUnit, cancelBeforeValue, cancelFeeValue, cancelCutoffTime } = this.state;
    const timePattern = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
    
    if (cancelBeforeUnit === 'hours') {
      if (!cancelBeforeValue || cancelBeforeValue <= 0) {
        NotificationManager.info("Please enter valid Hours value");
        return false;
      }
    } else if (cancelBeforeUnit === 'cutoff') {
      if (!cancelCutoffTime || !timePattern.test(cancelCutoffTime)) {
        NotificationManager.info("Please enter valid Cutoff Time in HH:MM:SS format (e.g., 22:00:00)");
        return false;
      }
    }
    
    if (!cancelFeeValue || cancelFeeValue <= 0) {
      NotificationManager.info("Please enter valid Cancellation Fee Value");
      return false;
    }
    
    if (isNaN(cancelFeeValue) || parseFloat(cancelFeeValue) <= 0) {
      NotificationManager.info("Please enter a valid numeric fee value");
      return false;
    }
    
    return true;
  };

  // Save selected policy
  handleSavePolicy = () => {
    if (!this.state.selectedPolicyId) {
      NotificationManager.info("Please select a policy");
      return;
    }
    
    if (!this.validateDynamicFields()) {
      return;
    }

    this.setState({ savingPolicy: true });

    var dateVals = {
      appID: logindetail && logindetail.aid,
      companyID: logindetail && logindetail.cid,
      memberID: logindetail && logindetail.uid,
      enableCancellationPolicy: this.state.selectedPolicyId,
      cancelBeforeValue: this.state.cancelBeforeValue,
      cancelBeforeUnit: this.state.cancelBeforeUnit,
      cancelFeeValue: this.state.cancelFeeValue,
      cancelFeeUnit: this.state.cancelFeeUnit,
      cancelCutoffTime: this.state.cancelCutoffTime
    };

    httpClient
      .post(
        "updateUserSettings.php",
        qs.stringify({
          action: "enableCancellationPolicy",
          source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
          enableCancellationPolicy: dateVals.enableCancellationPolicy,
          cancelBeforeValue: dateVals.cancelBeforeValue,
          cancelBeforeUnit: dateVals.cancelBeforeUnit,
          cancelFeeValue: dateVals.cancelFeeValue,
          cancelFeeUnit: dateVals.cancelFeeUnit,
          cancelCutoffTime: dateVals.cancelCutoffTime
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          var loginData = JSON.parse(localStorage.getItem("login"));

          loginData.enableCancellationPolicy = this.state.selectedPolicyId;
          
          this.setState({
            enableCancellationPolicy: this.state.selectedPolicyId,
            savingPolicy: false
          });
          
          localStorage.setItem("login", JSON.stringify(loginData));
          NotificationManager.success("Policy saved successfully");
          
          this.fetchPolicies();
        } else {
          this.setState({ savingPolicy: false });
          NotificationManager.info(data.msg || "Failed to save policy");
        }
      })
      .catch((error) => {
        console.error("Error saving policy:", error);
        this.setState({ savingPolicy: false });
        NotificationManager.info("Error saving policy");
      });
  };

  fetchAppCalendarSettings = (showNotification = false) => {
    this.setState({ appCalendarLoading: true });

    let parameters = {
      appID: this.state.appID,
      memberID: this.state.memberID,
      companyID: this.state.companyID,
    };

    const loginData = JSON.parse(localStorage.getItem("login"));
    const apiToken = loginData.memtoken ;

    httpClient
      .post(
        "/v2/mobileCalendarSettings.php",
        qs.stringify({
          action: "getSettings",
          api_token: apiToken,
          source: parameters,
        })
      )
      .then(({ data }) => {
        if (data.success) {
          const enabledSettings = data.data || [];
          
          const settingsMap = {};
          for (let i = 0; i < enabledSettings.length; i++) {
            const key = enabledSettings[i];
            settingsMap[key] = { enabled: true, order: i };
          }

          const orderedItems = [];
          
          for (let i = 0; i < enabledSettings.length; i++) {
            const apiKey = enabledSettings[i];
            for (let j = 0; j < this.state.appCalendarItems.length; j++) {
              const item = this.state.appCalendarItems[j];
              if (item.apiKey === apiKey) {
                orderedItems.push({
                  ...item,
                  enabled: true
                });
                break;
              }
            }
          }
          
          for (let i = 0; i < this.state.appCalendarItems.length; i++) {
            const item = this.state.appCalendarItems[i];
            if (!settingsMap.hasOwnProperty(item.apiKey)) {
              orderedItems.push({
                ...item,
                enabled: false
              });
            }
          }

          this.setState({ 
            appCalendarItems: orderedItems,
            appCalendarLoading: false,
            appCalendarInitialized: true
          });

          if (showNotification) {
            NotificationManager.success(data.message || "Calendar settings loaded");
          }
        } else {
          if (showNotification) {
            NotificationManager.info(data.message || "Failed to load calendar settings");
          }
          this.setState({ appCalendarLoading: false });
        }
      })
      .catch(error => {
        console.error("Error fetching app calendar settings:", error);
        if (showNotification) {
          NotificationManager.info("Error loading calendar settings");
        }
        this.setState({ appCalendarLoading: false });
      });
  };

//   handleCancellationPolicyChange = (e) => {
//     const { checked } = e.target;
    
//     if (checked) {
//       if (this.state.policies.length > 0 && this.state.selectedPolicyId) {
//         this.setState({
//           enableCancellationPolicy: this.state.selectedPolicyId
//         });

//         var dateVals = {
//           appID: logindetail && logindetail.aid,
//           companyID: logindetail && logindetail.cid,
//           memberID: logindetail && logindetail.uid,
//           enableCancellationPolicy: this.state.selectedPolicyId,
//           cancelBeforeValue: this.state.cancelBeforeValue,
//           cancelBeforeUnit: this.state.cancelBeforeUnit,
//           cancelFeeValue: this.state.cancelFeeValue,
//           cancelFeeUnit: this.state.cancelFeeUnit,
//           cancelCutoffTime: this.state.cancelCutoffTime
//         };
        
//         httpClient
//           .post(
//             "updateUserSettings.php",
//             qs.stringify({
//               action: "enableCancellationPolicy",
//               source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//               enableCancellationPolicy: dateVals.enableCancellationPolicy,
//               cancelBeforeValue: dateVals.cancelBeforeValue,
//               cancelBeforeUnit: dateVals.cancelBeforeUnit,
//               cancelFeeValue: dateVals.cancelFeeValue,
//               cancelFeeUnit: dateVals.cancelFeeUnit,
//               cancelCutoffTime: dateVals.cancelCutoffTime
//             })
//           ).then(({ data }) => {
//             if (data.success == "true") {
//               var loginData = JSON.parse(localStorage.getItem("login"));

//               loginData.enableCancellationPolicy = this.state.selectedPolicyId;
//               this.setState({
//                 enableCancellationPolicy: this.state.selectedPolicyId
//               });
//               localStorage.setItem("login", JSON.stringify(loginData));
//               NotificationManager.info("Cancellation policy enabled");
//             }
//           });
//       } else {
//         this.fetchPolicies();
//         this.setState({
//           enableCancellationPolicy: 1
//         });
//       }
//     } else {
//       this.setState({
//         enableCancellationPolicy: 0
//       });

//       var dateVals = {
//         appID: logindetail && logindetail.aid,
//         companyID: logindetail && logindetail.cid,
//         memberID: logindetail && logindetail.uid,
//         enableCancellationPolicy: 0
//       };
      
//       httpClient
//         .post(
//           "updateUserSettings.php",
//           qs.stringify({
//             action: "enableCancellationPolicy",
//             source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
//             enableCancellationPolicy: dateVals.enableCancellationPolicy
//           })
//         ).then(({ data }) => {
//           if (data.success == "true") {
//             var loginData = JSON.parse(localStorage.getItem("login"));

//             loginData.enableCancellationPolicy = 0;
//             this.setState({
//               enableCancellationPolicy: 0
//             });
//             localStorage.setItem("login", JSON.stringify(loginData));
//             NotificationManager.info("Cancellation policy disabled");
//           }
//         });
//     }
//   }

handleCancellationPolicyChange = (e) => {
  const { checked } = e.target;
  
  // Prevent multiple calls by checking if we're already processing
  if (this.isProcessingToggle) {
    return;
  }
  
  this.isProcessingToggle = true;
  
  if (checked) {
    // If there's already a selected policy ID, use it
    if (this.state.selectedPolicyId) {
      this.setState({
        enableCancellationPolicy: this.state.selectedPolicyId
      }, () => {
        var dateVals = {
          appID: logindetail && logindetail.aid,
          companyID: logindetail && logindetail.cid,
          memberID: logindetail && logindetail.uid,
          enableCancellationPolicy: this.state.selectedPolicyId,
          cancelBeforeValue: this.state.cancelBeforeValue,
          cancelBeforeUnit: this.state.cancelBeforeUnit,
          cancelFeeValue: this.state.cancelFeeValue,
          cancelFeeUnit: this.state.cancelFeeUnit,
          cancelCutoffTime: this.state.cancelCutoffTime
        };
        
        httpClient
          .post(
            "updateUserSettings.php",
            qs.stringify({
              action: "enableCancellationPolicy",
              source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
              enableCancellationPolicy: dateVals.enableCancellationPolicy,
              cancelBeforeValue: dateVals.cancelBeforeValue,
              cancelBeforeUnit: dateVals.cancelBeforeUnit,
              cancelFeeValue: dateVals.cancelFeeValue,
              cancelFeeUnit: dateVals.cancelFeeUnit,
              cancelCutoffTime: dateVals.cancelCutoffTime
            })
          ).then(({ data }) => {
            if (data.success == "true") {
              var loginData = JSON.parse(localStorage.getItem("login"));
              loginData.enableCancellationPolicy = this.state.selectedPolicyId;
              this.setState({
                enableCancellationPolicy: this.state.selectedPolicyId
              });
              localStorage.setItem("login", JSON.stringify(loginData));
              NotificationManager.info("Cancellation policy enabled");
            }
            this.isProcessingToggle = false;
          }).catch(() => {
            this.isProcessingToggle = false;
          });
      });
    } else {
      // Fetch policies and then auto-select if only one
      this.fetchPolicies();
      this.setState({
        enableCancellationPolicy: 1
      }, () => {
        this.isProcessingToggle = false;
      });
    }
  } else {
    // When closing the toggle, pass the same payload structure but with enableCancellationPolicy = 0
    this.setState({
      enableCancellationPolicy: 0
    }, () => {
      var dateVals = {
        appID: logindetail && logindetail.aid,
        companyID: logindetail && logindetail.cid,
        memberID: logindetail && logindetail.uid,
        enableCancellationPolicy: 0,
        cancelBeforeValue: this.state.cancelBeforeValue,
        cancelBeforeUnit: this.state.cancelBeforeUnit,
        cancelFeeValue: this.state.cancelFeeValue,
        cancelFeeUnit: this.state.cancelFeeUnit,
        cancelCutoffTime: this.state.cancelCutoffTime
      };
      
      httpClient
        .post(
          "updateUserSettings.php",
          qs.stringify({
            action: "enableCancellationPolicy",
            source: dateVals.appID + '_' + dateVals.companyID + '_' + dateVals.memberID + '_' + 'enableCancellationPolicy',
            enableCancellationPolicy: dateVals.enableCancellationPolicy,
            cancelBeforeValue: dateVals.cancelBeforeValue,
            cancelBeforeUnit: dateVals.cancelBeforeUnit,
            cancelFeeValue: dateVals.cancelFeeValue,
            cancelFeeUnit: dateVals.cancelFeeUnit,
            cancelCutoffTime: dateVals.cancelCutoffTime
          })
        ).then(({ data }) => {
          if (data.success == "true") {
            var loginData = JSON.parse(localStorage.getItem("login"));
            loginData.enableCancellationPolicy = 0;
            this.setState({
              enableCancellationPolicy: 0
            });
            localStorage.setItem("login", JSON.stringify(loginData));
            NotificationManager.info("Cancellation policy disabled");
          }
          this.isProcessingToggle = false;
        }).catch(() => {
          this.isProcessingToggle = false;
        });
    });
  }
};

  handleToggle = (event, value) => {
    var settingParam;
    var aid, cid, uid;
    var btntype;
    aid = logindetail && logindetail.aid;
    cid = logindetail && logindetail.cid;
    uid = logindetail && logindetail.uid;
    btntype = value;

    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex == -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked,
    });

    settingParam = aid + "_" + cid + "_" + uid + "_" + value;

    httpClient
      .post(
        "updateUserSettings.php",
        qs.stringify({
          action: btntype,
          source: settingParam,
        })
      )
      .then(
        ({ data }) => {
          if (data.success != "true") {
            NotificationManager.info(data.failedMSG);
          } else if (data.success == "true") {
            var loginTempOBJ = JSON.parse(localStorage.getItem("login"));
            var objname = data.actionOn;

            if (objname == "displayCustNotes")
              loginTempOBJ.displayCustNotes = 1 - loginTempOBJ.displayCustNotes;

            if (objname == "hideOldRecurring")
              loginTempOBJ.hideOldRecurring = 1 - loginTempOBJ.hideOldRecurring;

            if (objname == "displayBookingClash")
              loginTempOBJ.displayBookingClash =
                1 - loginTempOBJ.displayBookingClash;

            if (objname == "hidePastBookingsCalendarSearch")
              loginTempOBJ.hidePastBookingsCalendarSearch =
                1 - loginTempOBJ.hidePastBookingsCalendarSearch;

            if (objname == "filterBookingServices") {
              loginTempOBJ.filterBookingServices =
                1 - loginTempOBJ.filterBookingServices;
            }

            localStorage.setItem("login", JSON.stringify(loginTempOBJ));
            NotificationManager.info(data.msg);
          }
        },
        (error) => {
          this.setState({
            error,
          });
        }
      );
  };

  handleCalendarChange = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked });
  };

  handleBookingConfirmationChange = (event) => {
    this.setState({ selectedSetting: event.target.value });
  };

  handleChangeConfirmationHour = (e) => {
    this.setState({
      confirmationHour: e.target.value,
    });
  };

  handleSaveSettings() {
    if (this.state.incometemplate == "" && this.state.incomedescription == "") {
      NotificationManager.info("Nothing changed to save");
    } else {
      httpClient
        .post(
          "saveMemberSettings.php",
          qs.stringify({
            action: "save_settings",
            source: this.state,
          })
        )
        .then(
          ({ data }) => {
            if (data.success != "true") {
              NotificationManager.info(data.failedMSG);
            } else {
              NotificationManager.info(data.successMSG);
              this.setState({
                incometemplate: "",
                incomedescription: "",
              });
            }
          },
          (error) => {
            NotificationManager.info(
              "Error Occured: Refresh the page and try again"
            );
          }
        );
    }
  }

  handleChange(evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  handleSubmitCalendar = (e) => {
    e.preventDefault();

    let loginBlur = JSON.parse(localStorage.getItem("login"));
    if (loginBlur && loginBlur.ismobiledevice != 1) {
      document.getElementById("nav__menu__display") !== null &&
        (document.getElementById("nav__menu__display").style.cssText =
          "filter: blur(2px); pointer-events: none");
    }
    document.getElementById("appbar_mainapp__") !== null &&
      (document.getElementById("appbar_mainapp__").style.cssText =
        "filter: blur(2px); pointer-events: none");

    this.setState({
      ...this.state,
      loading: true,
    });
    
    let parameters = {
      appID: logindetail && logindetail.aid,
      memberID: logindetail && logindetail.uid,
      companyID: logindetail && logindetail.cid,
      customer_name: this.state.customerName,
      bookingCost: this.state.bookingTotal,
      customer_address: this.state.customerAddress,
      pet_name: this.state.petName,
      pet_breed: this.state.petBreed,
      services_name: this.state.serviceName,
    };

    httpClient
      .post(
        "updateUserSettings.php",
        qs.stringify({
          action: "update_calendar_settings",
          source: parameters,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          NotificationManager.success(data.successMSG);
          let calendarData = [];
          let calendarStorage = JSON.parse(localStorage.getItem("settings"));

          calendarData = {
            ...calendarStorage,
            customer_name: data.customer_name,
            bookingCost: data.bookingCost,
            pet_name: data.pet_name,
            services_name: data.services_name,
            customer_address: data.customer_address,
          };

          const cal = { ...calendarData };

          localStorage.setItem("settings", JSON.stringify(cal));

          setTimeout(() => {
            NotificationManager.info("Retrieving Calendar Entries");
          }, 1000);

          this.getCalendarEntry();
        } else {
          NotificationManager.info(data.failedMSG);
        }
      });
  };

  handleSubmitConfirmation = (e) => {
    e.preventDefault();

    this.setState({
      ...this.state,
      loadingConfirmation: true,
    });
    
    let parameters = {
      appID: logindetail && logindetail.aid,
      memberID: logindetail && logindetail.uid,
      companyID: logindetail && logindetail.cid,
    };

    httpClient
      .post(
        "updateUserSettings.php",
        qs.stringify({
          action: "bookingConfirmation",
          source: parameters.appID + "_" + parameters.companyID + "_" + parameters.memberID + "_" + "bookingConfirmation",
          confirmationBy: this.state.selectedSetting,
          confirmationHour: this.state.confirmationHour,
        })
      )
      .then(({ data }) => {
        if (data.success == "true") {
          this.setState({
            ...this.state,
            loadingConfirmation: false,
            selectedSetting: data.data.confirmationBy,
            confirmationHour: parseInt(data.data.confirmationHour),
          });
          NotificationManager.success(data.msg);
        } else {
          this.setState({
            ...this.state,
            loadingConfirmation: false,
            selectedSetting: "",
            confirmationHour: "",
          });
          NotificationManager.info(data.failedMSG);
        }
      });
  };

  getCalendarEntry = () => {
    httpClient
      .post(
        "getCalendarEntries.php",
        qs.stringify({
          action: "calendar_entries",
          source: param,
        })
      )
      .then(
        ({ data }) => {
          if (data) {
            var calendarLastMod = {
              calendarLastModified: data.calendarLastModified,
            };
            var dataIndex =
              modifiedData &&
              modifiedData.findIndex((arr, i) => arr.calendarLastModified);
            modifiedData && (modifiedData[dataIndex] = calendarLastMod);

            localStorage.setItem("calendar_entries", JSON.stringify(data.data));
            this.setState({
              syncModified: modifiedData,
            });

            this.setState({
              ...this.state,
              loading: false,
            });
            
            if (this.state.syncModified.length > 0) {
              var loginData = JSON.parse(localStorage.getItem("login"));
              loginData.syncLastModified = this.state.syncModified;
              loginData.syncLastModified !== [] &&
                localStorage.setItem("login", JSON.stringify(loginData));
            }

            NotificationManager.success(
              "Calendar Settings Successfully Updated"
            );

            let loginBlur = JSON.parse(localStorage.getItem("login"));

            if (loginBlur && loginBlur.ismobiledevice != 1) {
              document.getElementById("nav__menu__display") !== null &&
                (document.getElementById("nav__menu__display").style.cssText =
                  "filter: blur(0px); pointer-events: block");
            }
            document.getElementById("appbar_mainapp__") !== null &&
              (document.getElementById("appbar_mainapp__").style.cssText =
                "filter: blur(0px); pointer-events: block");
          } else {
          }
        }
      );
  };

  render() {
    const {
      error,
      isLoaded,
      incomedescription,
      settingdetail,
      incometemplate,
      customerName,
      bookingTotal,
      customerAddress,
      petName,
      petBreed,
      serviceName,
      appCalendarItems,
      appCalendarLoading,
      appCalendarInitialized,
      policies,
      policiesLoading,
      selectedPolicyId,
      savingPolicy,
      enableCancellationPolicy,
      cancelBeforeValue,
      cancelBeforeUnit,
      cancelFeeValue,
      cancelFeeUnit,
      cancelCutoffTime,
      dynamicFieldsDisabled,
      cutoffTimeError,
    } = this.state;

    if (error) {
      return <div className="jr-customers">Error: {error.message}</div>;
    } else if (!isLoaded || (appCalendarLoading && !appCalendarInitialized)) {
      return (
        <div className="jr-customers">
          <LinearProgress color="secondary" />
        </div>
      );
    } else {
      return (
        <>
          <div className="app-wrapper animated slideInUpTiny animation-duration-3">
            <ContainerHeader
              title={<IntlMessages id="sidebar.dashboard.settings" />}
              match={this.props.match}
            />

            <div className="row">
              <CardBox
                heading={<IntlMessages id="dashboard.settings.preferences" />}
              >
                <div className="col-md-12 col-12">
                  <List className="LawaList">
                    <ListItem>
                      <ListItemIcon>
                        <i className="zmdi zmdi-calendar-note zmdi-hc-fw zmdi-hc-2x" />
                      </ListItemIcon>
                      <ListItemText primary="Display Customer Notes on Booking" />
                      <ListItemSecondaryAction>
                        <Switch
                          color="primary"
                          onClick={(event) =>
                            this.handleToggle(event, "displayCustNotes")
                          }
                          checked={
                            this.state.checked.indexOf("displayCustNotes") != -1
                          }
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <i className="zmdi zmdi-eye-off zmdi-hc-fw zmdi-hc-2x" />
                      </ListItemIcon>
                      <ListItemText primary="Hide Expired/Completed Recurring Bookings" />
                      <ListItemSecondaryAction>
                        <Switch
                          color="primary"
                          onClick={(event) =>
                            this.handleToggle(event, "hideOldBookings")
                          }
                          checked={
                            this.state.checked.indexOf("hideOldBookings") != -1
                          }
                        />
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <i className="zmdi zmdi-notifications-off zmdi-hc-fw zmdi-hc-2x" />
                      </ListItemIcon>
                      <ListItemText primary="Hide Booking Clash Notifications" />
                      <ListItemSecondaryAction>
                        <Switch
                          color="primary"
                          onClick={(event) =>
                            this.handleToggle(event, "displayBookingClash")
                          }
                          checked={
                            this.state.checked.indexOf("displayBookingClash") !=
                            -1
                          }
                        />
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <i className="zmdi zmdi-calendar-close zmdi-hc-fw zmdi-hc-2x" />
                      </ListItemIcon>
                      <ListItemText primary="Hide Past Bookings from Calendar Search" />
                      <ListItemSecondaryAction>
                        <Switch
                          color="primary"
                          onClick={(event) =>
                            this.handleToggle(
                              event,
                              "hidePastBookingsCalendarSearch"
                            )
                          }
                          checked={
                            this.state.checked.indexOf(
                              "hidePastBookingsCalendarSearch"
                            ) != -1
                          }
                        />
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <i className="zmdi zmdi-evernote zmdi-hc-fw zmdi-hc-2x" />
                      </ListItemIcon>
                      <ListItemText primary="Filter Services based on pet size" />
                      <ListItemSecondaryAction>
                        <Switch
                          color="primary"
                          onClick={(event) =>
                            this.handleToggle(event, "filterBookingServices")
                          }
                          checked={
                            this.state.checked.indexOf("filterBookingServices") !=
                            -1
                          }
                        />
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
                      </ListItemIcon>
                      <ListItemText primary="Display Booking End Time" />
                      <ListItemSecondaryAction>
                        <Switch
                          color="primary"
                          checked={this.state.display_booking_end_time === "1"}
                          onChange={this.handleEndDate}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <i className="zmdi zmdi-receipt zmdi-hc-fw zmdi-hc-2x" />
                      </ListItemIcon>
                      <ListItemText primary="Show Address In Invoice" />
                      <ListItemSecondaryAction>
                        <Switch
                          color="primary"
                          checked={this.state.addressInInvoice === 1}
                          onChange={this.handleAddressInInvoiceChange}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-2x" />
                      </ListItemIcon>
                      <ListItemText primary="Show Personal Phone In Invoice" />
                      <ListItemSecondaryAction>
                        <Switch
                          color="primary"
                          checked={this.state.phoneInInvoice === 1}
                          onChange={this.handlePersonalPhoneInInvoiceChange}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <i className="zmdi zmdi-time-restore zmdi-hc-fw zmdi-hc-2x" />
                      </ListItemIcon>
                      <ListItemText primary="Toggle 24hr Time Format" />
                      <ListItemSecondaryAction>
                        <span style={{ fontSize: 'small' }}><small>12 hr</small></span>
                        <Tooltip title={this.state.timeFormat === 24 ? 'Change to 12 hour format' : 'Change to 24 hour format'}>
                          <Switch
                            color="primary"
                            checked={this.state.timeFormat === 24}
                            onChange={this.handleFormatChange}
                          />
                        </Tooltip>
                        <span style={{ fontSize: 'small' }}><small>24 hr</small></span>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </div>
              </CardBox>

              <div className="col-md-6">
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={12}>
                    <CardBoxNew heading={<IntlMessages id="dashboard.settings.sms" />}>
                      <div className="col-md-12 col-12">
                        <TextField
                          id="smsNumber"
                          label="SMS Sender"
                          value="0495149675"
                          margin="normal"
                          helperText="All your SMS will be sent using this number. You currently are not allowed to change this number."
                          fullWidth
                        />
                      </div>
                    </CardBoxNew>
                  </Grid>
                  
                  <Grid item xs={12}>
                 <CardBoxNew heading={"Cancellation Policy"}>
  <div className="col-md-12 col-12">
    <List>
      <ListItem>
        <ListItemIcon>
          <i className="zmdi zmdi-attachment zmdi-hc-fw zmdi-hc-2x" />
        </ListItemIcon>
        <ListItemText primary="Attach Cancellation Policy" />
        <ListItemSecondaryAction>
          <Switch
            color="primary"
            checked={enableCancellationPolicy === 1 || enableCancellationPolicy > 0}
            onChange={this.handleCancellationPolicyChange}
          />
        </ListItemSecondaryAction>
      </ListItem>
    </List>

    {(enableCancellationPolicy === 1 || enableCancellationPolicy > 0) && (
      <>
        <Divider style={{ margin: '15px 0' }} />
        
        {/* Dynamic Input Fields Section */}
        <div style={{ 
          marginBottom: '20px', 
          padding: '15px', 
          backgroundColor: '#f9f9f9', 
          borderRadius: '8px',
          border: '1px solid #e0e0e0'
        }}>
          <FormLabel component="legend" style={{ marginBottom: '15px', fontWeight: 600 }}>
            Cancellation Policy Settings
          </FormLabel>
          
          <Grid container spacing={2}>
            {/* Cancel Before - Dropdown */}
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth variant="outlined" disabled={dynamicFieldsDisabled}>
                <InputLabel shrink>Cancel Before</InputLabel>
                <Select
                  value={cancelBeforeUnit}
                  onChange={this.handleCancelBeforeUnitChange}
                  label="Cancel Before"
                  notched={true}
                >
                  <MenuItem value="hours">Hours</MenuItem>
                  <MenuItem value="cutoff">Cutoff Time</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            {/* Conditional Input - Shows Hours or Cutoff Time */}
            <Grid item xs={12} sm={6} md={6}>
              {cancelBeforeUnit === "hours" ? (
                <TextField
                  label="Hours"
                  type="text"
                  value={cancelBeforeValue}
                  onChange={this.handleCancelBeforeValueChange}
                  disabled={dynamicFieldsDisabled}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*'
                  }}
                />
              ) : (
                <TextField
                  label="Cutoff Time (24-hour format)"
                  value={cancelCutoffTime}
                  onChange={this.handleCancelCutoffTimeChange}
                  disabled={dynamicFieldsDisabled}
                  fullWidth
                  variant="outlined"
                  placeholder="22:00:00"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={cutoffTimeError}
                  helperText="Format: HH:MM:SS (e.g., 22:00:00 for 10:00 PM)"
                  inputProps={{
                    inputMode: 'numeric',
                    maxLength: 8
                  }}
                />
              )}
            </Grid>
            
            {/* Cancellation Fee Value */}
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                label="Cancellation Fee Value"
                type="text"
                value={cancelFeeValue}
                onChange={this.handleCancelFeeValueChange}
                disabled={dynamicFieldsDisabled}
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '[0-9.]*'
                }}
              />
            </Grid>
            
            {/* Fee Unit */}
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth variant="outlined" disabled={dynamicFieldsDisabled}>
                <InputLabel shrink>Fee Unit</InputLabel>
                <Select
                  value={cancelFeeUnit}
                  onChange={this.handleCancelFeeUnitChange}
                  label="Fee Unit"
                  notched={true}
                >
                  <MenuItem value="$">$ (Dollar)</MenuItem>
                  <MenuItem value="%">% (Percent)</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </div>
        
        <FormLabel component="legend" style={{ marginBottom: '10px', marginLeft: '15px' }}>
          Select Policy
        </FormLabel>
        {policiesLoading ? (
          <LinearProgress color="secondary" />
        ) : (
          <>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                name="policies-radio-group"
                value={selectedPolicyId}
                onChange={this.handlePolicyChange}
              >
                {policies.map((policy) => {
                  let displayPolicy = policy.policy;
                  
                  // Generate timeTemplate based on selection
                  let timeTemplate = '';
                  if (cancelBeforeUnit === 'hours') {
                    const hourText = parseInt(cancelBeforeValue) === 1 ? 'hour' : 'hours';
                    timeTemplate = `we kindly require ${cancelBeforeValue || '_____'} ${hourText} notice for any cancellations or reschedules.`;
                  } else {
                    // Format cutoff time for display (convert HH:MM:SS to 12-hour format)
                    let formattedCutoffTime = cancelCutoffTime || '_____';
                    if (cancelCutoffTime && cancelCutoffTime !== '_____') {
                      const [hours, minutes] = cancelCutoffTime.split(':');
                      let hour = parseInt(hours);
                      const ampm = hour >= 12 ? 'PM' : 'AM';
                      hour = hour % 12 || 12;
                      formattedCutoffTime = `${hour}:${minutes} ${ampm}`;
                    }
                    timeTemplate = `notice of cancellation or reschedules must be received by ${formattedCutoffTime} the business day prior.`;
                  }
                  displayPolicy = displayPolicy.replace(/{{timeTemplate}}/g, timeTemplate);
                  
                  // Generate feeTemplate based on selection
                  let feeTemplate = '';
                  if (cancelFeeUnit === '%') {
                    feeTemplate = `${cancelFeeValue || '_____'}% of the service cost`;
                  } else {
                    feeTemplate = `$${cancelFeeValue || '_____'}`;
                  }
                  displayPolicy = displayPolicy.replace(/{{feeTemplate}}/g, feeTemplate);
                  
                  return (
                    <FormControlLabel
                      key={policy.policyID}
                      value={policy.policyID}
                      control={<Radio color="primary" />}
                      label={
                        <div 
                          dangerouslySetInnerHTML={{ __html: displayPolicy }}
                          style={{ 
                            fontSize: '0.9rem',
                            lineHeight: '1.4',
                            wordBreak: 'break-word'
                          }}
                        />
                      }
                      style={{
                        marginBottom: '12px',
                        alignItems: 'flex-start',
                        width: '100%',
                      }}
                    />
                  );
                })}
              </RadioGroup>
            </FormControl>
            
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              {savingPolicy ? (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={true}
                  size="large"
                >
                  Saving...
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleSavePolicy}
                  disabled={!selectedPolicyId || dynamicFieldsDisabled}
                  size="large"
                >
                  Save Policy Selection
                </Button>
              )}
            </div>
          </>
        )}
      </>
    )}
  </div>
</CardBoxNew>
                  </Grid>
                </Grid>
              </div>

              <CardBox heading={<IntlMessages id="dashboard.settings.booking" />}>
                <form className="row" noValidate autoComplete="off">
                  <div className="col-md-12 col-12">
                    <TextField
                      id="incometemplate"
                      name="incometemplate"
                      label="Income Title Template"
                      margin="normal"
                      defaultValue={this.state.settingdetail.title}
                      helperText="##date## and ##customername## will be replaced by actual date and customer name"
                      onChange={this.handleChange}
                      fullWidth
                    />
                  </div>
                  <div className="col-md-12 col-12">
                    <TextField
                      id="incomedescription"
                      name="incomedescription"
                      label="Income Description"
                      defaultValue={this.state.settingdetail.desc}
                      margin="normal"
                      onChange={this.handleChange}
                      helperText="##date## and ##customername## will be replaced by actual date and customer name"
                      fullWidth
                    />
                  </div>
                  <div className="col-md-12 col-12">
                    <Button
                      variant="contained"
                      color="primary"
                      className="jr-btn btn-margin-topbottom"
                      position="static"
                      onClick={() => {
                        this.handleSaveSettings();
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </form>
              </CardBox>
              
              <CardBox heading="Send Booking Reminder">
                {this.state.loadingConfirmation && (
                  <div style={{ position: "relative", top: "15px" }}>
                    <LinearProgress color="secondary" />
                  </div>
                )}
                <div className="row">
                  <div className="col-md-12 col-12">
                    <List className="LawaList">
                      <ListItem>
                        <ListItemText primary="Do not send booking reminder" />
                        <ListItemSecondaryAction>
                          <Radio
                            color="primary"
                            name="calendarSetting"
                            value=""
                            checked={this.state.selectedSetting === ""}
                            onChange={this.handleBookingConfirmationChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Send email and SMS for all customers" />
                        <ListItemSecondaryAction>
                          <Radio
                            color="primary"
                            name="calendarSetting"
                            value="all"
                            checked={this.state.selectedSetting === "all"}
                            onChange={this.handleBookingConfirmationChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Send email only, do not send SMS" />
                        <ListItemSecondaryAction>
                          <Radio
                            color="primary"
                            name="calendarSetting"
                            value="emailOnly"
                            checked={this.state.selectedSetting === 'emailOnly'}
                            onChange={this.handleBookingConfirmationChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Send SMS only, do not send email" />
                        <ListItemSecondaryAction>
                          <Radio
                            color="primary"
                            name="calendarSetting"
                            value="smsOnly"
                            checked={this.state.selectedSetting === 'smsOnly'}
                            onChange={this.handleBookingConfirmationChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Send by email but if not found, send SMS" />
                        <ListItemSecondaryAction>
                          <Radio
                            color="primary"
                            name="calendarSetting"
                            value="preferedEmail"
                            checked={this.state.selectedSetting === 'preferedEmail'}
                            onChange={this.handleBookingConfirmationChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Send by SMS but if no mobile number, send email" />
                        <ListItemSecondaryAction>
                          <Radio
                            color="primary"
                            name="calendarSetting"
                            value="preferedSMS"
                            checked={this.state.selectedSetting === 'preferedSMS'}
                            onChange={this.handleBookingConfirmationChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary={`Send confirmation ${this.state.confirmationHour} hours before booking`} />
                        <ListItemSecondaryAction>
                          <FormControl variant="outlined" style={{ width: "150px" }}>
                            <Select
                              placeholder="Select Confirmation Before"
                              name="confirmationHour"
                              value={this.state.confirmationHour}
                              style={{
                                textAlign: 'center',
                                paddingLeft: '0',
                              }}
                              inputProps={{
                                style: {
                                  textAlign: 'center',
                                },
                              }}
                              onChange={(e) => this.handleChangeConfirmationHour(e)}
                            >
                              <MenuItem value="">
                                <em>Select Confirmation Before</em>
                              </MenuItem>
                              <MenuItem value={24}>{"24 hrs"} (1 day)</MenuItem>
                              <MenuItem value={48}>{"48 hrs"} (2 days)</MenuItem>
                              <MenuItem value={72}>{"72 hrs"} (3 days)</MenuItem>
                              <MenuItem value={168}>{"168 hrs"} (7 days)</MenuItem>
                            </Select>
                          </FormControl>
                        </ListItemSecondaryAction>
                      </ListItem>

                      {this.state.loadingConfirmation ? (
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ float: "right", marginTop: "20px" }}
                          onClick={this.handleSubmitConfirmation}
                          disabled={true}
                        >
                          Update Booking Reminder
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ float: "right", marginTop: "20px" }}
                          onClick={this.handleSubmitConfirmation}
                        >
                          Update Booking Reminder
                        </Button>
                      )}
                    </List>
                  </div>
                </div>
              </CardBox>

              <CardBox heading="Calendar Settings">
                {this.state.loading && (
                  <div style={{ position: "relative", top: "15px" }}>
                    <LinearProgress color="secondary" />
                  </div>
                )}
                <div className="row">
                  <div className="col-md-12 col-12">
                    <List className="LawaList">
                      <ListItem>
                        <ListItemText primary="Show Booking Total" />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            name="bookingTotal"
                            checked={bookingTotal}
                            onChange={this.handleCalendarChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Show Customer Name" />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            name="customerName"
                            checked={customerName}
                            onChange={this.handleCalendarChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Show Customer Address" />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            name="customerAddress"
                            checked={customerAddress}
                            onChange={this.handleCalendarChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>

                      <ListItem>
                        <ListItemText primary="Show Pet Name" />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            name="petName"
                            checked={petName}
                            onChange={this.handleCalendarChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>

                      <ListItem>
                        <ListItemText primary="Show Pet Breed" />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            name="petBreed"
                            checked={petBreed}
                            onChange={this.handleCalendarChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>

                      <ListItem>
                        <ListItemText primary="Show Services Name" />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            name="serviceName"
                            checked={serviceName}
                            onChange={this.handleCalendarChange}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>

                      <div>
                        <h5>Preview</h5>
                      </div>
                      {(bookingTotal ||
                        customerName ||
                        customerAddress ||
                        petName || petBreed ||
                        serviceName) && (
                          <Card
                            style={{
                              padding: "20px",
                              backgroundColor: "#3f51b5",
                              color: "#fff",
                              width: "400px",
                            }}
                          > 
                            {bookingTotal && <div>$Total Cost</div>}
                            {customerName && <div>Firstname Lastname</div>}
                            {customerAddress && <div>Street Address, Suburb, Postcode</div>}
                            {petName && <div>Pet Name</div>}
                            {petBreed && <div>Pet Breed</div>}
                            {serviceName && <div>Services</div>}
                          </Card>
                        )}
                    </List>
                    {this.state.loading ? (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ float: "right", marginTop: "10px" }}
                        onClick={this.handleSubmitCalendar}
                        disabled={true}
                      >
                        Update Calendar Settings
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ float: "right", marginTop: "10px" }}
                        onClick={this.handleSubmitCalendar}
                        disabled={
                          !(bookingTotal ||
                            customerName ||
                            customerAddress ||
                            petName || petBreed ||
                            serviceName)
                        }
                      >
                        Update Calendar Settings
                      </Button>
                    )}
                  </div>
                </div>
              </CardBox>

              {/* App Calendar Settings Section with Mobile Support */}
              <CardBox heading="App Calendar Settings">
                {appCalendarLoading && (
                  <div style={{ position: "relative", top: "15px", marginBottom: "20px" }}>
                    <LinearProgress color="secondary" />
                  </div>
                )}
                <div className="row">
                  <div className="col-md-12 col-12">
                    <p style={{ 
                      marginBottom: '15px', 
                      color: '#666', 
                      fontSize: '0.9rem',
                      padding: '10px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '4px',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      {this.state.isTouchDevice ? (
                        <span>Long press and drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
                      ) : (
                        <span>Drag the icon to reorder items. Toggle switches to show/hide in app calendar.</span>
                      )}
                    </p>

                    <List className="LawaList">
                      {appCalendarItems.map((item, index) => (
                        <ListItem
                          key={item.id}
                          className="app-calendar-item"
                          draggable={!this.state.isTouchDevice}
                          onDragStart={(e) => this.handleDragStart(e, index)}
                          onDragOver={(e) => this.handleDragOver(e, index)}
                          onDrop={(e) => this.handleDrop(e, index)}
                          onDragEnd={this.handleDragEnd}
                          onTouchStart={(e) => this.handleTouchStart(e, index)}
                          onTouchMove={this.handleTouchMove}
                          onTouchEnd={this.handleTouchEnd}
                          onTouchCancel={this.handleTouchCancel}
                          style={{
                            cursor: this.state.isTouchDevice ? 'default' : 'grab',
                            border: '1px solid transparent',
                            transition: 'all 0.2s',
                            backgroundColor: this.state.draggedItem === index ? '#f5f5f5' : 'transparent',
                            WebkitTapHighlightColor: 'transparent',
                          }}
                        >
                          <ListItemIcon 
                            className="drag-handle"
                            style={{ 
                              cursor: this.state.isTouchDevice ? 'pointer' : 'grab', 
                              minWidth: '40px',
                              padding: this.state.isTouchDevice ? '10px 5px' : '0',
                            }}
                          >
                            <i className="zmdi zmdi-menu" style={{ fontSize: '20px', color: '#999' }}></i>
                          </ListItemIcon>
                          <ListItemText primary={item.label} />
                          <ListItemSecondaryAction>
                            <Switch
                              color="primary"
                              checked={item.enabled}
                              onChange={() => this.handleAppCalendarToggle(item.id)}
                            />
                          </ListItemSecondaryAction>
                        </ListItem>
                      ))}
                    </List>

                    {/* Preview Section */}
                    <div style={{ marginTop: '20px' }}>
                      <h5>Preview</h5>
                      {appCalendarItems.some(item => item.enabled) ? (
                        <Card
                          style={{
                            padding: "20px",
                            backgroundColor: "#3f51b5",
                            color: "#fff",
                            width: "100%",
                            maxWidth: "400px",
                          }}
                        >
                          {appCalendarItems
                            .filter(item => item.enabled)
                            .map(item => {
                              switch(item.apiKey) {
                                case 'time':
                                  return <div key={item.id}>10:30 AM</div>;
                                case 'cost':
                                  return <div key={item.id}>Service Cost</div>;
                                case 'name':
                                  return <div key={item.id}>Customer Name</div>;
                                case 'address':
                                  return <div key={item.id}>123 Main St, Sydney 2000</div>;
                                case 'petName':
                                  return <div key={item.id}>Pet Name</div>;
                                case 'petBreed':
                                  return <div key={item.id}>Pet Breed</div>;
                                case 'serviceName':
                                  return <div key={item.id}>Full Grooming</div>;
                                default:
                                  return null;
                              }
                            })}
                        </Card>
                      ) : (
                        <p style={{ color: '#999', fontStyle: 'italic' }}>Toggle on items to see preview</p>
                      )}
                    </div>

                    {appCalendarLoading ? (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ float: "right", marginTop: "20px" }}
                        disabled={true}
                      >
                        Updating...
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ float: "right", marginTop: "20px" }}
                        onClick={this.handleAppCalendarSubmit}
                      >
                        Update App Calendar Settings
                      </Button>
                    )}
                  </div>
                </div>
              </CardBox>
            </div>
          </div>
          <NotificationContainer />
        </>
      );
    }
  }
}

export default Settings;